(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ui.tree',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ncy-angular-breadcrumb',
            'ui.tree',
            'ngFileUpload',
            'ngMessages',
            'ngMaterial',
            'ngMaterialSidemenu',
            'angular-click-outside',
            'ngCsv',
            'chart.js',
            'toastr'
        ])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

(function() {
    'use strict';

    angular
    .module('expedientesUriarteApp')
    .directive('confirmDelete',confirmDelete);

    //direcitves controller

     confirmDeleteCtrl.$inject = ['$scope'];

     function confirmDeleteCtrl($scope) {
        $scope.isDeleting = false;
        $scope.startDelete = function () {
           $scope.isDeleting = true;
         };
         $scope.cancel = function () {
           $scope.isDeleting = false;
         };
         $scope.confirm = function () {
           $scope.isDeleting = false;
           $scope.onConfirm();
         };
    }
/**
 * Directive to confirm record delete
 */
function confirmDelete() {
        return {
            replace: true,
            templateUrl: 'app/shared/utils/template/confirmDelete.html',
            scope: {
                onConfirm: '&'
            },
            controller: confirmDeleteCtrl
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .directive('docIdValid',docIdValid);

    docIdValid.$inject = [];

    /**
     * Validate NIF/CIF/CIF format
     */
    function validateDocument(modelValue, viewValue){
      if (angular.isUndefined(viewValue)){
        return true;
      }
      var value = viewValue.toUpperCase();
      // Texto común en todos los formatos
      if (!value.match('((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)')) {
          return false;
      }

      /* Inicio validacion NIF */
      if (/^[0-9]{8}[A-Z]{1}$/.test(value)) {
          return ("TRWAGMYFPDXBNJZSQVHLCKE".charAt(value.substring(8, 0) % 23) === value.charAt(8));
      }
      //  Hay ciertos NIFs que empiezan por K, L o M
      if (/^[KLM]{1}/.test(value)) {
          return (value[8] === String.fromCharCode(64));
      }
      /* Fin validacion NIF */

      /* Inicio validacion NIE */
      if (/^[T]{1}/.test(value)) {
          return (value[8] === /^[T]{1}[A-Z0-9]{8}$/.test(value));
      }

      // Con los que empiezan por XYZ
      if (/^[XYZ]{1}/.test(value)) {
          return (
              value[8] === "TRWAGMYFPDXBNJZSQVHLCKE".charAt(
                  value.replace('X', '0')
                  .replace('Y', '1')
                  .replace('Z', '2')
                  .substring(0, 8) % 23
              )
          );
      }
      /* Fin validacion NIE */

      /* Inicio validacion CIF */
      var sum,
          num = [],
          digitoControl;


      for (var i = 0; i < 9; i++) {
          num[i] = parseInt(value.charAt(i), 10);
      }

      // Comprobamos el CIF
      sum = num[2] + num[4] + num[6];
      for (var count = 1; count < 8; count += 2) {
          var tmp = (2 * num[count]).toString(),
              tmpValor = tmp.charAt(1);

          sum += parseInt(tmp.charAt(0), 10) + (tmpValor === '' ? 0 : parseInt(tmpValor, 10));
      }

      if (/^[ABCDEFGHJNPQRSUVW]{1}/.test(value)) {
          sum += '';
          digitoControl = 10 - parseInt(sum.charAt(sum.length - 1), 10);
          value += digitoControl;
          return (num[8].toString() === String.fromCharCode(64 + digitoControl) || num[8].toString() === value.charAt(value.length - 1));
      }
      /* Fin validacion CIF */

      return false;
    }

    function docIdValidLink(scope, elem, attrs, ngModel) {
        ngModel.$validators.docValid = validateDocument;
/*        elem.on('blur', function() {
            scope.$apply(function() {
                var value = elem.val().toUpperCase();
                if (!validateDocument(value)){
                  ctrl.$setValidity('valid', false);
                }

            });
        }); */
    }

    function docIdValid() {
      return {
          require: "ngModel",
          link: docIdValidLink
      };
    }

})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .directive('docExistValid', docExistValid);

    docExistValid.$inject = ['ThirdParty', '$q'];

    /**
     * Search a third party with same document
     */
    function searchDocument(modelValue, viewValue){
        if (angular.isUndefined(viewValue)){
            return true;
        }

        ThirdParty.get({id: '/nif/' + viewValue.toUpperCase()},
            function(data) {
                return angular.isUndefined(data);
            });

        return false;
    }

    function docExistValid(ThirdParty,$q) {
        return {
            require: "ngModel",
            link: function (scope, elem, attrs, ngModel) {
                ngModel.$asyncValidators.docExist = function (modelValue, viewValue){
                    var deferred  = $q.defer();
                    $q.all([
                      ThirdParty.query({
                             nif: viewValue
                           }).$promise]
                    ).then(function(data){
                      var result = data[0];
                       if (result.length === 1) {
                         ngModel.$setValidity('docExist', true);
                         deferred.reject(false);
                       } else {
                         ngModel.$setValidity('docExist', false);
                         deferred.resolve(true);
                       }
                    });
                    return deferred.promise;
                };
            }

        };
    }

})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('StepStatus', StepStatus);

    StepStatus.$inject = ['$resource'];

    function StepStatus ($resource) {
        var resourceUrl =  'api/step-status/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Step', Step);

    Step.$inject = ['$resource'];

    function Step ($resource) {
        var resourceUrl =  'api/steps/:id';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" >{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearResultSummaryFile", LebaniegoYearResultSummaryFile);

        LebaniegoYearResultSummaryFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearResultSummaryFile($resource, DateUtils) {
        var resourceUrl = "api/ly-result-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearResultSummary",
            LebaniegoYearResultSummary
        );

        LebaniegoYearResultSummary.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearResultSummary($resource, DateUtils) {
        var resourceUrl = "api/ly-result/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearResultDonorFile", LebaniegoYearResultDonorFile);

        LebaniegoYearResultDonorFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearResultDonorFile($resource, DateUtils) {
        var resourceUrl = "api/ly-result-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearResultDonor",
            LebaniegoYearResultDonor
        );

        LebaniegoYearResultDonor.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearResultDonor($resource, DateUtils) {
        var resourceUrl = "api/ly-result/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearResultAgreementFile", LebaniegoYearResultAgreementFile);

        LebaniegoYearResultAgreementFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearResultAgreementFile($resource, DateUtils) {
        var resourceUrl = "api/ly-result-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearResultAgreement",
            LebaniegoYearResultAgreement
        );

        LebaniegoYearResultAgreement.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearResultAgreement($resource, DateUtils) {
        var resourceUrl = "api/ly-result/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearResultContributorFile", LebaniegoYearResultContributorFile);

        LebaniegoYearResultContributorFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearResultContributorFile($resource, DateUtils) {
        var resourceUrl = "api/ly-result-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearResultContributor",
            LebaniegoYearResultContributor
        );

        LebaniegoYearResultContributor.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearResultContributor($resource, DateUtils) {
        var resourceUrl = "api/ly-result/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearDonor", LebaniegoYearDonor);

    LebaniegoYearDonor.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearDonor($resource, DateUtils) {
        var resourceUrl = "api/g-donor-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.registerDate !== null) {
                                data.registerDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.registerDate
                                    );
                            }
                            if (data.notificationDate !== null) {
                                data.notificationDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.notificationDate
                                    );
                            }
                            if (data.presentationDate !== null) {
                                data.presentationDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.presentationDate
                                    );
                            }
                            if (data.sectorDate !== null) {
                                data.sectorDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.sectorDate
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (data.registerDate !== null) {
                            data.registerDate =
                                DateUtils.convertLocalDateFromServer(
                                    data.registerDate
                                );
                        }
                        if (data.notificationDate !== null) {
                            data.notificationDate =
                                DateUtils.convertLocalDateFromServer(
                                    data.notificationDate
                                );
                        }
                        if (data.presentationDate !== null) {
                            data.presentationDate =
                                DateUtils.convertLocalDateFromServer(
                                    data.presentationDate
                                );
                        }
                        if (copy.sectorDate !== null) {
                            copy.sectorDate =
                                DateUtils.convertLocalDateToServer(
                                    copy.sectorDate
                                );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            var data = angular.fromJson(data);
                            if (data.registerDate !== null) {
                                data.registerDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.registerDate
                                    );
                            }
                            if (data.notificationDate !== null) {
                                data.notificationDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.notificationDate
                                    );
                            }
                            if (data.presentationDate !== null) {
                                data.presentationDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.presentationDate
                                    );
                            }
                            if (data.sectorDate !== null) {
                                data.sectorDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.sectorDate
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (data.registerDate !== null) {
                            data.registerDate =
                                DateUtils.convertLocalDateFromServer(
                                    data.registerDate
                                );
                        }
                        if (data.notificationDate !== null) {
                            data.notificationDate =
                                DateUtils.convertLocalDateFromServer(
                                    data.notificationDate
                                );
                        }
                        if (data.presentationDate !== null) {
                            data.presentationDate =
                                DateUtils.convertLocalDateFromServer(
                                    data.presentationDate
                                );
                        }
                        if (copy.sectorDate !== null) {
                            copy.sectorDate =
                                DateUtils.convertLocalDateToServer(
                                    copy.sectorDate
                                );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            var data = angular.fromJson(data);
                            if (data.registerDate !== null) {
                                data.registerDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.registerDate
                                    );
                            }
                            if (data.notificationDate !== null) {
                                data.notificationDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.notificationDate
                                    );
                            }
                            if (data.presentationDate !== null) {
                                data.presentationDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.presentationDate
                                    );
                            }
                            if (data.sectorDate !== null) {
                                data.sectorDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.sectorDate
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearDocumentosManualFile", LebaniegoYearDocumentosManualFile);

        LebaniegoYearDocumentosManualFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearDocumentosManualFile($resource, DateUtils) {
        var resourceUrl = "api/ly-documents-manual-files/:id";
        
        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearDocumentosManual", LebaniegoYearDocumentosManual);

        LebaniegoYearDocumentosManual.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearDocumentosManual($resource, DateUtils) {
        var resourceUrl = "api/ly-documents-manual/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearDocumentosDossierFile", LebaniegoYearDocumentosDossierFile);

        LebaniegoYearDocumentosDossierFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearDocumentosDossierFile($resource, DateUtils) {
        var resourceUrl = "api/ly-documents-dossier-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearDocumentosDossier", LebaniegoYearDocumentosDossier);

        LebaniegoYearDocumentosDossier.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearDocumentosDossier($resource, DateUtils) {
        var resourceUrl = "api/ly-documents-dossier/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearDocumentosAccionFile", LebaniegoYearDocumentosAccionFile);

        LebaniegoYearDocumentosAccionFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearDocumentosAccionFile($resource, DateUtils) {
        var resourceUrl = "api/ly-documents-action-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearDocumentosAccion", LebaniegoYearDocumentosAccion);

        LebaniegoYearDocumentosAccion.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearDocumentosAccion($resource, DateUtils) {
        var resourceUrl = "api/ly-documents-action/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('AmountCsv', AmountCsv);

        AmountCsv.$inject = ['$resource'];

    function AmountCsv ($resource) {
        var resourceUrl =  'api/ly-amount-csv';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET' }
        });
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearAmount",
            LebaniegoYearAmount
        );

        LebaniegoYearAmount.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearAmount($resource) {
        var resourceUrl = "api/ly-amount/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET" },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        return data;
                    },
                }
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearAgreement", LebaniegoYearAgreement);

    LebaniegoYearAgreement.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearAgreement($resource, DateUtils) {
        var resourceUrl = "api/g-donor-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.sectorDate !== null) {
                                data.sectorDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.sectorDate
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.sectorDate !== null) {
                            copy.sectorDate =
                                DateUtils.convertLocalDateToServer(
                                    copy.sectorDate
                                );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            var data = angular.fromJson(data);
                            if (data.sectorDate !== null) {
                                data.sectorDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.sectorDate
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.sectorDate !== null) {
                            copy.sectorDate =
                                DateUtils.convertLocalDateToServer(
                                    copy.sectorDate
                                );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            var data = angular.fromJson(data);
                            if (data.sectorDate !== null) {
                                data.sectorDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.sectorDate
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearControlDonorFile", LebaniegoYearControlDonorFile);

        LebaniegoYearControlDonorFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearControlDonorFile($resource, DateUtils) {
        var resourceUrl = "api/ly-control-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearControlDonor",
            LebaniegoYearControlDonor
        );

        LebaniegoYearControlDonor.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearControlDonor($resource, DateUtils) {
        var resourceUrl = "api/ly-control/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearControlAgreementFile", LebaniegoYearControlAgreementFile);

        LebaniegoYearControlAgreementFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearControlAgreementFile($resource, DateUtils) {
        var resourceUrl = "api/ly-control-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearControlAgreement",
            LebaniegoYearControlAgreement
        );

        LebaniegoYearControlAgreement.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearControlAgreement($resource, DateUtils) {
        var resourceUrl = "api/ly-control/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearControlContributorFile", LebaniegoYearControlContributorFile);

        LebaniegoYearControlContributorFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearControlContributorFile($resource, DateUtils) {
        var resourceUrl = "api/ly-control-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearControlContributor",
            LebaniegoYearControlContributor
        );

        LebaniegoYearControlContributor.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearControlContributor($resource, DateUtils) {
        var resourceUrl = "api/ly-control/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearContactosVisita",
            LebaniegoYearContactosVisita
        );

    LebaniegoYearContactosVisita.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearContactosVisita($resource, DateUtils) {
        var resourceUrl = "api/ly-contacts-visit/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearContactosSectorSfa",
            LebaniegoYearContactosSectorSfa
        );

    LebaniegoYearContactosSectorSfa.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearContactosSectorSfa($resource, DateUtils) {
        var resourceUrl = "api/ly-contacts-sector/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearContactosSectorSbn",
            LebaniegoYearContactosSectorSbn
        );

    LebaniegoYearContactosSectorSbn.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearContactosSectorSbn($resource, DateUtils) {
        var resourceUrl = "api/ly-contacts-sector/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearContactosSectorSan",
            LebaniegoYearContactosSectorSan
        );

    LebaniegoYearContactosSectorSan.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearContactosSectorSan($resource, DateUtils) {
        var resourceUrl = "api/ly-contacts-sector/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearContactosSectorOs",
            LebaniegoYearContactosSectorOs
        );

    LebaniegoYearContactosSectorOs.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearContactosSectorOs($resource, DateUtils) {
        var resourceUrl = "api/ly-contacts-sector/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearContactosSectorEd",
            LebaniegoYearContactosSectorEd
        );

    LebaniegoYearContactosSectorEd.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearContactosSectorEd($resource, DateUtils) {
        var resourceUrl = "api/ly-contacts-sector/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearContactosSectorBac",
            LebaniegoYearContactosSectorBac
        );

    LebaniegoYearContactosSectorBac.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearContactosSectorBac($resource, DateUtils) {
        var resourceUrl = "api/ly-contacts-sector/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearContactosReunion",
            LebaniegoYearContactosReunion
        );

    LebaniegoYearContactosReunion.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearContactosReunion($resource, DateUtils) {
        var resourceUrl = "api/ly-contacts-meeting/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearComisionConvocatoriaFile", LebaniegoYearComisionConvocatoriaFile);

        LebaniegoYearComisionConvocatoriaFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearComisionConvocatoriaFile($resource, DateUtils) {
        var resourceUrl = "api/ly-comission-annoucement-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearComisionConvocatoria",
            LebaniegoYearComisionConvocatoria
        );

    LebaniegoYearComisionConvocatoria.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearComisionConvocatoria($resource, DateUtils) {
        var resourceUrl = "api/ly-comission-annoucement/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearComisionActaFile", LebaniegoYearComisionActaFile);

        LebaniegoYearComisionActaFile.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearComisionActaFile($resource, DateUtils) {
        var resourceUrl = "api/ly-comission-proceeding-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "LebaniegoYearComisionActa",
            LebaniegoYearComisionActa
        );

    LebaniegoYearComisionActa.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearComisionActa($resource, DateUtils) {
        var resourceUrl = "api/ly-comission-proceeding/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date =
                                    DateUtils.convertLocalDateFromServer(
                                        data.date
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("LebaniegoYearContributor", LebaniegoYearContributor);

    LebaniegoYearContributor.$inject = ["$resource", "DateUtils"];

    function LebaniegoYearContributor($resource, DateUtils) {
        var resourceUrl = "api/g-donor-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.sectorDate !== null) {
                                data.sectorDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.sectorDate
                                    );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.sectorDate !== null) {
                            copy.sectorDate =
                                DateUtils.convertLocalDateToServer(
                                    copy.sectorDate
                                );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            var data = angular.fromJson(data);
                            if (data.sectorDate !== null) {
                                data.sectorDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.sectorDate
                                    );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.sectorDate !== null) {
                            copy.sectorDate =
                                DateUtils.convertLocalDateToServer(
                                    copy.sectorDate
                                );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            var data = angular.fromJson(data);
                            if (data.sectorDate !== null) {
                                data.sectorDate =
                                    DateUtils.convertLocalDateFromServer(
                                        data.sectorDate
                                    );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Lawyers', Lawyers);

    Lawyers.$inject = ['$resource'];

    function Lawyers ($resource) {
        var resourceUrl =  'api/lawyers';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Jurisdiction', Jurisdiction);

    Jurisdiction.$inject = ['$resource'];

    function Jurisdiction ($resource) {
        var resourceUrl =  'api/jurisdiction';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('GFileStep', GFileStep);

    GFileStep.$inject = ['$resource', 'DateUtils'];

    function GFileStep ($resource, DateUtils) {
        var resourceUrl =  'api/g-file-steps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.date){
                          data.date = DateUtils.convertLocalDateFromServer(data.date);
                        }
                        if (data.date2){
                          data.date2 = DateUtils.convertLocalDateFromServer(data.date2);
                        }
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    if (copy.date2 !== null) {
                        copy.date2 = DateUtils.convertLocalDateToServer(copy.date2);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.date){
                          data.date = DateUtils.convertLocalDateFromServer(data.date);
                        }
                        if (data.date2){
                          data.date2 = DateUtils.convertLocalDateFromServer(data.date2);
                        }
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                  var copy = angular.copy(data);
                  if (copy.date !== null) {
                      copy.date = DateUtils.convertLocalDateToServer(copy.date);
                  }
                  if (copy.date2 !== null) {
                      copy.date2 = DateUtils.convertLocalDateToServer(copy.date2);
                  }
                  return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.date){
                          data.date = DateUtils.convertLocalDateFromServer(data.date);
                        }
                        if (data.date2){
                          data.date2 = DateUtils.convertLocalDateFromServer(data.date2);
                        }
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('GFileStatus', GFileStatus);

    GFileStatus.$inject = ['$resource'];

    function GFileStatus ($resource) {
        var resourceUrl =  'api/gfile-status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('GFileCsv', GFileCsv);

    GFileCsv.$inject = ['$resource'];

    function GFileCsv ($resource) {
        var resourceUrl =  'api/g-files-csv';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('GFileCode', GFileCode);

    GFileCode.$inject = ['$resource'];

    function GFileCode ($resource) {
        var resourceUrl =  'api/g-files-code';

        return $resource(resourceUrl, {}, {
          'get': {
              method: 'GET',
              transformResponse: function (data) {
                  if (data) {
                      data = angular.fromJson(data);
                  }
                  return data;
              }
          }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('GFileClients', GFileClients);

    GFileClients.$inject = ['$resource'];

    function GFileClients ($resource) {
        var resourceUrl =  'api/clients';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('GFile', GFile);

    GFile.$inject = ['$resource', 'DateUtils'];

    function GFile ($resource, DateUtils) {
        var resourceUrl =  'api/g-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.registerDate !== null) {
                          data.registerDate = DateUtils.convertLocalDateFromServer(data.registerDate);
                        }
                        if (data.notificationDate !== null) {
                            data.notificationDate = DateUtils.convertLocalDateFromServer(data.notificationDate);
                        }
                        if (data.presentationDate !== null) {
                            data.presentationDate = DateUtils.convertLocalDateFromServer(data.presentationDate);
                        }
                    }
                    return data;
                }
            },
            'update': { method:'PUT' ,
            transformRequest: function (data) {
              var copy = angular.copy(data);
              if (copy.registerDate !== null) {
                  copy.registerDate = DateUtils.convertLocalDateToServer(copy.registerDate);
              }
              if (copy.notificationDate !== null) {
                  copy.notificationDate = DateUtils.convertLocalDateToServer(copy.notificationDate);
              }
              if (copy.presentationDate !== null) {
                  copy.presentationDate = DateUtils.convertLocalDateToServer(copy.presentationDate);
              }
              return angular.toJson(copy);
            },
            transformResponse: function (data) {
              if (data) {
                var data = angular.fromJson(data);
                if (data.registerDate !== null) {
                  data.registerDate = DateUtils.convertLocalDateFromServer(data.registerDate);
                }
                if (data.notificationDate !== null) {
                    data.notificationDate = DateUtils.convertLocalDateFromServer(data.notificationDate);
                }
                if (data.presentationDate !== null) {
                    data.presentationDate = DateUtils.convertLocalDateFromServer(data.presentationDate);
                }
              }
              return data;
            }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                  var copy = angular.copy(data);
                  if (copy.registerDate !== null) {
                      copy.registerDate = DateUtils.convertLocalDateToServer(copy.registerDate);
                  }
                  if (copy.notificationDate !== null) {
                      copy.notificationDate = DateUtils.convertLocalDateToServer(copy.notificationDate);
                  }
                  if (copy.presentationDate !== null) {
                      copy.presentationDate = DateUtils.convertLocalDateToServer(copy.presentationDate);
                  }
                  return angular.toJson(copy);
                },
                transformResponse: function (data) {
                  if (data) {
                    var data = angular.fromJson(data);
                    if (data.registerDate !== null) {
                      data.registerDate = DateUtils.convertLocalDateFromServer(data.registerDate);
                    }
                    if (data.notificationDate !== null) {
                        data.notificationDate = DateUtils.convertLocalDateFromServer(data.notificationDate);
                    }
                    if (data.presentationDate !== null) {
                        data.presentationDate = DateUtils.convertLocalDateFromServer(data.presentationDate);
                    }
                  }
                  return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumUsers', ConsortiumUsers);

    ConsortiumUsers.$inject = ['$resource'];

    function ConsortiumUsers ($resource) {
        var resourceUrl =  'api/consortium-users';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumTributosRevisionFile', ConsortiumTributosRevisionFile);

    ConsortiumTributosRevisionFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumTributosRevisionFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-tributos-revision-files/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete': { method: 'DELETE' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumTributosRevision', ConsortiumTributosRevision);

        ConsortiumTributosRevision.$inject = ['$resource', 'DateUtils'];

    function ConsortiumTributosRevision ($resource, DateUtils) {
        var resourceUrl =  'api/consortium-tributos-revision/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.requestDate){
                          data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate) {
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.incomeDate) {
                            data.incomeDate = DateUtils.convertLocalDateFromServer(data.incomeDate);
                        }
                    }
                    return data;
                }
            },
            'update': {
                method:'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.requestDate) {
                        copy.requestDate = DateUtils.convertLocalDateToServer(copy.requestDate);
                    }
                    if (copy.resolutionDate) {
                        copy.resolutionDate = DateUtils.convertLocalDateToServer(copy.resolutionDate);
                    }
                    if (copy.incomeDate) {
                        copy.incomeDate = DateUtils.convertLocalDateToServer(copy.incomeDate);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.requestDate){
                            data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate) {
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.incomeDate) {
                            data.incomeDate = DateUtils.convertLocalDateFromServer(data.incomeDate);
                        }
                    }
                    return data;
                }  
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.requestDate) {
                        copy.requestDate = DateUtils.convertLocalDateToServer(copy.requestDate);
                    }
                    if (copy.resolutionDate) {
                        copy.resolutionDate = DateUtils.convertLocalDateToServer(copy.resolutionDate);
                    }
                    if (copy.incomeDate) {
                        copy.incomeDate = DateUtils.convertLocalDateToServer(copy.incomeDate);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.requestDate){
                            data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate) {
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.incomeDate) {
                            data.incomeDate = DateUtils.convertLocalDateFromServer(data.incomeDate);
                        }
                    }
                    return data;
                }    
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumTributosEellFile', ConsortiumTributosEellFile);

    ConsortiumTributosEellFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumTributosEellFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-tributos-eell-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { 
                method: 'GET', 
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete': { method: 'DELETE' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumTributosEell', ConsortiumTributosEell);

        ConsortiumTributosEell.$inject = ['$resource', 'DateUtils'];

    function ConsortiumTributosEell ($resource, DateUtils) {
        var resourceUrl =  'api/consortium-tributos-eell/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.paymentDate){
                          data.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                        }
                    }
                    return data;
                }
            },
            'update': { method:'PUT',
            transformRequest: function (data) {
                var copy = angular.copy(data);
                if (copy.paymentDate !== null) {
                    copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                }
                return angular.toJson(copy);
            },
            transformResponse: function (data) {
                if (data) {
                    data = angular.fromJson(data);
                    if (data.paymentDate){
                    data.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                    }
                }
                return data;
            }  
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.paymentDate !== null) {
                        copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.paymentDate){
                        data.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                        }
                    }
                    return data;
                }    
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumTributosDevolucionFile', ConsortiumTributosDevolucionFile);

    ConsortiumTributosDevolucionFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumTributosDevolucionFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-tributos-devolucion-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { 
                method: 'GET', 
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },    
            'delete': { method: 'DELETE' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumTributosDevolucion', ConsortiumTributosDevolucion);

        ConsortiumTributosDevolucion.$inject = ['$resource', 'DateUtils'];

    function ConsortiumTributosDevolucion ($resource, DateUtils) {
        var resourceUrl =  'api/consortium-tributos-devolucion/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.requestDate){
                          data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate) {
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.incomeDate) {
                            data.incomeDate = DateUtils.convertLocalDateFromServer(data.incomeDate);
                        }
                    }
                    return data;
                }
            },
            'update': {
                method:'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.requestDate) {
                        copy.requestDate = DateUtils.convertLocalDateToServer(copy.requestDate);
                    }
                    if (copy.resolutionDate) {
                        copy.resolutionDate = DateUtils.convertLocalDateToServer(copy.resolutionDate);
                    }
                    if (copy.incomeDate) {
                        copy.incomeDate = DateUtils.convertLocalDateToServer(copy.incomeDate);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.requestDate){
                            data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate) {
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.incomeDate) {
                            data.incomeDate = DateUtils.convertLocalDateFromServer(data.incomeDate);
                        }
                    }
                    return data;
                }  
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.requestDate) {
                        copy.requestDate = DateUtils.convertLocalDateToServer(copy.requestDate);
                    }
                    if (copy.resolutionDate) {
                        copy.resolutionDate = DateUtils.convertLocalDateToServer(copy.resolutionDate);
                    }
                    if (copy.incomeDate) {
                        copy.incomeDate = DateUtils.convertLocalDateToServer(copy.incomeDate);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.requestDate){
                            data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate) {
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.incomeDate) {
                            data.incomeDate = DateUtils.convertLocalDateFromServer(data.incomeDate);
                        }
                    }
                    return data;
                }    
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumTributosCcaaFile', ConsortiumTributosCcaaFile);

    ConsortiumTributosCcaaFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumTributosCcaaFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-tributos-ccaa-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { 
                method: 'GET', 
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete': { method: 'DELETE' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumTributosCcaa', ConsortiumTributosCcaa);

        ConsortiumTributosCcaa.$inject = ['$resource', 'DateUtils'];

    function ConsortiumTributosCcaa ($resource, DateUtils) {
        var resourceUrl =  'api/consortium-tributos-ccaa/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.paymentDate){
                          data.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                        }
                    }
                    return data;
                }
            },
            'update': { method:'PUT',
            transformRequest: function (data) {
                var copy = angular.copy(data);
                if (copy.paymentDate !== null) {
                    copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                }
                return angular.toJson(copy);
            },
            transformResponse: function (data) {
                if (data) {
                    data = angular.fromJson(data);
                    if (data.paymentDate){
                    data.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                    }
                }
                return data;
            }  
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.paymentDate !== null) {
                        copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.paymentDate){
                        data.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                        }
                    }
                    return data;
                }    
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumTributosAeatFile', ConsortiumTributosAeatFile);

    ConsortiumTributosAeatFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumTributosAeatFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-tributos-aeat-files/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete': { method: 'DELETE' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumTributosAeat', ConsortiumTributosAeat);

        ConsortiumTributosAeat.$inject = ['$resource', 'DateUtils'];

    function ConsortiumTributosAeat ($resource, DateUtils) {
        var resourceUrl =  'api/consortium-tributos-aeat/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' 
            },
            'save': {
                method: 'POST'   
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumPersonalSeguroFile', ConsortiumPersonalSeguroFile);

    ConsortiumPersonalSeguroFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumPersonalSeguroFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-personal-seguro-files/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete': {
                method: 'DELETE'
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumPersonalSeguro', ConsortiumPersonalSeguro);

    ConsortiumPersonalSeguro.$inject = ['$resource', 'DateUtils'];

    function ConsortiumPersonalSeguro($resource, DateUtils) {
        var resourceUrl = 'api/consortium-personal-seguros/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'update': {
                method: 'PUT'
            },
            'save': {
                method: 'POST'
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumPersonalOtraFile', ConsortiumPersonalOtraFile);

    ConsortiumPersonalOtraFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumPersonalOtraFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-personal-otra-files/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete': { method: 'DELETE' }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumPersonalOtra', ConsortiumPersonalOtra);

    ConsortiumPersonalOtra.$inject = ['$resource', 'DateUtils'];

    function ConsortiumPersonalOtra($resource, DateUtils) {
        var resourceUrl = 'api/consortium-personal-otras/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.date) {
                            data.date = DateUtils.convertLocalDateFromServer(data.date);
                        }
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.date) {
                            data.date = DateUtils.convertLocalDateFromServer(data.date);
                        }
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.date) {
                            data.date = DateUtils.convertLocalDateFromServer(data.date);
                        }
                    }
                    return data;
                }
            }
        });
    }
})();
(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumPersonalNominaFile', ConsortiumPersonalNominaFile);

    ConsortiumPersonalNominaFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumPersonalNominaFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-personal-nomina-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { 
                method: 'GET', 
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete': { method: 'DELETE' }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumPersonalNomina', ConsortiumPersonalNomina);

    ConsortiumPersonalNomina.$inject = ['$resource', 'DateUtils'];

    function ConsortiumPersonalNomina($resource, DateUtils) {
        var resourceUrl = 'api/consortium-personal-nominas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET'
            },
            'update': {
                method: 'PUT'
            },
            'save': {
                method: 'POST'
            }
        });
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "ConsortiumPersonalContratoFile",
            ConsortiumPersonalContratoFile
        );

    ConsortiumPersonalContratoFile.$inject = ["$resource", "DateUtils"];

    function ConsortiumPersonalContratoFile($resource, DateUtils) {
        var resourceUrl = "api/consortium-personal-contrato-files/:id";

        return $resource(
            resourceUrl, {}, {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: {
                    method: "DELETE"
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("ConsortiumPersonalContrato", ConsortiumPersonalContrato);

    ConsortiumPersonalContrato.$inject = ["$resource", "DateUtils"];

    function ConsortiumPersonalContrato($resource, DateUtils) {
        var resourceUrl = "api/consortium-personal-contratos/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("ConsortiumFinancieraFile", ConsortiumFinancieraFile);

    ConsortiumFinancieraFile.$inject = ["$resource", "DateUtils"];

    function ConsortiumFinancieraFile($resource, DateUtils) {
        var resourceUrl = "api/consortium-financiera-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("ConsortiumFinanciera", ConsortiumFinanciera);

    ConsortiumFinanciera.$inject = ["$resource", "DateUtils"];

    function ConsortiumFinanciera($resource, DateUtils) {
        var resourceUrl = "api/consortium-financiera/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumExpediente', ConsortiumExpediente);

    ConsortiumExpediente.$inject = ['$resource', 'DateUtils'];

    function ConsortiumExpediente ($resource, DateUtils) {
        var resourceUrl =  'api/consortium-expedientes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.registerDate !== null) {
                          data.registerDate = DateUtils.convertLocalDateFromServer(data.registerDate);
                        }
                        if (data.notificationDate !== null) {
                            data.notificationDate = DateUtils.convertLocalDateFromServer(data.notificationDate);
                        }
                        if (data.presentationDate !== null) {
                            data.presentationDate = DateUtils.convertLocalDateFromServer(data.presentationDate);
                        }
                    }
                    return data;
                }
            },
            'update': { method:'PUT' ,
            transformRequest: function (data) {
              var copy = angular.copy(data);
              if (copy.registerDate !== null) {
                  copy.registerDate = DateUtils.convertLocalDateToServer(copy.registerDate);
              }
              if (copy.notificationDate !== null) {
                  copy.notificationDate = DateUtils.convertLocalDateToServer(copy.notificationDate);
              }
              if (copy.presentationDate !== null) {
                  copy.presentationDate = DateUtils.convertLocalDateToServer(copy.presentationDate);
              }
              return angular.toJson(copy);
            },
            transformResponse: function (data) {
              if (data) {
                var data = angular.fromJson(data);
                if (data.registerDate !== null) {
                  data.registerDate = DateUtils.convertLocalDateFromServer(data.registerDate);
                }
                if (data.notificationDate !== null) {
                    data.notificationDate = DateUtils.convertLocalDateFromServer(data.notificationDate);
                }
                if (data.presentationDate !== null) {
                    data.presentationDate = DateUtils.convertLocalDateFromServer(data.presentationDate);
                }
              }
              return data;
            }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                  var copy = angular.copy(data);
                  if (copy.registerDate !== null) {
                      copy.registerDate = DateUtils.convertLocalDateToServer(copy.registerDate);
                  }
                  if (copy.notificationDate !== null) {
                      copy.notificationDate = DateUtils.convertLocalDateToServer(copy.notificationDate);
                  }
                  if (copy.presentationDate !== null) {
                      copy.presentationDate = DateUtils.convertLocalDateToServer(copy.presentationDate);
                  }
                  return angular.toJson(copy);
                },
                transformResponse: function (data) {
                  if (data) {
                    var data = angular.fromJson(data);
                    if (data.registerDate !== null) {
                      data.registerDate = DateUtils.convertLocalDateFromServer(data.registerDate);
                    }
                    if (data.notificationDate !== null) {
                        data.notificationDate = DateUtils.convertLocalDateFromServer(data.notificationDate);
                    }
                    if (data.presentationDate !== null) {
                        data.presentationDate = DateUtils.convertLocalDateFromServer(data.presentationDate);
                    }
                  }
                  return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumExpedienteJuridicoJudicialFile', ConsortiumExpedienteJuridicoJudicialFile);

    ConsortiumExpedienteJuridicoJudicialFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumExpedienteJuridicoJudicialFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-expediente-juridico-judicial-files/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete': {
                method: 'DELETE'
            }
        });
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("ConsortiumExpedienteJuridicoJudicial", ConsortiumExpedienteJuridicoJudicial);

    ConsortiumExpedienteJuridicoJudicial.$inject = ["$resource", "DateUtils"];

    function ConsortiumExpedienteJuridicoJudicial($resource, DateUtils) {
        var resourceUrl = "api/consortium-expediente-juridicos-judiciales/:id";

        return $resource(
            resourceUrl, {}, {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "ConsortiumExpedienteJuridicoInformeFile",
            ConsortiumExpedienteJuridicoInformeFile
        );

    ConsortiumExpedienteJuridicoInformeFile.$inject = ["$resource", "DateUtils"];

    function ConsortiumExpedienteJuridicoInformeFile($resource, DateUtils) {
        var resourceUrl = "api/consortium-expediente-juridico-informe-files/:id";

        return $resource(
            resourceUrl, {}, {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: {
                    method: "DELETE"
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("ConsortiumExpedienteJuridicoInforme", ConsortiumExpedienteJuridicoInforme);

    ConsortiumExpedienteJuridicoInforme.$inject = ["$resource", "DateUtils"];

    function ConsortiumExpedienteJuridicoInforme($resource, DateUtils) {
        var resourceUrl = "api/consortium-expediente-juridicos-informes/:id";

        return $resource(
            resourceUrl, {}, {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumExpedienteExpropiacionFile', ConsortiumExpedienteExpropiacionFile);

    ConsortiumExpedienteExpropiacionFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumExpedienteExpropiacionFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-expediente-expropiacion-files/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete': {
                method: 'DELETE'
            }
        });
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "ConsortiumExpedienteExpropiacion",
            ConsortiumExpedienteExpropiacion
        );

    ConsortiumExpedienteExpropiacion.$inject = ["$resource", "DateUtils"];

    function ConsortiumExpedienteExpropiacion($resource, DateUtils) {
        var resourceUrl = "api/consortium-expediente-expropiacion/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                            if (data.fairPriceDate) {
                                data.fairPriceDate = DateUtils.convertLocalDateFromServer(
                                    data.fairPriceDate
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        if (copy.fairPriceDate !== null) {
                            copy.fairPriceDate = DateUtils.convertLocalDateToServer(
                                copy.fairPriceDate
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                            if (data.fairPriceDate) {
                                data.fairPriceDate = DateUtils.convertLocalDateFromServer(
                                    data.fairPriceDate
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        if (copy.fairPriceDate !== null) {
                            copy.fairPriceDate = DateUtils.convertLocalDateToServer(
                                copy.fairPriceDate
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                            if (data.fairPriceDate) {
                                data.fairPriceDate = DateUtils.convertLocalDateFromServer(
                                    data.fairPriceDate
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("ConsortiumContratoFile", ConsortiumContratoFile);

    ConsortiumContratoFile.$inject = ["$resource", "DateUtils"];

    function ConsortiumContratoFile($resource, DateUtils) {
        var resourceUrl = "api/consortium-contrato-files/:id";

        return $resource(
            resourceUrl, {}, {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: {
                    method: "DELETE"
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("ConsortiumContrato", ConsortiumContrato);

    ConsortiumContrato.$inject = ["$resource", "DateUtils"];

    function ConsortiumContrato($resource, DateUtils) {
        var resourceUrl = "api/consortium-contrato/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumContabilidadRecibidaFile', ConsortiumContabilidadRecibidaFile);

    ConsortiumContabilidadRecibidaFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumContabilidadRecibidaFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-contabilidad-recibida-files/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete': { method: 'DELETE' }
        });
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "ConsortiumContabilidadRecibida",
            ConsortiumContabilidadRecibida
        );

    ConsortiumContabilidadRecibida.$inject = ["$resource", "DateUtils"];

    function ConsortiumContabilidadRecibida($resource, DateUtils) {
        var resourceUrl = "api/consortium-contabilidad-recibidas/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.invoiceDate) {
                                data.invoiceDate = DateUtils.convertLocalDateFromServer(
                                    data.invoiceDate
                                );
                            }
                            if (data.payDate) {
                                data.payDate = DateUtils.convertLocalDateFromServer(
                                    data.payDate
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.invoiceDate !== null) {
                            copy.invoiceDate = DateUtils.convertLocalDateToServer(
                                copy.invoiceDate
                            );
                        }
                        if (copy.payDate !== null) {
                            copy.payDate = DateUtils.convertLocalDateToServer(
                                copy.payDate
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.invoiceDate) {
                                data.invoiceDate = DateUtils.convertLocalDateFromServer(
                                    data.invoiceDate
                                );
                            }
                            if (data.payDate) {
                                data.payDate = DateUtils.convertLocalDateFromServer(
                                    data.payDate
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.invoiceDate !== null) {
                            copy.invoiceDate = DateUtils.convertLocalDateToServer(
                                copy.invoiceDate
                            );
                        }
                        if (copy.payDate !== null) {
                            copy.payDate = DateUtils.convertLocalDateToServer(
                                copy.payDate
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.invoiceDate) {
                                data.invoiceDate = DateUtils.convertLocalDateFromServer(
                                    data.invoiceDate
                                );
                            }
                            if (data.payDate) {
                                data.payDate = DateUtils.convertLocalDateFromServer(
                                    data.payDate
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumContabilidadEmitidaFile', ConsortiumContabilidadEmitidaFile);

    ConsortiumContabilidadEmitidaFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumContabilidadEmitidaFile($resource, DateUtils) {
        var resourceUrl = 'api/consortium-contabilidad-emitida-files/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete': { method: 'DELETE' }
        });
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory(
            "ConsortiumContabilidadEmitida",
            ConsortiumContabilidadEmitida
        );

    ConsortiumContabilidadEmitida.$inject = ["$resource", "DateUtils"];

    function ConsortiumContabilidadEmitida($resource, DateUtils) {
        var resourceUrl = "api/consortium-contabilidad-emitidas/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.invoiceDate) {
                                data.invoiceDate = DateUtils.convertLocalDateFromServer(
                                    data.invoiceDate
                                );
                            }
                            if (data.receiveDate) {
                                data.receiveDate = DateUtils.convertLocalDateFromServer(
                                    data.receiveDate
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.invoiceDate !== null) {
                            copy.invoiceDate = DateUtils.convertLocalDateToServer(
                                copy.invoiceDate
                            );
                        }
                        if (copy.receiveDate !== null) {
                            copy.receiveDate = DateUtils.convertLocalDateToServer(
                                copy.receiveDate
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.invoiceDate) {
                                data.invoiceDate = DateUtils.convertLocalDateFromServer(
                                    data.invoiceDate
                                );
                            }
                            if (data.receiveDate) {
                                data.receiveDate = DateUtils.convertLocalDateFromServer(
                                    data.receiveDate
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.invoiceDate !== null) {
                            copy.invoiceDate = DateUtils.convertLocalDateToServer(
                                copy.invoiceDate
                            );
                        }
                        if (copy.receiveDate !== null) {
                            copy.receiveDate = DateUtils.convertLocalDateToServer(
                                copy.receiveDate
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.invoiceDate) {
                                data.invoiceDate = DateUtils.convertLocalDateFromServer(
                                    data.invoiceDate
                                );
                            }
                            if (data.receiveDate) {
                                data.receiveDate = DateUtils.convertLocalDateFromServer(
                                    data.receiveDate
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumContabilidadAnualFile', ConsortiumContabilidadAnualFile);

        ConsortiumContabilidadAnualFile.$inject = ['$resource', 'DateUtils'];

    function ConsortiumContabilidadAnualFile ($resource, DateUtils) {
        var resourceUrl =  'api/consortium-contabilidad-anual-files/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(document => {
                            if (document.date) {
                                document.date = DateUtils.convertLocalDateFromServer(document.date);
                            }
                        })
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if(copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                }
            },
            'delete':{ method:'DELETE'}
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumContabilidadAnual', ConsortiumContabilidadAnual);

    ConsortiumContabilidadAnual.$inject = ['$resource', 'DateUtils'];

    function ConsortiumContabilidadAnual($resource, DateUtils) {
        var resourceUrl = 'api/consortium-contabilidad-anuales/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.date) {
                            data.date = DateUtils.convertLocalDateFromServer(data.date);
                        }
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.date) {
                            data.date = DateUtils.convertLocalDateFromServer(data.date);
                        }
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date !== null) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.date) {
                            data.date = DateUtils.convertLocalDateFromServer(data.date);
                        }
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("ConsortiumCeaFile", ConsortiumCeaFile);

    ConsortiumCeaFile.$inject = ["$resource", "DateUtils"];

    function ConsortiumCeaFile($resource, DateUtils) {
        var resourceUrl = "api/consortium-cea-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("ConsortiumCea", ConsortiumCea);

    ConsortiumCea.$inject = ["$resource", "DateUtils"];

    function ConsortiumCea($resource, DateUtils) {
        var resourceUrl = "api/consortium-cea/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("ConsortiumAuditoriaFile", ConsortiumAuditoriaFile);

    ConsortiumAuditoriaFile.$inject = ["$resource", "DateUtils"];

    function ConsortiumAuditoriaFile($resource, DateUtils) {
        var resourceUrl = "api/consortium-auditoria-files/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.forEach((document) => {
                                if (document.date) {
                                    document.date = DateUtils.convertLocalDateFromServer(
                                        document.date
                                    );
                                }
                            });
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                },
                delete: { method: "DELETE" },
            }
        );
    }
})();

(function () {
    "use strict";
    angular
        .module("expedientesUriarteApp")
        .factory("ConsortiumAuditoria", ConsortiumAuditoria);

    ConsortiumAuditoria.$inject = ["$resource", "DateUtils"];

    function ConsortiumAuditoria($resource, DateUtils) {
        var resourceUrl = "api/consortium-auditoria/:id";

        return $resource(
            resourceUrl,
            {},
            {
                query: { method: "GET", isArray: true },
                get: {
                    method: "GET",
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                update: {
                    method: "PUT",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
                save: {
                    method: "POST",
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        if (copy.date !== null) {
                            copy.date = DateUtils.convertLocalDateToServer(
                                copy.date
                            );
                        }
                        return angular.toJson(copy);
                    },
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            if (data.date) {
                                data.date = DateUtils.convertLocalDateFromServer(
                                    data.date
                                );
                            }
                        }
                        return data;
                    },
                },
            }
        );
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);
                        $state.go('login');
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('AdviceQueryType', AdviceQueryType);

    AdviceQueryType.$inject = ['$resource'];

    function AdviceQueryType ($resource) {
        var resourceUrl =  'api/advice-query-types';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('AdviceDocument', AdviceDocument);

    AdviceDocument.$inject = ['$resource', 'DateUtils', 'Advice'];

    function AdviceDocument ($resource, DateUtils, Advice) {
        var resourceUrl =  'api/advice-documents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }

                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('AdviceCsv', AdviceCsv);

    AdviceCsv.$inject = ['$resource'];

    function AdviceCsv ($resource) {
        var resourceUrl =  'api/advices-csv';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Advice', Advice);

    Advice.$inject = ['$resource', 'DateUtils'];

    function Advice ($resource, DateUtils) {
        var resourceUrl =  'api/advices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.requestDate){
                            data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate){
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.issueDate){
                            data.issueDate = DateUtils.convertLocalDateFromServer(data.issueDate);
                        }
                    }
                    return data;
                }
            },
            'update': {
                method:'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.requestDate !== null) {
                        copy.requestDate = DateUtils.convertLocalDateToServer(copy.requestDate);
                    }
                    if (copy.resolutionDate !== null) {
                        copy.resolutionDate = DateUtils.convertLocalDateToServer(copy.resolutionDate);
                    }
                    if (copy.issueDate !== null) {
                        copy.issueDate = DateUtils.convertLocalDateToServer(copy.issueDate);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        if (data.requestDate){
                            data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate){
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.issueDate){
                            data.issueDate = DateUtils.convertLocalDateFromServer(data.issueDate);
                        }
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.requestDate !== null) {
                        copy.requestDate = DateUtils.convertLocalDateToServer(copy.requestDate);
                    }
                    if (copy.resolutionDate !== null) {
                        copy.resolutionDate = DateUtils.convertLocalDateToServer(copy.resolutionDate);
                    }
                    if (copy.issueDate !== null) {
                        copy.issueDate = DateUtils.convertLocalDateToServer(copy.issueDate);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.requestDate){
                            data.requestDate = DateUtils.convertLocalDateFromServer(data.requestDate);
                        }
                        if (data.resolutionDate){
                            data.resolutionDate = DateUtils.convertLocalDateFromServer(data.resolutionDate);
                        }
                        if (data.issueDate !== null) {
                            data.issueDate = DateUtils.convertLocalDateFromServer(data.issueDate);
                        }
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('AdviceStatus', AdviceStatus);

    AdviceStatus.$inject = ['$resource'];

    function AdviceStatus ($resource) {
        var resourceUrl =  'api/advice-status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('SidebarController', SidebarController);

    SidebarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', '$mdSidenav'];

    function SidebarController ($state, Auth, Principal, ProfileService, $mdSidenav) {
        var vm = this;
        Principal.identity().then(function(account) {
            vm.account = account;
        });
        vm.toggleNavigation = function() {
           $mdSidenav('navigation-drawer').toggle();
         };

        vm.dropdownMenu = function(index){
         if (vm.expandMenu !== index) {
             vm.expandMenu = index;
         }
         else {
             vm.expandMenu = -1;
         }
         vm.expandSubMenu = -1;
     };
     vm.dropdownSubMenu = function(index){
         if (vm.expandSubMenu !== index) {
          vm.expandSubMenu = index;
         }
         else {
             vm.expandSubMenu = -1;
         }
     };
     vm.showSubMenu = function(index){
         return vm.expandSubMenu === index;
     };
     vm.showMenu = function(index){
         return vm.expandMenu === index;
     };
     vm.logout = function logout() {
         Auth.logout();
         $state.go('login');
     }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService','$rootScope','$mdSidenav'];

    function NavbarController($state, Auth, Principal, ProfileService, LoginService, $rootScope,$mdSidenav) {
        var vm = this;
        $rootScope.sidebarToogled = false;
        vm.changeSidebar = function() {
            $rootScope.sidebarToogled = !$rootScope.sidebarToogled;
        };
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        Principal.identity().then(function(account) {
            vm.account = account;
        });
        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        vm.toggleSidenav = buildToggler('left');

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
            });
          };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            ncyBreadcrumb: {
                label: 'Inicio'
            },
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_CLIENT','ROLE_CONSORTIUM', 'ROLE_JUBILAR']
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                graphData: ['$stateParams', 'Graph', function ($stateParams, Graph) {
                    return Graph.get({
                        type: "data"
                    }).$promise;
                }],
                graphGFileTypeMonth: ['$stateParams', 'Graph', function ($stateParams, Graph) {
                    return Graph.get({
                        type: "gfile-type",
                        unit: "month"
                    }).$promise;
                }],
                graphGFileTypeYear: ['$stateParams', 'Graph', function ($stateParams, Graph) {
                    return Graph.get({
                        type: "gfile-type",
                        unit: "anual"
                    }).$promise;
                }],
                graphGFileDate: ['$stateParams', 'Graph', function ($stateParams, Graph) {
                    return Graph.get({
                        type: "gfile-date"
                    }).$promise;
                }],
                graphGFileStep: ['$stateParams', 'Graph', function ($stateParams, Graph) {
                    return Graph.get({
                        type: "gfile-step"
                    }).$promise;
                }],
                graphNotificationGroupDate: ['$stateParams', 'Graph', function ($stateParams, Graph) {
                    return Graph.get({
                        type: "notification-groupdate"
                    }).$promise;
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', 'graphData', 'graphGFileTypeMonth', 'graphGFileTypeYear', 'graphGFileDate', 'graphGFileStep', 'graphNotificationGroupDate', '$state', '$mdSidenav'];

    function HomeController($scope, Principal, LoginService, graphData, graphGFileTypeMonth, graphGFileTypeYear, graphGFileDate, graphGFileStep, graphNotificationGroupDate, $state, $mdSidenav) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.isAdmin = null;
        vm.isClient = null;
        vm.isConsortium = null;
        vm.isJubilar = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                for (var i = 0; i < account.authorities.length; i++) {
                    if (account.authorities[i] === "ROLE_ADMIN") {
                        vm.isAdmin = true;
                    } else if (account.authorities[i] === "ROLE_CLIENT") {
                        vm.isClient = true;
                    } else if (account.authorities[i] === "ROLE_CONSORTIUM") {
                        vm.isConsortium = true;
                    } else if (account.authorities[i] === "ROLE_JUBILAR") {
                        vm.isJubilar = true;
                    }
                }
            });
        }

        function register() {
            $state.go('register');
        }

        vm.colors = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];

        vm.options = {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            legend: {
                display: true,
                position: "bottom"
            }
        };

        vm.pieOptions = {
            legend: {
                display: true,
                position: "bottom"
            }
        };

        vm.numGFiles = graphData.numGFiles;
        vm.numActiveGFiles = graphData.numActiveGFiles;
        vm.numCivilGFiles = graphData.numCivilGFiles;
        vm.numCivilActiveGFiles = graphData.numCivilActiveGFiles;
        vm.numMercantilGFiles = graphData.numMercantilGFiles;
        vm.numMercantilActiveGFiles = graphData.numMercantilActiveGFiles;
        vm.numContenciosoGFiles = graphData.numContenciosoGFiles;
        vm.numContenciosoActiveGFiles = graphData.numContenciosoActiveGFiles;
        vm.numPenalGFiles = graphData.numPenalGFiles;
        vm.numPenalActiveGFiles = graphData.numPenalActiveGFiles;
        vm.numLaboralGFiles = graphData.numLaboralGFiles;
        vm.numLaboralActiveGFiles = graphData.numLaboralActiveGFiles;
        vm.numPendingNotifications = graphData.numPendingNotifications;
        vm.numTotalAdvices = graphData.numAdvices;
        vm.numActiveAdvices = graphData.numActiveAdvices;
        vm.numTotalReports = graphData.numReports;
        vm.numActiveReports = graphData.numActiveReports;
        vm.numExpiredTasks = graphData.numExpiredTasks;
        vm.numExpiredTasksSoon = graphData.numExpiredTasksSoon;

        vm.numTotalCExpedientes = graphData.numTotalCExpedientes;
        vm.numActiveCExpedientes = graphData.numActiveCExpedientes;

        vm.numDonantesJubilar = graphData.numDonantesJubilar;
        vm.numAportantesJubilar = graphData.numAportantesJubilar;
        vm.numConveniosJubilar = graphData.numConveniosJubilar;

        vm.gfiletypeMonth = {};
        vm.gfiletypeMonth.label = graphGFileTypeMonth.label;
        vm.gfiletypeMonth.series = graphGFileTypeMonth.series;
        vm.gfiletypeMonth.data = graphGFileTypeMonth.values;

        vm.gfiletypeYear = {};
        vm.gfiletypeYear.label = graphGFileTypeYear.label;
        vm.gfiletypeYear.series = graphGFileTypeYear.series;
        vm.gfiletypeYear.data = graphGFileTypeYear.values;

        vm.gfileDate = {};
        vm.gfileDate.label = graphGFileDate.label;
        vm.gfileDate.series = graphGFileDate.series;
        vm.gfileDate.data = graphGFileDate.values;

        vm.gfileStep = {};
        vm.gfileStep.label = graphGFileStep.label;
        vm.gfileStep.data = graphGFileStep.pieValues;

        vm.notificationDate = {};
        vm.notificationDate.label = graphNotificationGroupDate.label;
        vm.notificationDate.series = graphNotificationGroupDate.series;
        vm.notificationDate.data = graphNotificationGroupDate.values;
        vm.toggleSidenav = buildToggler('left');
        vm.onClick = function (points, evt) {
            console.log(points, evt);
        };

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Graph', Graph);

    Graph.$inject = ['$resource'];

    function Graph($resource) {
        var resourceUrl = 'api/graph-:type';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('task-panel', {
                parent: 'entity',
                url: '/task-panel?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'TaskPanel'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/task-panel/task-panel.html',
                        controller: 'TaskPanelController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Tareas'
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('TaskPanel', TaskPanel);

    TaskPanel.$inject = ['$resource'];

    function TaskPanel ($resource) {
        var resourceUrl =  'api/observations/panel-tasks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('TaskPanelController', TaskPanelController);

    TaskPanelController.$inject = ['$state', 'TaskPanel', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$mdSidenav'];

    function TaskPanelController($state, TaskPanel, ParseLinks, AlertService, paginationConstants, pagingParams, $mdSidenav) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.checkTask = checkTask;

        vm.searchItem = {};

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.untilDate = "3";
        vm.toggleSidenav = buildToggler('left');

        vm.untilDates = [
          {label: "Próximos 3 días", value: "3"},
          {label: "Próxima semana", value: "7"},
          {label: "Próximas 2 semanas", value: "14"},
          {label: "Próximo mes", value: "30"}
        ];

        searchExp();

        function searchExp() {
            TaskPanel.query({
                untilDate: vm.untilDate,
                search: null,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taskPanel = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function checkTask(taskDto) {
            var task = Object.assign({}, taskDto);
            TaskPanel.update(task);
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('tasks', {
            bindings: {
                entitytype: '<',
                entityid: '<'
            },
            templateUrl: 'app/entities/task/tasks-component.html',
            controller: ['$timeout', '$rootScope', '$scope', 'Task', '$q', 'toastr',
                function($timeout, $rootScope, $scope, Task, $q, toastr) {
                    var $ctrl = this;
                    $ctrl.saved = false;

                    $ctrl.onEdit = false;
                    $ctrl.editTask = {};
                    $ctrl.editCancel = editCancel;
                    $ctrl.editUpdate = editUpdate;
                    $ctrl.modifyTask = modifyTask;
                    $ctrl.editDelete = editDelete;

                    $ctrl.onNew = false;
                    $ctrl.newCancel = newCancel;
                    $ctrl.newSave = newSave;
                    $ctrl.newTask = {};
                    $ctrl.tasks = {};
                    $ctrl.$onInit = onInit;

                    $ctrl.$onChanges = function(changes) {
                        retrieveTasks();
                    };

                    function onInit() {
                        retrieveTasks();
                        $ctrl.onEdit = false;
                    }

                    function newCancel() {
                        $ctrl.onNew = false;
                        $ctrl.newTask = {};
                    }

                    function newSave() {
                        Task.save($ctrl.newTask, onNewSaveSucess, onNewSaveError);
                    }

                    function onNewSaveSucess(data) {
                        $ctrl.onNew = false;
                        toastr.success('Tarea creada con éxito!');
                        $ctrl.newTask = {};
                        retrieveTasks();
                    }

                    function onNewSaveError() {
                        toastr.error('Error al crear la tarea!');
                    }

                    function modifyTask(task) {
                        if(!task.done){
                          Task.get({
                              id: task.id
                          }, onEditTaskSuccess, onEditTaskError);
                        }
                    }

                    function onEditTaskSuccess(data) {
                        $ctrl.onEdit = true;
                        $ctrl.editTask = data;
                        if ($ctrl.editTask.reminderDate !== null) {
                            $ctrl.editTask.reminderDate = new Date($ctrl.editTask.reminderDate);
                        }
                        $ctrl.editTask.registerDate = new Date($ctrl.editTask.registerDate);
                    }

                    function onEditTaskError() {
                    }

                    function editDelete() {
                        Task.delete($ctrl.editTask, onEditDeleteSucess, onEditDeleteError);
                    }

                    function onEditDeleteSucess(data) {
                        $ctrl.onEdit = false;
                        toastr.success('Tarea eliminada con éxito!');
                        $ctrl.editTask = {};
                        retrieveTasks();
                    }

                    function onEditDeleteError() {
                        toastr.error('Error al eliminar la tarea!');
                    }

                    function editCancel() {
                        $ctrl.onEdit = false;
                    }

                    function editUpdate() {
                        $ctrl.onEdit = false;
                        Task.update($ctrl.editTask, onEditUpdateSucess, onEditUpdateError);
                    }

                    function onEditUpdateSucess(data) {
                        $ctrl.onEdit = false;
                        toastr.success('Tarea actualizada con éxito!');
                        $ctrl.editTask = {};
                        retrieveTasks();
                    }

                    function onEditUpdateError() {
                        toastr.error('Error al actualizar la tarea!');
                    }


                    function retrieveTasks() {
                        $q.all([
                                Task.query({
                                    entityType: $ctrl.entitytype,
                                    entityId: $ctrl.entityid,
                                    type: 'TASK'
                                }).$promise
                            ])
                            .then(function(data) {
                                $ctrl.tasks = buildGridModel(data[0]);
                            });
                    }

                    function buildGridModel(tasks) {
                        var it, results = [];

                        for (var j = 0; j < tasks.length; j++) {

                            it = angular.extend({}, tasks[j]);
                            it.span = {
                                row: 1,
                                col: 1
                            };

                            switch (j + 1) {
                                case 1:
                                    it.background = "red";
                                    it.span.row = it.span.col = 2;
                                    break;

                                case 2:
                                    it.background = "green";
                                    break;
                                case 3:
                                    it.background = "darkBlue";
                                    break;
                                case 4:
                                    it.background = "blue";
                                    it.span.col = 2;
                                    break;

                                case 5:
                                    it.background = "yellow";
                                    it.span.row = it.span.col = 2;
                                    break;

                                case 6:
                                    it.background = "pink";
                                    break;
                                case 7:
                                    it.background = "darkBlue";
                                    break;
                                case 8:
                                    it.background = "purple";
                                    break;
                                case 9:
                                    it.background = "deepBlue";
                                    break;
                                case 10:
                                    it.background = "lightPurple";
                                    break;
                                default:
                                    it.background = "white";
                                    break;
                            }

                            if(tasks[j].done){
                              it.background = "done";
                            }

                            results.push(it);
                        }
                        return results;
                    }

                }
            ]
        });
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Task', Task);

    Task.$inject = ['$resource', 'DateUtils'];

    function Task ($resource, DateUtils) {
        var resourceUrl =  'api/observations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.registerDate = DateUtils.convertLocalDateFromServer(data.registerDate);
                        if (data.reminderDate){
                            data.reminderDate = DateUtils.convertLocalDateFromServer(data.reminderDate);
                        }
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.registerDate = DateUtils.convertLocalDateToServer(copy.registerDate);
                    if (copy.reminderDate){
                        copy.reminderDate = DateUtils.convertLocalDateToServer(copy.reminderDate);
                    }
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.registerDate = DateUtils.convertLocalDateToServer(copy.registerDate);
                    if (copy.reminderDate){
                        copy.reminderDate = DateUtils.convertLocalDateToServer(copy.reminderDate);
                    }
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('newTask', {
            bindings: {
                newTask: '<',
                entitytype: '<',
                entityid: '<',
                onNew: '<',
                cancel: '&',
                save: '&'
            },
            templateUrl: 'app/entities/task/new-task-component.html',
            controller: ['$timeout',
                function($timeout) {
                    var $ctrl = this;

                    $ctrl.onCancel = onCancel;
                    $ctrl.onSave = onSave;
                    $ctrl.initNew = initNew;

                    $timeout(function() {
                        angular.element('#description').focus();
                    });

                    function initNew() {
                        $ctrl.onNew = true;
                        $ctrl.newTask.entityType = $ctrl.entitytype;
                        $ctrl.newTask.entityId = $ctrl.entityid;
                        $ctrl.newTask.type = "TASK";
                        $ctrl.newTask.reminderDate = null;
                        $ctrl.newTask.done = false;
                    }

                    function onCancel() {
                        $ctrl.onNew = false;
                        $ctrl.cancel();
                    }

                    function onSave() {
                        $ctrl.onNew = false;
                        $ctrl.save();
                    }
                }
            ]
        });
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('editTask', {
            bindings: {
                editTask: '<',
                cancel: '&',
                update: '&',
                delete: '&'
            },
            templateUrl: 'app/entities/task/edit-task-component.html',
            controller: ['$timeout',
                function($timeout) {
                    var $ctrl = this;

                    $ctrl.onCancel = onCancel;
                    $ctrl.onUpdate = onUpdate;
                    $ctrl.onDelete = onDelete;

                    $timeout(function() {
                        angular.element('#description').focus();
                    });

                    function onUpdate() {
                        $ctrl.update();
                    }

                    function onCancel() {
                        $ctrl.cancel();
                    }

                    function onDelete() {
                        $ctrl.delete();
                    }
                }
            ]
        });
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('StepNode', StepNode);

    StepNode.$inject = ['$resource'];

    function StepNode ($resource) {
        var resourceUrl =  'api/steps-tree';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('step', {
                parent: 'entity',
                url: '/step?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Steps'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/step/steps.html',
                        controller: 'StepController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    jurisdictions: ['$stateParams', 'Jurisdiction', function($stateParams, Jurisdiction) {
                        return Jurisdiction.query().$promise;
                    }]
                }
            })
            .state('step-detail', {
                parent: 'entity',
                url: '/step/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Step'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/step/step-detail.html',
                        controller: 'StepDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Step', function($stateParams, Step) {
                        return Step.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'step',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('step-detail.edit', {
                parent: 'step-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/step/step-dialog.html',
                        controller: 'StepDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Step', function(Step) {
                                return Step.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('file-type.step-new', {
                parent: 'file-type',
                url: '/{fileTypeId}/step/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/step/step-dialog.html',
                        controller: 'StepDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    duration: null,
                                    id: null
                                };
                            },
                            entityfile: ['FileType','$stateParams', function(FileType,$stateParams) {
                                return FileType.get({id : $stateParams.id}).$promise;
                                //return FileType.get({id : 1}).$promise;
                            }]
                        }
                    }).result.then(
                        function() {
                            $state.go('file-type-detail', {id: $stateParams.fileTypeId});
                        }, function() {
                            $state.go('file-type');
                        });
                }]
            })
            .state('step.edit', {
                parent: 'step',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/step/step-dialog.html',
                        controller: 'StepDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Step', function(Step) {
                                return Step.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('step', null, { reload: 'step' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('step.delete', {
                parent: 'step',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/step/step-delete-dialog.html',
                        controller: 'StepDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Step', function(Step) {
                                return Step.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('step', null, { reload: 'step' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('StepController', StepController);

    StepController.$inject = ["$scope", "Step", "StepNode", "jurisdictions", "$mdSidenav"];

    function StepController($scope, Step, StepNode, jurisdictions, $mdSidenav) {
        var vm = this;
        vm.changeJurisdiction = changeJurisdiction;
        vm.openNewStepForm = openNewStepForm;
        vm.editStep = edit_step;
        vm.toggleSidenav = buildToggler('left');

        if (angular.isUndefined(vm.searchItem)) {
            vm.searchItem = {};
            vm.searchItem.jurisdiction = "CIVIL";
            changeJurisdiction();
        }

        vm.jurisdictions = jurisdictions;
        vm.nodes = [];

        vm.newstepform = false;
        vm.editstepform = false;
        vm.updatetree = false;

        $scope.$watch('vm.updatetree', function() {
            if (vm.updatetree) {
                changeJurisdiction();
            }
            vm.updatetree = false;
        });

        function changeJurisdiction() {
            var query = {
                jurisdiction: vm.searchItem.jurisdiction
            };

            StepNode.query(query).$promise
                .then(function(data) {
                    vm.nodes = data;
                });
        }

        function openNewStepForm(stepParent) {
            if (stepParent) {
                Step.get({
                    id: stepParent
                }, onNewStepSuccess, onNewStepError);
            }
            else {
                vm.newstepform = true;
                vm.stepParent = null;
                vm.editstepform = false;
                vm.newdocumentform = false;
                vm.editdocumentform = false;
            }
        }

        function onNewStepSuccess(data) {
            vm.stepParent = data;
            vm.updatetree = true;
            vm.newstepform = true;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }
        function onNewStepError() {
            //TODO
        }

        function edit_step(step_id, isdeleted) {
            vm.isdeletedstep = isdeleted;
            vm.step = {};
            Step.get({
                id: step_id
            }, onEditStepSuccess, onEditStepError);
        }

        function onEditStepSuccess(data) {
            vm.step = data;
            vm.editstepform = true;
            $scope.isDeleting = false;

            vm.newstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }

        function onEditStepError() {
            //TODO
        }
        
        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
            });
          };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('newStep', {
            bindings: {
                stepparent: '=',
                jurisdiction: '=',
                updatetree: '=',
                newstepform: '='
            },
            templateUrl: 'app/entities/step/new-step-component.html',
            controller: ['$scope', 'Step', 'toastr',
                function ($scope, Step, toastr) {
                    var $ctrl = this;

                    $ctrl.$onInit = initialization;
                    $ctrl.save = save;
                    $ctrl.close = close;
                    $ctrl.status = [];

                    $scope.$watch('$ctrl.newstepform', function() {
                        if ($ctrl.newstepform === true) {
                            $ctrl.step = {
                                documents: false,
                                status: false
                            };
                        }
                    });

                    /**
                     * public methods
                     */
                    /**
                     * @function
                     * @name initialization
                     * @description
                     * A component's lifeCycle hook which is called after all the controllers on an element have been constructed and had their bindings initialized
                     */
                    function initialization() {
                    }

                    function save() {
                        $ctrl.isSaving = true;

                        var step = Object.assign({}, $ctrl.step);
                        step.jurisdiction = $ctrl.jurisdiction;
                        if ($ctrl.stepparent) {
                            step.stepParent = $ctrl.stepparent.id;
                        }

                        Step.save(step, onSaveSuccess, onSaveError);
                    }

                    function onSaveSuccess() {
                        toastr.success('Fase creada con éxito');
                        $ctrl.updatetree = true;
                        $ctrl.newstepform = false;
                        $ctrl.isSaving = false;
                    }

                    function onSaveError() {
                        toastr.error('Error al crear la fase');
                        $ctrl.isSaving = false;
                    }

                    function close() {
                        $ctrl.newstepform = false;
                    }

                }
            ]
        });
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('editStep', {
            bindings: {
                step: '=',
                editstepform: '=',
                updatetree: '=',
                isdeletedstep: '<'
            },
            templateUrl: 'app/entities/step/edit-step-component.html',
            controller: ['$scope', 'Step', 'StepStatus', 'toastr',
                function ($scope, Step, StepStatus, toastr) {
                    var $ctrl = this;

                    $ctrl.$onInit = initialization;
                    $ctrl.save = save;
                    $ctrl.close = close;
                    $ctrl.remove_step = remove_step;
                    $ctrl.save_status = save_status;
                    $ctrl.delete_status = delete_status;


                    function initialization() {}

                    function findStatus() {
                      StepStatus.query({
                          stepId: $ctrl.step.id
                      }).$promise
                          .then(function(data) {
                              $ctrl.stepStatus = data;
                          });
                    }

                    $scope.$watch('$ctrl.step', function() {
                        if ($ctrl.step && $ctrl.step.status){
                            findStatus();
                        }
                    });

                    function save() {
                        $ctrl.isSaving = true;
                        var step = Object.assign({}, $ctrl.step);
                        Step.update(step, onSaveSuccess, onSaveError);
                    }

                    function onSaveSuccess(result) {
                        toastr.success('Actualizada con éxito!', 'Fase ' + result.name);

                        $ctrl.updatetree = true;
//                        $ctrl.editstepform = false;
                        $ctrl.isSaving = false;
                    }

                    function onSaveError() {
                        toastr.error('Error al actualizar la fase');
                        $ctrl.isSaving = false;
                    }

                    function close() {
                        $ctrl.editstepform = false;
                    }

                    function save_status() {
                        $ctrl.isSaving = true;

                        var step_status = {
                            step: $ctrl.step,
                            description: $ctrl.status
                        };

                        StepStatus.update(step_status, onSaveStepSuccess, onSaveStepError);
                    }

                    function onSaveStepSuccess (result) {
                        toastr.success('Estado añadido con éxito!', 'Estado ' + result.description);
                          $ctrl.status = undefined;
                          $ctrl.isSaving = false;
                          findStatus();
                    }

                    function onSaveStepError () {
                        toastr.error('Error al añadir estado');
                        $ctrl.isSaving = false;
                    }
                    function delete_status(idStatus) {
                        StepStatus.delete({
                                id: idStatus
                            },
                            function() {
                                toastr.success('Estado eliminado con éxito');
                                findStatus();
                            },
                            function () {
                                toastr.error('No puede eliminar el estado');
                            }
                        );
                    }
                    function remove_step() {
                        Step.delete({
                                id: $ctrl.step.id
                            },
                            function() {
                                toastr.success('Fase eliminada con éxito');
                                $ctrl.updatetree = true;
                                $ctrl.editstepform = false;
                                $ctrl.isdeletedstep = false;
                            },
                            function () {
                                toastr.error('No puede eliminarse una fase con subfases');
                            }
                        );
                    }

                }
            ]
        });
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ProcessType', ProcessType);

    ProcessType.$inject = ['$resource'];

    function ProcessType ($resource) {
        var resourceUrl =  'api/process-types';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('notes', {
            bindings: {
                entitytype: '<',
                entityid: '<'
            },
            templateUrl: 'app/entities/observation/observations-component.html',
            controller: ['$timeout', '$rootScope', '$scope', 'Observation', '$q', 'toastr',
                function($timeout, $rootScope, $scope, Observation, $q, toastr) {
                    var $ctrl = this;

                    $ctrl.saved = false;

                    $ctrl.onEdit = false;
                    $ctrl.editObservation = {};
                    $ctrl.editCancel = editCancel;
                    $ctrl.editUpdate = editUpdate;
                    $ctrl.editNote = editNote;
                    $ctrl.editDelete = editDelete;

                    $ctrl.onNew = false;
                    $ctrl.newCancel = newCancel;
                    $ctrl.newSave = newSave;
                    $ctrl.newObservation = {};
                    $ctrl.notes = {};
                    $ctrl.$onInit = onInit;

                    $ctrl.$onChanges = function(changes) {
                        retrieveNotes();
                    };

                    function onInit() {
                        retrieveNotes();
                        $ctrl.onEdit = false;
                    }

                    function newCancel() {
                        $ctrl.onNew = false;
                        $ctrl.newObservation = {};
                    }

                    function newSave() {
                        Observation.save($ctrl.newObservation, onNewSaveSucess, onNewSaveError);
                    }

                    function onNewSaveSucess(data) {
                        $ctrl.onNew = false;
                        toastr.success('Nota creada con éxito!');
                        $ctrl.newObservation = {};
                        retrieveNotes();
                    }

                    function onNewSaveError() {
                        toastr.error('Error al crear la nota!');
                    }

                    function editNote(observation_id) {
                        Observation.get({
                            id: observation_id
                        }, onEditObservationSuccess, onEditObservationError);
                    }

                    function onEditObservationSuccess(data) {
                        $ctrl.onEdit = true;
                        $ctrl.editObservation = data;
                    }

                    function onEditObservationError() {
                        //TODO
                    }

                    function editDelete() {
                        Observation.delete($ctrl.editObservation, onEditDeleteSucess, onEditDeleteError);
                    }

                    function onEditDeleteSucess(data) {
                        $ctrl.onEdit = false;
                        toastr.success('Nota eliminada con éxito!');
                        $ctrl.editObservation = {};
                        retrieveNotes();
                    }

                    function onEditDeleteError() {
                        toastr.error('Error al eliminar la nota!');
                    }

                    function editCancel() {
                        $ctrl.onEdit = false;
                    }

                    function editUpdate() {
                        $ctrl.onEdit = false;
                        Observation.update($ctrl.editObservation, onEditUpdateSucess, onEditUpdateError);
                    }

                    function onEditUpdateSucess(data) {
                        $ctrl.onEdit = false;
                        toastr.success('Nota actualizada con éxito!');
                        $ctrl.editObservation = {};
                        retrieveNotes();
                    }

                    function onEditUpdateError() {
                        toastr.error('Error al actualizar la nota!');
                    }


                    function retrieveNotes() {
                        $q.all([
                                Observation.query({
                                  entityType: $ctrl.entitytype,
                                  entityId: $ctrl.entityid,
                                  type: 'NOTE'
                                }).$promise
                            ])
                            .then(function(data) {
                                $ctrl.notes = buildGridModel(data[0]);
                                $rootScope.hasNotes = $ctrl.notes.length;
                            });
                    }

                    function buildGridModel(notes) {
                        var it, results = [];

                        for (var j = 0; j < notes.length; j++) {
                            it = angular.extend({}, notes[j]);
                            it.span = {
                                row: 1,
                                col: 1
                            };

                            switch (j + 1) {
                                case 1:
                                    it.background = "red";
                                    it.span.row = it.span.col = 2;
                                    break;

                                case 2:
                                    it.background = "green";
                                    break;
                                case 3:
                                    it.background = "darkBlue";
                                    break;
                                case 4:
                                    it.background = "blue";
                                    it.span.col = 2;
                                    break;

                                case 5:
                                    it.background = "yellow";
                                    it.span.row = it.span.col = 2;
                                    break;

                                case 6:
                                    it.background = "pink";
                                    break;
                                case 7:
                                    it.background = "darkBlue";
                                    break;
                                case 8:
                                    it.background = "purple";
                                    break;
                                case 9:
                                    it.background = "deepBlue";
                                    break;
                                case 10:
                                    it.background = "lightPurple";
                                    break;
                                case 11:
                                    it.background = "yellow";
                                    break;
                                default:
                                    it.background = "yellow";
                                    break;
                            }

                            results.push(it);
                        }
                        return results;
                    }

                }
            ]
        });
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Observation', Observation);

    Observation.$inject = ['$resource'];

    function Observation($resource) {
        var resourceUrl =  'api/observations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('newNote', {
            bindings: {
                newObservation: '<',
                entitytype: '<',
                entityid: '<',
                onNew: '<',
                cancel: '&',
                save: '&'
            },
            templateUrl: 'app/entities/observation/new-observation-component.html',
            controller: ['$timeout', '$rootScope', '$scope', 'Observation', '$q',
                function($timeout) {
                    var $ctrl = this;

                    $ctrl.onCancel = onCancel;
                    $ctrl.onSave = onSave;
                    $ctrl.initNew = initNew;

                    $timeout(function() {
                        angular.element('#description').focus();
                    });

                    function initNew() {
                        $ctrl.onNew = true;
                        $ctrl.newObservation.entityType = $ctrl.entitytype;
                        $ctrl.newObservation.entityId = $ctrl.entityid;
                        $ctrl.newObservation.type = "NOTE";
                        $ctrl.newObservation.done = false;
                    }

                    function onCancel() {
                        $ctrl.onNew = false;
                        $ctrl.cancel();
                    }

                    function onSave() {
                        $ctrl.onNew = false;
                        $ctrl.save();
                    }
                }
            ]
        });
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('editNote', {
            bindings: {
                editObservation: '<',
                cancel: '&',
                update: '&',
                delete: '&'
            },
            templateUrl: 'app/entities/observation/edit-observation-component.html',
            controller: ['$timeout',
                function($timeout) {
                    var $ctrl = this;

                    $ctrl.onCancel = onCancel;
                    $ctrl.onUpdate = onUpdate;
                    $ctrl.onDelete = onDelete;

                    $timeout(function() {
                        angular.element('#description').focus();
                    });

                    function onUpdate() {
                        $ctrl.update();
                    }

                    function onCancel() {
                        $ctrl.cancel();
                    }

                    function onDelete() {
                        $ctrl.delete();
                    }
                }
            ]
        });
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearResultSummaryNewController", LebaniegoYearResultSummaryNewController);

        LebaniegoYearResultSummaryNewController.$inject = [
        "$timeout",
        "$state",
        "$mdSidenav",
        "$q",
        "entity",
        "LebaniegoYearResultSummary",
        "previousState",
        "toastr"
    ]

    function LebaniegoYearResultSummaryNewController(
        $timeout,
        $state,
        $mdSidenav,
        $q,
        entity,
        LebaniegoYearResultSummary,
        previousState,
        toastr
    ) {
        var vm = this;

        vm.lebaniegoYearResultSummary = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearResultSummaryParameters")
        );
        
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearResultSummary = Object.assign({}, vm.lebaniegoYearResultSummary);
            lebaniegoYearResultSummary.id = null;
            lebaniegoYearResultSummary.year = vm.lebaniegoYearResultSummary.year;
            lebaniegoYearResultSummary.gFile = null;
            lebaniegoYearResultSummary.sector = 'RESUMEN';
            LebaniegoYearResultSummary.save(lebaniegoYearResultSummary, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-result-summary", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el resumen");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearResultSummaryDetailController",
            LebaniegoYearResultSummaryDetailController
        );

        LebaniegoYearResultSummaryDetailController.$inject = [
        "$rootScope",
        "$mdSidenav",
        "$scope",
        "$http",
        "$q",
        "$mdDialog",
        "previousState",
        "entity",
        "Principal",
        "LebaniegoYearResultSummary",
        "LebaniegoYearResultSummaryFile",
        "$state",
        "toastr",
        "Upload"
    ];

    function LebaniegoYearResultSummaryDetailController(
        $rootScope,
        $mdSidenav,
        $scope,
        $http,
        $q,
        $mdDialog,
        previousState,
        entity,
        Principal,
        LebaniegoYearResultSummary,
        LebaniegoYearResultSummaryFile,
        $state,
        toastr,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearResultSummary = entity;
        vm.actualYear = vm.lebaniegoYearResultSummary.year;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;
        vm.clear = clear;

        vm.list = [];
        vm.nodes = [];

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        });
        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        });

        LebaniegoYearResultSummaryFile.query(
            {
                id: vm.lebaniegoYearResultSummary.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearResultSummary = Object.assign({}, vm.lebaniegoYearResultSummary);
            lebaniegoYearResultSummary.gFile = null;
            LebaniegoYearResultSummary.update(lebaniegoYearResultSummary, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Actualizado con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-result-summary");
        }

        function onSaveError() {
            toastr.error("Error al actualizar el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

        function updateDocument(document) {
            LebaniegoYearResultSummaryFile.update(document, onSaveSuccess, onSaveError);
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-result-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearResultSummaryFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearResultSummaryFile.query(
                        {
                            id: vm.lebaniegoYearResultSummary.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-result-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyResultId: vm.lebaniegoYearResultSummary.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearResultSummaryFile.query(
                            {
                                id: vm.lebaniegoYearResultSummary.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-result-summary", {
                parent: "entity",
                url: "/lebaniego-result-summary?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearResultSummary",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-resumenes/lebaniego-resultado-resumen.html",
                        controller:
                            "LebaniegoYearResultSummaryController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-result-summary.new", {
                parent: "lebaniego-result-summary",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-resumenes/lebaniego-resultado-resumen-new.html",
                        controller: "LebaniegoYearResultSummaryNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-result-summary"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-result-summary",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-result-summary.edit", {
                parent: "lebaniego-result-summary",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearResultSummary"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-resumenes/lebaniego-resultado-resumen-detail.html",
                        controller: "LebaniegoYearResultSummaryDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-result-summary"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearResultSummary",
                        function ($stateParams, LebaniegoYearResultSummary) {
                            return LebaniegoYearResultSummary.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-result-summary",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearResultSummaryController",
            LebaniegoYearResultSummaryController
        );

        LebaniegoYearResultSummaryController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearResultSummary",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearResultSummaryController(
        DateUtils,
        $state,
        LebaniegoYearResultSummary,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearResultSummaryParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearResultSummaryParameters",
                JSON.stringify(vm.searchItem)
            );
            LebaniegoYearResultSummary.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    sector: 'RESUMEN',
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearResultSummarys = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearResultSummaryParameters",
                JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearResultDonorNewController", LebaniegoYearResultDonorNewController);

        LebaniegoYearResultDonorNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "$http",
        "$state",
        "$mdSidenav",
        "$q",
        "entity",
        "LebaniegoYearResultDonor",
        "previousState",
        "toastr",
        "DateUtils",
    ]

    function LebaniegoYearResultDonorNewController(
        $rootScope,
        $timeout,
        $scope,
        $http,
        $state,
        $mdSidenav,
        $q,
        entity,
        LebaniegoYearResultDonor,
        previousState,
        toastr,
        DateUtils
    ) {
        var vm = this;

        vm.lebaniegoYearResultDonor = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearResultDonorParameters")
        );
        
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearResultDonor = Object.assign({}, vm.lebaniegoYearResultDonor);
            lebaniegoYearResultDonor.id = null;
            lebaniegoYearResultDonor.year = vm.lebaniegoYearResultDonor.year;
            lebaniegoYearResultDonor.sector = 'DONANTE';
            vm.lebaniegoYearResultDonor.gFile = {
                id: vm.lebaniegoYearResultDonor.gFile
            };
            lebaniegoYearResultDonor.gFile = vm.lebaniegoYearResultDonor.gFile;
            LebaniegoYearResultDonor.save(lebaniegoYearResultDonor, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-result-donor", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el donante");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-result/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_DONANTES')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearResultDonor.businessName = item.sectorBusinessName;
                vm.lebaniegoYearResultDonor.gFile = item.gFileId;
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearResultDonorDetailController",
            LebaniegoYearResultDonorDetailController
        );

        LebaniegoYearResultDonorDetailController.$inject = [
        "$rootScope",
        "$mdSidenav",
        "$scope",
        "$http",
        "$q",
        "$mdDialog",
        "previousState",
        "entity",
        "Principal",
        "LebaniegoYearResultDonor",
        "LebaniegoYearResultDonorFile",
        "$state",
        "toastr",
        "Upload"
    ];

    function LebaniegoYearResultDonorDetailController(
        $rootScope,
        $mdSidenav,
        $scope,
        $http,
        $q,
        $mdDialog,
        previousState,
        entity,
        Principal,
        LebaniegoYearResultDonor,
        LebaniegoYearResultDonorFile,
        $state,
        toastr,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearResultDonor = entity;
        vm.actualBusinessName = vm.lebaniegoYearResultDonor.gFile.sectorBusinessName;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;
        vm.clear = clear;

        vm.list = [];
        vm.nodes = [];

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        });
        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        });

        LebaniegoYearResultDonorFile.query(
            {
                id: vm.lebaniegoYearResultDonor.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearResultDonor = Object.assign({}, vm.lebaniegoYearResultDonor);
            lebaniegoYearResultDonor.gFile = {id: vm.lebaniegoYearResultDonor.gFile.id};
            LebaniegoYearResultDonor.update(lebaniegoYearResultDonor, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            if (vm.actualBusinessName != vm.lebaniegoYearResultDonor.gFile.sectorBusinessName) {
                vm.actualBusinessName = vm.lebaniegoYearResultDonor.gFile.sectorBusinessName.sectorBusinessName;
            }
            toastr.success("Actualizado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al actualizar el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

        function updateDocument(document) {
            LebaniegoYearResultDonorFile.update(document, onSaveSuccess, onSaveError);
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-result-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearResultDonorFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearResultDonorFile.query(
                        {
                            id: vm.lebaniegoYearResultDonor.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-result-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyResultId: vm.lebaniegoYearResultDonor.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearResultDonorFile.query(
                            {
                                id: vm.lebaniegoYearResultDonor.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-result/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_DONANTES')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearResultDonor.businessName = item.sectorBusinessName;
                vm.lebaniegoYearResultDonor.gFile.id = item.gFileId;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-result-donor", {
                parent: "entity",
                url: "/lebaniego-result-donor?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearResultDonor",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-donantes/lebaniego-resultado-donante.html",
                        controller:
                            "LebaniegoYearResultDonorController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-result-donor.new", {
                parent: "lebaniego-result-donor",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-donantes/lebaniego-resultado-donante-new.html",
                        controller: "LebaniegoYearResultDonorNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-result-donor"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-result-donor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-result-donor.edit", {
                parent: "lebaniego-result-donor",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearResultDonor"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-donantes/lebaniego-resultado-donante-detail.html",
                        controller: "LebaniegoYearResultDonorDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-result-donor"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearResultDonor",
                        function ($stateParams, LebaniegoYearResultDonor) {
                            return LebaniegoYearResultDonor.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-result-donor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearResultDonorController",
            LebaniegoYearResultDonorController
        );

        LebaniegoYearResultDonorController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearResultDonor",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearResultDonorController(
        DateUtils,
        $state,
        LebaniegoYearResultDonor,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearResultDonorParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearResultDonorParameters",
                JSON.stringify(vm.searchItem)
            );
            LebaniegoYearResultDonor.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    jurisdiction: 'AÑO_LEBANIEGO_DONANTES',
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearResultDonors = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearResultDonorParameters",
                JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearResultAgreementNewController", LebaniegoYearResultAgreementNewController);

        LebaniegoYearResultAgreementNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "$http",
        "$state",
        "$mdSidenav",
        "$q",
        "entity",
        "LebaniegoYearResultAgreement",
        "previousState",
        "toastr",
        "DateUtils",
    ]

    function LebaniegoYearResultAgreementNewController(
        $rootScope,
        $timeout,
        $scope,
        $http,
        $state,
        $mdSidenav,
        $q,
        entity,
        LebaniegoYearResultAgreement,
        previousState,
        toastr,
        DateUtils
    ) {
        var vm = this;

        vm.lebaniegoYearResultAgreement = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearResultAgreementParameters")
        );
        
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearResultAgreement = Object.assign({}, vm.lebaniegoYearResultAgreement);
            lebaniegoYearResultAgreement.id = null;
            lebaniegoYearResultAgreement.year = vm.lebaniegoYearResultAgreement.year;
            lebaniegoYearResultAgreement.sector = 'CONVENIO';
            vm.lebaniegoYearResultAgreement.gFile = {
                id: vm.lebaniegoYearResultAgreement.gFile
            };
            lebaniegoYearResultAgreement.gFile = vm.lebaniegoYearResultAgreement.gFile;
            LebaniegoYearResultAgreement.save(lebaniegoYearResultAgreement, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-result-agreement", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el convenio");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-result/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_CONVENIO')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearResultAgreement.businessName = item.sectorBusinessName;
                vm.lebaniegoYearResultAgreement.gFile = item.gFileId;
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearResultAgreementDetailController",
            LebaniegoYearResultAgreementDetailController
        );

        LebaniegoYearResultAgreementDetailController.$inject = [
        "$rootScope",
        "$mdSidenav",
        "$scope",
        "$http",
        "$q",
        "$mdDialog",
        "previousState",
        "entity",
        "Principal",
        "LebaniegoYearResultAgreement",
        "LebaniegoYearResultAgreementFile",
        "$state",
        "toastr",
        "Upload"
    ];

    function LebaniegoYearResultAgreementDetailController(
        $rootScope,
        $mdSidenav,
        $scope,
        $http,
        $q,
        $mdDialog,
        previousState,
        entity,
        Principal,
        LebaniegoYearResultAgreement,
        LebaniegoYearResultAgreementFile,
        $state,
        toastr,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearResultAgreement = entity;
        vm.actualBusinessName = vm.lebaniegoYearResultAgreement.gFile.sectorBusinessName;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;
        vm.clear = clear;

        vm.list = [];
        vm.nodes = [];

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        });
        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        });

        LebaniegoYearResultAgreementFile.query(
            {
                id: vm.lebaniegoYearResultAgreement.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearResultAgreement = Object.assign({}, vm.lebaniegoYearResultAgreement);
            lebaniegoYearResultAgreement.gFile = {id: vm.lebaniegoYearResultAgreement.gFile.id};
            LebaniegoYearResultAgreement.update(lebaniegoYearResultAgreement, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            if (vm.actualBusinessName != vm.lebaniegoYearResultAgreement.gFile.sectorBusinessName) {
                vm.actualBusinessName = vm.lebaniegoYearResultAgreement.gFile.sectorBusinessName.sectorBusinessName;
            }
            toastr.success("Actualizado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al actualizar el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

        function updateDocument(document) {
            LebaniegoYearResultAgreementFile.update(document, onSaveSuccess, onSaveError);
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-result-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearResultAgreementFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearResultAgreementFile.query(
                        {
                            id: vm.lebaniegoYearResultAgreement.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-result-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyResultId: vm.lebaniegoYearResultAgreement.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearResultAgreementFile.query(
                            {
                                id: vm.lebaniegoYearResultAgreement.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-result/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_CONVENIO')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearResultAgreement.businessName = item.sectorBusinessName;
                vm.lebaniegoYearResultAgreement.gFile.id = item.gFileId;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-result-agreement", {
                parent: "entity",
                url: "/lebaniego-result-agreement?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearResultAgreement",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-convenios/lebaniego-resultado-convenio.html",
                        controller:
                            "LebaniegoYearResultAgreementController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-result-agreement.new", {
                parent: "lebaniego-result-agreement",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-convenios/lebaniego-resultado-convenio-new.html",
                        controller: "LebaniegoYearResultAgreementNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-result-agreement"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-result-agreement",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-result-agreement.edit", {
                parent: "lebaniego-result-agreement",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearResultAgreement"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-convenios/lebaniego-resultado-convenio-detail.html",
                        controller: "LebaniegoYearResultAgreementDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-result-agreement"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearResultAgreement",
                        function ($stateParams, LebaniegoYearResultAgreement) {
                            return LebaniegoYearResultAgreement.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-result-agreement",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearResultAgreementController",
            LebaniegoYearResultAgreementController
        );

        LebaniegoYearResultAgreementController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearResultAgreement",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearResultAgreementController(
        DateUtils,
        $state,
        LebaniegoYearResultAgreement,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearResultAgreementParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearResultAgreementParameters",
                JSON.stringify(vm.searchItem)
            );
            LebaniegoYearResultAgreement.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    jurisdiction: 'AÑO_LEBANIEGO_CONVENIO',
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearResultAgreements = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearResultAgreementParameters",
                JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearResultContributorNewController", LebaniegoYearResultContributorNewController);

        LebaniegoYearResultContributorNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "$http",
        "$state",
        "$mdSidenav",
        "$q",
        "entity",
        "LebaniegoYearResultContributor",
        "previousState",
        "toastr",
        "DateUtils",
    ]

    function LebaniegoYearResultContributorNewController(
        $rootScope,
        $timeout,
        $scope,
        $http,
        $state,
        $mdSidenav,
        $q,
        entity,
        LebaniegoYearResultContributor,
        previousState,
        toastr,
        DateUtils
    ) {
        var vm = this;

        vm.lebaniegoYearResultContributor = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearResultContributorParameters")
        );
        
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearResultContributor = Object.assign({}, vm.lebaniegoYearResultContributor);
            lebaniegoYearResultContributor.id = null;
            lebaniegoYearResultContributor.year = vm.lebaniegoYearResultContributor.year;
            lebaniegoYearResultContributor.sector = 'APORTANTE';
            vm.lebaniegoYearResultContributor.gFile = {
                id: vm.lebaniegoYearResultContributor.gFile
            };
            lebaniegoYearResultContributor.gFile = vm.lebaniegoYearResultContributor.gFile;
            LebaniegoYearResultContributor.save(lebaniegoYearResultContributor, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-result-contributor", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el aportante");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-result/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_APORTANTES')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearResultContributor.businessName = item.sectorBusinessName;
                vm.lebaniegoYearResultContributor.gFile = item.gFileId;
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearResultContributorDetailController",
            LebaniegoYearResultContributorDetailController
        );

        LebaniegoYearResultContributorDetailController.$inject = [
        "$rootScope",
        "$mdSidenav",
        "$scope",
        "$http",
        "$q",
        "$mdDialog",
        "previousState",
        "entity",
        "Principal",
        "LebaniegoYearResultContributor",
        "LebaniegoYearResultContributorFile",
        "$state",
        "toastr",
        "Upload"
    ];

    function LebaniegoYearResultContributorDetailController(
        $rootScope,
        $mdSidenav,
        $scope,
        $http,
        $q,
        $mdDialog,
        previousState,
        entity,
        Principal,
        LebaniegoYearResultContributor,
        LebaniegoYearResultContributorFile,
        $state,
        toastr,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearResultContributor = entity;
        vm.actualBusinessName = vm.lebaniegoYearResultContributor.gFile.sectorBusinessName;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;
        vm.clear = clear;

        vm.list = [];
        vm.nodes = [];

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        });
        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        });

        LebaniegoYearResultContributorFile.query(
            {
                id: vm.lebaniegoYearResultContributor.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearResultContributor = Object.assign({}, vm.lebaniegoYearResultContributor);
            lebaniegoYearResultContributor.gFile = {id: vm.lebaniegoYearResultContributor.gFile.id};
            LebaniegoYearResultContributor.update(lebaniegoYearResultContributor, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            if (vm.actualBusinessName != vm.lebaniegoYearResultContributor.gFile.sectorBusinessName) {
                vm.actualBusinessName = vm.lebaniegoYearResultContributor.gFile.sectorBusinessName.sectorBusinessName;
            }
            toastr.success("Actualizado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al actualizar el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

        function updateDocument(document) {
            LebaniegoYearResultContributorFile.update(document, onSaveSuccess, onSaveError);
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-result-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearResultContributorFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearResultContributorFile.query(
                        {
                            id: vm.lebaniegoYearResultContributor.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-result-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyResultId: vm.lebaniegoYearResultContributor.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearResultContributorFile.query(
                            {
                                id: vm.lebaniegoYearResultContributor.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-result/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_APORTANTES')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearResultContributor.businessName = item.sectorBusinessName;
                vm.lebaniegoYearResultContributor.gFile.id = item.gFileId;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-result-contributor", {
                parent: "entity",
                url: "/lebaniego-result-contributor?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearResultContributor",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-aportantes/lebaniego-resultado-aportante.html",
                        controller:
                            "LebaniegoYearResultContributorController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-result-contributor.new", {
                parent: "lebaniego-result-contributor",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-aportantes/lebaniego-resultado-aportante-new.html",
                        controller: "LebaniegoYearResultContributorNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-result-contributor"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-result-contributor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-result-contributor.edit", {
                parent: "lebaniego-result-contributor",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearResultContributor"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-aportantes/lebaniego-resultado-aportante-detail.html",
                        controller: "LebaniegoYearResultContributorDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-result-contributor"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearResultContributor",
                        function ($stateParams, LebaniegoYearResultContributor) {
                            return LebaniegoYearResultContributor.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-result-contributor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearResultContributorController",
            LebaniegoYearResultContributorController
        );

        LebaniegoYearResultContributorController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearResultContributor",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearResultContributorController(
        DateUtils,
        $state,
        LebaniegoYearResultContributor,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearResultContributorParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearResultContributorParameters",
                JSON.stringify(vm.searchItem)
            );
            LebaniegoYearResultContributor.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    jurisdiction: 'AÑO_LEBANIEGO_APORTANTES',
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearResultContributors = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearResultContributorParameters",
                JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearDonorNewController",
            LebaniegoYearDonorNewController
        );

    LebaniegoYearDonorNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "GFile",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "$http",
        "$q"
    ];

    function LebaniegoYearDonorNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        GFile,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        $http,
        $q
    ) {
        var vm = this;

        vm.gFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            vm.gFile.jurisdiction = "AÑO_LEBANIEGO_DONANTES";
            var gFile = Object.assign({}, vm.gFile);
            if (gFile.sectorDate !== null) {
                gFile.sectorDate = DateUtils.convertLocalDateToServer(
                    gFile.sectorDate
                );
            }
            gFile.id = null;
            GFile.save(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-donor.edit", {
                id: result.id,
            });
        }

        function onSaveError() {
            toastr.error("Error al crear el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/g-donor-files/search?searchText=' + searchText)
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.gFile.year = item.year;
                vm.gFile.sectorBusinessName = item.sectorBusinessName;
                vm.gFile.sectorNif = item.sectorNif;
                vm.gFile.sectorContact = item.sectorContact;
                vm.gFile.sectorAddress = item.sectorAddress;
                vm.gFile.sectorTelephone = item.sectorTelephone;
                vm.gFile.sectorEmail = item.sectorEmail;
                if (item.sectorDate !== null) {
                    vm.gFile.sectorDate = DateUtils.convertLocalDateFromServer(
                        item.sectorDate
                    );
                }
                vm.gFile.sectorDescription = item.sectorDescription;
                vm.gFile.sectorObservations = item.sectorObservations;

                $scope.searchText = '';
            }
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearDonorDetailController",
            LebaniegoYearDonorDetailController
        );

    LebaniegoYearDonorDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$http",
        "previousState",
        "entity",
        "Principal",
        "LebaniegoYearDonor",
        "GFileStep",
        "$state",
        "status",
        "Document",
        "DateUtils",
        "Observation",
        "toastr",
        "$mdSidenav",
    ];

    function LebaniegoYearDonorDetailController(
        $scope,
        $rootScope,
        $http,
        previousState,
        entity,
        Principal,
        LebaniegoYearDonor,
        GFileStep,
        $state,
        status,
        Document,
        DateUtils,
        Observation,
        toastr,
        $mdSidenav
    ) {
        var vm = this;

        vm.gFile = entity;

        vm.gfilestep = {};
        vm.toggleSidenav = buildToggler("left");
        vm.save = save;
        vm.clear = clear;

        vm.isdeletedstep = false;
        vm.edit_gstep = edit_gstep;
        vm.status = status;

        vm.openNewStepForm = openNewStepForm;
        vm.download_file = downloadfile;
        vm.new_document = new_document;
        vm.edit_document = edit_document;
        vm.previousState = previousState.name;
        vm.newstepform = false;
        vm.editdocumentform = false;
        vm.entityType = "GF";
        vm.list = [];
        vm.updatetree = false;
        vm.nodes = [];

        vm.actualDonor = vm.gFile.sectorBusinessName;

        $scope.$watch("vm.updatetree", function () {
            if (vm.updatetree === true) {
                loadGFileSteps();
            }
            vm.updatetree = false;
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        var unsubscribe = $rootScope.$on(
            "expedientesUriarteApp:gFileUpdate",
            function (event, result) {
                vm.gFile = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        });
        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        });

        loadGFileSteps();
        hasNotes();

        function loadGFileSteps() {
            GFileStep.query(
                {
                    g_file_id: vm.gFile.id,
                    allSteps: false,
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                vm.list = [];
                if (data.length >= 1) {
                    vm.list = data;
                    vm.nodes = data;
                }
            }

            function onError(error) {}
        }

        function save() {
            vm.isSaving = true;
            var gFile = Object.assign({}, vm.gFile);
            LebaniegoYearDonor.update(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.actualDonor = vm.gFile.sectorBusinessName;
            toastr.success(
                "Actualizado con éxito!"
            );
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al actualizar el donante");
            vm.isSaving = false;
        }

        function openNewStepForm(stepParent) {
            if (stepParent) {
                GFileStep.get(
                    {
                        id: stepParent,
                    },
                    onNewGStepSuccess,
                    onNewGStepError
                );
            } else {
                vm.newstepform = true;
                vm.stepParent = null;
                vm.editstepform = false;
                vm.newdocumentform = false;
                vm.editdocumentform = false;
            }
        }

        function onNewGStepSuccess(data) {
            vm.stepParent = data;
            vm.newstepform = true;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }
        function onNewGStepError(mssg) {
            console.log(mssg);
        }

        function edit_gstep(gstep_id, isdeleted) {
            vm.isdeletedstep = isdeleted;
            vm.gfilestep = {};
            GFileStep.get(
                {
                    id: gstep_id,
                },
                onEditGStepSuccess,
                onEditGStepError
            );
        }

        function onEditGStepSuccess(data) {
            vm.gfilestep = data;
            vm.editstepform = true;
            $scope.isDeleting = false;

            vm.newstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }

        function onEditGStepError(mssg) {
            console.log(mssg);
        }

        function downloadfile(documentId, fileType) {
            Document.get(
                {
                    id: documentId,
                },
                function (data) {
                    $http({
                        method: "GET",
                        url: "api/g-files/download/" + documentId,
                        responseType: "arraybuffer",
                        cache: false,
                    })
                        .success(function (result) {
                            var a = document.createElement("a");
                            var blob = new Blob([result], {
                                type: "application/octet-stream",
                            });
                            a.href = URL.createObjectURL(blob);

                            a.download = data.filename;
                            a.click();
                        })
                        .error(function (data, status, headers, config) {});
                }
            );
        }

        function new_document(gstep_id) {
            GFileStep.get(
                {
                    id: gstep_id,
                },
                onNewDocumentSuccess,
                onNewDocumentError
            );
        }

        function onNewDocumentSuccess(data) {
            vm.gfilestep = data;
            vm.newdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.editdocumentform = false;
        }

        function onNewDocumentError(mssg) {
            console.log(mssg);
        }

        function edit_document(document_id) {
            Document.get(
                {
                    id: document_id,
                },
                onEditDocumentSuccess,
                onEditDocumentError
            );
        }

        function onEditDocumentSuccess(data) {
            vm.document = data;
            vm.editdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.newdocumentform = false;
        }

        function onEditDocumentError(mssg) {
            console.log(mssg);
        }

        function hasNotes() {
            Observation.query(
                {
                    gFile: vm.gFile.id,
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                $rootScope.hasNotes = data.length;
            }

            function onError() {
                $rootScope.hasNotes = 0;
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-donor", {
                parent: "entity",
                url: "/lebaniego-donor?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearDonor",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-donantes/lebaniego-donante.html",
                        controller:
                            "LebaniegoYearDonorController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    steps: ['$stateParams', 'Step', function($stateParams, Step) {
                        return Step.query().$promise;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                },
            })
            .state("lebaniego-donor.new", {
                parent: "lebaniego-donor",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-donantes/lebaniego-donante-new.html",
                        controller: "LebaniegoYearDonorNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-donor"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-donor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-donor.edit", {
                parent: "lebaniego-donor",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearDonor"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-donantes/lebaniego-donante-detail.html",
                        controller: "LebaniegoYearDonorDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-donor"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearDonor",
                        function ($stateParams, LebaniegoYearDonor) {
                            return LebaniegoYearDonor.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-donor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearDonorController", LebaniegoYearDonorController);

        LebaniegoYearDonorController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearDonor",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav"
    ];

    function LebaniegoYearDonorController(
        DateUtils,
        $state,
        LebaniegoYearDonor,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav
    ) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem("searchParameters"));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        if (vm.searchItem.startDate !== null) {
            vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(
                vm.searchItem.startDate
            );
        }

        if (vm.searchItem.endDate !== null) {
            vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(
                vm.searchItem.endDate
            );
        }

        vm.status = status;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        searchExp();

        function searchExp() {
            if (vm.searchItem.startDate !== null)
                vm.searchItem.startDate = DateUtils.convertLocalDateToServer(
                    vm.searchItem.startDate
                );
            if (vm.searchItem.endDate !== null)
                vm.searchItem.endDate = DateUtils.convertLocalDateToServer(
                    vm.searchItem.endDate
                );
            localStorage.setItem(
                "searchParameters",
                JSON.stringify(vm.searchItem)
            );

            LebaniegoYearDonor.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    jurisdiction: 'AÑO_LEBANIEGO_DONANTES',
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.gFiles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
            vm.searchItem.status = status[0];

            localStorage.setItem(
                "searchParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearDocumentosManualNewController", LebaniegoYearDocumentosManualNewController);

        LebaniegoYearDocumentosManualNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearDocumentosManual",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearDocumentosManualNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearDocumentosManual,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearDocumentosManual = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearDocumentosManual = Object.assign({}, vm.lebaniegoYearDocumentosManual);
            lebaniegoYearDocumentosManual.id = null;
            LebaniegoYearDocumentosManual.save(lebaniegoYearDocumentosManual, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-documents-manual", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el manual");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearDocumentosManualDetailController",
            LebaniegoYearDocumentosManualDetailController
        );

        LebaniegoYearDocumentosManualDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearDocumentosManual",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "LebaniegoYearDocumentosManualFile",
        "$http",
        "Upload",
    ]

    function LebaniegoYearDocumentosManualDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearDocumentosManual,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        LebaniegoYearDocumentosManualFile,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearDocumentosManual = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        LebaniegoYearDocumentosManualFile.query(
            {
                id: vm.lebaniegoYearDocumentosManual.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearDocumentosManual = Object.assign({}, vm.lebaniegoYearDocumentosManual);

            LebaniegoYearDocumentosManual.update(lebaniegoYearDocumentosManual, onSaveSuccess, onError);
        }

        function updateDocument(document) {
            LebaniegoYearDocumentosManualFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-documents-manual-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearDocumentosManualFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearDocumentosManualFile.query(
                        {
                            id: vm.lebaniegoYearDocumentosManual.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-documents-manual-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyDocumentsManualId: vm.lebaniegoYearDocumentosManual.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearDocumentosManualFile.query(
                            {
                                id: vm.lebaniegoYearDocumentosManual.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-documents-manual", {
                parent: "entity",
                url: "/lebaniego-documents-manual?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearDocumentosManual",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-manuales/lebaniego-documentos-manual.html",
                        controller:
                            "LebaniegoYearDocumentosManualController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-documents-manual.new", {
                parent: "lebaniego-documents-manual",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-manuales/lebaniego-documentos-manual-new.html",
                        controller: "LebaniegoYearDocumentosManualNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-documents-manual"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-documents-manual",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-documents-manual.edit", {
                parent: "lebaniego-documents-manual",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearDocumentosManual"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-manuales/lebaniego-documentos-manual-detail.html",
                        controller: "LebaniegoYearDocumentosManualDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-documents-manual"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearDocumentosManual",
                        function ($stateParams, LebaniegoYearDocumentosManual) {
                            return LebaniegoYearDocumentosManual.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-documents-manual",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearDocumentosManualController", LebaniegoYearDocumentosManualController);

        LebaniegoYearDocumentosManualController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearDocumentosManual",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearDocumentosManualController(
        DateUtils,
        $state,
        LebaniegoYearDocumentosManual,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearDocumentosManualParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearDocumentosManualParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearDocumentosManual.query(
                {
                    year: vm.searchItem.year,
                    description: vm.searchItem.description,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearDocumentosManuales = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearDocumentosManualParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearDocumentosDossierNewController", LebaniegoYearDocumentosDossierNewController);

        LebaniegoYearDocumentosDossierNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearDocumentosDossier",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearDocumentosDossierNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearDocumentosDossier,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearDocumentosDossier = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearDocumentosDossier = Object.assign({}, vm.lebaniegoYearDocumentosDossier);
            lebaniegoYearDocumentosDossier.id = null;
            LebaniegoYearDocumentosDossier.save(lebaniegoYearDocumentosDossier, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-documents-dossier", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el dossier");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearDocumentosDossierDetailController",
            LebaniegoYearDocumentosDossierDetailController
        );

        LebaniegoYearDocumentosDossierDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearDocumentosDossier",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "LebaniegoYearDocumentosDossierFile",
        "$http",
        "Upload",
    ]

    function LebaniegoYearDocumentosDossierDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearDocumentosDossier,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        LebaniegoYearDocumentosDossierFile,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearDocumentosDossier = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        LebaniegoYearDocumentosDossierFile.query(
            {
                id: vm.lebaniegoYearDocumentosDossier.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearDocumentosDossier = Object.assign({}, vm.lebaniegoYearDocumentosDossier);

            LebaniegoYearDocumentosDossier.update(lebaniegoYearDocumentosDossier, onSaveSuccess, onError);
        }

        function updateDocument(document) {
            LebaniegoYearDocumentosDossierFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-documents-dossier-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearDocumentosDossierFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearDocumentosDossierFile.query(
                        {
                            id: vm.lebaniegoYearDocumentosDossier.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-documents-dossier-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyDocumentsDossierId: vm.lebaniegoYearDocumentosDossier.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearDocumentosDossierFile.query(
                            {
                                id: vm.lebaniegoYearDocumentosDossier.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-documents-dossier", {
                parent: "entity",
                url: "/lebaniego-documents-dossier?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearDocumentosDossier",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-dossiers/lebaniego-documentos-dossier.html",
                        controller:
                            "LebaniegoYearDocumentosDossierController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-documents-dossier.new", {
                parent: "lebaniego-documents-dossier",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-dossiers/lebaniego-documentos-dossier-new.html",
                        controller: "LebaniegoYearDocumentosDossierNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-documents-dossier"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-documents-dossier",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-documents-dossier.edit", {
                parent: "lebaniego-documents-dossier",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearDocumentosDossier"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-dossiers/lebaniego-documentos-dossier-detail.html",
                        controller: "LebaniegoYearDocumentosDossierDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-documents-dossier"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearDocumentosDossier",
                        function ($stateParams, LebaniegoYearDocumentosDossier) {
                            return LebaniegoYearDocumentosDossier.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-documents-dossier",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearDocumentosDossierController", LebaniegoYearDocumentosDossierController);

        LebaniegoYearDocumentosDossierController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearDocumentosDossier",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearDocumentosDossierController(
        DateUtils,
        $state,
        LebaniegoYearDocumentosDossier,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearDocumentosDossierParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearDocumentosDossierParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearDocumentosDossier.query(
                {
                    year: vm.searchItem.year,
                    description: vm.searchItem.description,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearDocumentosDossiers = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearDocumentosDossierParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearDocumentosAccionNewController", LebaniegoYearDocumentosAccionNewController);

        LebaniegoYearDocumentosAccionNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearDocumentosAccion",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearDocumentosAccionNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearDocumentosAccion,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearDocumentosAccion = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearDocumentosAccion = Object.assign({}, vm.lebaniegoYearDocumentosAccion);
            lebaniegoYearDocumentosAccion.id = null;
            LebaniegoYearDocumentosAccion.save(lebaniegoYearDocumentosAccion, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-documents-accion", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el accion");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearDocumentosAccionDetailController",
            LebaniegoYearDocumentosAccionDetailController
        );

        LebaniegoYearDocumentosAccionDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearDocumentosAccion",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "LebaniegoYearDocumentosAccionFile",
        "$http",
        "Upload",
    ]

    function LebaniegoYearDocumentosAccionDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearDocumentosAccion,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        LebaniegoYearDocumentosAccionFile,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearDocumentosAccion = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        LebaniegoYearDocumentosAccionFile.query(
            {
                id: vm.lebaniegoYearDocumentosAccion.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearDocumentosAccion = Object.assign({}, vm.lebaniegoYearDocumentosAccion);

            LebaniegoYearDocumentosAccion.update(lebaniegoYearDocumentosAccion, onSaveSuccess, onError);
        }

        function updateDocument(document) {
            LebaniegoYearDocumentosAccionFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-documents-action-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearDocumentosAccionFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearDocumentosAccionFile.query(
                        {
                            id: vm.lebaniegoYearDocumentosAccion.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-documents-action-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyDocumentsActionId: vm.lebaniegoYearDocumentosAccion.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearDocumentosAccionFile.query(
                            {
                                id: vm.lebaniegoYearDocumentosAccion.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-documents-accion", {
                parent: "entity",
                url: "/lebaniego-documents-accion?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearDocumentosAccion",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-acciones/lebaniego-documentos-accion.html",
                        controller:
                            "LebaniegoYearDocumentosAccionController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-documents-accion.new", {
                parent: "lebaniego-documents-accion",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-acciones/lebaniego-documentos-accion-new.html",
                        controller: "LebaniegoYearDocumentosAccionNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-documents-accion"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-documents-accion",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-documents-accion.edit", {
                parent: "lebaniego-documents-accion",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearDocumentosAccion"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-acciones/lebaniego-documentos-accion-detail.html",
                        controller: "LebaniegoYearDocumentosAccionDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-documents-accion"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearDocumentosAccion",
                        function ($stateParams, LebaniegoYearDocumentosAccion) {
                            return LebaniegoYearDocumentosAccion.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-documents-accion",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearDocumentosAccionController", LebaniegoYearDocumentosAccionController);

        LebaniegoYearDocumentosAccionController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearDocumentosAccion",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearDocumentosAccionController(
        DateUtils,
        $state,
        LebaniegoYearDocumentosAccion,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearDocumentosAccionParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearDocumentosAccionParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearDocumentosAccion.query(
                {
                    year: vm.searchItem.year,
                    description: vm.searchItem.description,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearDocumentosAcciones = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearDocumentosAccionParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("lebaniego-amount", {
            parent: "entity",
            url: "/lebaniego-amount?page&sort&search",
            data: {
                authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                pageTitle: "LebaniegoYearAmount",
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/entities/lebaniego/lebaniego-cuantias/lebaniego-cuantia.html",
                    controller: "LebaniegoYearAmountController",
                    controllerAs: "vm",
                },
            },
            params: {
                page: {
                    value: "1",
                    squash: true,
                },
                sort: {
                    value: "id,asc",
                    squash: true,
                },
                search: null,
            },
            resolve: {
                pagingParams: [
                    "$stateParams",
                    "PaginationUtil",
                    function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate(
                                $stateParams.sort
                            ),
                            ascending: PaginationUtil.parseAscending(
                                $stateParams.sort
                            ),
                            search: $stateParams.search,
                        };
                    },
                ],
            },
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearAmountController",
            LebaniegoYearAmountController
        );

    LebaniegoYearAmountController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearAmount",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "AmountCsv",
    ];

    function LebaniegoYearAmountController(
        DateUtils,
        $state,
        LebaniegoYearAmount,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        AmountCsv
    ) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem("searchParameters"));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.jurisdictions = [
            "Todas las cuantías",
            "Cuantías donantes",
            "Cuantías aportadas",
            "Cuantías ingresadas por convenio",
        ];

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.csvOrder = ["year", "businessName", "amount"];
        vm.getHeader = function () {
            return ["Año", "Razón Social", "Cuantía"];
        };

        searchExp();

        function searchExp() {
            localStorage.setItem(
                "searchParameters",
                JSON.stringify(vm.searchItem)
            );

            LebaniegoYearAmount.query(
                {
                    year: vm.searchItem.year,
                    jurisdiction: vm.searchItem.jurisdiction,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.amounts = data.listAmountDTO.content;
                vm.totalAmount = data.total;
                vm.page = pagingParams.page;

                if (vm.amounts.length > 0) {
                    vm.amounts.forEach(element => {
                        if (element.jurisdiction == "AÑO_LEBANIEGO_DONANTES") {
                            element.type = "Cuantías donantes";
                        } else if (element.jurisdiction == "AÑO_LEBANIEGO_APORTANTES") {
                            element.type = "Cuantías aportadas";
                        } else {
                            element.type = "Cuantías ingresadas por convenio";
                        }
                    });
                }

                console.log(vm.amounts);
                vm.filename = getFilename();
                getExportData();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getFilename() {
            var today = new Date();

            var dd = today.getDate();
            if (dd < 10) dd = "0" + dd;

            var mm = today.getMonth() + 1;
            if (mm < 10) mm = "0" + mm;

            var yy = today.getFullYear();

            return "export_cuantías_" + yy + mm + dd + ".csv";
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function getExportData() {
            AmountCsv.query({
                year: vm.searchItem.year,
                jurisdiction: vm.searchItem.jurisdiction,
            },
            function (data) {
                vm.exportData = data.listAmountDTO.content;
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearAgreementNewController",
            LebaniegoYearAgreementNewController
        );

    LebaniegoYearAgreementNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "GFile",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "$http",
        "$q"
    ];

    function LebaniegoYearAgreementNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        GFile,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        $http,
        $q
    ) {
        var vm = this;

        vm.gFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            vm.gFile.jurisdiction = "AÑO_LEBANIEGO_CONVENIO";
            var gFile = Object.assign({}, vm.gFile);
            if (gFile.sectorDate !== null) {
                gFile.sectorDate = DateUtils.convertLocalDateToServer(
                    gFile.sectorDate
                );
            }
            gFile.id = null;
            GFile.save(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-agreement.edit", {
                id: result.id,
            });
        }

        function onSaveError() {
            toastr.error("Error al crear el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/g-donor-files/search?searchText=' + searchText)
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.gFile.year = item.year;
                vm.gFile.sectorBusinessName = item.sectorBusinessName;
                vm.gFile.sectorNif = item.sectorNif;
                vm.gFile.sectorContact = item.sectorContact;
                vm.gFile.sectorAddress = item.sectorAddress;
                vm.gFile.sectorTelephone = item.sectorTelephone;
                vm.gFile.sectorEmail = item.sectorEmail;
                if (item.sectorDate !== null) {
                    vm.gFile.sectorDate = DateUtils.convertLocalDateFromServer(
                        item.sectorDate
                    );
                }
                vm.gFile.sectorDescription = item.sectorDescription;
                vm.gFile.sectorObservations = item.sectorObservations;

                $scope.searchText = '';
            }
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearAgreementDetailController",
            LebaniegoYearAgreementDetailController
        );

    LebaniegoYearAgreementDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$http",
        "previousState",
        "entity",
        "Principal",
        "LebaniegoYearAgreement",
        "GFileStep",
        "$state",
        "status",
        "Document",
        "DateUtils",
        "Observation",
        "toastr",
        "$mdSidenav",
    ];

    function LebaniegoYearAgreementDetailController(
        $scope,
        $rootScope,
        $http,
        previousState,
        entity,
        Principal,
        LebaniegoYearAgreement,
        GFileStep,
        $state,
        status,
        Document,
        DateUtils,
        Observation,
        toastr,
        $mdSidenav
    ) {
        var vm = this;

        vm.gFile = entity;

        vm.gfilestep = {};
        vm.toggleSidenav = buildToggler("left");
        vm.save = save;
        vm.clear = clear;

        vm.isdeletedstep = false;
        vm.edit_gstep = edit_gstep;
        vm.status = status;

        vm.openNewStepForm = openNewStepForm;
        vm.download_file = downloadfile;
        vm.new_document = new_document;
        vm.edit_document = edit_document;
        vm.previousState = previousState.name;
        vm.newstepform = false;
        vm.editdocumentform = false;
        vm.entityType = "GF";
        vm.list = [];
        vm.updatetree = false;
        vm.nodes = [];

        vm.actualAgreement = vm.gFile.sectorBusinessName;

        $scope.$watch("vm.updatetree", function () {
            if (vm.updatetree === true) {
                loadGFileSteps();
            }
            vm.updatetree = false;
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        var unsubscribe = $rootScope.$on(
            "expedientesUriarteApp:gFileUpdate",
            function (event, result) {
                vm.gFile = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        });
        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        });

        loadGFileSteps();
        hasNotes();

        function loadGFileSteps() {
            GFileStep.query(
                {
                    g_file_id: vm.gFile.id,
                    allSteps: false,
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                vm.list = [];
                if (data.length >= 1) {
                    vm.list = data;
                    vm.nodes = data;
                }
            }

            function onError(error) {}
        }

        function save() {
            vm.isSaving = true;
            var gFile = Object.assign({}, vm.gFile);
            LebaniegoYearAgreement.update(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.actualAgreement = vm.gFile.sectorBusinessName;
            toastr.success(
                "Actualizado con éxito!"
            );
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al actualizar el convenio");
            vm.isSaving = false;
        }

        function openNewStepForm(stepParent) {
            if (stepParent) {
                GFileStep.get(
                    {
                        id: stepParent,
                    },
                    onNewGStepSuccess,
                    onNewGStepError
                );
            } else {
                vm.newstepform = true;
                vm.stepParent = null;
                vm.editstepform = false;
                vm.newdocumentform = false;
                vm.editdocumentform = false;
            }
        }

        function onNewGStepSuccess(data) {
            vm.stepParent = data;
            vm.newstepform = true;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }
        function onNewGStepError(mssg) {
            console.log(mssg);
        }

        function edit_gstep(gstep_id, isdeleted) {
            vm.isdeletedstep = isdeleted;
            vm.gfilestep = {};
            GFileStep.get(
                {
                    id: gstep_id,
                },
                onEditGStepSuccess,
                onEditGStepError
            );
        }

        function onEditGStepSuccess(data) {
            vm.gfilestep = data;
            vm.editstepform = true;
            $scope.isDeleting = false;

            vm.newstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }

        function onEditGStepError(mssg) {
            console.log(mssg);
        }

        function downloadfile(documentId, fileType) {
            Document.get(
                {
                    id: documentId,
                },
                function (data) {
                    $http({
                        method: "GET",
                        url: "api/g-files/download/" + documentId,
                        responseType: "arraybuffer",
                        cache: false,
                    })
                        .success(function (result) {
                            var a = document.createElement("a");
                            var blob = new Blob([result], {
                                type: "application/octet-stream",
                            });
                            a.href = URL.createObjectURL(blob);

                            a.download = data.filename;
                            a.click();
                        })
                        .error(function (data, status, headers, config) {});
                }
            );
        }

        function new_document(gstep_id) {
            GFileStep.get(
                {
                    id: gstep_id,
                },
                onNewDocumentSuccess,
                onNewDocumentError
            );
        }

        function onNewDocumentSuccess(data) {
            vm.gfilestep = data;
            vm.newdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.editdocumentform = false;
        }

        function onNewDocumentError(mssg) {
            console.log(mssg);
        }

        function edit_document(document_id) {
            Document.get(
                {
                    id: document_id,
                },
                onEditDocumentSuccess,
                onEditDocumentError
            );
        }

        function onEditDocumentSuccess(data) {
            vm.document = data;
            vm.editdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.newdocumentform = false;
        }

        function onEditDocumentError(mssg) {
            console.log(mssg);
        }

        function hasNotes() {
            Observation.query(
                {
                    gFile: vm.gFile.id,
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                $rootScope.hasNotes = data.length;
            }

            function onError() {
                $rootScope.hasNotes = 0;
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-agreement", {
                parent: "entity",
                url: "/lebaniego-agreement?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearAgreement",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-convenios/lebaniego-convenio.html",
                        controller:
                            "LebaniegoYearAgreementController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    steps: ['$stateParams', 'Step', function($stateParams, Step) {
                        return Step.query().$promise;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                },
            })
            .state("lebaniego-agreement.new", {
                parent: "lebaniego-agreement",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-convenios/lebaniego-convenio-new.html",
                        controller: "LebaniegoYearAgreementNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-agreement"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-agreement",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-agreement.edit", {
                parent: "lebaniego-agreement",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearAgreement"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-convenios/lebaniego-convenio-detail.html",
                        controller: "LebaniegoYearAgreementDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-agreement"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearAgreement",
                        function ($stateParams, LebaniegoYearAgreement) {
                            return LebaniegoYearAgreement.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-agreement",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearAgreementController", LebaniegoYearAgreementController);

        LebaniegoYearAgreementController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearAgreement",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav"
    ];

    function LebaniegoYearAgreementController(
        DateUtils,
        $state,
        LebaniegoYearAgreement,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav
    ) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem("searchParameters"));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        if (vm.searchItem.startDate !== null) {
            vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(
                vm.searchItem.startDate
            );
        }

        if (vm.searchItem.endDate !== null) {
            vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(
                vm.searchItem.endDate
            );
        }

        vm.status = status;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        searchExp();

        function searchExp() {
            if (vm.searchItem.startDate !== null)
                vm.searchItem.startDate = DateUtils.convertLocalDateToServer(
                    vm.searchItem.startDate
                );
            if (vm.searchItem.endDate !== null)
                vm.searchItem.endDate = DateUtils.convertLocalDateToServer(
                    vm.searchItem.endDate
                );
            localStorage.setItem(
                "searchParameters",
                JSON.stringify(vm.searchItem)
            );

            LebaniegoYearAgreement.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    jurisdiction: 'AÑO_LEBANIEGO_CONVENIO',
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.gFiles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
            vm.searchItem.status = status[0];

            localStorage.setItem(
                "searchParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearControlDonorNewController", LebaniegoYearControlDonorNewController);

    LebaniegoYearControlDonorNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "$http",
        "$state",
        "$mdSidenav",
        "$q",
        "entity",
        "LebaniegoYearControlDonor",
        "previousState",
        "toastr",
        "DateUtils",
    ]

    function LebaniegoYearControlDonorNewController(
        $rootScope,
        $timeout,
        $scope,
        $http,
        $state,
        $mdSidenav,
        $q,
        entity,
        LebaniegoYearControlDonor,
        previousState,
        toastr,
        DateUtils
    ) {
        var vm = this;

        vm.lebaniegoYearControlDonor = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearControlDonorParameters")
        );
        
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearControlDonor = Object.assign({}, vm.lebaniegoYearControlDonor);
            lebaniegoYearControlDonor.id = null;
            lebaniegoYearControlDonor.year = vm.lebaniegoYearControlDonor.year;
            lebaniegoYearControlDonor.sector = 'DONANTE';
            vm.lebaniegoYearControlDonor.gFile = {
                id: vm.lebaniegoYearControlDonor.gFile
            };
            lebaniegoYearControlDonor.gFile = vm.lebaniegoYearControlDonor.gFile;
            LebaniegoYearControlDonor.save(lebaniegoYearControlDonor, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-control-donor", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el donante");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-control/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_DONANTES')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearControlDonor.businessName = item.sectorBusinessName;
                vm.lebaniegoYearControlDonor.gFile = item.gFileId;
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearControlDonorDetailController",
            LebaniegoYearControlDonorDetailController
        );

    LebaniegoYearControlDonorDetailController.$inject = [
        "$rootScope",
        "$mdSidenav",
        "$scope",
        "$http",
        "$q",
        "$mdDialog",
        "previousState",
        "entity",
        "Principal",
        "LebaniegoYearControlDonor",
        "LebaniegoYearControlDonorFile",
        "$state",
        "toastr",
        "Upload"
    ];

    function LebaniegoYearControlDonorDetailController(
        $rootScope,
        $mdSidenav,
        $scope,
        $http,
        $q,
        $mdDialog,
        previousState,
        entity,
        Principal,
        LebaniegoYearControlDonor,
        LebaniegoYearControlDonorFile,
        $state,
        toastr,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearControlDonor = entity;
        vm.actualBusinessName = vm.lebaniegoYearControlDonor.gFile.sectorBusinessName;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;
        vm.clear = clear;

        vm.list = [];
        vm.nodes = [];

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        });
        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        });

        LebaniegoYearControlDonorFile.query(
            {
                id: vm.lebaniegoYearControlDonor.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearControlDonor = Object.assign({}, vm.lebaniegoYearControlDonor);
            lebaniegoYearControlDonor.gFile = {id: vm.lebaniegoYearControlDonor.gFile.id};
            LebaniegoYearControlDonor.update(lebaniegoYearControlDonor, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            if (vm.actualBusinessName != vm.lebaniegoYearControlDonor.gFile.sectorBusinessName) {
                vm.actualBusinessName = vm.lebaniegoYearControlDonor.gFile.sectorBusinessName.sectorBusinessName;
            }
            toastr.success("Actualizado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al actualizar el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

        function updateDocument(document) {
            LebaniegoYearControlDonorFile.update(document, onSaveSuccess, onSaveError);
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-control-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearControlDonorFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearControlDonorFile.query(
                        {
                            id: vm.lebaniegoYearControlDonor.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-control-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyControlId: vm.lebaniegoYearControlDonor.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearControlDonorFile.query(
                            {
                                id: vm.lebaniegoYearControlDonor.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-control/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_DONANTES')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearControlDonor.businessName = item.sectorBusinessName;
                vm.lebaniegoYearControlDonor.gFile.id = item.gFileId;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-control-donor", {
                parent: "entity",
                url: "/lebaniego-control-donor?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearControlDonor",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-control/lebaniego-control-donantes/lebaniego-control-donante.html",
                        controller:
                            "LebaniegoYearControlDonorController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-control-donor.new", {
                parent: "lebaniego-control-donor",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-control/lebaniego-control-donantes/lebaniego-control-donante-new.html",
                        controller: "LebaniegoYearControlDonorNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-control-donor"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-control-donor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-control-donor.edit", {
                parent: "lebaniego-control-donor",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearControlDonor"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-control/lebaniego-control-donantes/lebaniego-control-donante-detail.html",
                        controller: "LebaniegoYearControlDonorDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-control-donor"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearControlDonor",
                        function ($stateParams, LebaniegoYearControlDonor) {
                            return LebaniegoYearControlDonor.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-control-donor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearControlDonorController",
            LebaniegoYearControlDonorController
        );

    LebaniegoYearControlDonorController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearControlDonor",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearControlDonorController(
        DateUtils,
        $state,
        LebaniegoYearControlDonor,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearControlDonorParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearControlDonorParameters",
                JSON.stringify(vm.searchItem)
            );
            LebaniegoYearControlDonor.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    jurisdiction: 'AÑO_LEBANIEGO_DONANTES',
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearControlDonors = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearControlDonorParameters",
                JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearControlAgreementNewController", LebaniegoYearControlAgreementNewController);

    LebaniegoYearControlAgreementNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "$http",
        "$state",
        "$mdSidenav",
        "$q",
        "entity",
        "LebaniegoYearControlAgreement",
        "previousState",
        "toastr",
        "DateUtils",
    ]

    function LebaniegoYearControlAgreementNewController(
        $rootScope,
        $timeout,
        $scope,
        $http,
        $state,
        $mdSidenav,
        $q,
        entity,
        LebaniegoYearControlAgreement,
        previousState,
        toastr,
        DateUtils
    ) {
        var vm = this;

        vm.lebaniegoYearControlAgreement = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearControlAgreementParameters")
        );
        
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearControlAgreement = Object.assign({}, vm.lebaniegoYearControlAgreement);
            lebaniegoYearControlAgreement.id = null;
            lebaniegoYearControlAgreement.year = vm.lebaniegoYearControlAgreement.year;
            lebaniegoYearControlAgreement.sector = 'CONVENIO';
            vm.lebaniegoYearControlAgreement.gFile = {
                id: vm.lebaniegoYearControlAgreement.gFile
            };
            lebaniegoYearControlAgreement.gFile = vm.lebaniegoYearControlAgreement.gFile;
            LebaniegoYearControlAgreement.save(lebaniegoYearControlAgreement, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-control-agreement", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el convenio");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-control/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_CONVENIO')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearControlAgreement.businessName = item.sectorBusinessName;
                vm.lebaniegoYearControlAgreement.gFile = item.gFileId;
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearControlAgreementDetailController",
            LebaniegoYearControlAgreementDetailController
        );

    LebaniegoYearControlAgreementDetailController.$inject = [
        "$rootScope",
        "$mdSidenav",
        "$scope",
        "$http",
        "$q",
        "$mdDialog",
        "previousState",
        "entity",
        "Principal",
        "LebaniegoYearControlAgreement",
        "LebaniegoYearControlAgreementFile",
        "$state",
        "toastr",
        "Upload"
    ];

    function LebaniegoYearControlAgreementDetailController(
        $rootScope,
        $mdSidenav,
        $scope,
        $http,
        $q,
        $mdDialog,
        previousState,
        entity,
        Principal,
        LebaniegoYearControlAgreement,
        LebaniegoYearControlAgreementFile,
        $state,
        toastr,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearControlAgreement = entity;
        vm.actualBusinessName = vm.lebaniegoYearControlAgreement.gFile.sectorBusinessName;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;
        vm.clear = clear;

        vm.list = [];
        vm.nodes = [];

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        });
        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        });

        LebaniegoYearControlAgreementFile.query(
            {
                id: vm.lebaniegoYearControlAgreement.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearControlAgreement = Object.assign({}, vm.lebaniegoYearControlAgreement);
            lebaniegoYearControlAgreement.gFile = {id: vm.lebaniegoYearControlAgreement.gFile.id};
            LebaniegoYearControlAgreement.update(lebaniegoYearControlAgreement, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            if (vm.actualBusinessName != vm.lebaniegoYearControlAgreement.gFile.sectorBusinessName) {
                vm.actualBusinessName = vm.lebaniegoYearControlAgreement.gFile.sectorBusinessName.sectorBusinessName;
            }
            toastr.success("Actualizado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al actualizar el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

        function updateDocument(document) {
            LebaniegoYearControlAgreementFile.update(document, onSaveSuccess, onSaveError);
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-control-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearControlAgreementFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearControlAgreementFile.query(
                        {
                            id: vm.lebaniegoYearControlAgreement.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-control-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyControlId: vm.lebaniegoYearControlAgreement.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearControlAgreementFile.query(
                            {
                                id: vm.lebaniegoYearControlAgreement.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-control/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_CONVENIO')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearControlAgreement.businessName = item.sectorBusinessName;
                vm.lebaniegoYearControlAgreement.gFile.id = item.gFileId;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-control-agreement", {
                parent: "entity",
                url: "/lebaniego-control-agreement?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearControlAgreement",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-control/lebaniego-control-convenios/lebaniego-control-convenio.html",
                        controller:
                            "LebaniegoYearControlAgreementController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-control-agreement.new", {
                parent: "lebaniego-control-agreement",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-control/lebaniego-control-convenios/lebaniego-control-convenio-new.html",
                        controller: "LebaniegoYearControlAgreementNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-control-agreement"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-control-agreement",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-control-agreement.edit", {
                parent: "lebaniego-control-agreement",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearControlAgreement"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-control/lebaniego-control-convenios/lebaniego-control-convenio-detail.html",
                        controller: "LebaniegoYearControlAgreementDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-control-agreement"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearControlAgreement",
                        function ($stateParams, LebaniegoYearControlAgreement) {
                            return LebaniegoYearControlAgreement.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-control-agreement",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearControlAgreementController",
            LebaniegoYearControlAgreementController
        );

    LebaniegoYearControlAgreementController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearControlAgreement",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearControlAgreementController(
        DateUtils,
        $state,
        LebaniegoYearControlAgreement,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearControlAgreementParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearControlAgreementParameters",
                JSON.stringify(vm.searchItem)
            );
            LebaniegoYearControlAgreement.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    jurisdiction: 'AÑO_LEBANIEGO_CONVENIO',
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearControlAgreements = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearControlAgreementParameters",
                JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearControlContributorNewController", LebaniegoYearControlContributorNewController);

    LebaniegoYearControlContributorNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "$http",
        "$state",
        "$mdSidenav",
        "$q",
        "entity",
        "LebaniegoYearControlContributor",
        "previousState",
        "toastr",
        "DateUtils",
    ]

    function LebaniegoYearControlContributorNewController(
        $rootScope,
        $timeout,
        $scope,
        $http,
        $state,
        $mdSidenav,
        $q,
        entity,
        LebaniegoYearControlContributor,
        previousState,
        toastr,
        DateUtils
    ) {
        var vm = this;

        vm.lebaniegoYearControlContributor = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearControlContributorParameters")
        );
        
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearControlContributor = Object.assign({}, vm.lebaniegoYearControlContributor);
            lebaniegoYearControlContributor.id = null;
            lebaniegoYearControlContributor.year = vm.lebaniegoYearControlContributor.year;
            lebaniegoYearControlContributor.sector = 'APORTANTE';
            vm.lebaniegoYearControlContributor.gFile = {
                id: vm.lebaniegoYearControlContributor.gFile
            };
            lebaniegoYearControlContributor.gFile = vm.lebaniegoYearControlContributor.gFile;
            LebaniegoYearControlContributor.save(lebaniegoYearControlContributor, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-control-contributor", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el aportante");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-control/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_APORTANTES')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearControlContributor.businessName = item.sectorBusinessName;
                vm.lebaniegoYearControlContributor.gFile = item.gFileId;
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearControlContributorDetailController",
            LebaniegoYearControlContributorDetailController
        );

    LebaniegoYearControlContributorDetailController.$inject = [
        "$rootScope",
        "$mdSidenav",
        "$scope",
        "$http",
        "$q",
        "$mdDialog",
        "previousState",
        "entity",
        "Principal",
        "LebaniegoYearControlContributor",
        "LebaniegoYearControlContributorFile",
        "$state",
        "toastr",
        "Upload"
    ];

    function LebaniegoYearControlContributorDetailController(
        $rootScope,
        $mdSidenav,
        $scope,
        $http,
        $q,
        $mdDialog,
        previousState,
        entity,
        Principal,
        LebaniegoYearControlContributor,
        LebaniegoYearControlContributorFile,
        $state,
        toastr,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearControlContributor = entity;
        vm.actualBusinessName = vm.lebaniegoYearControlContributor.gFile.sectorBusinessName;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;
        vm.clear = clear;

        vm.list = [];
        vm.nodes = [];

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        });
        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        });

        LebaniegoYearControlContributorFile.query(
            {
                id: vm.lebaniegoYearControlContributor.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearControlContributor = Object.assign({}, vm.lebaniegoYearControlContributor);
            lebaniegoYearControlContributor.gFile = {id: vm.lebaniegoYearControlContributor.gFile.id};
            LebaniegoYearControlContributor.update(lebaniegoYearControlContributor, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            if (vm.actualBusinessName != vm.lebaniegoYearControlContributor.gFile.sectorBusinessName) {
                vm.actualBusinessName = vm.lebaniegoYearControlContributor.gFile.sectorBusinessName.sectorBusinessName;
            }
            toastr.success("Actualizado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al actualizar el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

        function updateDocument(document) {
            LebaniegoYearControlContributorFile.update(document, onSaveSuccess, onSaveError);
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-control-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearControlContributorFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearControlContributorFile.query(
                        {
                            id: vm.lebaniegoYearControlContributor.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-control-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyControlId: vm.lebaniegoYearControlContributor.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearControlContributorFile.query(
                            {
                                id: vm.lebaniegoYearControlContributor.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-control/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_APORTANTES')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearControlContributor.businessName = item.sectorBusinessName;
                vm.lebaniegoYearControlContributor.gFile.id = item.gFileId;
            }
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-control-contributor", {
                parent: "entity",
                url: "/lebaniego-control-contributor?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearControlContributor",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-control/lebaniego-control-aportantes/lebaniego-control-aportante.html",
                        controller:
                            "LebaniegoYearControlContributorController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-control-contributor.new", {
                parent: "lebaniego-control-contributor",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-control/lebaniego-control-aportantes/lebaniego-control-aportante-new.html",
                        controller: "LebaniegoYearControlContributorNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-control-contributor"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-control-contributor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-control-contributor.edit", {
                parent: "lebaniego-control-contributor",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearControlContributor"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-control/lebaniego-control-aportantes/lebaniego-control-aportante-detail.html",
                        controller: "LebaniegoYearControlContributorDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-control-contributor"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearControlContributor",
                        function ($stateParams, LebaniegoYearControlContributor) {
                            return LebaniegoYearControlContributor.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-control-contributor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearControlContributorController",
            LebaniegoYearControlContributorController
        );

    LebaniegoYearControlContributorController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearControlContributor",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearControlContributorController(
        DateUtils,
        $state,
        LebaniegoYearControlContributor,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearControlContributorParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearControlContributorParameters",
                JSON.stringify(vm.searchItem)
            );
            LebaniegoYearControlContributor.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    jurisdiction: 'AÑO_LEBANIEGO_APORTANTES',
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearControlContributors = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearControlContributorParameters",
                JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosVisitaNewController", LebaniegoYearContactosVisitaNewController);

        LebaniegoYearContactosVisitaNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosVisita",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosVisitaNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosVisita,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosVisita = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");
        vm.sectors = ["Bebidas y alimentación de Cantabria", "Sector alimentario nacional", "Sector bebidas nacionales", "Sector fabricantes de aceite", "Empresas distribución", "Otros sectores"];

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosVisita = Object.assign({}, vm.lebaniegoYearContactosVisita);
            lebaniegoYearContactosVisita.id = null;
            LebaniegoYearContactosVisita.save(lebaniegoYearContactosVisita, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-visit", {});
        }

        function onSaveError() {
            toastr.error("Error al crear la visita");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContactosVisitaDetailController",
            LebaniegoYearContactosVisitaDetailController
        );

    LebaniegoYearContactosVisitaDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearContactosVisita",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "$http",
        "Upload",
    ]

    function LebaniegoYearContactosVisitaDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearContactosVisita,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearContactosVisita = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.sectors = ["Bebidas y alimentación de Cantabria", "Sector alimentario nacional", "Sector bebidas nacionales", "Sector fabricantes de aceite", "Empresas distribución", "Otros sectores"];
        
        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosVisita = Object.assign({}, vm.lebaniegoYearContactosVisita);

            LebaniegoYearContactosVisita.update(lebaniegoYearContactosVisita, onSaveSuccess, onError);
        }

        function onSaveSuccess(result) {
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contacts-visit", {
                parent: "entity",
                url: "/lebaniego-contacts-visit?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosVisita",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-visita/lebaniego-contactos-visita.html",
                        controller:
                            "LebaniegoYearContactosVisitaController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-contacts-visit.new", {
                parent: "lebaniego-contacts-visit",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-visita/lebaniego-contactos-visita-new.html",
                        controller: "LebaniegoYearContactosVisitaNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contacts-visit"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-visit",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contacts-visit.edit", {
                parent: "lebaniego-contacts-visit",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosVisita"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-visita/lebaniego-contactos-visita-detail.html",
                        controller: "LebaniegoYearContactosVisitaDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contacts-visit"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContactosVisita",
                        function ($stateParams, LebaniegoYearContactosVisita) {
                            return LebaniegoYearContactosVisita.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-visit",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosVisitaController", LebaniegoYearContactosVisitaController);

        LebaniegoYearContactosVisitaController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearContactosVisita",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearContactosVisitaController(
        DateUtils,
        $state,
        LebaniegoYearContactosVisita,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearContactosVisitaParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearContactosVisitaParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearContactosVisita.query(
                {
                    year: vm.searchItem.year,
                    sector: vm.searchItem.sector,
                    description: vm.searchItem.description,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearContactosVisitas = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearContactosVisitaParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorSfaNewController", LebaniegoYearContactosSectorSfaNewController);

    LebaniegoYearContactosSectorSfaNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosSectorSfa",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosSectorSfaNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosSectorSfa,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorSfa = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorSfa = Object.assign({}, vm.lebaniegoYearContactosSectorSfa);
            lebaniegoYearContactosSectorSfa.id = null;
            lebaniegoYearContactosSectorSfa.sector = "Sector fabricantes de aceite";
            LebaniegoYearContactosSectorSfa.save(lebaniegoYearContactosSectorSfa, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-sector-sfa", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el acta");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContactosSectorSfaDetailController",
            LebaniegoYearContactosSectorSfaDetailController
        );

    LebaniegoYearContactosSectorSfaDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearContactosSectorSfa",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "$http",
        "Upload",
    ]

    function LebaniegoYearContactosSectorSfaDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearContactosSectorSfa,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorSfa = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updatetree = false;
        vm.nodes = [];

        vm.actualSector = vm.lebaniegoYearContactosSectorSfa.businessName;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorSfa = Object.assign({}, vm.lebaniegoYearContactosSectorSfa);

            LebaniegoYearContactosSectorSfa.update(lebaniegoYearContactosSectorSfa, onSaveSuccess, onError);
        }

        function onSaveSuccess(result) {
            vm.actualSector = vm.lebaniegoYearContactosSectorSfa.businessName;
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contacts-sector-sfa", {
                parent: "entity",
                url: "/lebaniego-contacts-sector-sfa?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorSfa",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sfa/lebaniego-contactos-sector-sfa.html",
                        controller:
                            "LebaniegoYearContactosSectorSfaController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-contacts-sector-sfa.new", {
                parent: "lebaniego-contacts-sector-sfa",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sfa/lebaniego-contactos-sector-sfa-new.html",
                        controller: "LebaniegoYearContactosSectorSfaNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contacts-sector-sfa"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-sfa",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contacts-sector-sfa.edit", {
                parent: "lebaniego-contacts-sector-sfa",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorSfa"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sfa/lebaniego-contactos-sector-sfa-detail.html",
                        controller: "LebaniegoYearContactosSectorSfaDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contacts-sector-sfa"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContactosSectorSfa",
                        function ($stateParams, LebaniegoYearContactosSectorSfa) {
                            return LebaniegoYearContactosSectorSfa.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-sfa",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorSfaController", LebaniegoYearContactosSectorSfaController);

        LebaniegoYearContactosSectorSfaController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearContactosSectorSfa",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearContactosSectorSfaController(
        DateUtils,
        $state,
        LebaniegoYearContactosSectorSfa,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearContactosSectorSfaParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearContactosSectorSfaParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearContactosSectorSfa.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    sector: "Sector fabricantes de aceite",
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearContactosSectorSfas = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearContactosSectorSfaParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorSbnNewController", LebaniegoYearContactosSectorSbnNewController);

    LebaniegoYearContactosSectorSbnNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosSectorSbn",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosSectorSbnNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosSectorSbn,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorSbn = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorSbn = Object.assign({}, vm.lebaniegoYearContactosSectorSbn);
            lebaniegoYearContactosSectorSbn.id = null;
            lebaniegoYearContactosSectorSbn.sector = "Sector bebidas nacionales";
            LebaniegoYearContactosSectorSbn.save(lebaniegoYearContactosSectorSbn, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-sector-sbn", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el acta");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContactosSectorSbnDetailController",
            LebaniegoYearContactosSectorSbnDetailController
        );

    LebaniegoYearContactosSectorSbnDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearContactosSectorSbn",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "$http",
        "Upload",
    ]

    function LebaniegoYearContactosSectorSbnDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearContactosSectorSbn,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorSbn = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updatetree = false;
        vm.nodes = [];

        vm.actualSector = vm.lebaniegoYearContactosSectorSbn.businessName;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorSbn = Object.assign({}, vm.lebaniegoYearContactosSectorSbn);

            LebaniegoYearContactosSectorSbn.update(lebaniegoYearContactosSectorSbn, onSaveSuccess, onError);
        }

        function onSaveSuccess(result) {
            vm.actualSector = vm.lebaniegoYearContactosSectorSbn.businessName;
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contacts-sector-sbn", {
                parent: "entity",
                url: "/lebaniego-contacts-sector-sbn?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorSbn",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sbn/lebaniego-contactos-sector-sbn.html",
                        controller:
                            "LebaniegoYearContactosSectorSbnController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-contacts-sector-sbn.new", {
                parent: "lebaniego-contacts-sector-sbn",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sbn/lebaniego-contactos-sector-sbn-new.html",
                        controller: "LebaniegoYearContactosSectorSbnNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contacts-sector-sbn"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-sbn",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contacts-sector-sbn.edit", {
                parent: "lebaniego-contacts-sector-sbn",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorSbn"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sbn/lebaniego-contactos-sector-sbn-detail.html",
                        controller: "LebaniegoYearContactosSectorSbnDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contacts-sector-sbn"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContactosSectorSbn",
                        function ($stateParams, LebaniegoYearContactosSectorSbn) {
                            return LebaniegoYearContactosSectorSbn.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-sbn",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorSbnController", LebaniegoYearContactosSectorSbnController);

        LebaniegoYearContactosSectorSbnController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearContactosSectorSbn",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearContactosSectorSbnController(
        DateUtils,
        $state,
        LebaniegoYearContactosSectorSbn,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearContactosSectorSbnParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearContactosSectorSbnParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearContactosSectorSbn.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    sector: "Sector bebidas nacionales",
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearContactosSectorSbns = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearContactosSectorSbnParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorSanNewController", LebaniegoYearContactosSectorSanNewController);

    LebaniegoYearContactosSectorSanNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosSectorSan",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosSectorSanNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosSectorSan,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorSan = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorSan = Object.assign({}, vm.lebaniegoYearContactosSectorSan);
            lebaniegoYearContactosSectorSan.id = null;
            lebaniegoYearContactosSectorSan.sector = "Sector alimentario nacional"
            LebaniegoYearContactosSectorSan.save(lebaniegoYearContactosSectorSan, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-sector-san", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el acta");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContactosSectorSanDetailController",
            LebaniegoYearContactosSectorSanDetailController
        );

    LebaniegoYearContactosSectorSanDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearContactosSectorSan",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "$http",
        "Upload",
    ]

    function LebaniegoYearContactosSectorSanDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearContactosSectorSan,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorSan = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updatetree = false;
        vm.nodes = [];

        vm.actualSector = vm.lebaniegoYearContactosSectorSan.businessName;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorSan = Object.assign({}, vm.lebaniegoYearContactosSectorSan);

            LebaniegoYearContactosSectorSan.update(lebaniegoYearContactosSectorSan, onSaveSuccess, onError);
        }

        function onSaveSuccess(result) {
            vm.actualSector = vm.lebaniegoYearContactosSectorSan.businessName;
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contacts-sector-san", {
                parent: "entity",
                url: "/lebaniego-contacts-sector-san?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorSan",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-san/lebaniego-contactos-sector-san.html",
                        controller:
                            "LebaniegoYearContactosSectorSanController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-contacts-sector-san.new", {
                parent: "lebaniego-contacts-sector-san",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-san/lebaniego-contactos-sector-san-new.html",
                        controller: "LebaniegoYearContactosSectorSanNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contacts-sector-san"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-san",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contacts-sector-san.edit", {
                parent: "lebaniego-contacts-sector-san",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorSan"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-san/lebaniego-contactos-sector-san-detail.html",
                        controller: "LebaniegoYearContactosSectorSanDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contacts-sector-san"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContactosSectorSan",
                        function ($stateParams, LebaniegoYearContactosSectorSan) {
                            return LebaniegoYearContactosSectorSan.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-san",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorSanController", LebaniegoYearContactosSectorSanController);

        LebaniegoYearContactosSectorSanController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearContactosSectorSan",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearContactosSectorSanController(
        DateUtils,
        $state,
        LebaniegoYearContactosSectorSan,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearContactosSectorSanParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearContactosSectorSanParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearContactosSectorSan.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    sector: "Sector alimentario nacional",
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearContactosSectorSans = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearContactosSectorSanParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorOsNewController", LebaniegoYearContactosSectorOsNewController);

    LebaniegoYearContactosSectorOsNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosSectorOs",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosSectorOsNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosSectorOs,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorOs = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorOs = Object.assign({}, vm.lebaniegoYearContactosSectorOs);
            lebaniegoYearContactosSectorOs.id = null;
            lebaniegoYearContactosSectorOs.sector = "Otros sectores";
            LebaniegoYearContactosSectorOs.save(lebaniegoYearContactosSectorOs, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-sector-os", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el acta");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContactosSectorOsDetailController",
            LebaniegoYearContactosSectorOsDetailController
        );

    LebaniegoYearContactosSectorOsDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearContactosSectorOs",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "$http",
        "Upload",
    ]

    function LebaniegoYearContactosSectorOsDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearContactosSectorOs,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorOs = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updatetree = false;
        vm.nodes = [];

        vm.actualSector = vm.lebaniegoYearContactosSectorOs.businessName;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorOs = Object.assign({}, vm.lebaniegoYearContactosSectorOs);

            LebaniegoYearContactosSectorOs.update(lebaniegoYearContactosSectorOs, onSaveSuccess, onError);
        }

        function onSaveSuccess(result) {
            vm.actualSector = vm.lebaniegoYearContactosSectorOs.businessName;
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contacts-sector-os", {
                parent: "entity",
                url: "/lebaniego-contacts-sector-os?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorOs",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-os/lebaniego-contactos-sector-os.html",
                        controller:
                            "LebaniegoYearContactosSectorOsController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-contacts-sector-os.new", {
                parent: "lebaniego-contacts-sector-os",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-os/lebaniego-contactos-sector-os-new.html",
                        controller: "LebaniegoYearContactosSectorOsNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contacts-sector-os"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-os",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contacts-sector-os.edit", {
                parent: "lebaniego-contacts-sector-os",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorOs"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-os/lebaniego-contactos-sector-os-detail.html",
                        controller: "LebaniegoYearContactosSectorOsDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contacts-sector-os"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContactosSectorOs",
                        function ($stateParams, LebaniegoYearContactosSectorOs) {
                            return LebaniegoYearContactosSectorOs.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-os",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorOsController", LebaniegoYearContactosSectorOsController);

        LebaniegoYearContactosSectorOsController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearContactosSectorOs",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearContactosSectorOsController(
        DateUtils,
        $state,
        LebaniegoYearContactosSectorOs,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearContactosSectorOsParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearContactosSectorOsParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearContactosSectorOs.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    sector: "Otros sectores",
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearContactosSectorOss = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearContactosSectorOsParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorEdNewController", LebaniegoYearContactosSectorEdNewController);

    LebaniegoYearContactosSectorEdNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosSectorEd",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosSectorEdNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosSectorEd,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorEd = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorEd = Object.assign({}, vm.lebaniegoYearContactosSectorEd);
            lebaniegoYearContactosSectorEd.id = null;
            lebaniegoYearContactosSectorEd.sector = "Empresas distribución";
            LebaniegoYearContactosSectorEd.save(lebaniegoYearContactosSectorEd, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-sector-ed", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el acta");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContactosSectorEdDetailController",
            LebaniegoYearContactosSectorEdDetailController
        );

    LebaniegoYearContactosSectorEdDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearContactosSectorEd",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "$http",
        "Upload",
    ]

    function LebaniegoYearContactosSectorEdDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearContactosSectorEd,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorEd = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updatetree = false;
        vm.nodes = [];

        vm.actualSector = vm.lebaniegoYearContactosSectorEd.businessName;
        
        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorEd = Object.assign({}, vm.lebaniegoYearContactosSectorEd);

            LebaniegoYearContactosSectorEd.update(lebaniegoYearContactosSectorEd, onSaveSuccess, onError);
        }

        function onSaveSuccess(result) {
            vm.actualSector = vm.lebaniegoYearContactosSectorEd.businessName;
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contacts-sector-ed", {
                parent: "entity",
                url: "/lebaniego-contacts-sector-ed?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorEd",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-ed/lebaniego-contactos-sector-ed.html",
                        controller:
                            "LebaniegoYearContactosSectorEdController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-contacts-sector-ed.new", {
                parent: "lebaniego-contacts-sector-ed",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-ed/lebaniego-contactos-sector-ed-new.html",
                        controller: "LebaniegoYearContactosSectorEdNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contacts-sector-ed"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-ed",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contacts-sector-ed.edit", {
                parent: "lebaniego-contacts-sector-ed",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorEd"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-ed/lebaniego-contactos-sector-ed-detail.html",
                        controller: "LebaniegoYearContactosSectorEdDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contacts-sector-ed"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContactosSectorEd",
                        function ($stateParams, LebaniegoYearContactosSectorEd) {
                            return LebaniegoYearContactosSectorEd.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-ed",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorEdController", LebaniegoYearContactosSectorEdController);

        LebaniegoYearContactosSectorEdController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearContactosSectorEd",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearContactosSectorEdController(
        DateUtils,
        $state,
        LebaniegoYearContactosSectorEd,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearContactosSectorEdParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearContactosSectorEdParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearContactosSectorEd.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    sector: "Empresas distribución",
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearContactosSectorEds = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearContactosSectorEdParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorBacNewController", LebaniegoYearContactosSectorBacNewController);

    LebaniegoYearContactosSectorBacNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosSectorBac",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosSectorBacNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosSectorBac,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorBac = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorBac = Object.assign({}, vm.lebaniegoYearContactosSectorBac);
            lebaniegoYearContactosSectorBac.id = null;
            lebaniegoYearContactosSectorBac.sector = "Bebidas y alimentación de Cantabria";
            LebaniegoYearContactosSectorBac.save(lebaniegoYearContactosSectorBac, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-sector-bac", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el acta");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContactosSectorBacDetailController",
            LebaniegoYearContactosSectorBacDetailController
        );

    LebaniegoYearContactosSectorBacDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearContactosSectorBac",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "$http",
        "Upload",
    ]

    function LebaniegoYearContactosSectorBacDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearContactosSectorBac,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorBac = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updatetree = false;
        vm.nodes = [];

        vm.actualSector = vm.lebaniegoYearContactosSectorBac.businessName;

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorBac = Object.assign({}, vm.lebaniegoYearContactosSectorBac);

            LebaniegoYearContactosSectorBac.update(lebaniegoYearContactosSectorBac, onSaveSuccess, onError);
        }

        function onSaveSuccess(result) {
            vm.actualSector = vm.lebaniegoYearContactosSectorBac.businessName;
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contacts-sector-bac", {
                parent: "entity",
                url: "/lebaniego-contacts-sector-bac?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorBac",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-bac/lebaniego-contactos-sector-bac.html",
                        controller:
                            "LebaniegoYearContactosSectorBacController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-contacts-sector-bac.new", {
                parent: "lebaniego-contacts-sector-bac",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-bac/lebaniego-contactos-sector-bac-new.html",
                        controller: "LebaniegoYearContactosSectorBacNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contacts-sector-bac"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-bac",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contacts-sector-bac.edit", {
                parent: "lebaniego-contacts-sector-bac",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosSectorBac"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-bac/lebaniego-contactos-sector-bac-detail.html",
                        controller: "LebaniegoYearContactosSectorBacDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contacts-sector-bac"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContactosSectorBac",
                        function ($stateParams, LebaniegoYearContactosSectorBac) {
                            return LebaniegoYearContactosSectorBac.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-sector-bac",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorBacController", LebaniegoYearContactosSectorBacController);

        LebaniegoYearContactosSectorBacController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearContactosSectorBac",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearContactosSectorBacController(
        DateUtils,
        $state,
        LebaniegoYearContactosSectorBac,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearContactosSectorBacParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearContactosSectorBacParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearContactosSectorBac.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    sector: "Bebidas y alimentación de Cantabria",
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearContactosSectorBacs = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearContactosSectorBacParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosReunionNewController", LebaniegoYearContactosReunionNewController);

        LebaniegoYearContactosReunionNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosReunion",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosReunionNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosReunion,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosReunion = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");
        vm.sectors = ["Bebidas y alimentación de Cantabria", "Sector alimentario nacional", "Sector bebidas nacionales", "Sector fabricantes de aceite", "Empresas distribución", "Otros sectores"];
        vm.results = ["Interesado", "No Interesado", "Posponer Visita"];

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosReunion = Object.assign({}, vm.lebaniegoYearContactosReunion);
            lebaniegoYearContactosReunion.id = null;
            LebaniegoYearContactosReunion.save(lebaniegoYearContactosReunion, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-meeting", {});
        }

        function onSaveError() {
            toastr.error("Error al crear la reunión");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContactosReunionDetailController",
            LebaniegoYearContactosReunionDetailController
        );

    LebaniegoYearContactosReunionDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearContactosReunion",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "$http",
        "Upload",
    ]

    function LebaniegoYearContactosReunionDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearContactosReunion,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearContactosReunion = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.sectors = ["Bebidas y alimentación de Cantabria", "Sector alimentario nacional", "Sector bebidas nacionales", "Sector fabricantes de aceite", "Empresas distribución", "Otros sectores"];
        vm.results = ["Interesado", "No Interesado", "Posponer Visita"];
        
        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosReunion = Object.assign({}, vm.lebaniegoYearContactosReunion);

            LebaniegoYearContactosReunion.update(lebaniegoYearContactosReunion, onSaveSuccess, onError);
        }

        function onSaveSuccess(result) {
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contacts-meeting", {
                parent: "entity",
                url: "/lebaniego-contacts-meeting?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosReunion",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-reunion/lebaniego-contactos-reunion.html",
                        controller:
                            "LebaniegoYearContactosReunionController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-contacts-meeting.new", {
                parent: "lebaniego-contacts-meeting",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-reunion/lebaniego-contactos-reunion-new.html",
                        controller: "LebaniegoYearContactosReunionNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contacts-meeting"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-meeting",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contacts-meeting.edit", {
                parent: "lebaniego-contacts-meeting",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContactosReunion"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-reunion/lebaniego-contactos-reunion-detail.html",
                        controller: "LebaniegoYearContactosReunionDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contacts-meeting"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContactosReunion",
                        function ($stateParams, LebaniegoYearContactosReunion) {
                            return LebaniegoYearContactosReunion.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contacts-meeting",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosReunionController", LebaniegoYearContactosReunionController);

        LebaniegoYearContactosReunionController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearContactosReunion",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearContactosReunionController(
        DateUtils,
        $state,
        LebaniegoYearContactosReunion,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearContactosReunionParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearContactosReunionParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearContactosReunion.query(
                {
                    year: vm.searchItem.year,
                    sector: vm.searchItem.sector,
                    result: vm.searchItem.result,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearContactosReuniones = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearContactosReunionParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearComisionConvocatoriaNewController", LebaniegoYearComisionConvocatoriaNewController);

    LebaniegoYearComisionConvocatoriaNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearComisionConvocatoria",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearComisionConvocatoriaNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearComisionConvocatoria,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearComisionConvocatoria = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearComisionConvocatoria = Object.assign({}, vm.lebaniegoYearComisionConvocatoria);
            lebaniegoYearComisionConvocatoria.id = null;
            LebaniegoYearComisionConvocatoria.save(lebaniegoYearComisionConvocatoria, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-comission-annoucement", {});
        }

        function onSaveError() {
            toastr.error("Error al crear la convocatoria");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearComisionConvocatoriaDetailController",
            LebaniegoYearComisionConvocatoriaDetailController
        );

    LebaniegoYearComisionConvocatoriaDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearComisionConvocatoria",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "LebaniegoYearComisionConvocatoriaFile",
        "$http",
        "Upload",
    ]

    function LebaniegoYearComisionConvocatoriaDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearComisionConvocatoria,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        LebaniegoYearComisionConvocatoriaFile,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearComisionConvocatoria = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        LebaniegoYearComisionConvocatoriaFile.query(
            {
                id: vm.lebaniegoYearComisionConvocatoria.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearComisionConvocatoria = Object.assign({}, vm.lebaniegoYearComisionConvocatoria);

            LebaniegoYearComisionConvocatoria.update(lebaniegoYearComisionConvocatoria, onSaveSuccess, onError);
        }

        function updateDocument(document) {
            LebaniegoYearComisionConvocatoriaFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-comission-annoucement-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearComisionConvocatoriaFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearComisionConvocatoriaFile.query(
                        {
                            id: vm.lebaniegoYearComisionConvocatoria.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-comission-annoucement-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyComissionAnnoucementId: vm.lebaniegoYearComisionConvocatoria.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearComisionConvocatoriaFile.query(
                            {
                                id: vm.lebaniegoYearComisionConvocatoria.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-comission-annoucement", {
                parent: "entity",
                url: "/lebaniego-comission-annoucement?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearComisionConvocatoria",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-comision/lebaniego-comision-convocatorias/lebaniego-comision-convocatoria.html",
                        controller:
                            "LebaniegoYearComisionConvocatoriaController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-comission-annoucement.new", {
                parent: "lebaniego-comission-annoucement",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-comision/lebaniego-comision-convocatorias/lebaniego-comision-convocatoria-new.html",
                        controller: "LebaniegoYearComisionConvocatoriaNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-comission-annoucement"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-comission-annoucement",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-comission-annoucement.edit", {
                parent: "lebaniego-comission-annoucement",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearComisionConvocatoria"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-comision/lebaniego-comision-convocatorias/lebaniego-comision-convocatoria-detail.html",
                        controller: "LebaniegoYearComisionConvocatoriaDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-comission-annoucement"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearComisionConvocatoria",
                        function ($stateParams, LebaniegoYearComisionConvocatoria) {
                            return LebaniegoYearComisionConvocatoria.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-comission-annoucement",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearComisionConvocatoriaController", LebaniegoYearComisionConvocatoriaController);

        LebaniegoYearComisionConvocatoriaController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearComisionConvocatoria",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearComisionConvocatoriaController(
        DateUtils,
        $state,
        LebaniegoYearComisionConvocatoria,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearComisionConvocatoriaParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearComisionConvocatoriaParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearComisionConvocatoria.query(
                {
                    year: vm.searchItem.year,
                    description: vm.searchItem.description,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearComisionConvocatorias = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearComisionConvocatoriaParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearComisionActaNewController", LebaniegoYearComisionActaNewController);

    LebaniegoYearComisionActaNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearComisionActa",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearComisionActaNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearComisionActa,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearComisionActa = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearComisionActa = Object.assign({}, vm.lebaniegoYearComisionActa);
            lebaniegoYearComisionActa.id = null;
            LebaniegoYearComisionActa.save(lebaniegoYearComisionActa, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-comission-proceeding", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el acta");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearComisionActaDetailController",
            LebaniegoYearComisionActaDetailController
        );

    LebaniegoYearComisionActaDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "LebaniegoYearComisionActa",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "LebaniegoYearComisionActaFile",
        "$http",
        "Upload",
    ]

    function LebaniegoYearComisionActaDetailController(
        $mdDialog,
        entity,
        Principal,
        LebaniegoYearComisionActa,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        LebaniegoYearComisionActaFile,
        $http,
        Upload
    ) {
        var vm = this;

        vm.lebaniegoYearComisionActa = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        })
        Principal.hasAuthority("ROL_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        })

        LebaniegoYearComisionActaFile.query(
            {
                id: vm.lebaniegoYearComisionActa.id
            },
            onSuccess,
            onError
        );

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearComisionActa = Object.assign({}, vm.lebaniegoYearComisionActa);

            LebaniegoYearComisionActa.update(lebaniegoYearComisionActa, onSaveSuccess, onError);
        }

        function updateDocument(document) {
            LebaniegoYearComisionActaFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Guardada con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/ly-comission-proceeding-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            LebaniegoYearComisionActaFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    LebaniegoYearComisionActaFile.query(
                        {
                            id: vm.lebaniegoYearComisionActa.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/ly-comission-proceeding-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        lyComissionProceedingId: vm.lebaniegoYearComisionActa.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        LebaniegoYearComisionActaFile.query(
                            {
                                id: vm.lebaniegoYearComisionActa.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();
(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-comission-proceeding", {
                parent: "entity",
                url: "/lebaniego-comission-proceeding?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearComisionActa",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-comision/lebaniego-comision-actas/lebaniego-comision-acta.html",
                        controller:
                            "LebaniegoYearComisionActaController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-comission-proceeding.new", {
                parent: "lebaniego-comission-proceeding",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-comision/lebaniego-comision-actas/lebaniego-comision-acta-new.html",
                        controller: "LebaniegoYearComisionActaNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-comission-proceeding"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-comission-proceeding",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-comission-proceeding.edit", {
                parent: "lebaniego-comission-proceeding",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearComisionActa"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-comision/lebaniego-comision-actas/lebaniego-comision-acta-detail.html",
                        controller: "LebaniegoYearComisionActaDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-comission-proceeding"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearComisionActa",
                        function ($stateParams, LebaniegoYearComisionActa) {
                            return LebaniegoYearComisionActa.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-comission-proceeding",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearComisionActaController", LebaniegoYearComisionActaController);

        LebaniegoYearComisionActaController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearComisionActa",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function LebaniegoYearComisionActaController(
        DateUtils,
        $state,
        LebaniegoYearComisionActa,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearComisionActaParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            if (result) vm.searchItem.lebaniego = "";
            searchExp();
        });

        function searchExp() {
            localStorage.setItem(
                "searchLebaniegoYearComisionActaParameters", JSON.stringify(vm.searchItem)
            );
            LebaniegoYearComisionActa.query(
                {
                    year: vm.searchItem.year,
                    proceedingNumber: vm.searchItem.proceedingNumber,
                    description: vm.searchItem.description,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }
            
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.lebaniegoYearComisionActas = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchLebaniegoYearComisionActaParameters", JSON.stringify(vm.searchItem)
            );

            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContributorNewController",
            LebaniegoYearContributorNewController
        );

    LebaniegoYearContributorNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "GFile",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "$http",
        "$q"
    ];

    function LebaniegoYearContributorNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        GFile,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        $http,
        $q
    ) {
        var vm = this;

        vm.gFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            vm.gFile.jurisdiction = "AÑO_LEBANIEGO_APORTANTES";
            var gFile = Object.assign({}, vm.gFile);
            if (gFile.sectorDate !== null) {
                gFile.sectorDate = DateUtils.convertLocalDateToServer(
                    gFile.sectorDate
                );
            }
            gFile.status = null;
            gFile.id = null;
            GFile.save(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contributor.edit", {
                id: result.id,
            });
        }

        function onSaveError() {
            toastr.error("Error al crear el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/g-donor-files/search?searchText=' + searchText)
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.gFile.year = item.year;
                vm.gFile.sectorBusinessName = item.sectorBusinessName;
                vm.gFile.sectorNif = item.sectorNif;
                vm.gFile.sectorContact = item.sectorContact;
                vm.gFile.sectorAddress = item.sectorAddress;
                vm.gFile.sectorTelephone = item.sectorTelephone;
                vm.gFile.sectorEmail = item.sectorEmail;
                if (item.sectorDate !== null) {
                    vm.gFile.sectorDate = DateUtils.convertLocalDateFromServer(
                        item.sectorDate
                    );
                }
                vm.gFile.sectorDescription = item.sectorDescription;
                vm.gFile.sectorObservations = item.sectorObservations;

                $scope.searchText = '';
            }
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "LebaniegoYearContributorDetailController",
            LebaniegoYearContributorDetailController
        );

    LebaniegoYearContributorDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$http",
        "previousState",
        "entity",
        "Principal",
        "LebaniegoYearContributor",
        "GFileStep",
        "$state",
        "status",
        "Document",
        "DateUtils",
        "Observation",
        "toastr",
        "$mdSidenav",
    ];

    function LebaniegoYearContributorDetailController(
        $scope,
        $rootScope,
        $http,
        previousState,
        entity,
        Principal,
        LebaniegoYearContributor,
        GFileStep,
        $state,
        status,
        Document,
        DateUtils,
        Observation,
        toastr,
        $mdSidenav
    ) {
        var vm = this;

        vm.gFile = entity;

        vm.gfilestep = {};
        vm.toggleSidenav = buildToggler("left");
        vm.save = save;
        vm.clear = clear;

        vm.isdeletedstep = false;
        vm.edit_gstep = edit_gstep;
        vm.status = status;

        vm.openNewStepForm = openNewStepForm;
        vm.download_file = downloadfile;
        vm.new_document = new_document;
        vm.edit_document = edit_document;
        vm.previousState = previousState.name;
        vm.newstepform = false;
        vm.editdocumentform = false;
        vm.entityType = "GF";
        vm.list = [];
        vm.updatetree = false;
        vm.nodes = [];

        vm.actualContributor = vm.gFile.sectorBusinessName;

        $scope.$watch("vm.updatetree", function () {
            if (vm.updatetree === true) {
                loadGFileSteps();
            }
            vm.updatetree = false;
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        var unsubscribe = $rootScope.$on(
            "expedientesUriarteApp:gFileUpdate",
            function (event, result) {
                vm.gFile = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = true;
        });
        Principal.hasAuthority("ROLE_JUBILAR").then(function (result) {
            vm.isAdmin = true;
        });

        loadGFileSteps();
        hasNotes();

        function loadGFileSteps() {
            GFileStep.query(
                {
                    g_file_id: vm.gFile.id,
                    allSteps: false,
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                vm.list = [];
                if (data.length >= 1) {
                    vm.list = data;
                    vm.nodes = data;
                }
            }

            function onError(error) {}
        }

        function save() {
            vm.isSaving = true;
            var gFile = Object.assign({}, vm.gFile);
            LebaniegoYearContributor.update(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.actualContributor = vm.gFile.sectorBusinessName;
            toastr.success(
                "Actualizado con éxito!"
            );
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al actualizar");
            vm.isSaving = false;
        }

        function openNewStepForm(stepParent) {
            if (stepParent) {
                GFileStep.get(
                    {
                        id: stepParent,
                    },
                    onNewGStepSuccess,
                    onNewGStepError
                );
            } else {
                vm.newstepform = true;
                vm.stepParent = null;
                vm.editstepform = false;
                vm.newdocumentform = false;
                vm.editdocumentform = false;
            }
        }

        function onNewGStepSuccess(data) {
            vm.stepParent = data;
            vm.newstepform = true;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }
        function onNewGStepError(mssg) {
            console.log(mssg);
        }

        function edit_gstep(gstep_id, isdeleted) {
            vm.isdeletedstep = isdeleted;
            vm.gfilestep = {};
            GFileStep.get(
                {
                    id: gstep_id,
                },
                onEditGStepSuccess,
                onEditGStepError
            );
        }

        function onEditGStepSuccess(data) {
            vm.gfilestep = data;
            vm.editstepform = true;
            $scope.isDeleting = false;

            vm.newstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }

        function onEditGStepError(mssg) {
            console.log(mssg);
        }

        function downloadfile(documentId, fileType) {
            Document.get(
                {
                    id: documentId,
                },
                function (data) {
                    $http({
                        method: "GET",
                        url: "api/g-files/download/" + documentId,
                        responseType: "arraybuffer",
                        cache: false,
                    })
                        .success(function (result) {
                            var a = document.createElement("a");
                            var blob = new Blob([result], {
                                type: "application/octet-stream",
                            });
                            a.href = URL.createObjectURL(blob);

                            a.download = data.filename;
                            a.click();
                        })
                        .error(function (data, status, headers, config) {});
                }
            );
        }

        function new_document(gstep_id) {
            GFileStep.get(
                {
                    id: gstep_id,
                },
                onNewDocumentSuccess,
                onNewDocumentError
            );
        }

        function onNewDocumentSuccess(data) {
            vm.gfilestep = data;
            vm.newdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.editdocumentform = false;
        }

        function onNewDocumentError(mssg) {
            console.log(mssg);
        }

        function edit_document(document_id) {
            Document.get(
                {
                    id: document_id,
                },
                onEditDocumentSuccess,
                onEditDocumentError
            );
        }

        function onEditDocumentSuccess(data) {
            vm.document = data;
            vm.editdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.newdocumentform = false;
        }

        function onEditDocumentError(mssg) {
            console.log(mssg);
        }

        function hasNotes() {
            Observation.query(
                {
                    gFile: vm.gFile.id,
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                $rootScope.hasNotes = data.length;
            }

            function onError() {
                $rootScope.hasNotes = 0;
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-contributor", {
                parent: "entity",
                url: "/lebaniego-contributor?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContributor",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-aportantes/lebaniego-aportante.html",
                        controller:
                            "LebaniegoYearContributorController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    steps: ['$stateParams', 'Step', function($stateParams, Step) {
                        return Step.query().$promise;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                },
            })
            .state("lebaniego-contributor.new", {
                parent: "lebaniego-contributor",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-aportantes/lebaniego-aportante-new.html",
                        controller: "LebaniegoYearContributorNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-contributor"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contributor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-contributor.edit", {
                parent: "lebaniego-contributor",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearContributor"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-aportantes/lebaniego-aportante-detail.html",
                        controller: "LebaniegoYearContributorDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-contributor"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearContributor",
                        function ($stateParams, LebaniegoYearContributor) {
                            return LebaniegoYearContributor.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-contributor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            });
    }
})();
(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContributorController", LebaniegoYearContributorController);

        LebaniegoYearContributorController.$inject = [
        "DateUtils",
        "$state",
        "LebaniegoYearContributor",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
    ];

    function LebaniegoYearContributorController(
        DateUtils,
        $state,
        LebaniegoYearContributor,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav
    ) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem("searchParameters"));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        if (vm.searchItem.startDate !== null) {
            vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(
                vm.searchItem.startDate
            );
        }

        if (vm.searchItem.endDate !== null) {
            vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(
                vm.searchItem.endDate
            );
        }

        vm.status = status;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        searchExp();

        function searchExp() {
            if (vm.searchItem.startDate !== null)
                vm.searchItem.startDate = DateUtils.convertLocalDateToServer(
                    vm.searchItem.startDate
                );
            if (vm.searchItem.endDate !== null)
                vm.searchItem.endDate = DateUtils.convertLocalDateToServer(
                    vm.searchItem.endDate
                );
            localStorage.setItem(
                "searchParameters",
                JSON.stringify(vm.searchItem)
            );

            LebaniegoYearContributor.query(
                {
                    year: vm.searchItem.year,
                    businessName: vm.searchItem.businessName,
                    nif: vm.searchItem.nif,
                    jurisdiction: 'AÑO_LEBANIEGO_APORTANTES',
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.gFiles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
            vm.searchItem.status = status[0];

            localStorage.setItem(
                "searchParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('newGfileStep', {
            bindings: {
                gfile: '<',
                stepparent: '=',
                updatetree: '=',
                newstepform: '='
            },
            templateUrl: 'app/entities/g-file-step/new-g-file-step-component.html',
            controller: ['$scope', 'Step', 'StepStatus', 'GFileStep', 'DateUtils','toastr',
                function ($scope, Step, StepStatus, GFileStep, DateUtils, toastr) {
                    var $ctrl = this;

                    $ctrl.$onInit = initialization;
                    $ctrl.save = save;
                    $ctrl.close = close;
                    $ctrl.gfilestep = {};
                    $ctrl.status = [];

                    $scope.$watch('$ctrl.newstepform', function() {
                        if ($ctrl.newstepform === true) {
                            $ctrl.gfilestep = {};
                            calculate_combo_step();
                        }
                    });

                    $scope.$watch('$ctrl.gfilestep.step', function() {
                        if ($ctrl.gfilestep.step && $ctrl.gfilestep.step.status){
                            StepStatus.query({
                                stepId: $ctrl.gfilestep.step.id
                            }).$promise
                                .then(function(data) {
                                    $ctrl.status = data;
                                });
                        }
                    });

                    /**
                     * public methods
                     */
                    /**
                     * @function
                     * @name initialization
                     * @description
                     * A component's lifeCycle hook which is called after all the controllers on an element have been constructed and had their bindings initialized
                     */
                    function initialization() {}

                    function calculate_combo_step() {

                        var stepParentId = null;

                        if($ctrl.stepparent != null) {
                            stepParentId = $ctrl.stepparent.step.id;
                        }

                        var query = {
                            jurisdiction: $ctrl.gfile.jurisdiction,
                            stepParent : stepParentId
                        };

                        Step.query(query)
                            .$promise
                            .then(function(data) {
                                var stepsPosible = data;
                                GFileStep.query({
                                    g_file_id: $ctrl.gfile.id,
                                    allSteps: true
                                }).$promise
                                    .then(function(data) {
                                        $ctrl.steps = [];

                                        for (var i = 0; i < stepsPosible.length; i++) {
                                            var found = false;

                                            for (var j = 0; j < data.length; j++) {
                                                if (stepsPosible[i].name === data[j].title) {
                                                    found = true;
                                                    break;
                                                }
                                            }

                                            if (!found) {
                                                $ctrl.steps.push(stepsPosible[i]);
                                            }
                                        }
                                    });
                            });
                    }


                    function save() {
                        $ctrl.isSaving = true;
                        var gFile = {"id": $ctrl.gfile.id};
                        var gFileStep = Object.assign({}, $ctrl.gfilestep);
                        gFileStep.gfile = gFile;
                        if ($ctrl.stepparent) {
                            gFileStep.stepParent = $ctrl.stepparent.id;
                        }
                        GFileStep.save(gFileStep, onSaveSuccess, onSaveError);
                    }

                    function onSaveSuccess() {
                        toastr.success('Fase creada con éxito');
                        $ctrl.updatetree = true;
                        $ctrl.newstepform = false;
                        $ctrl.isSaving = false;
                    }

                    function onSaveError() {
                        toastr.error('Error al crear la fase');
                        $ctrl.isSaving = false;
                    }

                    function close() {
                        $ctrl.newstepform = false;
                    }

                }
            ]
        });
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('editGfileStep', {
            bindings: {
                gfilestep: '=',
                editstepform: '=',
                updatetree: '=',
                isdeletedstep: '<'
            },
            templateUrl: 'app/entities/g-file-step/edit-g-file-step-component.html',
            controller: ['$scope', 'StepStatus','DateUtils', 'GFileStep', 'toastr',
                function ($scope, StepStatus, DateUtils, GFileStep, toastr) {
                    var $ctrl = this;

                    $ctrl.$onInit = initialization;
                    $ctrl.save = save;
                    $ctrl.close = close;
                    $ctrl.remove_gstep = remove_gstep;

                    function initialization() {

                    }

                    $scope.$watch('$ctrl.gfilestep.step', function() {
                      if ($ctrl.gfilestep.step && $ctrl.gfilestep.step.status){
                        StepStatus.query({
                            stepId: $ctrl.gfilestep.step.id
                        })
                            .$promise
                            .then(function(data) {
                              $ctrl.status = data;
                            });
                      }
                    });

                    function save() {
                        $ctrl.isSaving = true;
                        var gFile = {"id": $ctrl.gfilestep.gfile.id};
                        var gFileStep = Object.assign({}, $ctrl.gfilestep);
                        gFileStep.actions = undefined;
                        gFileStep.gfile = gFile;
                        GFileStep.update(gFileStep, onSaveSuccess, onSaveError);
                    }

                    function onSaveSuccess(result) {
                        toastr.success('Actualizada con éxito!', 'Fase ' + result.step.name);

                        $ctrl.editstepform = false;
                        $ctrl.isSaving = false;
                    }

                    function onSaveError() {
                        toastr.error('Error al actualizar la fase');
                        $ctrl.isSaving = false;
                    }

                    function close() {
                        $ctrl.editstepform = false;
                    }

                    function remove_gstep() {
                        GFileStep.delete({
                                id: $ctrl.gfilestep.id
                            },
                            function() {
                                toastr.success('Fase eliminada con éxito');
                                $ctrl.updatetree = true;
                                $ctrl.editstepform = false;
                                $ctrl.isdeletedstep = false;
                            },
                            function () {
                                toastr.error('No puede eliminarse una fase con actuaciones');
                            });
                    }

                }
            ]
        });
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFilePenalNewController', GFilePenalNewController);

    GFilePenalNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'GFile', 'lawyers', '$state', 'previousState',  'processtypes', 'clients', 'toastr', 'DateUtils', '$mdSidenav'];

    function GFilePenalNewController($rootScope, $timeout, $scope, entity, GFile, lawyers, $state, previousState, processtypes, clients ,toastr, DateUtils, $mdSidenav) {
        var vm = this;

        vm.gFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.processtypes = processtypes;
        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.toggleSidenav = buildToggler('left');
        vm.gFile.code = '';

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            vm.gFile.jurisdiction = 'PENAL';
            var gFile = Object.assign({}, vm.gFile);
            if (gFile.registerDate !== null) {
                gFile.registerDate = DateUtils.convertLocalDateToServer(gFile.registerDate);
            }
            if (gFile.notificationDate !== null) {
                gFile.notificationDate = DateUtils.convertLocalDateToServer(gFile.notificationDate);
            }
            if (gFile.presentationDate !== null) {
                gFile.presentationDate = DateUtils.convertLocalDateToServer(gFile.presentationDate);
            }
            gFile.client = vm.gFile.client.name;
            gFile.id = null;
            GFile.save(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!', 'Expediente ' + result.code);
            vm.isSaving = false;
            $state.go('g-file-penal.edit', {
                'id': result.id
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el expediente');
            vm.isSaving = false;
        }


        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
          }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFilePenalDetailController', GFilePenalDetailController);

    GFilePenalDetailController.$inject = ['$scope', '$rootScope', '$http', 'previousState', 'entity', 'Principal', 'GFile', 'GFileStep', '$state',
        'Document', 'DateUtils', 'processtypes', 'status', 'Observation', 'toastr', 'lawyers', 'clients' ,'$mdSidenav'];

    function GFilePenalDetailController($scope, $rootScope, $http, previousState, entity, Principal, GFile,  GFileStep, $state,
                                   Document, DateUtils, processtypes, status, Observation, toastr, lawyers, clients, $mdSidenav) {
        var vm = this;

        vm.gFile = entity;

        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.gfilestep = {};
        vm.file_type= "PENAL";

        vm.save = save;

        vm.isdeletedstep = false;
        vm.edit_gstep = edit_gstep;
        vm.processtypes = processtypes;
        vm.status = status;

        vm.openNewStepForm = openNewStepForm;
        vm.download_file =  downloadfile;
        vm.new_document = new_document;
        vm.edit_document = edit_document;
        vm.previousState = previousState.name;
        vm.newstepform = false;
        vm.editdocumentform = false;
        vm.entityType = "GF";
        vm.list = [];
        vm.updatetree = false;
        vm.nodes = [];
        vm.toggleSidenav = buildToggler('left');

        $scope.$watch('vm.updatetree', function() {
            if (vm.updatetree === true) {
                loadGFileSteps();
            }
            vm.updatetree = false;
        });

        var unsubscribe = $rootScope.$on('expedientesUriarteApp:gFileUpdate', function(event, result) {
            vm.gFile = result;
        });
        $scope.$on('$destroy', unsubscribe);

        Principal.hasAuthority("ROLE_ADMIN")
            .then(function (result) {
                vm.isAdmin = result;
            });

        loadGFileSteps();
        hasNotes();

        function loadGFileSteps() {
            GFileStep.query({
                g_file_id: vm.gFile.id,
                allSteps: false
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.list = [];
                if (data.length >= 1) {
                    vm.list = data;
                    vm.nodes = data;
                }
            }

            function onError(error) {
            }
        }

        function save() {
            vm.isSaving = true;
            var gFile = Object.assign({}, vm.gFile);
            gFile.client = vm.gFile.client.name;
            GFile.update(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Actualizado con éxito!', 'Expediente ' + result.code);
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al actualizar el expediente');
            vm.isSaving = false;
        }

        function openNewStepForm(stepParent) {

           if (stepParent) {
             GFileStep.get({
                 id: stepParent
             }, onNewGStepSuccess, onNewGStepError);
           }
           else {
            vm.newstepform = true;
            vm.stepParent = null;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
          }
        }

        function onNewGStepSuccess(data) {
            vm.stepParent = data;
            vm.newstepform = true;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }
        function onNewGStepError() {
            //TODO
        }

        function edit_gstep(gstep_id, isdeleted) {
            vm.isdeletedstep = isdeleted;
            vm.gfilestep = {};
            GFileStep.get({
                id: gstep_id
            }, onEditGStepSuccess, onEditGStepError);
        }

        function onEditGStepSuccess(data) {
            vm.gfilestep = data;
            vm.editstepform = true;
            $scope.isDeleting = false;

            vm.newstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }

        function onEditGStepError() {
            //TODO
        }

        function downloadfile(documentId, fileType) {
            Document.get({
                id: documentId
            }, function(data) {
                $http({
                    method: 'GET',
                    url: 'api/g-files/download/' + documentId,
                    responseType: 'arraybuffer',
                    cache: false
                }).success(function (result) {
                    var a = document.createElement('a');
                    var blob = new Blob([result], {
                        'type': "application/octet-stream"
                    });
                    a.href = URL.createObjectURL(blob);
                    
                    a.download = data.filename;
                    a.click();
                }).error(function (data, status, headers, config) {

                });
            });
        }

        function new_document(gstep_id) {
            GFileStep.get({
                id: gstep_id
            }, onNewDocumentSuccess, onNewDocumentError);
        }

        function onNewDocumentSuccess(data) {
            vm.gfilestep = data;
            vm.newdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.editdocumentform = false;
        }

        function onNewDocumentError() {
            //TODO
        }

        function edit_document(document_id) {
            Document.get({
                id: document_id
            }, onEditDocumentSuccess, onEditDocumentError);
        }

        function onEditDocumentSuccess(data) {
            vm.document = data;
            vm.editdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.newdocumentform = false;
        }

        function onEditDocumentError() {
            //TODO
        }

        function hasNotes() {
            Observation.query({
                gFile: vm.gFile.id
            }, onSuccess, onError);

            function onSuccess(data) {
                $rootScope.hasNotes = data.length;
            }

            function onError() {
                $rootScope.hasNotes = 0;
            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
            });
          };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('g-file-penal', {
                parent: 'entity',
                url: '/g-file-penal?page&sort&search&code&type&nif&name&sn1&sn2&company_name',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'GFiles'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/g-file-penal/g-files.html',
                    controller: 'GFilePenalController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    steps: ['$stateParams', 'Step', function($stateParams, Step) {
                        return Step.query().$promise;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('g-file-penal.edit', {
                parent: 'g-file-penal',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'GFile'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/g-file-penal/g-file-detail.html',
                        controller: 'GFilePenalDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Administrar',
                      parent: 'g-file-penal'
                },
                resolve: {
                    entity: ['$stateParams', 'GFile', function($stateParams, GFile) {
                        return GFile.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    processtypes: ['$stateParams', 'ProcessType', function($stateParams, ProcessType) {
                        return ProcessType.query({jurisdiction: 'PENAL'}).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'g-file',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('g-file-penal.new', {
                parent: 'g-file-penal',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/g-file-penal/g-file-new.html',
                    controller: 'GFilePenalNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'g-file-penal'
                },
                resolve: {
                    entity: function() {
                        return {
                            code: null,
                            id: null
                        };
                    },
                    processtypes: ['$stateParams', 'ProcessType', function($stateParams, ProcessType) {
                        return ProcessType.query({jurisdiction: 'PENAL'}).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'g-file',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFilePenalController', GFilePenalController);

    GFilePenalController.$inject = ['DateUtils', '$state', 'GFile', 'GFileCsv', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','steps', 'status', '$mdSidenav'];

    function GFilePenalController (DateUtils, $state, GFile, GFileCsv, ParseLinks, AlertService, paginationConstants, pagingParams, steps, status, $mdSidenav) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchParameters'));

        if (vm.searchItem === null) {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];
        }

        if (vm.searchItem.startDate !== null) {
            vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
        }

        if (vm.searchItem.endDate !== null) {
            vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);
        }

        vm.status = status;
        vm.steps = steps;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.csvOrder = ["code", "lawyer", "client", "applicant", "applicantNif" , "procuratorApplicant", "defendant",  "defendantNif", "procuratorDefendant", "court", "processType", "step", "status"];
        vm.getHeader = function () {
            return ["Código", "Letrado",  "Cliente", "Demandante", "NIF Demandante", "Procurador demandante", "Demandado", "NIF Demandado",  "Procurador demandado", "Juzgado", "Procedimiento", "Fase", "Estado"];
        };

        searchExp();

        function searchExp() {
            // Store the value(s)
            if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
            if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);
            localStorage.setItem('searchParameters', JSON.stringify(vm.searchItem));

            var idStep = null;
            if (angular.isDefined(vm.searchItem.step) ) {
                idStep = vm.searchItem.step.id;
            }

            var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
                idStatus = vm.searchItem.status.id;
            }

            GFile.query({
                code: vm.searchItem.code,
                status: idStatus,
                client: vm.searchItem.client,
                startDate: vm.searchItem.startDate,
                endDate: vm.searchItem.endDate,
                jurisdiction: 'PENAL',
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.gFiles = data;
                vm.page = pagingParams.page;

                if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
                if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);

                vm.filename = getFilename();
                getExportData();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getFilename() {
          var today = new Date();

          var dd = today.getDate();
          if(dd < 10) dd = "0" + dd;

          var mm = today.getMonth()+1;
          if(mm < 10) mm = "0" + mm;

          var yy = today.getFullYear();

            return "export_expedientes_penal_" + yy + mm + dd + ".csv";
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];

          localStorage.setItem('searchParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function getExportData(){
          var idFileType = null;
          if (angular.isDefined(vm.searchItem.fileType) ) {
            idFileType = vm.searchItem.fileType.id;
          }

          var idStep = null;
          if (angular.isDefined(vm.searchItem.step) ) {
              idStep = vm.searchItem.step.id;
          }

          var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
              idStatus = vm.searchItem.status.id;
          }

          if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
          if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);

          GFileCsv.query({
            code: vm.searchItem.code,
            year: vm.searchItem.year,
            status: idStatus,
            step: idStep,
            startDate: vm.searchItem.startDate,
            endDate: vm.searchItem.endDate,
            jurisdiction: 'PENAL'
        }, function(data) {
            vm.exportData = data;
            vm.exportData.forEach(function(item) {
              if (item.processType) { 
                  item.processType = item.processType.description;
              }
              if (item.client) { 
                  item.client = item.client.description;
              }
            });
        });
        }

        if(angular.isDefined(vm.searchItem.fileType)) {
            Step.query({
                file_type_id: vm.searchItem.fileType.id
            }, function (data) {
                vm.steps = data;
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
            });
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFileMercantilNewController', GFileMercantilNewController);

    GFileMercantilNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'GFile', 'lawyers', '$state', 'previousState',  'processtypes', 'clients', 'toastr', 'DateUtils', '$mdSidenav'];

    function GFileMercantilNewController($rootScope, $timeout, $scope, entity, GFile, lawyers, $state, previousState, processtypes, clients ,toastr, DateUtils, $mdSidenav) {
        var vm = this;

        vm.gFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.processtypes = processtypes;
        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.toggleSidenav = buildToggler('left');
        vm.gFile.code = '';

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            vm.gFile.jurisdiction = 'MERCANTIL';
            var gFile = Object.assign({}, vm.gFile);
            if (gFile.registerDate !== null) {
                gFile.registerDate = DateUtils.convertLocalDateToServer(gFile.registerDate);
            }
            if (gFile.notificationDate !== null) {
                gFile.notificationDate = DateUtils.convertLocalDateToServer(gFile.notificationDate);
            }
            if (gFile.presentationDate !== null) {
                gFile.presentationDate = DateUtils.convertLocalDateToServer(gFile.presentationDate);
            }
            gFile.client = vm.gFile.client.name;
            gFile.id = null;
            GFile.save(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!', 'Expediente ' + result.code);
            vm.isSaving = false;
            $state.go('g-file-mercantil.edit', {
                'id': result.id
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el expediente');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFileMercantilDetailController', GFileMercantilDetailController);

    GFileMercantilDetailController.$inject = ['$scope', '$rootScope', '$http', 'previousState', 'entity', 'Principal', 'GFile', 'GFileStep', '$state',
        'Document', 'DateUtils', 'processtypes', 'status', 'Observation', 'toastr', 'lawyers' , 'clients', '$mdSidenav'];

    function GFileMercantilDetailController($scope, $rootScope, $http, previousState, entity, Principal, GFile,  GFileStep, $state,
                                   Document, DateUtils, processtypes, status, Observation, toastr, lawyers, clients, $mdSidenav) {
        var vm = this;

        vm.gFile = entity;

        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.gfilestep = {};
        vm.file_type= "MERCANTIL";
        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.isdeletedstep = false;
        vm.edit_gstep = edit_gstep;
        vm.processtypes = processtypes;
        vm.status = status;

        vm.openNewStepForm = openNewStepForm;
        vm.download_file =  downloadfile;
        vm.new_document = new_document;
        vm.edit_document = edit_document;
        vm.previousState = previousState.name;
        vm.newstepform = false;
        vm.editdocumentform = false;
        vm.entityType = "GF";
        vm.list = [];
        vm.updatetree = false;
        vm.nodes = [];

        $scope.$watch('vm.updatetree', function() {
            if (vm.updatetree === true) {
                loadGFileSteps();
            }
            vm.updatetree = false;
        });

        var unsubscribe = $rootScope.$on('expedientesUriarteApp:gFileUpdate', function(event, result) {
            vm.gFile = result;
        });
        $scope.$on('$destroy', unsubscribe);

        Principal.hasAuthority("ROLE_ADMIN")
            .then(function (result) {
                vm.isAdmin = result;
            });

        loadGFileSteps();
        hasNotes();

        function loadGFileSteps() {
            GFileStep.query({
                g_file_id: vm.gFile.id,
                allSteps: false
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.list = [];
                if (data.length >= 1) {
                    vm.list = data;
                    vm.nodes = data;
                }
            }

            function onError(error) {
            }
        }

        function save() {
            vm.isSaving = true;
            var gFile = Object.assign({}, vm.gFile);
            gFile.client = vm.gFile.client.name;
            GFile.update(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Actualizado con éxito!', 'Expediente ' + result.code);
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al actualizar el expediente');
            vm.isSaving = false;
        }

        function openNewStepForm(stepParent) {

           if (stepParent) {
             GFileStep.get({
                 id: stepParent
             }, onNewGStepSuccess, onNewGStepError);
           }
           else {
            vm.newstepform = true;
            vm.stepParent = null;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
          }
        }

        function onNewGStepSuccess(data) {
            vm.stepParent = data;
            vm.newstepform = true;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }
        function onNewGStepError() {
            //TODO
        }

        function edit_gstep(gstep_id, isdeleted) {
            vm.isdeletedstep = isdeleted;
            vm.gfilestep = {};
            GFileStep.get({
                id: gstep_id
            }, onEditGStepSuccess, onEditGStepError);
        }

        function onEditGStepSuccess(data) {
            vm.gfilestep = data;
            vm.editstepform = true;
            $scope.isDeleting = false;

            vm.newstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }

        function onEditGStepError() {
            //TODO
        }

        function downloadfile(documentId, fileType) {
            Document.get({
                id: documentId
            }, function(data) {
                $http({
                    method: 'GET',
                    url: 'api/g-files/download/' + documentId,
                    responseType: 'arraybuffer',
                    cache: false
                }).success(function (result) {
                    var a = document.createElement('a');
                    var blob = new Blob([result], {
                        'type': "application/octet-stream"
                    });
                    a.href = URL.createObjectURL(blob);
                    
                    a.download = data.filename;
                    a.click();
                }).error(function (data, status, headers, config) {

                });
            });
        }

        function new_document(gstep_id) {
            GFileStep.get({
                id: gstep_id
            }, onNewDocumentSuccess, onNewDocumentError);
        }

        function onNewDocumentSuccess(data) {
            vm.gfilestep = data;
            vm.newdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.editdocumentform = false;
        }

        function onNewDocumentError() {
            //TODO
        }

        function edit_document(document_id) {
            Document.get({
                id: document_id
            }, onEditDocumentSuccess, onEditDocumentError);
        }

        function onEditDocumentSuccess(data) {
            vm.document = data;
            vm.editdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.newdocumentform = false;
        }

        function onEditDocumentError() {
            //TODO
        }

        function hasNotes() {
            Observation.query({
                gFile: vm.gFile.id
            }, onSuccess, onError);

            function onSuccess(data) {
                $rootScope.hasNotes = data.length;
            }

            function onError() {
                $rootScope.hasNotes = 0;
            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('g-file-mercantil', {
                parent: 'entity',
                url: '/g-file-mercantil?page&sort&search&code&type&nif&name&sn1&sn2&company_name',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'GFiles'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/g-file-mercantil/g-files.html',
                    controller: 'GFileMercantilController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    steps: ['$stateParams', 'Step', function($stateParams, Step) {
                        return Step.query().$promise;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('g-file-mercantil.edit', {
                parent: 'g-file-mercantil',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'GFile'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/g-file-mercantil/g-file-detail.html',
                        controller: 'GFileMercantilDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Administrar',
                      parent: 'g-file-mercantil'
                },
                resolve: {
                    entity: ['$stateParams', 'GFile', function($stateParams, GFile) {
                        return GFile.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    processtypes: ['$stateParams', 'ProcessType', function($stateParams, ProcessType) {
                        return ProcessType.query({jurisdiction: 'MERCANTIL'}).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'g-file',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('g-file-mercantil.new', {
                parent: 'g-file-mercantil',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/g-file-mercantil/g-file-new.html',
                    controller: 'GFileMercantilNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'g-file-mercantil'
                },
                resolve: {
                    entity: function() {
                        return {
                            code: null,
                            id: null
                        };
                    },
                    processtypes: ['$stateParams', 'ProcessType', function($stateParams, ProcessType) {
                        return ProcessType.query({jurisdiction: 'MERCANTIL'}).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'g-file',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFileMercantilController', GFileMercantilController);

    GFileMercantilController.$inject = ['DateUtils', '$state', 'GFile', 'GFileCsv', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','steps', 'status', '$mdSidenav'];

    function GFileMercantilController (DateUtils, $state, GFile, GFileCsv, ParseLinks, AlertService, paginationConstants, pagingParams, steps, status, $mdSidenav) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchParameters'));

        if (vm.searchItem === null) {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];
        }

        if (vm.searchItem.startDate !== null) {
            vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
        }

        if (vm.searchItem.endDate !== null) {
            vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);
        }

        vm.status = status;
        vm.steps = steps;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.csvOrder = ["code", "lawyer", "client", "applicant", "applicantNif" , "procuratorApplicant", "defendant",  "defendantNif", "procuratorDefendant", "court", "processType", "step", "status"];
        vm.getHeader = function () {
            return ["Código", "Letrado",  "Cliente", "Demandante", "NIF Demandante", "Procurador demandante", "Demandado", "NIF Demandado",  "Procurador demandado", "Juzgado", "Procedimiento", "Fase", "Estado"];
        };

        searchExp();

        function searchExp() {
            // Store the value(s)
            if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
            if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);
            localStorage.setItem('searchParameters', JSON.stringify(vm.searchItem));

            var idStep = null;
            if (angular.isDefined(vm.searchItem.step) ) {
                idStep = vm.searchItem.step.id;
            }

            var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
                idStatus = vm.searchItem.status.id;
            }

            GFile.query({
                code: vm.searchItem.code,
                status: idStatus,
                client: vm.searchItem.client,
                startDate: vm.searchItem.startDate,
                endDate: vm.searchItem.endDate,
                jurisdiction: 'MERCANTIL',
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.gFiles = data;
                vm.page = pagingParams.page;

                if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
                if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);

                vm.filename = getFilename();
                getExportData();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getFilename() {
          var today = new Date();

          var dd = today.getDate();
          if(dd < 10) dd = "0" + dd;

          var mm = today.getMonth()+1;
          if(mm < 10) mm = "0" + mm;

          var yy = today.getFullYear();

            return "export_expedientes_mercantil_" + yy + mm + dd + ".csv";
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];

          localStorage.setItem('searchParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function getExportData(){
          var idFileType = null;
          if (angular.isDefined(vm.searchItem.fileType) ) {
            idFileType = vm.searchItem.fileType.id;
          }

          var idStep = null;
          if (angular.isDefined(vm.searchItem.step) ) {
              idStep = vm.searchItem.step.id;
          }

          var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
              idStatus = vm.searchItem.status.id;
          }

          if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
          if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);

          GFileCsv.query({
            code: vm.searchItem.code,
            year: vm.searchItem.year,
            status: idStatus,
            step: idStep,
            startDate: vm.searchItem.startDate,
            endDate: vm.searchItem.endDate,
            jurisdiction: 'MERCANTIL'
        }, function(data) {
            vm.exportData = data;
            vm.exportData.forEach(function(item) {
              if (item.processType) { 
                  item.processType = item.processType.description;
              }
              if (item.client) { 
                  item.client = item.client.description;
              }
            });
        });
        }

        if(angular.isDefined(vm.searchItem.fileType)) {
            Step.query({
                file_type_id: vm.searchItem.fileType.id
            }, function (data) {
                vm.steps = data;
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFileLaboralNewController', GFileLaboralNewController);

    GFileLaboralNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'GFile', 'lawyers', '$state', 'previousState',  'processtypes', 'clients', 'toastr', 'DateUtils','$mdSidenav'];

    function GFileLaboralNewController($rootScope, $timeout, $scope, entity, GFile, lawyers, $state, previousState, processtypes, clients ,toastr, DateUtils, $mdSidenav) {
        var vm = this;

        vm.gFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.processtypes = processtypes;
        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.toggleSidenav = buildToggler('left');
        vm.gFile.code = '';

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            vm.gFile.jurisdiction = 'LABORAL';
            var gFile = Object.assign({}, vm.gFile);
            if (gFile.registerDate !== null) {
                gFile.registerDate = DateUtils.convertLocalDateToServer(gFile.registerDate);
            }
            if (gFile.notificationDate !== null) {
                gFile.notificationDate = DateUtils.convertLocalDateToServer(gFile.notificationDate);
            }
            if (gFile.presentationDate !== null) {
                gFile.presentationDate = DateUtils.convertLocalDateToServer(gFile.presentationDate);
            }
            gFile.client = vm.gFile.client.name;
            gFile.id = null;
            GFile.save(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!', 'Expediente ' + result.code);
            vm.isSaving = false;
            $state.go('g-file-laboral.edit', {
                'id': result.id
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el expediente');
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFileLaboralDetailController', GFileLaboralDetailController);

    GFileLaboralDetailController.$inject = ['$scope', '$rootScope', '$http', 'previousState', 'entity', 'Principal', 'GFile', 'GFileStep', '$state',
        'Document', 'DateUtils', 'processtypes', 'status', 'Observation', 'toastr', 'lawyers' , 'clients', '$mdSidenav'];

    function GFileLaboralDetailController($scope, $rootScope, $http, previousState, entity, Principal, GFile,  GFileStep, $state,
                                   Document, DateUtils, processtypes, status, Observation, toastr, lawyers, clients, $mdSidenav) {
        var vm = this;

        vm.gFile = entity;

        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.gfilestep = {};
        vm.file_type= "LABORAL";
        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.isdeletedstep = false;
        vm.edit_gstep = edit_gstep;
        vm.processtypes = processtypes;
        vm.status = status;

        vm.openNewStepForm = openNewStepForm;
        vm.download_file =  downloadfile;
        vm.new_document = new_document;
        vm.edit_document = edit_document;
        vm.previousState = previousState.name;
        vm.newstepform = false;
        vm.editdocumentform = false;
        vm.entityType = "GF";
        vm.list = [];
        vm.updatetree = false;
        vm.nodes = [];

        $scope.$watch('vm.updatetree', function() {
            if (vm.updatetree === true) {
                loadGFileSteps();
            }
            vm.updatetree = false;
        });

        var unsubscribe = $rootScope.$on('expedientesUriarteApp:gFileUpdate', function(event, result) {
            vm.gFile = result;
        });
        $scope.$on('$destroy', unsubscribe);

        Principal.hasAuthority("ROLE_ADMIN")
            .then(function (result) {
                vm.isAdmin = result;
            });

        loadGFileSteps();
        hasNotes();

        function loadGFileSteps() {
            GFileStep.query({
                g_file_id: vm.gFile.id,
                allSteps: false
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.list = [];
                if (data.length >= 1) {
                    vm.list = data;
                    vm.nodes = data;
                }
            }

            function onError(error) {
            }
        }

        function save() {
            vm.isSaving = true;
            var gFile = Object.assign({}, vm.gFile);
            gFile.client = vm.gFile.client.name;
            GFile.update(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Actualizado con éxito!', 'Expediente ' + result.code);
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al actualizar el expediente');
            vm.isSaving = false;
        }

        function openNewStepForm(stepParent) {

           if (stepParent) {
             GFileStep.get({
                 id: stepParent
             }, onNewGStepSuccess, onNewGStepError);
           }
           else {
            vm.newstepform = true;
            vm.stepParent = null;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
          }
        }

        function onNewGStepSuccess(data) {
            vm.stepParent = data;
            vm.newstepform = true;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }
        function onNewGStepError() {
            //TODO
        }

        function edit_gstep(gstep_id, isdeleted) {
            vm.isdeletedstep = isdeleted;
            vm.gfilestep = {};
            GFileStep.get({
                id: gstep_id
            }, onEditGStepSuccess, onEditGStepError);
        }

        function onEditGStepSuccess(data) {
            vm.gfilestep = data;
            vm.editstepform = true;
            $scope.isDeleting = false;

            vm.newstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }

        function onEditGStepError() {
            //TODO
        }

        function downloadfile(documentId, fileType) {
            Document.get({
                id: documentId
            }, function(data) {
                $http({
                    method: 'GET',
                    url: 'api/g-files/download/' + documentId,
                    responseType: 'arraybuffer',
                    cache: false
                }).success(function (result) {
                    var a = document.createElement('a');
                    var blob = new Blob([result], {
                        'type': "application/octet-stream"
                    });
                    a.href = URL.createObjectURL(blob);
                    
                    a.download = data.filename;
                    a.click();
                }).error(function (data, status, headers, config) {

                });
            });
        }

        function new_document(gstep_id) {
            GFileStep.get({
                id: gstep_id
            }, onNewDocumentSuccess, onNewDocumentError);
        }

        function onNewDocumentSuccess(data) {
            vm.gfilestep = data;
            vm.newdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.editdocumentform = false;
        }

        function onNewDocumentError() {
            //TODO
        }

        function edit_document(document_id) {
            Document.get({
                id: document_id
            }, onEditDocumentSuccess, onEditDocumentError);
        }

        function onEditDocumentSuccess(data) {
            vm.document = data;
            vm.editdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.newdocumentform = false;
        }

        function onEditDocumentError() {
            //TODO
        }

        function hasNotes() {
            Observation.query({
                gFile: vm.gFile.id
            }, onSuccess, onError);

            function onSuccess(data) {
                $rootScope.hasNotes = data.length;
            }

            function onError() {
                $rootScope.hasNotes = 0;
            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('g-file-laboral', {
                parent: 'entity',
                url: '/g-file-laboral?page&sort&search&code&type&nif&name&sn1&sn2&company_name',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'GFiles'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/g-file-laboral/g-files.html',
                    controller: 'GFileLaboralController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    steps: ['$stateParams', 'Step', function($stateParams, Step) {
                        return Step.query().$promise;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('g-file-laboral.edit', {
                parent: 'g-file-laboral',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'GFile'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/g-file-laboral/g-file-detail.html',
                        controller: 'GFileLaboralDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Administrar',
                      parent: 'g-file-laboral'
                },
                resolve: {
                    entity: ['$stateParams', 'GFile', function($stateParams, GFile) {
                        return GFile.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    processtypes: ['$stateParams', 'ProcessType', function($stateParams, ProcessType) {
                        return ProcessType.query({jurisdiction: 'LABORAL'}).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'g-file',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('g-file-laboral.new', {
                parent: 'g-file-laboral',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/g-file-laboral/g-file-new.html',
                    controller: 'GFileLaboralNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'g-file-laboral'
                },
                resolve: {
                    entity: function() {
                        return {
                            code: null,
                            id: null
                        };
                    },
                    processtypes: ['$stateParams', 'ProcessType', function($stateParams, ProcessType) {
                        return ProcessType.query({jurisdiction: 'LABORAL'}).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'g-file',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFileLaboralController', GFileLaboralController);

    GFileLaboralController.$inject = ['DateUtils', '$state', 'GFile', 'GFileCsv', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','steps', 'status', '$mdSidenav'];

    function GFileLaboralController (DateUtils, $state, GFile, GFileCsv, ParseLinks, AlertService, paginationConstants, pagingParams, steps, status, $mdSidenav) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchParameters'));

        if (vm.searchItem === null) {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];
        }

        if (vm.searchItem.startDate !== null) {
            vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
        }

        if (vm.searchItem.endDate !== null) {
            vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);
        }

        vm.status = status;
        vm.steps = steps;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.csvOrder = ["code", "lawyer", "client", "applicant", "applicantNif" , "procuratorApplicant", "defendant",  "defendantNif", "procuratorDefendant", "court", "processType", "step", "status"];
        vm.getHeader = function () {
            return ["Código", "Letrado",  "Cliente", "Demandante", "NIF Demandante", "Procurador demandante", "Demandado", "NIF Demandado",  "Procurador demandado", "Juzgado", "Procedimiento", "Fase", "Estado"];
        };

        searchExp();

        function searchExp() {
            // Store the value(s)
            if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
            if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);
            localStorage.setItem('searchParameters', JSON.stringify(vm.searchItem));

            var idStep = null;
            if (angular.isDefined(vm.searchItem.step) ) {
                idStep = vm.searchItem.step.id;
            }

            var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
                idStatus = vm.searchItem.status.id;
            }

            GFile.query({
                code: vm.searchItem.code,
                status: idStatus,
                client: vm.searchItem.client,
                startDate: vm.searchItem.startDate,
                endDate: vm.searchItem.endDate,
                jurisdiction: 'LABORAL',
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.gFiles = data;
                vm.page = pagingParams.page;

                if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
                if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);

                vm.filename = getFilename();
                getExportData();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getFilename() {
          var today = new Date();

          var dd = today.getDate();
          if(dd < 10) dd = "0" + dd;

          var mm = today.getMonth()+1;
          if(mm < 10) mm = "0" + mm;

          var yy = today.getFullYear();

            return "export_expedientes_laboral_" + yy + mm + dd + ".csv";
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];

          localStorage.setItem('searchParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function getExportData(){
          var idFileType = null;
          if (angular.isDefined(vm.searchItem.fileType) ) {
            idFileType = vm.searchItem.fileType.id;
          }

          var idStep = null;
          if (angular.isDefined(vm.searchItem.step) ) {
              idStep = vm.searchItem.step.id;
          }

          var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
              idStatus = vm.searchItem.status.id;
          }

          if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
          if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);

          GFileCsv.query({
            code: vm.searchItem.code,
            year: vm.searchItem.year,
            status: idStatus,
            step: idStep,
            startDate: vm.searchItem.startDate,
            endDate: vm.searchItem.endDate,
            jurisdiction: 'LABORAL'
        }, function(data) {
            vm.exportData = data;
            vm.exportData.forEach(function(item) {
              if (item.processType) { 
                  item.processType = item.processType.description;
              }
              if (item.client) { 
                  item.client = item.client.description;
              }
            });
        });
        }

        if(angular.isDefined(vm.searchItem.fileType)) {
            Step.query({
                file_type_id: vm.searchItem.fileType.id
            }, function (data) {
                vm.steps = data;
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFileContenciosoNewController', GFileContenciosoNewController);

    GFileContenciosoNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'GFile', 'lawyers', '$state', 'previousState',  'processtypes', 'clients', 'toastr', 'DateUtils', '$mdSidenav'];

    function GFileContenciosoNewController($rootScope, $timeout, $scope, entity, GFile, lawyers, $state, previousState, processtypes, clients ,toastr, DateUtils, $mdSidenav) {
        var vm = this;

        vm.gFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.processtypes = processtypes;
        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.toggleSidenav = buildToggler('left');
        vm.gFile.code = '';

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            vm.gFile.jurisdiction = 'CONTENCIOSA';
            var gFile = Object.assign({}, vm.gFile);
            if (gFile.registerDate !== null) {
                gFile.registerDate = DateUtils.convertLocalDateToServer(gFile.registerDate);
            }
            if (gFile.notificationDate !== null) {
                gFile.notificationDate = DateUtils.convertLocalDateToServer(gFile.notificationDate);
            }
            if (gFile.presentationDate !== null) {
                gFile.presentationDate = DateUtils.convertLocalDateToServer(gFile.presentationDate);
            }
            gFile.client = vm.gFile.client.name;
            gFile.id = null;
            GFile.save(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!', 'Expediente ' + result.code);
            vm.isSaving = false;
            $state.go('g-file-contencioso.edit', {
                'id': result.id
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el expediente');
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "GFileContenciosoDetailController",
            GFileContenciosoDetailController
        );

    GFileContenciosoDetailController.$inject = [
        "$scope",
        "$rootScope",
        "$http",
        "previousState",
        "entity",
        "Principal",
        "GFile",
        "GFileStep",
        "$state",
        "Document",
        "DateUtils",
        "processtypes",
        "status",
        "Observation",
        "toastr",
        "lawyers",
        "clients",
        "$mdSidenav",
    ];

    function GFileContenciosoDetailController(
        $scope,
        $rootScope,
        $http,
        previousState,
        entity,
        Principal,
        GFile,
        GFileStep,
        $state,
        Document,
        DateUtils,
        processtypes,
        status,
        Observation,
        toastr,
        lawyers,
        clients,
        $mdSidenav
    ) {
        var vm = this;

        vm.gFile = entity;

        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.gfilestep = {};
        vm.file_type = "CONTENCIOSA";
        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.isdeletedstep = false;
        vm.edit_gstep = edit_gstep;
        vm.processtypes = processtypes;
        vm.status = status;

        vm.openNewStepForm = openNewStepForm;
        vm.download_file = downloadfile;
        vm.new_document = new_document;
        vm.edit_document = edit_document;
        vm.previousState = previousState.name;
        vm.newstepform = false;
        vm.editdocumentform = false;
        vm.entityType = "GF";
        vm.list = [];
        vm.updatetree = false;
        vm.nodes = [];

        $scope.$watch("vm.updatetree", function () {
            if (vm.updatetree === true) {
                loadGFileSteps();
            }
            vm.updatetree = false;
        });

        var unsubscribe = $rootScope.$on(
            "expedientesUriarteApp:gFileUpdate",
            function (event, result) {
                vm.gFile = result;
            }
        );
        $scope.$on("$destroy", unsubscribe);

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        loadGFileSteps();
        hasNotes();

        function loadGFileSteps() {
            GFileStep.query(
                {
                    g_file_id: vm.gFile.id,
                    allSteps: false,
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                vm.list = [];
                if (data.length >= 1) {
                    vm.list = data;
                    vm.nodes = data;
                }
            }

            function onError(error) {}
        }

        function save() {
            vm.isSaving = true;
            var gFile = Object.assign({}, vm.gFile);
            gFile.client = vm.gFile.client.name;
            GFile.update(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success(
                "Actualizado con éxito!",
                "Expediente " + result.code
            );
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al actualizar el expediente");
            vm.isSaving = false;
        }

        function openNewStepForm(stepParent) {
            if (stepParent) {
                GFileStep.get(
                    {
                        id: stepParent,
                    },
                    onNewGStepSuccess,
                    onNewGStepError
                );
            } else {
                vm.newstepform = true;
                vm.stepParent = null;
                vm.editstepform = false;
                vm.newdocumentform = false;
                vm.editdocumentform = false;
            }
        }

        function onNewGStepSuccess(data) {
            vm.stepParent = data;
            vm.newstepform = true;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }
        function onNewGStepError() {
            //TODO
        }

        function edit_gstep(gstep_id, isdeleted) {
            vm.isdeletedstep = isdeleted;
            vm.gfilestep = {};
            GFileStep.get(
                {
                    id: gstep_id,
                },
                onEditGStepSuccess,
                onEditGStepError
            );
        }

        function onEditGStepSuccess(data) {
            vm.gfilestep = data;
            vm.editstepform = true;
            $scope.isDeleting = false;

            vm.newstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }

        function onEditGStepError() {
            //TODO
        }

        function downloadfile(documentId, fileType) {
            Document.get(
                {
                    id: documentId,
                },
                function (data) {
                    $http({
                        method: "GET",
                        url: "api/g-files/download/" + documentId,
                        responseType: "arraybuffer",
                        cache: false,
                    })
                        .success(function (result) {
                            var a = document.createElement("a");
                            var blob = new Blob([result], {
                                type: "application/octet-stream",
                            });
                            a.href = URL.createObjectURL(blob);

                            a.download = data.filename;
                            a.click();
                        })
                        .error(function (data, status, headers, config) {});
                }
            );
        }

        function new_document(gstep_id) {
            GFileStep.get(
                {
                    id: gstep_id,
                },
                onNewDocumentSuccess,
                onNewDocumentError
            );
        }

        function onNewDocumentSuccess(data) {
            vm.gfilestep = data;
            vm.newdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.editdocumentform = false;
        }

        function onNewDocumentError() {
            //TODO
        }

        function edit_document(document_id) {
            Document.get(
                {
                    id: document_id,
                },
                onEditDocumentSuccess,
                onEditDocumentError
            );
        }

        function onEditDocumentSuccess(data) {
            vm.document = data;
            vm.editdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.newdocumentform = false;
        }

        function onEditDocumentError() {
            //TODO
        }

        function hasNotes() {
            Observation.query(
                {
                    gFile: vm.gFile.id,
                },
                onSuccess,
                onError
            );

            function onSuccess(data) {
                $rootScope.hasNotes = data.length;
            }

            function onError() {
                $rootScope.hasNotes = 0;
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("g-file-contencioso", {
                parent: "entity",
                url: "/g-file-contencioso?page&sort&search&code&type&nif&name&sn1&sn2&company_name",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CLIENT"],
                    pageTitle: "GFiles",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/g-file-contencioso/g-files.html",
                        controller: "GFileContenciosoController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                    steps: [
                        "$stateParams",
                        "Step",
                        function ($stateParams, Step) {
                            return Step.query().$promise;
                        },
                    ],
                    status: [
                        "$stateParams",
                        "GFileStatus",
                        function ($stateParams, GFileStatus) {
                            return GFileStatus.query().$promise;
                        },
                    ],
                },
            })
            .state("g-file-contencioso.edit", {
                parent: "g-file-contencioso",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CLIENT"],
                    pageTitle: "GFile",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/g-file-contencioso/g-file-detail.html",
                        controller: "GFileContenciosoDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Administrar",
                    parent: "g-file-contencioso",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "GFile",
                        function ($stateParams, GFile) {
                            return GFile.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    processtypes: [
                        "$stateParams",
                        "ProcessType",
                        function ($stateParams, ProcessType) {
                            return ProcessType.query({
                                jurisdiction: "CONTENCIOSA",
                            }).$promise;
                        },
                    ],
                    clients: [
                        "$stateParams",
                        "GFileClients",
                        function ($stateParams, GFileClients) {
                            return GFileClients.query().$promise;
                        },
                    ],
                    lawyers: [
                        "$stateParams",
                        "Lawyers",
                        function ($stateParams, Lawyers) {
                            return Lawyers.query().$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "g-file",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                    status: [
                        "$stateParams",
                        "GFileStatus",
                        function ($stateParams, GFileStatus) {
                            return GFileStatus.query().$promise;
                        },
                    ],
                },
            })
            .state("g-file-contencioso.new", {
                parent: "g-file-contencioso",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/g-file-contencioso/g-file-new.html",
                        controller: "GFileContenciosoNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "g-file-contencioso",
                },
                resolve: {
                    entity: function () {
                        return {
                            code: null,
                            id: null,
                        };
                    },
                    processtypes: [
                        "$stateParams",
                        "ProcessType",
                        function ($stateParams, ProcessType) {
                            return ProcessType.query({
                                jurisdiction: "CONTENCIOSA",
                            }).$promise;
                        },
                    ],
                    clients: [
                        "$stateParams",
                        "GFileClients",
                        function ($stateParams, GFileClients) {
                            return GFileClients.query().$promise;
                        },
                    ],
                    lawyers: [
                        "$stateParams",
                        "Lawyers",
                        function ($stateParams, Lawyers) {
                            return Lawyers.query().$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "g-file",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("GFileContenciosoController", GFileContenciosoController);

    GFileContenciosoController.$inject = [
        "DateUtils",
        "$state",
        "GFile",
        "GFileCsv",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "steps",
        "status",
        "$mdSidenav",
    ];

    function GFileContenciosoController(
        DateUtils,
        $state,
        GFile,
        GFileCsv,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        steps,
        status,
        $mdSidenav
    ) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem("searchParameters"));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
            vm.searchItem.status = status[0];
        }

        if (vm.searchItem.startDate !== null) {
            vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(
                vm.searchItem.startDate
            );
        }

        if (vm.searchItem.endDate !== null) {
            vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(
                vm.searchItem.endDate
            );
        }

        vm.status = status;
        vm.steps = steps;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.csvOrder = [
            "code",
            "lawyer",
            "client",
            "applicant",
            "applicantNif",
            "procuratorApplicant",
            "defendant",
            "defendantNif",
            "procuratorDefendant",
            "court",
            "processType",
            "step",
            "status",
        ];
        vm.getHeader = function () {
            return [
                "Código",
                "Letrado",
                "Cliente",
                "Demandante",
                "NIF Demandante",
                "Procurador demandante",
                "Demandado",
                "NIF Demandado",
                "Procurador demandado",
                "Juzgado",
                "Procedimiento",
                "Fase",
                "Estado",
            ];
        };

        searchExp();

        function searchExp() {
            // Store the value(s)
            if (vm.searchItem.startDate !== null)
                vm.searchItem.startDate = DateUtils.convertLocalDateToServer(
                    vm.searchItem.startDate
                );
            if (vm.searchItem.endDate !== null)
                vm.searchItem.endDate = DateUtils.convertLocalDateToServer(
                    vm.searchItem.endDate
                );
            localStorage.setItem(
                "searchParameters",
                JSON.stringify(vm.searchItem)
            );

            var idStep = null;
            if (angular.isDefined(vm.searchItem.step)) {
                idStep = vm.searchItem.step.id;
            }

            var idStatus = null;
            if (
                angular.isDefined(vm.searchItem.status) &&
                vm.searchItem.status != null
            ) {
                idStatus = vm.searchItem.status.id;
            }

            GFile.query(
                {
                    code: vm.searchItem.code,
                    status: idStatus,
                    client: vm.searchItem.client,
                    startDate: vm.searchItem.startDate,
                    endDate: vm.searchItem.endDate,
                    jurisdiction: "CONTENCIOSA",
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.gFiles = data;
                vm.page = pagingParams.page;

                if (vm.searchItem.startDate !== null)
                    vm.searchItem.startDate =
                        DateUtils.convertLocalDateFromServer(
                            vm.searchItem.startDate
                        );
                if (vm.searchItem.endDate !== null)
                    vm.searchItem.endDate =
                        DateUtils.convertLocalDateFromServer(
                            vm.searchItem.endDate
                        );

                vm.filename = getFilename();
                getExportData();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getFilename() {
            var today = new Date();

            var dd = today.getDate();
            if (dd < 10) dd = "0" + dd;

            var mm = today.getMonth() + 1;
            if (mm < 10) mm = "0" + mm;

            var yy = today.getFullYear();

            return "export_expedientes_contencioso_" + yy + mm + dd + ".csv";
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
            vm.searchItem.status = status[0];

            localStorage.setItem(
                "searchParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function getExportData() {
            var idFileType = null;
            if (angular.isDefined(vm.searchItem.fileType)) {
                idFileType = vm.searchItem.fileType.id;
            }

            var idStep = null;
            if (angular.isDefined(vm.searchItem.step)) {
                idStep = vm.searchItem.step.id;
            }

            var idStatus = null;
            if (
                angular.isDefined(vm.searchItem.status) &&
                vm.searchItem.status != null
            ) {
                idStatus = vm.searchItem.status.id;
            }

            if (vm.searchItem.startDate !== null)
                vm.searchItem.startDate = DateUtils.convertLocalDateToServer(
                    vm.searchItem.startDate
                );
            if (vm.searchItem.endDate !== null)
                vm.searchItem.endDate = DateUtils.convertLocalDateToServer(
                    vm.searchItem.endDate
                );

            GFileCsv.query(
                {
                    code: vm.searchItem.code,
                    year: vm.searchItem.year,
                    status: idStatus,
                    step: idStep,
                    startDate: vm.searchItem.startDate,
                    endDate: vm.searchItem.endDate,
                    jurisdiction: "CONTENCIOSA",
                },
                function (data) {
                    vm.exportData = data;
                    vm.exportData.forEach(function (item) {
                        if (item.processType) {
                            item.processType = item.processType.description;
                        }
                        if (item.client) {
                            item.client = item.client.description;
                        }
                    });
                }
            );
        }

        if (angular.isDefined(vm.searchItem.fileType)) {
            Step.query(
                {
                    file_type_id: vm.searchItem.fileType.id,
                },
                function (data) {
                    vm.steps = data;
                }
            );
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFileCivilNewController', GFileCivilNewController);

    GFileCivilNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'GFile', 'lawyers', '$state', 'previousState',  'processtypes', 'clients', 'toastr', 'DateUtils', '$mdSidenav'];

    function GFileCivilNewController($rootScope, $timeout, $scope, entity, GFile, lawyers, $state, previousState, processtypes, clients ,toastr, DateUtils, $mdSidenav) {
        var vm = this;

        vm.gFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.processtypes = processtypes;
        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.toggleSidenav = buildToggler('left');
        vm.gFile.code = '';

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            vm.gFile.jurisdiction = 'CIVIL';
            var gFile = Object.assign({}, vm.gFile);
            if (gFile.registerDate !== null) {
                gFile.registerDate = DateUtils.convertLocalDateToServer(gFile.registerDate);
            }
            if (gFile.notificationDate !== null) {
                gFile.notificationDate = DateUtils.convertLocalDateToServer(gFile.notificationDate);
            }
            if (gFile.presentationDate !== null) {
                gFile.presentationDate = DateUtils.convertLocalDateToServer(gFile.presentationDate);
            }
            gFile.client = vm.gFile.client.name;
            gFile.id = null;
            GFile.save(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!', 'Expediente ' + result.code);
            vm.isSaving = false;
            $state.go('g-file-civil.edit', {
                'id': result.id
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el expediente');
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFileCivilDetailController', GFileCivilDetailController);

    GFileCivilDetailController.$inject = ['$scope', '$rootScope', '$http', 'previousState', 'entity', 'Principal', 'GFile', 'GFileStep', '$state',
        'Document', 'DateUtils', 'processtypes', 'status', 'Observation', 'toastr', 'lawyers', 'clients', '$mdSidenav' ];

    function GFileCivilDetailController($scope, $rootScope, $http, previousState, entity, Principal, GFile,  GFileStep, $state,
                                   Document, DateUtils, processtypes, status, Observation, toastr, lawyers, clients, $mdSidenav) {
        var vm = this;

        vm.gFile = entity;

        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.gfilestep = {};
        vm.file_type= "CIVIL";
        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.isdeletedstep = false;
        vm.edit_gstep = edit_gstep;
        vm.processtypes = processtypes;
        vm.status = status;

        vm.openNewStepForm = openNewStepForm;
        vm.download_file =  downloadfile;
        vm.new_document = new_document;
        vm.edit_document = edit_document;
        vm.previousState = previousState.name;
        vm.newstepform = false;
        vm.editdocumentform = false;
        vm.entityType = "GF";
        vm.list = [];
        vm.updatetree = false;
        vm.nodes = [];

        $scope.$watch('vm.updatetree', function() {
            if (vm.updatetree === true) {
                loadGFileSteps();
            }
            vm.updatetree = false;
        });

        var unsubscribe = $rootScope.$on('expedientesUriarteApp:gFileUpdate', function(event, result) {
            vm.gFile = result;
        });
        $scope.$on('$destroy', unsubscribe);

        Principal.hasAuthority("ROLE_ADMIN")
            .then(function (result) {
                vm.isAdmin = result;
            });

        loadGFileSteps();
        hasNotes();

        function loadGFileSteps() {
            GFileStep.query({
                g_file_id: vm.gFile.id,
                allSteps: false
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.list = [];
                if (data.length >= 1) {
                    vm.list = data;
                    vm.nodes = data;
                }
            }

            function onError(error) {
            }
        }

        function save() {
            vm.isSaving = true;
            var gFile = Object.assign({}, vm.gFile);
            gFile.client = vm.gFile.client.name;
            GFile.update(gFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Actualizado con éxito!', 'Expediente ' + result.code);
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al actualizar el expediente');
            vm.isSaving = false;
        }

        function openNewStepForm(stepParent) {

           if (stepParent) {
             GFileStep.get({
                 id: stepParent
             }, onNewGStepSuccess, onNewGStepError);
           }
           else {
            vm.newstepform = true;
            vm.stepParent = null;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
          }
        }

        function onNewGStepSuccess(data) {
            vm.stepParent = data;
            vm.newstepform = true;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }
        function onNewGStepError() {
            //TODO
        }

        function edit_gstep(gstep_id, isdeleted) {
            vm.isdeletedstep = isdeleted;
            vm.gfilestep = {};
            GFileStep.get({
                id: gstep_id
            }, onEditGStepSuccess, onEditGStepError);
        }

        function onEditGStepSuccess(data) {
            vm.gfilestep = data;
            vm.editstepform = true;
            $scope.isDeleting = false;

            vm.newstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }

        function onEditGStepError() {
            //TODO
        }

        function downloadfile(documentId, fileType) {
            Document.get({
                id: documentId
            }, function(data) {
                $http({
                    method: 'GET',
                    url: 'api/g-files/download/' + documentId,
                    responseType: 'arraybuffer',
                    cache: false
                }).success(function (result) {
                    var a = document.createElement('a');
                    var blob = new Blob([result], {
                        'type': "application/octet-stream"
                    });
                    a.href = URL.createObjectURL(blob);
                    
                    a.download = data.filename;
                    a.click();
                }).error(function (data, status, headers, config) {

                });
            });
        }

        function new_document(gstep_id) {
            GFileStep.get({
                id: gstep_id
            }, onNewDocumentSuccess, onNewDocumentError);
        }

        function onNewDocumentSuccess(data) {
            vm.gfilestep = data;
            vm.newdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.editdocumentform = false;
        }

        function onNewDocumentError() {
            //TODO
        }

        function edit_document(document_id) {
            Document.get({
                id: document_id
            }, onEditDocumentSuccess, onEditDocumentError);
        }

        function onEditDocumentSuccess(data) {
            vm.document = data;
            vm.editdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.newdocumentform = false;
        }

        function onEditDocumentError() {
            //TODO
        }

        function hasNotes() {
            Observation.query({
                gFile: vm.gFile.id
            }, onSuccess, onError);

            function onSuccess(data) {
                $rootScope.hasNotes = data.length;
            }

            function onError() {
                $rootScope.hasNotes = 0;
            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('g-file-civil', {
                parent: 'entity',
                url: '/g-file-civil?page&sort&search&code&type&nif&name&sn1&sn2&company_name',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'GFiles'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/g-file-civil/g-files.html',
                    controller: 'GFileCivilController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    steps: ['$stateParams', 'Step', function($stateParams, Step) {
                        return Step.query().$promise;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('g-file-civil.edit', {
                parent: 'g-file-civil',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'GFile'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/g-file-civil/g-file-detail.html',
                        controller: 'GFileCivilDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Administrar',
                      parent: 'g-file-civil'
                },
                resolve: {
                    entity: ['$stateParams', 'GFile', function($stateParams, GFile) {
                        return GFile.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    processtypes: ['$stateParams', 'ProcessType', function($stateParams, ProcessType) {
                        return ProcessType.query({jurisdiction: 'CIVIL'}).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'g-file',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],
                    status: ['$stateParams', 'GFileStatus', function($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('g-file-civil.new', {
                parent: 'g-file-civil',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/g-file-civil/g-file-new.html',
                    controller: 'GFileCivilNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'g-file-civil'
                },
                resolve: {
                    entity: function() {
                        return {
                            code: null,
                            id: null
                        };
                    },
                    processtypes: ['$stateParams', 'ProcessType', function($stateParams, ProcessType) {
                        return ProcessType.query({jurisdiction: 'CIVIL'}).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'g-file',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('GFileCivilController', GFileCivilController);

    GFileCivilController.$inject = ['DateUtils', '$state', 'GFile', 'GFileCsv', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','steps', 'status', '$mdSidenav'];

    function GFileCivilController (DateUtils, $state, GFile, GFileCsv, ParseLinks, AlertService, paginationConstants, pagingParams, steps, status, $mdSidenav) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchParameters'));

        if (vm.searchItem === null) {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];
        }

        if (vm.searchItem.startDate !== null) {
            vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
        }

        if (vm.searchItem.endDate !== null) {
            vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);
        }

        vm.status = status;
        vm.steps = steps;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.csvOrder = ["code", "lawyer", "client", "applicant", "applicantNif" , "procuratorApplicant", "defendant",  "defendantNif", "procuratorDefendant", "court", "processType", "step", "status"];
        vm.getHeader = function () {
            return ["Código", "Letrado",  "Cliente", "Demandante", "NIF Demandante", "Procurador demandante", "Demandado", "NIF Demandado",  "Procurador demandado", "Juzgado", "Procedimiento", "Fase", "Estado"];
        };

        searchExp();

        function searchExp() {
            // Store the value(s)
            if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
            if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);
            localStorage.setItem('searchParameters', JSON.stringify(vm.searchItem));

            var idStep = null;
            if (angular.isDefined(vm.searchItem.step) ) {
                idStep = vm.searchItem.step.id;
            }

            var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
                idStatus = vm.searchItem.status.id;
            }

            GFile.query({
                code: vm.searchItem.code,
                status: idStatus,
                client: vm.searchItem.client,
                startDate: vm.searchItem.startDate,
                endDate: vm.searchItem.endDate,
                jurisdiction: 'CIVIL',
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.gFiles = data;
                vm.page = pagingParams.page;

                if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
                if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);

                vm.filename = getFilename();
                getExportData();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getFilename() {
          var today = new Date();

          var dd = today.getDate();
          if(dd < 10) dd = "0" + dd;

          var mm = today.getMonth()+1;
          if(mm < 10) mm = "0" + mm;

          var yy = today.getFullYear();

            return "export_expedientes_civil_" + yy + mm + dd + ".csv";
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];

          localStorage.setItem('searchParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function getExportData(){
          var idFileType = null;
          if (angular.isDefined(vm.searchItem.fileType) ) {
            idFileType = vm.searchItem.fileType.id;
          }

          var idStep = null;
          if (angular.isDefined(vm.searchItem.step) ) {
              idStep = vm.searchItem.step.id;
          }

          var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
              idStatus = vm.searchItem.status.id;
          }

          if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
          if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);

          GFileCsv.query({
              code: vm.searchItem.code,
              year: vm.searchItem.year,
              status: idStatus,
              step: idStep,
              startDate: vm.searchItem.startDate,
              endDate: vm.searchItem.endDate,
              jurisdiction: 'CIVIL'
          }, function(data) {
              vm.exportData = data;
              vm.exportData.forEach(function(item) {
                if (item.processType) { 
                    item.processType = item.processType.description;
                }
                if (item.client) { 
                    item.client = item.client.description;
                }
              });
          });
        }

        if(angular.isDefined(vm.searchItem.fileType)) {
            Step.query({
                file_type_id: vm.searchItem.fileType.id
            }, function (data) {
                vm.steps = data;
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('FileTypeNewController', FileTypeNewController);

    FileTypeNewController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'FileType'];

    function FileTypeNewController ($timeout, $scope, $state, $stateParams,  FileType) {
        var vm = this;

        vm.fileType = {};
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $state.go("file-type");
        }

        function save () {
            vm.isSaving = true;
            if (vm.fileType.id !== null) {
                FileType.update(vm.fileType, onSaveSuccess, onSaveError);
            } else {
                FileType.save(vm.fileType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('expedientesUriarteApp:fileTypeUpdate', result);
            vm.isSaving = false;
            $state.go('file-type', null, { });
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('FileTypeDetailController', FileTypeDetailController);

    FileTypeDetailController.$inject = ['previousState', 'entity', 'FileType', '$state', 'toastr'];

    function FileTypeDetailController(previousState, entity, FileType, $state, toastr) {
        var vm = this;

        vm.fileType = entity;
        vm.previousState = previousState.name;
        vm.deleteFileType = deleteFileType;
        vm.clear = clear;

        vm.save = save;

        function save () {
            vm.isSaving = true;
            if (vm.fileType.id !== null) {
                FileType.update(vm.fileType, onSaveSuccess, onSaveError);
            } else {
                FileType.save(vm.fileType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            toastr.success('Actualizado con éxito!', 'Tipo de expediente ' + result.name);
            $state.go('file-type');
            vm.isSaving = false;
        }

        function onSaveError () {
            toastr.error('Error al actualizar el tipo de expediente');
            vm.isSaving = false;
        }

        function deleteFileType() {
            FileType.delete({id: vm.fileType.id}, onDeleteSuccess, onDeleteError);
        }

        function onDeleteSuccess() {
            toastr.success('Tipo de expediente eliminado con éxito');
            $state.go('file-type');
            vm.isSaving = false;
        }

        function onDeleteError() {
            toastr.error('Error al eliminar el tipo de expediente');
            vm.isSaving = false;
        }

        function clear() {
            $state.go('file-type');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('file-type', {
                parent: 'entity',
                url: '/file-type?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'FileTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/file-type/file-types.html',
                        controller: 'FileTypeController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('file-type.edit', {
                parent: 'file-type',
                url: '/file-type/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'FileType'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/file-type/file-type-detail.html',
                        controller: 'FileTypeDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Edición',
                    parent: 'file-type'
                },
                resolve: {
                    entity: ['$stateParams', 'FileType', function ($stateParams, FileType) {
                        return FileType.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'file-type',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('file-type.new', {
                parent: 'file-type',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'FileType'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/file-type/file-type-detail.html',
                        controller: 'FileTypeDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Nuevo',
                    parent: 'file-type'
                },
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'file-type',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('FileType', FileType);

    FileType.$inject = ['$resource'];

    function FileType ($resource) {
        var resourceUrl =  'api/file-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('FileTypeController', FileTypeController);

    FileTypeController.$inject = ['$state', 'FileType', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FileTypeController($state, FileType, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            FileType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fileTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            parent: 'app',
            abstract: true
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('newDocument', {
            bindings: {
                gfilestep: '<',
                gfile: '<',
                updatetree: '=',
                newdocumentform: '=',
                editdocumentform: '=',
                document: '='
            },
            templateUrl: 'app/entities/document/new-document-component.html',
            controller: ['$scope', 'Upload', 'Document',  'toastr',
                function ($scope, Upload, Document,  toastr) {
                    var $ctrl = this;

                    $ctrl.$onInit = initialization;
                    $ctrl.save = save;
                    $ctrl.uploadfile = uploadfile;
                    $ctrl.close = close;

                    $ctrl.document = {};

                    $scope.$watch('$ctrl.newdocumentform', function() {
                        if ($ctrl.newdocumentform === true) {
                            $ctrl.document = {};
                        }
                    });

                    function initialization() {

                    }

                    function save() {
                        $ctrl.isSaving = true;
                        $ctrl.document.signed = false;
                        var gFileStep = {"id": $ctrl.gfilestep.id};
                        var document = Object.assign({}, $ctrl.document);
                        document.gFileStep = gFileStep;
                        Document.save(document, onSaveSuccess, onSaveError);
                    }

                    function uploadfile(file, errFiles) {
                      if (file) {
                        $ctrl.file = file;
                        $ctrl.document.filename = file.name;
                      }
                    }

                    function upload() {
                      Upload.upload({
                                url: "api/g-files/upload",
                                data: {
                                    file: $ctrl.file,
                                    name: $ctrl.file.name,
                                    previousFile: "",
                                    gFileID: $ctrl.gfile.id,
                                    documentID: $ctrl.document.id
                                },
                                method: 'POST'
                            }).then(
                                function() {
                                    $ctrl.isSaving = false;
                                    toastr.success('Documento subido con éxito');
                                    Document.get({id: $ctrl.document.id}, onUploadSuccess, onUploadError);
                                },
                                function(response) {
                                    $ctrl.isSaving = false;
                                    toastr.error('Error al subir el documento');
                                    Document.get({id: $ctrl.document.id}, onUploadSuccess, onUploadError);
                                },
                                function() {});
                    }

                    function onSaveSuccess(result) {
//                        toastr.success('Documento creado con éxito');
                        $ctrl.updatetree = true;
                        $ctrl.newdocumentform = false;
                        $ctrl.editdocumentform = false;
                        $ctrl.isSaving = false;
                        $ctrl.document = result;

                        upload();
                    }

                    function onSaveError() {
                        toastr.error('Error al crear el documento');
                        $ctrl.isSaving = false;
                    }

                    function onUploadSuccess(result) {
/*                        $scope.$emit('expedientesUriarteApp:gFileStepUpdate', result); */
                    }

                    function onUploadError() {
                        $ctrl.isSaving = false;
                    }

                    function close() {
                        $ctrl.newdocumentform = false;
                    }

                }
            ]
        });
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('editDocument', {
            bindings: {
                gfilestep: '<',
                gfile: '<',
                updatetree: '=',
                editdocumentform: '=',
                document: '='
            },
            templateUrl: 'app/entities/document/edit-document-component.html',
            controller: ['$scope', 'Document', 'Upload', '$http', 'DateUtils', 'toastr',
                function ($scope, Document,  Upload, $http, DateUtils, toastr) {
                    var $ctrl = this;

                    $ctrl.$onInit = initialization;
                    $ctrl.save = save;
                    $ctrl.close = close;
                    $ctrl.uploadfile = uploadfile;
                    $ctrl.downloadfile = downloadfile;
                    $ctrl.remove_document = remove_document;

                    $ctrl.document = {};

                    function initialization() {

                    }

                    function save() {
                        $ctrl.isSaving = true;
                        var gFileStep = {"id": $ctrl.document.gFileStep.id};
                        var document = Object.assign({}, $ctrl.document);
                        document.gFileStep = gFileStep;
                        Document.update(document, onSaveSuccess, onSaveError);
                    }

                    function close() {
                        $ctrl.editdocumentform = false;
                    }

                    function uploadfile(file, errFiles) {
                        if (file) {
                            $ctrl.file = file;
                            $ctrl.previousFile = $ctrl.document.path;
                            $ctrl.document.filename = $ctrl.file.name;
                        }
                    }

                    function upload() {
                        Upload.upload({
                            url: "api/g-files/upload",
                            data: {
                                file: $ctrl.file,
                                name: $ctrl.file.name,
                                previousFile: $ctrl.previousFile,
                                gFileID: $ctrl.gfile.id,
                                documentID: $ctrl.document.id
                            },
                            method: 'POST'
                        }).then(
                            function() {
                                $ctrl.isSaving = false;
                                $ctrl.updatetree = true;
                                $ctrl.editdocumentform = false;
                                toastr.success('Documento actualizado con éxito');
                                Document.get({id: $ctrl.document.id}, onUploadSuccess, onUploadError);
                            },
                            function() {
                                $ctrl.isSaving = false;
                                toastr.error('Error al subir el documento');
                            },
                            function() {});
                    }

                    function onUploadSuccess(result) {
                      $ctrl.document = result;
                    }

                    function onUploadError() {
                        $ctrl.isSaving = false;
                    }

                    function onSaveSuccess(result) {
                        if ($ctrl.file) {
                          upload();
                        }
                        else {
                          $ctrl.isSaving = false;
                          toastr.success('Documento actualizado con éxito');
                        }
                        $ctrl.updatetree = true;
                        $ctrl.editdocumentform = false;
                        $ctrl.isSaving = false;
                    }

                    function onSaveError() {
                        $ctrl.isSaving = false;
                        toastr.error('Error al actualizar el documento');
                    }

                    function remove_document() {
                        Document.delete({
                                id: $ctrl.document.id
                            },
                            function() {
                                toastr.success('Documento eliminado con éxito');
                                $ctrl.updatetree = true;
                                $ctrl.editdocumentform = false;
                            },
                            function () {
                                toastr.error('Error al eliminar el documento');
                                $ctrl.updatetree = true;
                                $ctrl.editdocumentform = false;
                            });
                    }

                    function downloadfile(documentId, fileType) {
                        $http({
                            method: 'GET',
                            url: 'api/g-files/download/' + $ctrl.document.id,
                            responseType: 'arraybuffer',
                            cache: false
                        }).success(function(data) {
                            var a = document.createElement('a');
                            var blob = new Blob([data], {
                                'type': "application/octet-stream"
                            });
                            a.href = URL.createObjectURL(blob);
                            a.download = $ctrl.document.filename;
                            a.click();
                        }).error(function(data, status, headers, config) {

                        });
                    }

                }
            ]
        });
})();

(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Document', Document);

    Document.$inject = ['$resource', 'DateUtils'];

    function Document ($resource, DateUtils) {
        var resourceUrl =  'api/documents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.register_date = DateUtils.convertLocalDateFromServer(data.register_date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.register_date = DateUtils.convertLocalDateToServer(copy.register_date);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.register_date = DateUtils.convertLocalDateFromServer(data.register_date);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.register_date = DateUtils.convertLocalDateToServer(copy.register_date);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.register_date = DateUtils.convertLocalDateFromServer(data.register_date);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosRevisionNewController', ConsortiumTributosRevisionNewController);

    ConsortiumTributosRevisionNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumTributosRevision', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumTributosRevisionNewController($rootScope, $timeout, $scope, entity, ConsortiumTributosRevision, $state, previousState, toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumTributosRevision = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');

        ConsortiumUsers.query({}, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumTributosRevision = Object.assign({}, vm.consortiumTributosRevision);
            consortiumTributosRevision.id = null;
            ConsortiumTributosRevision.save(consortiumTributosRevision, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-tributos-revision', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el tributo');
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID).toggle().then(function () {
                });
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosRevisionDetailController', ConsortiumTributosRevisionDetailController);

    ConsortiumTributosRevisionDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumTributosRevision', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumTributosRevisionFile', 'ConsortiumUsers', '$http', 'Upload'];

    function ConsortiumTributosRevisionDetailController($mdDialog, entity, Principal, ConsortiumTributosRevision, toastr, $mdSidenav, $state, previousState, ConsortiumTributosRevisionFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumTributosRevision = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumTributosRevisionFile.query({
            id: vm.consortiumTributosRevision.id
        }, onSuccess, onError);

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumTributosRevision = Object.assign({}, vm.consortiumTributosRevision);
            ConsortiumTributosRevision.update(consortiumTributosRevision, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumTributosRevisionFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-tributos-revision-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function (data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function (data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea borrar el documento?')
                .textContent('Si elimina el documento no se podrá recuperar.')
                .ok('Borrar')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {

            });
        }

        function removeDocument(documentId) {
            ConsortiumTributosRevisionFile.delete({
                id: documentId
            },
                function () {
                    toastr.success('Documento eliminado con éxito');
                    ConsortiumTributosRevisionFile.query({
                        id: vm.consortiumTributosRevision.id
                    }, onSuccess, onError);
                },
                function () {
                    toastr.error('Error al eliminar el documento');
                });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-tributos-revision-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumTributosRevisionId: vm.consortiumTributosRevision.id
                    },
                    method: 'POST'
                }).then(
                    function () {
                        toastr.success('Documento subido con éxito');
                        ConsortiumTributosRevisionFile.query({
                            id: vm.consortiumTributosRevision.id
                        }, onSuccess, onError);
                    },
                    function (response) {
                        toastr.error('Error al subir el documento');
                    },
                    function () { }
                );

            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID).toggle().then(function () {
                });
            };
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-tributos-revision', {
                parent: 'entity',
                url: '/consortium-tributos-revision?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosRevision'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-tributos/consortium-tributos-revision/consortium-tributos-revision.html',
                        controller: 'ConsortiumTributosRevisionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-tributos-revision.new', {
                parent: 'consortium-tributos-revision',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-tributos/consortium-tributos-revision/consortium-tributos-revision-new.html',
                        controller: 'ConsortiumTributosRevisionNewController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Nuevo',
                    parent: 'consortium-tributos-revision'
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-tributos-revision',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            }).state('consortium-tributos-revision.edit', {
                parent: 'consortium-tributos-revision',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosRevision'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-tributos/consortium-tributos-revision/consortium-tributos-revision-detail.html',
                        controller: 'ConsortiumTributosRevisionDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Lista',
                    parent: 'consortium-tributos-revision'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumTributosRevision', function ($stateParams, ConsortiumTributosRevision) {
                        return ConsortiumTributosRevision.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-tributos-revision',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosRevisionController', ConsortiumTributosRevisionController);

    ConsortiumTributosRevisionController.$inject = ['DateUtils', '$state', 'ConsortiumTributosRevision', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$mdSidenav', 'Principal'];

    function ConsortiumTributosRevisionController(DateUtils, $state, ConsortiumTributosRevision, ParseLinks, AlertService, paginationConstants, pagingParams, $mdSidenav, Principal) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumTributosRevisionParameters'));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function (result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumTributosRevisionParameters', JSON.stringify(vm.searchItem));
            ConsortiumTributosRevision.query({
                year: vm.searchItem.year,
                consortium: vm.searchItem.consortium,
                text: vm.searchItem.text,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumTributosRevisionItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem('searchConsortiumTributosRevisionParameters', JSON.stringify(vm.searchItem));
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID).toggle().then(function () {
                });
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosEellNewController', ConsortiumTributosEellNewController);

        ConsortiumTributosEellNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumTributosEell', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumTributosEellNewController($rootScope, $timeout, $scope, entity, ConsortiumTributosEell, $state, previousState,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumTributosEell = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumTributosEell = Object.assign({}, vm.consortiumTributosEell);
            consortiumTributosEell.id = null;
            ConsortiumTributosEell.save(consortiumTributosEell, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-tributos-eell', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el tributo');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosEellDetailController', ConsortiumTributosEellDetailController);

        ConsortiumTributosEellDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumTributosEell', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumTributosEellFile', 'ConsortiumUsers', '$http', 'Upload' ];

    function ConsortiumTributosEellDetailController($mdDialog, entity, Principal, ConsortiumTributosEell, toastr, $mdSidenav, $state, previousState, ConsortiumTributosEellFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumTributosEell = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumTributosEellFile.query({
            id: vm.consortiumTributosEell.id
        }, onSuccess, onError);
        
        ConsortiumUsers.query({}, onConsortiumSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumTributosEell = Object.assign({}, vm.consortiumTributosEell);
            ConsortiumTributosEell.update(consortiumTributosEell, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumTributosEellFile.update(document, onSaveSuccess, onSaveError);            
        }

        function onSaveSuccess(result) {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-tributos-eell-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function(data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function(data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
              .title('¿Desea borrar el documento?')
              .textContent('Si elimina el documento no se podrá recuperar.')
              .ok('Borrar')
              .cancel('Cancelar');
        
            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {
              
            });
        }

        function removeDocument(documentId) {
            ConsortiumTributosEellFile.delete({
                id: documentId
            },
            function() {
                toastr.success('Documento eliminado con éxito');
                ConsortiumTributosEellFile.query({
                    id: vm.consortiumTributosEell.id
                }, onSuccess, onError);
            },
            function () {
                toastr.error('Error al eliminar el documento');
            });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-tributos-eell-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumTributosEellId: vm.consortiumTributosEell.id
                    },
                    method: 'POST'
                }).then(
                    function() {
                        toastr.success('Documento subido con éxito');
                        ConsortiumTributosEellFile.query({
                            id: vm.consortiumTributosEell.id
                        }, onSuccess, onError);
                    },
                    function(response) {
                        toastr.error('Error al subir el documento');
                    },
                    function() {}
                );              

            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-tributos-eell', {
                parent: 'entity',
                url: '/consortium-tributos-eell?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosEell'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-eell/consortium-tributos-eell.html',
                    controller: 'ConsortiumTributosEellController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-tributos-eell.new', {
                parent: 'consortium-tributos-eell',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-eell/consortium-tributos-eell-new.html',
                    controller: 'ConsortiumTributosEellNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-tributos-eell'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-tributos-eell',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-tributos-eell.edit', {
                parent: 'consortium-tributos-eell',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosEell'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-tributos/consortium-tributos-eell/consortium-tributos-eell-detail.html',
                        controller: 'ConsortiumTributosEellDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-tributos-eell'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumTributosEell', function($stateParams, ConsortiumTributosEell) {
                        return ConsortiumTributosEell.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-tributos-eell',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosEellController', ConsortiumTributosEellController);

        ConsortiumTributosEellController.$inject = ['DateUtils', '$state', 'ConsortiumTributosEell', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$mdSidenav', 'Principal'];

    function ConsortiumTributosEellController (DateUtils, $state, ConsortiumTributosEell, ParseLinks, AlertService, paginationConstants, pagingParams, $mdSidenav, Principal) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumTributosEellParameters'));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function(result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumTributosEellParameters', JSON.stringify(vm.searchItem));
            ConsortiumTributosEell.query({
                year: vm.searchItem.year,
                consortium: vm.searchItem.consortium,
                text: vm.searchItem.text,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumTributosEellItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();

          localStorage.setItem('searchConsortiumTributosEellParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosDevolucionNewController', ConsortiumTributosDevolucionNewController);

        ConsortiumTributosDevolucionNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumTributosDevolucion', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumTributosDevolucionNewController($rootScope, $timeout, $scope, entity, ConsortiumTributosDevolucion, $state, previousState,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumTributosDevolucion = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumTributosDevolucion = Object.assign({}, vm.consortiumTributosDevolucion);
            consortiumTributosDevolucion.id = null;
            ConsortiumTributosDevolucion.save(consortiumTributosDevolucion, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-tributos-devolucion', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el tributo');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosDevolucionDetailController', ConsortiumTributosDevolucionDetailController);

        ConsortiumTributosDevolucionDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumTributosDevolucion', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumTributosDevolucionFile', 'ConsortiumUsers', '$http', 'Upload' ];

    function ConsortiumTributosDevolucionDetailController($mdDialog, entity, Principal, ConsortiumTributosDevolucion, toastr, $mdSidenav, $state, previousState, ConsortiumTributosDevolucionFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumTributosDevolucion = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumTributosDevolucionFile.query({
            id: vm.consortiumTributosDevolucion.id
        }, onSuccess, onError);
        
        ConsortiumUsers.query({}, onConsortiumSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumTributosDevolucion = Object.assign({}, vm.consortiumTributosDevolucion);
            ConsortiumTributosDevolucion.update(consortiumTributosDevolucion, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumTributosDevolucionFile.update(document, onSaveSuccess, onSaveError);            
        }

        function onSaveSuccess(result) {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-tributos-devolucion-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function(data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function(data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
              .title('¿Desea borrar el documento?')
              .textContent('Si elimina el documento no se podrá recuperar.')
              .ok('Borrar')
              .cancel('Cancelar');
        
            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {
              
            });
        }

        function removeDocument(documentId) {
            ConsortiumTributosDevolucionFile.delete({
                id: documentId
            },
            function() {
                toastr.success('Documento eliminado con éxito');
                ConsortiumTributosDevolucionFile.query({
                    id: vm.consortiumTributosDevolucion.id
                }, onSuccess, onError);
            },
            function () {
                toastr.error('Error al eliminar el documento');
            });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-tributos-devolucion-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumTributosDevolucionId: vm.consortiumTributosDevolucion.id
                    },
                    method: 'POST'
                }).then(
                    function() {
                        toastr.success('Documento subido con éxito');
                        ConsortiumTributosDevolucionFile.query({
                            id: vm.consortiumTributosDevolucion.id
                        }, onSuccess, onError);
                    },
                    function(response) {
                        toastr.error('Error al subir el documento');
                    },
                    function() {}
                );              

            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-tributos-devolucion', {
                parent: 'entity',
                url: '/consortium-tributos-devolucion?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosDevolucion'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-devolucion/consortium-tributos-devolucion.html',
                    controller: 'ConsortiumTributosDevolucionController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-tributos-devolucion.new', {
                parent: 'consortium-tributos-devolucion',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-devolucion/consortium-tributos-devolucion-new.html',
                    controller: 'ConsortiumTributosDevolucionNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-tributos-devolucion'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-tributos-devolucion',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-tributos-devolucion.edit', {
                parent: 'consortium-tributos-devolucion',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosDevolucion'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-tributos/consortium-tributos-devolucion/consortium-tributos-devolucion-detail.html',
                        controller: 'ConsortiumTributosDevolucionDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-tributos-devolucion'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumTributosDevolucion', function($stateParams, ConsortiumTributosDevolucion) {
                        return ConsortiumTributosDevolucion.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-tributos-devolucion',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosDevolucionController', ConsortiumTributosDevolucionController);

        ConsortiumTributosDevolucionController.$inject = ['DateUtils', '$state', 'ConsortiumTributosDevolucion', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$mdSidenav', 'Principal'];

    function ConsortiumTributosDevolucionController (DateUtils, $state, ConsortiumTributosDevolucion, ParseLinks, AlertService, paginationConstants, pagingParams, $mdSidenav, Principal) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumTributosDevolucionParameters'));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function(result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumTributosDevolucionParameters', JSON.stringify(vm.searchItem));
            ConsortiumTributosDevolucion.query({
                year: vm.searchItem.year,
                consortium: vm.searchItem.consortium,
                text: vm.searchItem.text,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumTributosDevolucionItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();

          localStorage.setItem('searchConsortiumTributosDevolucionParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosCcaaNewController', ConsortiumTributosCcaaNewController);

        ConsortiumTributosCcaaNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumTributosCcaa', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumTributosCcaaNewController($rootScope, $timeout, $scope, entity, ConsortiumTributosCcaa, $state, previousState,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumTributosCcaa = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumTributosCcaa = Object.assign({}, vm.consortiumTributosCcaa);
            consortiumTributosCcaa.id = null;
            ConsortiumTributosCcaa.save(consortiumTributosCcaa, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-tributos-ccaa', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el tributo');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosCcaaDetailController', ConsortiumTributosCcaaDetailController);

        ConsortiumTributosCcaaDetailController.$inject = ['$mdDialog','entity', 'Principal', 'ConsortiumTributosCcaa', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumTributosCcaaFile', 'ConsortiumUsers', '$http', 'Upload' ];

    function ConsortiumTributosCcaaDetailController($mdDialog, entity, Principal, ConsortiumTributosCcaa, toastr, $mdSidenav, $state, previousState, ConsortiumTributosCcaaFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumTributosCcaa = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumTributosCcaaFile.query({
            id: vm.consortiumTributosCcaa.id
        }, onSuccess, onError);
        
        ConsortiumUsers.query({}, onConsortiumSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumTributosCcaa = Object.assign({}, vm.consortiumTributosCcaa);
            ConsortiumTributosCcaa.update(consortiumTributosCcaa, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumTributosCcaaFile.update(document, onSaveSuccess, onSaveError);            
        }

        function onSaveSuccess(result) {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-tributos-ccaa-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function(data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function(data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
              .title('¿Desea borrar el documento?')
              .textContent('Si elimina el documento no se podrá recuperar.')
              .ok('Borrar')
              .cancel('Cancelar');
        
            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {
              
            });
        }

        function removeDocument(documentId) {
            ConsortiumTributosCcaaFile.delete({
                id: documentId
            },
            function() {
                toastr.success('Documento eliminado con éxito');
                ConsortiumTributosCcaaFile.query({
                    id: vm.consortiumTributosCcaa.id
                }, onSuccess, onError);
            },
            function () {
                toastr.error('Error al eliminar el documento');
            });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-tributos-ccaa-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumTributosCcaaId: vm.consortiumTributosCcaa.id
                    },
                    method: 'POST'
                }).then(
                    function() {
                        toastr.success('Documento subido con éxito');
                        ConsortiumTributosCcaaFile.query({
                            id: vm.consortiumTributosCcaa.id
                        }, onSuccess, onError);
                    },
                    function(response) {
                        toastr.error('Error al subir el documento');
                    },
                    function() {}
                );              

            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-tributos-ccaa', {
                parent: 'entity',
                url: '/consortium-tributos-ccaa?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosCcaa'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-ccaa/consortium-tributos-ccaa.html',
                    controller: 'ConsortiumTributosCcaaController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-tributos-ccaa.new', {
                parent: 'consortium-tributos-ccaa',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-ccaa/consortium-tributos-ccaa-new.html',
                    controller: 'ConsortiumTributosCcaaNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-tributos-ccaa'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-tributos-ccaa',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-tributos-ccaa.edit', {
                parent: 'consortium-tributos-ccaa',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosCcaa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-tributos/consortium-tributos-ccaa/consortium-tributos-ccaa-detail.html',
                        controller: 'ConsortiumTributosCcaaDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-tributos-ccaa'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumTributosCcaa', function($stateParams, ConsortiumTributosCcaa) {
                        return ConsortiumTributosCcaa.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-tributos-ccaa',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosCcaaController', ConsortiumTributosCcaaController);

        ConsortiumTributosCcaaController.$inject = ['DateUtils', '$state', 'ConsortiumTributosCcaa', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$mdSidenav', 'Principal'];

    function ConsortiumTributosCcaaController (DateUtils, $state, ConsortiumTributosCcaa, ParseLinks, AlertService, paginationConstants, pagingParams, $mdSidenav, Principal) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumTributosCcaaParameters'));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function(result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumTributosCcaaParameters', JSON.stringify(vm.searchItem));
            ConsortiumTributosCcaa.query({
                year: vm.searchItem.year,
                consortium: vm.searchItem.consortium,
                text: vm.searchItem.text,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumTributosCcaaItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();

          localStorage.setItem('searchConsortiumTributosCcaaParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosAeatNewController', ConsortiumTributosAeatNewController);

        ConsortiumTributosAeatNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumTributosAeat', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumTributosAeatNewController($rootScope, $timeout, $scope, entity, ConsortiumTributosAeat, $state, previousState,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumTributosAeat = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumTributosAeat = Object.assign({}, vm.consortiumTributosAeat);
            consortiumTributosAeat.id = null;
            ConsortiumTributosAeat.save(consortiumTributosAeat, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-tributos-aeat', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el tributo');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosAeatDetailController', ConsortiumTributosAeatDetailController);

    ConsortiumTributosAeatDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumTributosAeat', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumTributosAeatFile', 'ConsortiumUsers', '$http', 'Upload'];

    function ConsortiumTributosAeatDetailController($mdDialog, entity, Principal, ConsortiumTributosAeat, toastr, $mdSidenav, $state, previousState, ConsortiumTributosAeatFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumTributosAeat = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumTributosAeatFile.query({
            id: vm.consortiumTributosAeat.id
        }, onSuccess, onError);

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumTributosAeat = Object.assign({}, vm.consortiumTributosAeat);
            ConsortiumTributosAeat.update(consortiumTributosAeat, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumTributosAeatFile.update(document, onSaveSuccess, onSaveError);            
        }

        function onSaveSuccess(result) {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-tributos-aeat-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function (data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function (data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea borrar el documento?')
                .textContent('Si elimina el documento no se podrá recuperar.')
                .ok('Borrar')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {

            });
        }

        function removeDocument(documentId) {
            ConsortiumTributosAeatFile.delete({
                id: documentId
            },
                function () {
                    toastr.success('Documento eliminado con éxito');
                    ConsortiumTributosAeatFile.query({
                        id: vm.consortiumTributosAeat.id
                    }, onSuccess, onError);
                },
                function () {
                    toastr.error('Error al eliminar el documento');
                });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-tributos-aeat-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumTributosAeatId: vm.consortiumTributosAeat.id
                    },
                    method: 'POST'
                }).then(
                    function () {
                        toastr.success('Documento subido con éxito');
                        ConsortiumTributosAeatFile.query({
                            id: vm.consortiumTributosAeat.id
                        }, onSuccess, onError);
                    },
                    function (response) {
                        toastr.error('Error al subir el documento');
                    },
                    function () { }
                );

            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID).toggle().then(function () {
                });
            };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-tributos-aeat', {
                parent: 'entity',
                url: '/consortium-tributos-aeat?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosAeat'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-aeat/consortium-tributos-aeat.html',
                    controller: 'ConsortiumTributosAeatController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-tributos-aeat.new', {
                parent: 'consortium-tributos-aeat',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-tributos/consortium-tributos-aeat/consortium-tributos-aeat-new.html',
                    controller: 'ConsortiumTributosAeatNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-tributos-aeat'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-tributos-aeat',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-tributos-aeat.edit', {
                parent: 'consortium-tributos-aeat',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumTributosAeat'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-tributos/consortium-tributos-aeat/consortium-tributos-aeat-detail.html',
                        controller: 'ConsortiumTributosAeatDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-tributos-aeat'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumTributosAeat', function($stateParams, ConsortiumTributosAeat) {
                        return ConsortiumTributosAeat.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-tributos-aeat',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumTributosAeatController', ConsortiumTributosAeatController);

        ConsortiumTributosAeatController.$inject = ['DateUtils', '$state', 'ConsortiumTributosAeat', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$mdSidenav', 'Principal'];

    function ConsortiumTributosAeatController (DateUtils, $state, ConsortiumTributosAeat, ParseLinks, AlertService, paginationConstants, pagingParams, $mdSidenav, Principal) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumTributosAeatParameters'));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function(result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumTributosAeatParameters', JSON.stringify(vm.searchItem));
            ConsortiumTributosAeat.query({
                year: vm.searchItem.year,
                consortium: vm.searchItem.consortium,
                concept: vm.searchItem.concept,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumTributosAeatItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();

          localStorage.setItem('searchConsortiumTributosAeatParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumPersonalSeguroNewController', ConsortiumPersonalSeguroNewController);

        ConsortiumPersonalSeguroNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumPersonalSeguro', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumPersonalSeguroNewController($rootScope, $timeout, $scope, entity, ConsortiumPersonalSeguro, $state, previousState,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumPersonalSeguro = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');
        vm.months = ["ENERO","FEBRERO","MARZO","ABRIL","MAYO","JUNIO","JULIO","AGOSTO","SEPTIEMBRE","OCTUBRE","NOVIEMBRE","DICIEMBRE"];

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumPersonalSeguro = Object.assign({}, vm.consortiumPersonalSeguro);
            consortiumPersonalSeguro.id = null;
            ConsortiumPersonalSeguro.save(consortiumPersonalSeguro, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-personal-seguros', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el seguro social');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumPersonalSeguroDetailController', ConsortiumPersonalSeguroDetailController);

        ConsortiumPersonalSeguroDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumPersonalSeguro', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumPersonalSeguroFile', 'ConsortiumUsers', '$http', 'Upload' ];

    function ConsortiumPersonalSeguroDetailController($mdDialog, entity, Principal, ConsortiumPersonalSeguro, toastr, $mdSidenav, $state, previousState, ConsortiumPersonalSeguroFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumPersonalSeguro = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.months = ["ENERO","FEBRERO","MARZO","ABRIL","MAYO","JUNIO","JULIO","AGOSTO","SEPTIEMBRE","OCTUBRE","NOVIEMBRE","DICIEMBRE"];

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumPersonalSeguroFile.query({
            id: vm.consortiumPersonalSeguro.id
        }, onSuccess, onError);
        
        ConsortiumUsers.query({}, onConsortiumSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumPersonalSeguro = Object.assign({}, vm.consortiumPersonalSeguro);
            ConsortiumPersonalSeguro.update(consortiumPersonalSeguro, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumPersonalSeguroFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-personal-seguro-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function(data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function(data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
              .title('¿Desea borrar el documento?')
              .textContent('Si elimina el documento no se podrá recuperar.')
              .ok('Borrar')
              .cancel('Cancelar');
        
            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {
              
            });
        }

        function removeDocument(documentId) {
            ConsortiumPersonalSeguroFile.delete({
                id: documentId
            },
            function() {
                toastr.success('Documento eliminado con éxito');
                ConsortiumPersonalSeguroFile.query({
                    id: vm.consortiumPersonalSeguro.id
                }, onSuccess, onError);
            },
            function () {
                toastr.error('Error al eliminar el documento');
            });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-personal-seguro-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumPersonalSeguroId: vm.consortiumPersonalSeguro.id
                    },
                    method: 'POST'
                }).then(
                    function() {
                        toastr.success('Documento subido con éxito');
                        ConsortiumPersonalSeguroFile.query({
                            id: vm.consortiumPersonalSeguro.id
                        }, onSuccess, onError);
                    },
                    function(response) {
                        toastr.error('Error al subir el documento');
                    },
                    function() {}
                );              

            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-personal-seguros', {
                parent: 'entity',
                url: '/consortium-personal-seguros?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumPersonalSeguro'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-personal/consortium-personal-seguros/consortium-personal-seguros.html',
                    controller: 'ConsortiumPersonalSeguroController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-personal-seguros.new', {
                parent: 'consortium-personal-seguros',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-personal/consortium-personal-seguros/consortium-personal-seguros-new.html',
                    controller: 'ConsortiumPersonalSeguroNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-personal-seguros'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-personal-seguros',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-personal-seguros.edit', {
                parent: 'consortium-personal-seguros',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumPersonalSeguro'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-personal/consortium-personal-seguros/consortium-personal-seguros-detail.html',
                        controller: 'ConsortiumPersonalSeguroDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-personal-seguros'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumPersonalSeguro', function($stateParams, ConsortiumPersonalSeguro) {
                        return ConsortiumPersonalSeguro.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-personal-seguros',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumPersonalSeguroController', ConsortiumPersonalSeguroController);

        ConsortiumPersonalSeguroController.$inject = ['ConsortiumPersonalSeguro', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$mdSidenav', 'Principal'];

    function ConsortiumPersonalSeguroController (ConsortiumPersonalSeguro, $state, ParseLinks, AlertService, paginationConstants, pagingParams, $mdSidenav, Principal) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumPersonalSeguroParameters'));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function(result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumPersonalSeguroParameters', JSON.stringify(vm.searchItem));
            ConsortiumPersonalSeguro.query({
                year: vm.searchItem.year,
                consortium: vm.searchItem.consortium,
                employee: vm.searchItem.employee,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumPersonalSeguros = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();

          localStorage.setItem('searchConsortiumPersonalSeguroParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumPersonalOtraNewController",
            ConsortiumPersonalOtraNewController
        );

    ConsortiumPersonalOtraNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "ConsortiumPersonalOtra",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "ConsortiumUsers",
    ];

    function ConsortiumPersonalOtraNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        ConsortiumPersonalOtra,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        ConsortiumUsers
    ) {
        var vm = this;

        vm.consortiumPersonalOtra = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        ConsortiumUsers.query({}, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumPersonalOtra = Object.assign(
                {},
                vm.consortiumPersonalOtra
            );
            consortiumPersonalOtra.id = null;
            ConsortiumPersonalOtra.save(
                consortiumPersonalOtra,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("consortium-personal-otras", {});
        }

        function onSaveError() {
            toastr.error("Error al crear otra gestión de personal");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumPersonalOtraDetailController', ConsortiumPersonalOtraDetailController);

        ConsortiumPersonalOtraDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumPersonalOtra', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumPersonalOtraFile', 'ConsortiumUsers', '$http', 'Upload' ];

    function ConsortiumPersonalOtraDetailController($mdDialog, entity, Principal, ConsortiumPersonalOtra, toastr, $mdSidenav, $state, previousState, ConsortiumPersonalOtraFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumPersonalOtra = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumPersonalOtraFile.query({
            id: vm.consortiumPersonalOtra.id
        }, onSuccess, onError);
        
        ConsortiumUsers.query({}, onConsortiumSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumPersonalOtra = Object.assign({}, vm.consortiumPersonalOtra);
            ConsortiumPersonalOtra.update(consortiumPersonalOtra, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumPersonalOtraFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-personal-otra-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function(data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function(data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
              .title('¿Desea borrar el documento?')
              .textContent('Si elimina el documento no se podrá recuperar.')
              .ok('Borrar')
              .cancel('Cancelar');
        
            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {
              
            });
        }

        function removeDocument(documentId) {
            ConsortiumPersonalOtraFile.delete({
                id: documentId
            },
            function() {
                toastr.success('Documento eliminado con éxito');
                ConsortiumPersonalOtraFile.query({
                    id: vm.consortiumPersonalOtra.id
                }, onSuccess, onError);
            },
            function () {
                toastr.error('Error al eliminar el documento');
            });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-personal-otra-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumPersonalOtraId: vm.consortiumPersonalOtra.id
                    },
                    method: 'POST'
                }).then(
                    function() {
                        toastr.success('Documento subido con éxito');
                        ConsortiumPersonalOtraFile.query({
                            id: vm.consortiumPersonalOtra.id
                        }, onSuccess, onError);
                    },
                    function(response) {
                        toastr.error('Error al subir el documento');
                    },
                    function() {}
                );              

            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-personal-otras', {
                parent: 'entity',
                url: '/consortium-personal-otras?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumPersonalOtra'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-personal/consortium-personal-otras/consortium-personal-otras.html',
                    controller: 'ConsortiumPersonalOtraController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-personal-otras.new', {
                parent: 'consortium-personal-otras',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-personal/consortium-personal-otras/consortium-personal-otras-new.html',
                    controller: 'ConsortiumPersonalOtraNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-personal-otras'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-personal-otras',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-personal-otras.edit', {
                parent: 'consortium-personal-otras',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumPersonalOtra'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-personal/consortium-personal-otras/consortium-personal-otras-detail.html',
                        controller: 'ConsortiumPersonalOtraDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-personal-otras'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumPersonalOtra', function($stateParams, ConsortiumPersonalOtra) {
                        return ConsortiumPersonalOtra.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-personal-otras',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumPersonalOtraController', ConsortiumPersonalOtraController);

        ConsortiumPersonalOtraController.$inject = ['ConsortiumPersonalOtra', 'DateUtils', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$mdSidenav', 'Principal'];

    function ConsortiumPersonalOtraController (ConsortiumPersonalOtra, DateUtils, $state, ParseLinks, AlertService, paginationConstants, pagingParams, $mdSidenav, Principal) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumPersonalOtraParameters'));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function(result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumPersonalOtraParameters', JSON.stringify(vm.searchItem));
            ConsortiumPersonalOtra.query({
                year: vm.searchItem.year,
                consortium: vm.searchItem.consortium,
                employee: vm.searchItem.employee,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumPersonalOtras = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();

          localStorage.setItem('searchConsortiumPersonalOtraParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumPersonalNominaNewController', ConsortiumPersonalNominaNewController);

        ConsortiumPersonalNominaNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumPersonalNomina', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumPersonalNominaNewController($rootScope, $timeout, $scope, entity, ConsortiumPersonalNomina, $state, previousState,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumPersonalNomina = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');
        vm.months = ["ENERO","FEBRERO","MARZO","ABRIL","MAYO","JUNIO","JULIO","AGOSTO","SEPTIEMBRE","OCTUBRE","NOVIEMBRE","DICIEMBRE"];

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumPersonalNomina = Object.assign({}, vm.consortiumPersonalNomina);
            consortiumPersonalNomina.id = null;
            ConsortiumPersonalNomina.save(consortiumPersonalNomina, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-personal-nominas', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear la nómina');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumPersonalNominaDetailController', ConsortiumPersonalNominaDetailController);

        ConsortiumPersonalNominaDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumPersonalNomina', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumPersonalNominaFile', 'ConsortiumUsers', '$http', 'Upload' ];

    function ConsortiumPersonalNominaDetailController($mdDialog, entity, Principal, ConsortiumPersonalNomina, toastr, $mdSidenav, $state, previousState, ConsortiumPersonalNominaFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumPersonalNomina = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.months = ["ENERO","FEBRERO","MARZO","ABRIL","MAYO","JUNIO","JULIO","AGOSTO","SEPTIEMBRE","OCTUBRE","NOVIEMBRE","DICIEMBRE"];

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumPersonalNominaFile.query({
            id: vm.consortiumPersonalNomina.id
        }, onSuccess, onError);
        
        ConsortiumUsers.query({}, onConsortiumSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumPersonalNomina = Object.assign({}, vm.consortiumPersonalNomina);
            ConsortiumPersonalNomina.update(consortiumPersonalNomina, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumPersonalNominaFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-personal-nomina-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function(data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function(data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
              .title('¿Desea borrar el documento?')
              .textContent('Si elimina el documento no se podrá recuperar.')
              .ok('Borrar')
              .cancel('Cancelar');
        
            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {
              
            });
        }

        function removeDocument(documentId) {
            ConsortiumPersonalNominaFile.delete({
                id: documentId
            },
            function() {
                toastr.success('Documento eliminado con éxito');
                ConsortiumPersonalNominaFile.query({
                    id: vm.consortiumPersonalNomina.id
                }, onSuccess, onError);
            },
            function () {
                toastr.error('Error al eliminar el documento');
            });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-personal-nomina-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumPersonalNominaId: vm.consortiumPersonalNomina.id
                    },
                    method: 'POST'
                }).then(
                    function() {
                        toastr.success('Documento subido con éxito');
                        ConsortiumPersonalNominaFile.query({
                            id: vm.consortiumPersonalNomina.id
                        }, onSuccess, onError);
                    },
                    function(response) {
                        toastr.error('Error al subir el documento');
                    },
                    function() {}
                );              

            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-personal-nominas', {
                parent: 'entity',
                url: '/consortium-personal-nominas?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumPersonalNomina'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-personal/consortium-personal-nominas/consortium-personal-nominas.html',
                    controller: 'ConsortiumPersonalNominaController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-personal-nominas.new', {
                parent: 'consortium-personal-nominas',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-personal/consortium-personal-nominas/consortium-personal-nominas-new.html',
                    controller: 'ConsortiumPersonalNominaNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-personal-nominas'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-personal-nominas',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-personal-nominas.edit', {
                parent: 'consortium-personal-nominas',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumPersonalNomina'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-personal/consortium-personal-nominas/consortium-personal-nominas-detail.html',
                        controller: 'ConsortiumPersonalNominaDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-personal-nominas'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumPersonalNomina', function($stateParams, ConsortiumPersonalNomina) {
                        return ConsortiumPersonalNomina.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-personal-nominas',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumPersonalNominaController', ConsortiumPersonalNominaController);

        ConsortiumPersonalNominaController.$inject = ['ConsortiumPersonalNomina', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$mdSidenav', 'Principal'];

    function ConsortiumPersonalNominaController (ConsortiumPersonalNomina, $state, ParseLinks, AlertService, paginationConstants, pagingParams, $mdSidenav, Principal) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumPersonalNominaParameters'));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function(result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumPersonalNominaParameters', JSON.stringify(vm.searchItem));
            ConsortiumPersonalNomina.query({
                year: vm.searchItem.year,
                consortium: vm.searchItem.consortium,
                employee: vm.searchItem.employee,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumPersonalNominas = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();

          localStorage.setItem('searchConsortiumPersonalNominaParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumPersonalContratoNewController', ConsortiumPersonalContratoNewController);

        ConsortiumPersonalContratoNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumPersonalContrato', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumPersonalContratoNewController($rootScope, $timeout, $scope, entity, ConsortiumPersonalContrato, $state, previousState,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumPersonalContrato = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumPersonalContrato = Object.assign({}, vm.consortiumPersonalContrato);
            consortiumPersonalContrato.id = null;
            ConsortiumPersonalContrato.save(consortiumPersonalContrato, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-personal-contratos', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el contrato');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumPersonalContratoDetailController', ConsortiumPersonalContratoDetailController);

    ConsortiumPersonalContratoDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumPersonalContrato', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumPersonalContratoFile', 'ConsortiumUsers', '$http', 'Upload'];

    function ConsortiumPersonalContratoDetailController($mdDialog, entity, Principal, ConsortiumPersonalContrato, toastr, $mdSidenav, $state, previousState, ConsortiumPersonalContratoFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumPersonalContrato = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumPersonalContratoFile.query({
            id: vm.consortiumPersonalContrato.id
        }, onSuccess, onError);

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumPersonalContrato = Object.assign({}, vm.consortiumPersonalContrato);
            ConsortiumPersonalContrato.update(consortiumPersonalContrato, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumPersonalContratoFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-personal-contrato-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function (data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function (data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea borrar el documento?')
                .textContent('Si elimina el documento no se podrá recuperar.')
                .ok('Borrar')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {

            });
        }

        function removeDocument(documentId) {
            ConsortiumPersonalContratoFile.delete({
                    id: documentId
                },
                function () {
                    toastr.success('Documento eliminado con éxito');
                    ConsortiumPersonalContratoFile.query({
                        id: vm.consortiumPersonalOtra.id
                    }, onSuccess, onError);
                },
                function () {
                    toastr.error('Error al eliminar el documento');
                });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-personal-contrato-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumPersonalContratoId: vm.consortiumPersonalContrato.id
                    },
                    method: 'POST'
                }).then(
                    function () {
                        toastr.success('Documento subido con éxito');
                        ConsortiumPersonalContratoFile.query({
                            id: vm.consortiumPersonalContrato.id
                        }, onSuccess, onError);
                    },
                    function (response) {
                        toastr.error('Error al subir el documento');
                    },
                    function () {}
                );

            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID).toggle().then(function () {});
            };
        }

    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-personal-contratos", {
                parent: "entity",
                url: "/consortium-personal-contratos?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumPersonalContrato",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-personal/consortium-personal-contratos/consortium-personal-contratos.html",
                        controller: "ConsortiumPersonalContratoController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-personal-contratos.new", {
                parent: "consortium-personal-contratos",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-personal/consortium-personal-contratos/consortium-personal-contratos-new.html",
                        controller: "ConsortiumPersonalContratoNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-personal-contratos",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-personal-contratos",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-personal-contratos.edit", {
                parent: "consortium-personal-contratos",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumPersonalContrato",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-personal/consortium-personal-contratos/consortium-personal-contratos-detail.html",
                        controller:
                            "ConsortiumPersonalContratoDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-personal-contratos",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumPersonalContrato",
                        function ($stateParams, ConsortiumPersonalContrato) {
                            return ConsortiumPersonalContrato.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-personal-contratos",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumPersonalContratoController",
            ConsortiumPersonalContratoController
        );

    ConsortiumPersonalContratoController.$inject = [
        "ConsortiumPersonalContrato",
        "DateUtils",
        "$state",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function ConsortiumPersonalContratoController(
        ConsortiumPersonalContrato,
        DateUtils,
        $state,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchConsortiumPersonalContratoParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function (result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem(
                "searchConsortiumPersonalContratoParameters",
                JSON.stringify(vm.searchItem)
            );
            ConsortiumPersonalContrato.query(
                {
                    year: vm.searchItem.year,
                    consortium: vm.searchItem.consortium,
                    employee: vm.searchItem.employee,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.consortiumPersonalContratos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchConsortiumPersonalContratoParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumFinancieraNewController",
            ConsortiumFinancieraNewController
        );

    ConsortiumFinancieraNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "ConsortiumFinanciera",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "ConsortiumUsers",
    ];

    function ConsortiumFinancieraNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        ConsortiumFinanciera,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        ConsortiumUsers
    ) {
        var vm = this;

        vm.consortiumFinanciera = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        ConsortiumUsers.query({}, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumFinanciera = Object.assign(
                {},
                vm.consortiumFinanciera
            );
            consortiumFinanciera.id = null;
            ConsortiumFinanciera.save(
                consortiumFinanciera,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("consortium-financiera", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumFinancieraDetailController",
            ConsortiumFinancieraDetailController
        );

    ConsortiumFinancieraDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "ConsortiumFinanciera",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "ConsortiumFinancieraFile",
        "ConsortiumUsers",
        "$http",
        "Upload",
    ];

    function ConsortiumFinancieraDetailController(
        $mdDialog,
        entity,
        Principal,
        ConsortiumFinanciera,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        ConsortiumFinancieraFile,
        ConsortiumUsers,
        $http,
        Upload
    ) {
        var vm = this;

        vm.consortiumFinanciera = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumFinancieraFile.query(
            {
                id: vm.consortiumFinanciera.id,
            },
            onSuccess,
            onError
        );

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumFinanciera = Object.assign(
                {},
                vm.consortiumFinanciera
            );

            ConsortiumFinanciera.update(
                consortiumFinanciera,
                onSaveSuccess,
                onSaveError
            );
        }

        function updateDocument(document) {
            ConsortiumFinancieraFile.update(
                document,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess(result) {
            toastr.success("Guardado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/consortium-financiera-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            ConsortiumFinancieraFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    ConsortiumFinancieraFile.query(
                        {
                            id: vm.consortiumFinanciera.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-financiera-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumFinancieraId: vm.consortiumFinanciera.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        ConsortiumFinancieraFile.query(
                            {
                                id: vm.consortiumFinanciera.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-financiera', {
                parent: 'entity',
                url: '/consortium-financiera?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumFinanciera'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-financiera/consortium-financiera.html',
                        controller: 'ConsortiumFinancieraController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-financiera.new', {
                parent: 'consortium-financiera',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-financiera/consortium-financiera-new.html',
                        controller: 'ConsortiumFinancieraNewController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Nuevo',
                    parent: 'consortium-financiera'
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-financiera',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            }).state('consortium-financiera.edit', {
                parent: 'consortium-financiera',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumFinanciera'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-financiera/consortium-financiera-detail.html',
                        controller: 'ConsortiumFinancieraDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Lista',
                    parent: 'consortium-financiera'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumFinanciera', function ($stateParams, ConsortiumFinanciera) {
                        return ConsortiumFinanciera.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-financiera',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumFinancieraController', ConsortiumFinancieraController);

    ConsortiumFinancieraController.$inject = ['DateUtils', '$state', 'ConsortiumFinanciera', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$mdSidenav', 'Principal'];

    function ConsortiumFinancieraController(DateUtils, $state, ConsortiumFinanciera, ParseLinks, AlertService, paginationConstants, pagingParams, $mdSidenav, Principal) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumFinancieraParameters'));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function (result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumFinancieraParameters', JSON.stringify(vm.searchItem));
            ConsortiumFinanciera.query({
                year: vm.searchItem.year,
                consortium: vm.searchItem.consortium,
                text: vm.searchItem.text,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumFinancieras = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem('searchConsortiumFinancieraParameters', JSON.stringify(vm.searchItem));
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID).toggle().then(function () {});
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumExpedienteNewController', ConsortiumExpedienteNewController);

    ConsortiumExpedienteNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumExpediente', 'lawyers', '$state', 'previousState',  'processtypes', 'clients', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumExpedienteNewController($rootScope, $timeout, $scope, entity, ConsortiumExpediente, lawyers, $state, previousState, processtypes, clients ,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumExpediente = entity;
        vm.clear = clear;
        vm.save = save;
        vm.processtypes = processtypes;
        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.toggleSidenav = buildToggler('left');
        vm.consortiumExpediente.code = '';

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            vm.consortiumExpediente.jurisdiction = 'ADMINISTRATIVA_CONSORCIOS';
            var consortiumExpediente = Object.assign({}, vm.consortiumExpediente);
            if (consortiumExpediente.registerDate !== null) {
                consortiumExpediente.registerDate = DateUtils.convertLocalDateToServer(consortiumExpediente.registerDate);
            }
            if (consortiumExpediente.notificationDate !== null) {
                consortiumExpediente.notificationDate = DateUtils.convertLocalDateToServer(consortiumExpediente.notificationDate);
            }
            if (consortiumExpediente.presentationDate !== null) {
                consortiumExpediente.presentationDate = DateUtils.convertLocalDateToServer(consortiumExpediente.presentationDate);
            }
            consortiumExpediente.client = vm.consortiumExpediente.client.name;
            consortiumExpediente.id = null;
            ConsortiumExpediente.save(consortiumExpediente, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!', 'Expediente ' + result.code);
            vm.isSaving = false;
            $state.go('consortium-expedientes.edit', {
                'id': result.id
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el expediente');
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumExpedienteDetailController', ConsortiumExpedienteDetailController);

    ConsortiumExpedienteDetailController.$inject = ['$scope', '$rootScope', '$http', 'previousState', 'entity', 'Principal', 'ConsortiumExpediente', 'GFileStep', '$state',
        'Document', 'DateUtils', 'processtypes', 'status', 'Observation', 'toastr', 'lawyers', 'clients', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumExpedienteDetailController($scope, $rootScope, $http, previousState, entity, Principal, ConsortiumExpediente, GFileStep, $state,
        Document, DateUtils, processtypes, status, Observation, toastr, lawyers, clients, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumExpediente = entity;

        vm.clients = clients;
        vm.lawyers = lawyers;
        vm.gfilestep = {};
        vm.file_type = "ADMINISTRATIVA_CONSORCIOS";
        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.isdeletedstep = false;
        vm.edit_gstep = edit_gstep;
        vm.processtypes = processtypes;
        vm.status = status;

        vm.openNewStepForm = openNewStepForm;
        vm.download_file = downloadfile;
        vm.new_document = new_document;
        vm.edit_document = edit_document;
        vm.previousState = previousState.name;
        vm.newstepform = false;
        vm.editdocumentform = false;
        vm.entityType = "GF";
        vm.list = [];
        vm.updatetree = false;
        vm.nodes = [];

        $scope.$watch('vm.updatetree', function () {
            if (vm.updatetree === true) {
                loadGFileSteps();
            }
            vm.updatetree = false;
        });

        var unsubscribe = $rootScope.$on('expedientesUriarteApp:consortiumExpedienteUpdate', function (event, result) {
            vm.consortiumExpediente = result;
        });
        $scope.$on('$destroy', unsubscribe);

        Principal.hasAuthority("ROLE_ADMIN")
            .then(function (result) {
                vm.isAdmin = result;
            });

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        loadGFileSteps();
        hasNotes();

        function loadGFileSteps() {
            GFileStep.query({
                g_file_id: vm.consortiumExpediente.id,
                allSteps: false
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.list = [];
                if (data.length >= 1) {
                    vm.list = data;
                    vm.nodes = data;
                }
            }

            function onError(error) {
            }
        }

        function save() {
            vm.isSaving = true;
            var consortiumExpediente = Object.assign({}, vm.consortiumExpediente);
            consortiumExpediente.client = vm.consortiumExpediente.client.name;
            ConsortiumExpediente.update(consortiumExpediente, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Actualizado con éxito!', 'Expediente ' + result.code);
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al actualizar el expediente');
            vm.isSaving = false;
        }

        function openNewStepForm(stepParent) {

            if (stepParent) {
                GFileStep.get({
                    id: stepParent
                }, onNewGStepSuccess, onNewGStepError);
            }
            else {
                vm.newstepform = true;
                vm.stepParent = null;
                vm.editstepform = false;
                vm.newdocumentform = false;
                vm.editdocumentform = false;
            }
        }

        function onNewGStepSuccess(data) {
            vm.stepParent = data;
            vm.newstepform = true;
            vm.editstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }
        function onNewGStepError() {
            //TODO
        }

        function edit_gstep(gstep_id, isdeleted) {
            vm.isdeletedstep = isdeleted;
            vm.gfilestep = {};
            GFileStep.get({
                id: gstep_id
            }, onEditGStepSuccess, onEditGStepError);
        }

        function onEditGStepSuccess(data) {
            vm.gfilestep = data;
            vm.editstepform = true;
            $scope.isDeleting = false;

            vm.newstepform = false;
            vm.newdocumentform = false;
            vm.editdocumentform = false;
        }

        function onEditGStepError() {
            //TODO
        }

        function downloadfile(documentId, fileType) {
            Document.get({
                id: documentId
            }, function (data) {
                $http({
                    method: 'GET',
                    url: 'api/g-files/download/' + documentId,
                    responseType: 'arraybuffer',
                    cache: false
                }).success(function (result) {
                    var a = document.createElement('a');
                    var blob = new Blob([result], {
                        'type': "application/octet-stream"
                    });
                    a.href = URL.createObjectURL(blob);

                    a.download = data.filename;
                    a.click();
                }).error(function (data, status, headers, config) {

                });
            });
        }

        function new_document(gstep_id) {
            GFileStep.get({
                id: gstep_id
            }, onNewDocumentSuccess, onNewDocumentError);
        }

        function onNewDocumentSuccess(data) {
            vm.gfilestep = data;
            vm.newdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.editdocumentform = false;
        }

        function onNewDocumentError() {
            //TODO
        }

        function edit_document(document_id) {
            Document.get({
                id: document_id
            }, onEditDocumentSuccess, onEditDocumentError);
        }

        function onEditDocumentSuccess(data) {
            vm.document = data;
            vm.editdocumentform = true;
            vm.newstepform = false;
            vm.editstepform = false;
            vm.newdocumentform = false;
        }

        function onEditDocumentError() {
            //TODO
        }

        function hasNotes() {
            Observation.query({
                gFile: vm.consortiumExpediente.id
            }, onSuccess, onError);

            function onSuccess(data) {
                $rootScope.hasNotes = data.length;
            }

            function onError() {
                $rootScope.hasNotes = 0;
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID).toggle().then(function () {
                });
            };
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-expedientes', {
                parent: 'entity',
                url: '/consortium-expedientes?page&sort&search&code&type&nif&name&sn1&sn2&company_name',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumExpediente'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-expedientes/consortium-expedientes.html',
                        controller: 'ConsortiumExpedienteController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    steps: ['$stateParams', 'Step', function ($stateParams, Step) {
                        return Step.query().$promise;
                    }],
                    status: ['$stateParams', 'GFileStatus', function ($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('consortium-expedientes.edit', {
                parent: 'consortium-expedientes',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumExpediente'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-expedientes/consortium-expedientes-detail.html',
                        controller: 'ConsortiumExpedienteDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Administrar',
                    parent: 'consortium-expedientes'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumExpediente', function ($stateParams, ConsortiumExpediente) {
                        return ConsortiumExpediente.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    processtypes: ['$stateParams', 'ProcessType', function ($stateParams, ProcessType) {
                        return ProcessType.query({ jurisdiction: 'ADMINISTRATIVA_CONSORCIOS' }).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function ($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function ($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-expedientes',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],
                    status: ['$stateParams', 'GFileStatus', function ($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('consortium-expedientes.new', {
                parent: 'consortium-expedientes',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-expedientes/consortium-expedientes-new.html',
                        controller: 'ConsortiumExpedienteNewController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Nuevo',
                    parent: 'consortium-expedientes'
                },
                resolve: {
                    entity: function () {
                        return {
                            code: null,
                            id: null
                        };
                    },
                    processtypes: ['$stateParams', 'ProcessType', function ($stateParams, ProcessType) {
                        return ProcessType.query({ jurisdiction: 'ADMINISTRATIVA_CONSORCIOS' }).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function ($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function ($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-expedientes',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumExpedienteController', ConsortiumExpedienteController);

        ConsortiumExpedienteController.$inject = ['DateUtils', '$state', 'ConsortiumExpediente', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','steps', 'status', '$mdSidenav', 'Principal'];

    function ConsortiumExpedienteController (DateUtils, $state, ConsortiumExpediente, ParseLinks, AlertService, paginationConstants, pagingParams, steps, status, $mdSidenav, Principal) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumExpedienteParameters'));

        if (vm.searchItem === null) {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];
        }

        vm.status = status;
        vm.steps = steps;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function(result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumExpedienteParameters', JSON.stringify(vm.searchItem));

            var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
                idStatus = vm.searchItem.status.id;
            }

            ConsortiumExpediente.query({
                code: vm.searchItem.code,
                status: idStatus,
                consortium: vm.searchItem.consortium,
                jurisdiction: 'ADMINISTRATIVA_CONSORCIOS',
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumExpedienteItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];

          localStorage.setItem('searchConsortiumExpedienteParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }


        if(angular.isDefined(vm.searchItem.fileType)) {
            Step.query({
                file_type_id: vm.searchItem.fileType.id
            }, function (data) {
                vm.steps = data;
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumExpedienteJuridicoJudicialNewController",
            ConsortiumExpedienteJuridicoJudicialNewController
        );

    ConsortiumExpedienteJuridicoJudicialNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "ConsortiumExpedienteJuridicoJudicial",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "ConsortiumUsers",
    ];

    function ConsortiumExpedienteJuridicoJudicialNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        ConsortiumExpedienteJuridicoJudicial,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        ConsortiumUsers
    ) {
        var vm = this;

        vm.consortiumExpedienteJuridicoJudicial = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        ConsortiumUsers.query({}, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumExpedienteJuridicoJudicial = Object.assign({},
                vm.consortiumExpedienteJuridicoJudicial
            );
            consortiumExpedienteJuridicoJudicial.id = null;
            ConsortiumExpedienteJuridicoJudicial.save(
                consortiumExpedienteJuridicoJudicial,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("consortium-expediente-juridicos-judiciales", {});
        }

        function onSaveError() {
            toastr.error("Error al crear la expropiación");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumExpedienteJuridicoJudicialDetailController",
            ConsortiumExpedienteJuridicoJudicialDetailController
        );

    ConsortiumExpedienteJuridicoJudicialDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "ConsortiumExpedienteJuridicoJudicial",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "ConsortiumExpedienteJuridicoJudicialFile",
        "ConsortiumUsers",
        "$http",
        "Upload",
    ];

    function ConsortiumExpedienteJuridicoJudicialDetailController(
        $mdDialog,
        entity,
        Principal,
        ConsortiumExpedienteJuridicoJudicial,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        ConsortiumExpedienteJuridicoJudicialFile,
        ConsortiumUsers,
        $http,
        Upload
    ) {
        var vm = this;

        vm.consortiumExpedienteJuridicoJudicial = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumExpedienteJuridicoJudicialFile.query({
                id: vm.consortiumExpedienteJuridicoJudicial.id,
            },
            onSuccess,
            onError
        );

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumExpedienteJuridicoJudicial = Object.assign({},
                vm.consortiumExpedienteJuridicoJudicial
            );
            ConsortiumExpedienteJuridicoJudicial.update(
                consortiumExpedienteJuridicoJudicial,
                onSaveSuccess,
                onSaveError
            );
        }

        function updateDocument(document) {
            ConsortiumExpedienteJuridicoJudicialFile.update(
                document,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess() {
            toastr.success("Guardado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                    method: "GET",
                    url: "api/consortium-expediente-juridico-judicial-files/download/" +
                        documentId,
                    responseType: "arraybuffer",
                    cache: false,
                })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            ConsortiumExpedienteJuridicoJudicialFile.delete({
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    ConsortiumExpedienteJuridicoJudicialFile.query({
                            id: vm.consortiumExpedienteOtra.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-expediente-juridico-judicial-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumExpedienteJuridicoJudicialId: vm.consortiumExpedienteJuridicoJudicial.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        ConsortiumExpedienteJuridicoJudicialFile.query({
                                id: vm.consortiumExpedienteJuridicoJudicial.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-expediente-juridicos-judiciales", {
                parent: "entity",
                url: "/consortium-expediente-juridicos-judiciales?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteJuridicoJudicial",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-judiciales/consortium-expediente-juridicos-judiciales.html",
                        controller: "ConsortiumExpedienteJuridicoJudicialController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-expediente-juridicos-judiciales.new", {
                parent: "consortium-expediente-juridicos-judiciales",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-judiciales/consortium-expediente-juridicos-judiciales-new.html",
                        controller: "ConsortiumExpedienteJuridicoJudicialNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-expediente-juridicos-judiciales",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-juridicos-judiciales",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-expediente-juridicos-judiciales.edit", {
                parent: "consortium-expediente-juridicos-judiciales",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteJuridicoJudicial",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-judiciales/consortium-expediente-juridicos-judiciales-detail.html",
                        controller: "ConsortiumExpedienteJuridicoJudicialDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-expediente-juridicos-judiciales",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumExpedienteJuridicoJudicial",
                        function (
                            $stateParams,
                            ConsortiumExpedienteJuridicoJudicial
                        ) {
                            return ConsortiumExpedienteJuridicoJudicial.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-juridicos-judiciales",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumExpedienteJuridicoJudicialController",
            ConsortiumExpedienteJuridicoJudicialController
        );

    ConsortiumExpedienteJuridicoJudicialController.$inject = [
        "ConsortiumExpedienteJuridicoJudicial",
        "DateUtils",
        "$state",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function ConsortiumExpedienteJuridicoJudicialController(
        ConsortiumExpedienteJuridicoJudicial,
        DateUtils,
        $state,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem(
                "searchConsortiumExpedienteJuridicoJudicialParameters"
            )
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function (result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem(
                "searchConsortiumExpedienteJuridicoJudicialParameters",
                JSON.stringify(vm.searchItem)
            );
            ConsortiumExpedienteJuridicoJudicial.query({
                    year: vm.searchItem.year,
                    consortium: vm.searchItem.consortium,
                    jurisdiction: vm.searchItem.jurisdiction,
                    demand: vm.searchItem.demand,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.consortiumExpedienteJuridicosJudiciales = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchConsortiumExpedienteJuridicoJudicialParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumExpedienteJuridicoInformeNewController",
            ConsortiumExpedienteJuridicoInformeNewController
        );

    ConsortiumExpedienteJuridicoInformeNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "ConsortiumExpedienteJuridicoInforme",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "ConsortiumUsers",
    ];

    function ConsortiumExpedienteJuridicoInformeNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        ConsortiumExpedienteJuridicoInforme,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        ConsortiumUsers
    ) {
        var vm = this;

        vm.consortiumExpedienteJuridicoInforme = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        ConsortiumUsers.query({}, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumExpedienteJuridicoInforme = Object.assign({},
                vm.consortiumExpedienteJuridicoInforme
            );
            consortiumExpedienteJuridicoInforme.id = null;
            ConsortiumExpedienteJuridicoInforme.save(
                consortiumExpedienteJuridicoInforme,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("consortium-expediente-juridicos-informes", {});
        }

        function onSaveError() {
            toastr.error("Error al crear la expropiación");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumExpedienteJuridicoInformeDetailController', ConsortiumExpedienteJuridicoInformeDetailController);

    ConsortiumExpedienteJuridicoInformeDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumExpedienteJuridicoInforme', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumExpedienteJuridicoInformeFile', 'ConsortiumUsers', '$http', 'Upload'];

    function ConsortiumExpedienteJuridicoInformeDetailController($mdDialog, entity, Principal, ConsortiumExpedienteJuridicoInforme, toastr, $mdSidenav, $state, previousState, ConsortiumExpedienteJuridicoInformeFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumExpedienteJuridicoInforme = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumExpedienteJuridicoInformeFile.query({
            id: vm.consortiumExpedienteJuridicoInforme.id
        }, onSuccess, onError);

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumExpedienteJuridicoInforme = Object.assign({}, vm.consortiumExpedienteJuridicoInforme);
            ConsortiumExpedienteJuridicoInforme.update(consortiumExpedienteJuridicoInforme, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumExpedienteJuridicoInformeFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-expediente-juridico-informe-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function (data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function (data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea borrar el documento?')
                .textContent('Si elimina el documento no se podrá recuperar.')
                .ok('Borrar')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {

            });
        }

        function removeDocument(documentId) {
            ConsortiumExpedienteJuridicoInformeFile.delete({
                    id: documentId
                },
                function () {
                    toastr.success('Documento eliminado con éxito');
                    ConsortiumExpedienteJuridicoInformeFile.query({
                        id: vm.consortiumPersonalOtra.id
                    }, onSuccess, onError);
                },
                function () {
                    toastr.error('Error al eliminar el documento');
                });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-expediente-juridico-informe-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumExpedienteJuridicoInformeId: vm.consortiumExpedienteJuridicoInforme.id
                    },
                    method: 'POST'
                }).then(
                    function () {
                        toastr.success('Documento subido con éxito');
                        ConsortiumExpedienteJuridicoInformeFile.query({
                            id: vm.consortiumExpedienteJuridicoInforme.id
                        }, onSuccess, onError);
                    },
                    function (response) {
                        toastr.error('Error al subir el documento');
                    },
                    function () {}
                );

            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID).toggle().then(function () {});
            };
        }

    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-expediente-juridicos-informes", {
                parent: "entity",
                url: "/consortium-expediente-juridicos-informes?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteJuridicoInforme",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-informes/consortium-expediente-juridicos-informes.html",
                        controller: "ConsortiumExpedienteJuridicoInformeController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-expediente-juridicos-informes.new", {
                parent: "consortium-expediente-juridicos-informes",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-informes/consortium-expediente-juridicos-informes-new.html",
                        controller: "ConsortiumExpedienteJuridicoInformeNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-expediente-juridicos-informes",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-juridicos-informes",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-expediente-juridicos-informes.edit", {
                parent: "consortium-expediente-juridicos-informes",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteJuridicoInforme",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-informes/consortium-expediente-juridicos-informes-detail.html",
                        controller: "ConsortiumExpedienteJuridicoInformeDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-expediente-juridicos-informes",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumExpedienteJuridicoInforme",
                        function (
                            $stateParams,
                            ConsortiumExpedienteJuridicoInforme
                        ) {
                            return ConsortiumExpedienteJuridicoInforme.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-juridicos-informes",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumExpedienteJuridicoInformeController",
            ConsortiumExpedienteJuridicoInformeController
        );

    ConsortiumExpedienteJuridicoInformeController.$inject = [
        "ConsortiumExpedienteJuridicoInforme",
        "DateUtils",
        "$state",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function ConsortiumExpedienteJuridicoInformeController(
        ConsortiumExpedienteJuridicoInforme,
        DateUtils,
        $state,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem(
                "searchConsortiumExpedienteJuridicoInformeParameters"
            )
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function (result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem(
                "searchConsortiumExpedienteJuridicoInformeParameters",
                JSON.stringify(vm.searchItem)
            );
            ConsortiumExpedienteJuridicoInforme.query({
                    year: vm.searchItem.year,
                    consortium: vm.searchItem.consortium,
                    matter: vm.searchItem.matter,
                    petitioner: vm.searchItem.petitioner,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.consortiumExpedienteJuridicosInformes = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchConsortiumExpedienteJuridicoInformeParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumExpedienteExpropiacionNewController",
            ConsortiumExpedienteExpropiacionNewController
        );

    ConsortiumExpedienteExpropiacionNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "ConsortiumExpedienteExpropiacion",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "ConsortiumUsers",
    ];

    function ConsortiumExpedienteExpropiacionNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        ConsortiumExpedienteExpropiacion,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        ConsortiumUsers
    ) {
        var vm = this;

        vm.consortiumExpedienteExpropiacion = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        ConsortiumUsers.query({}, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumExpedienteExpropiacion = Object.assign({},
                vm.consortiumExpedienteExpropiacion
            );
            consortiumExpedienteExpropiacion.id = null;
            ConsortiumExpedienteExpropiacion.save(
                consortiumExpedienteExpropiacion,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("consortium-expediente-expropiaciones", {});
        }

        function onSaveError() {
            toastr.error("Error al crear la expropiación");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumExpedienteExpropiacionDetailController",
            ConsortiumExpedienteExpropiacionDetailController
        );

    ConsortiumExpedienteExpropiacionDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "ConsortiumExpedienteExpropiacion",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "ConsortiumExpedienteExpropiacionFile",
        "ConsortiumUsers",
        "$http",
        "Upload",
    ];

    function ConsortiumExpedienteExpropiacionDetailController(
        $mdDialog,
        entity,
        Principal,
        ConsortiumExpedienteExpropiacion,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        ConsortiumExpedienteExpropiacionFile,
        ConsortiumUsers,
        $http,
        Upload
    ) {
        var vm = this;

        vm.consortiumExpedienteExpropiacion = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumExpedienteExpropiacionFile.query({
                id: vm.consortiumExpedienteExpropiacion.id,
            },
            onSuccess,
            onError
        );

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumExpedienteExpropiacion = Object.assign({},
                vm.consortiumExpedienteExpropiacion
            );
            ConsortiumExpedienteExpropiacion.update(
                consortiumExpedienteExpropiacion,
                onSaveSuccess,
                onSaveError
            );
        }

        function updateDocument(document) {
            ConsortiumExpedienteExpropiacionFile.update(
                document,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess() {
            toastr.success("Guardado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                    method: "GET",
                    url: "api/consortium-expediente-expropiacion-files/download/" +
                        documentId,
                    responseType: "arraybuffer",
                    cache: false,
                })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            ConsortiumExpedienteExpropiacionFile.delete({
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    ConsortiumExpedienteExpropiacionFile.query({
                            id: vm.consortiumExpedienteOtra.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-expediente-expropiacion-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumExpedienteExpropiacionId: vm.consortiumExpedienteExpropiacion.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        ConsortiumExpedienteExpropiacionFile.query({
                                id: vm.consortiumExpedienteExpropiacion.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-expediente-expropiaciones", {
                parent: "entity",
                url: "/consortium-expediente-expropiaciones?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteExpropiacion",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-expropiaciones/consortium-expediente-expropiaciones.html",
                        controller: "ConsortiumExpedienteExpropiacionController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-expediente-expropiaciones.new", {
                parent: "consortium-expediente-expropiaciones",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-expropiaciones/consortium-expediente-expropiaciones-new.html",
                        controller: "ConsortiumExpedienteExpropiacionNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-expediente-expropiaciones",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-expropiaciones",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-expediente-expropiaciones.edit", {
                parent: "consortium-expediente-expropiaciones",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumExpedienteExpropiacion",
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/consortium-expediente/consortium-expediente-expropiaciones/consortium-expediente-expropiaciones-detail.html",
                        controller: "ConsortiumExpedienteExpropiacionDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-expediente-expropiaciones",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumExpedienteExpropiacion",
                        function (
                            $stateParams,
                            ConsortiumExpedienteExpropiacion
                        ) {
                            return ConsortiumExpedienteExpropiacion.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name ||
                                    "consortium-expediente-expropiaciones",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumExpedienteExpropiacionController",
            ConsortiumExpedienteExpropiacionController
        );

    ConsortiumExpedienteExpropiacionController.$inject = [
        "ConsortiumExpedienteExpropiacion",
        "DateUtils",
        "$state",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function ConsortiumExpedienteExpropiacionController(
        ConsortiumExpedienteExpropiacion,
        DateUtils,
        $state,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem(
                "searchConsortiumExpedienteExpropiacionParameters"
            )
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function (result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem(
                "searchConsortiumExpedienteExpropiacionParameters",
                JSON.stringify(vm.searchItem)
            );
            ConsortiumExpedienteExpropiacion.query(
                {
                    year: vm.searchItem.year,
                    consortium: vm.searchItem.consortium,
                    denomination: vm.searchItem.denomination,
                    text: vm.searchItem.text,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.consortiumExpedienteExpropiaciones = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchConsortiumExpedienteExpropiacionParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumContratoNewController",
            ConsortiumContratoNewController
        );

    ConsortiumContratoNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "ConsortiumContrato",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "ConsortiumUsers",
    ];

    function ConsortiumContratoNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        ConsortiumContrato,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        ConsortiumUsers
    ) {
        var vm = this;

        vm.consortiumContrato = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        ConsortiumUsers.query({}, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumContrato = Object.assign({}, vm.consortiumContrato);
            consortiumContrato.id = null;
            ConsortiumContrato.save(
                consortiumContrato,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("consortium-contrato", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumContratoDetailController",
            ConsortiumContratoDetailController
        );

    ConsortiumContratoDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "ConsortiumContrato",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "ConsortiumContratoFile",
        "ConsortiumUsers",
        "$http",
        "Upload",
    ];

    function ConsortiumContratoDetailController(
        $mdDialog,
        entity,
        Principal,
        ConsortiumContrato,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        ConsortiumContratoFile,
        ConsortiumUsers,
        $http,
        Upload
    ) {
        var vm = this;

        vm.consortiumContrato = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumContratoFile.query(
            {
                id: vm.consortiumContrato.id,
            },
            onSuccess,
            onError
        );

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumContrato = Object.assign({}, vm.consortiumContrato);

            ConsortiumContrato.update(
                consortiumContrato,
                onSaveSuccess,
                onSaveError
            );
        }

        function updateDocument(document) {
            ConsortiumContratoFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Guardado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/consortium-contrato-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            ConsortiumContratoFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    ConsortiumContratoFile.query(
                        {
                            id: vm.consortiumContrato.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-contrato-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumContratoId: vm.consortiumContrato.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        ConsortiumContratoFile.query(
                            {
                                id: vm.consortiumContrato.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-contrato", {
                parent: "entity",
                url: "/consortium-contrato?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumContrato",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contrato/consortium-contrato.html",
                        controller: "ConsortiumContratoController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-contrato.new", {
                parent: "consortium-contrato",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contrato/consortium-contrato-new.html",
                        controller: "ConsortiumContratoNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-contrato",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-contrato",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-contrato.edit", {
                parent: "consortium-contrato",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumContrato",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contrato/consortium-contrato-detail.html",
                        controller: "ConsortiumContratoDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-contrato",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumContrato",
                        function ($stateParams, ConsortiumContrato) {
                            return ConsortiumContrato.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-contrato",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumContratoController",
            ConsortiumContratoController
        );

    ConsortiumContratoController.$inject = [
        "DateUtils",
        "$state",
        "ConsortiumContrato",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function ConsortiumContratoController(
        DateUtils,
        $state,
        ConsortiumContrato,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchConsortiumContratoParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function (result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem(
                "searchConsortiumContratoParameters",
                JSON.stringify(vm.searchItem)
            );
            ConsortiumContrato.query(
                {
                    year: vm.searchItem.year,
                    consortium: vm.searchItem.consortium,
                    text: vm.searchItem.text,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.consortiumContratos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchConsortiumContratoParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumContabilidadRecibidaNewController', ConsortiumContabilidadRecibidaNewController);

        ConsortiumContabilidadRecibidaNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumContabilidadRecibida', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumContabilidadRecibidaNewController($rootScope, $timeout, $scope, entity, ConsortiumContabilidadRecibida, $state, previousState,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumContabilidadRecibida = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumContabilidadRecibida = Object.assign({}, vm.consortiumContabilidadRecibida);
            consortiumContabilidadRecibida.id = null;
            ConsortiumContabilidadRecibida.save(consortiumContabilidadRecibida, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-contabilidad-recibida', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el expediente');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumContabilidadRecibidaDetailController', ConsortiumContabilidadRecibidaDetailController);

        ConsortiumContabilidadRecibidaDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumContabilidadRecibida', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumContabilidadRecibidaFile', 'ConsortiumUsers', '$http', 'Upload' ];

    function ConsortiumContabilidadRecibidaDetailController($mdDialog, entity, Principal, ConsortiumContabilidadRecibida, toastr, $mdSidenav, $state, previousState, ConsortiumContabilidadRecibidaFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumContabilidadRecibida = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumContabilidadRecibidaFile.query({
            id: vm.consortiumContabilidadRecibida.id
        }, onSuccess, onError);
        
        ConsortiumUsers.query({}, onConsortiumSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumContabilidadRecibida = Object.assign({}, vm.consortiumContabilidadRecibida);
            ConsortiumContabilidadRecibida.update(consortiumContabilidadRecibida, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumContabilidadRecibidaFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-contabilidad-recibida-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function(data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function(data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
              .title('¿Desea borrar el documento?')
              .textContent('Si elimina el documento no se podrá recuperar.')
              .ok('Borrar')
              .cancel('Cancelar');
        
            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {
              
            });
        }

        function removeDocument(documentId) {
            ConsortiumContabilidadRecibidaFile.delete({
                id: documentId
            },
            function() {
                toastr.success('Documento eliminado con éxito');
                ConsortiumContabilidadRecibidaFile.query({
                    id: vm.consortiumContabilidadOtra.id
                }, onSuccess, onError);
            },
            function () {
                toastr.error('Error al eliminar el documento');
            });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-contabilidad-recibida-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumContabilidadRecibidaId: vm.consortiumContabilidadRecibida.id
                    },
                    method: 'POST'
                }).then(
                    function() {
                        toastr.success('Documento subido con éxito');
                        ConsortiumContabilidadRecibidaFile.query({
                            id: vm.consortiumContabilidadRecibida.id
                        }, onSuccess, onError);
                    },
                    function(response) {
                        toastr.error('Error al subir el documento');
                    },
                    function() {}
                );              

            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-contabilidad-recibidas", {
                parent: "entity",
                url: "/consortium-contabilidad-recibidas?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumContabilidadRecibidas",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contabilidad/consortium-contabilidad-recibidas/consortium-contabilidad-recibidas.html",
                        controller: "ConsortiumContabilidadRecibidaController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-contabilidad-recibidas.new", {
                parent: "consortium-contabilidad-recibidas",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contabilidad/consortium-contabilidad-recibidas/consortium-contabilidad-recibidas-new.html",
                        controller:
                            "ConsortiumContabilidadRecibidaNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-contabilidad-recibidas",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-contabilidad-recibidas",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-contabilidad-recibidas.edit", {
                parent: "consortium-contabilidad-recibidas",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumContabilidadRecibidas",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contabilidad/consortium-contabilidad-recibidas/consortium-contabilidad-recibidas-detail.html",
                        controller:
                            "ConsortiumContabilidadRecibidaDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-contabilidad-recibidas",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumContabilidadRecibida",
                        function (
                            $stateParams,
                            ConsortiumContabilidadRecibida
                        ) {
                            return ConsortiumContabilidadRecibida.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-contabilidad-recibidas",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumContabilidadRecibidaController",
            ConsortiumContabilidadRecibidaController
        );

    ConsortiumContabilidadRecibidaController.$inject = [
        "ConsortiumContabilidadRecibida",
        "$state",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function ConsortiumContabilidadRecibidaController(
        ConsortiumContabilidadRecibida,
        $state,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem(
                "searchConsortiumContabilidadRecibidaParameters"
            )
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function (result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem(
                "searchConsortiumContabilidadRecibidaParameters",
                JSON.stringify(vm.searchItem)
            );
            ConsortiumContabilidadRecibida.query({
                    year: vm.searchItem.year,
                    consortium: vm.searchItem.consortium,
                    namedesc: vm.searchItem.namedesc,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.consortiumContabilidadRecibidaItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchConsortiumContabilidadRecibidaParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumContabilidadEmitidaNewController', ConsortiumContabilidadEmitidaNewController);

        ConsortiumContabilidadEmitidaNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumContabilidadEmitida', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumContabilidadEmitidaNewController($rootScope, $timeout, $scope, entity, ConsortiumContabilidadEmitida, $state, previousState,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumContabilidadEmitida = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumContabilidadEmitida = Object.assign({}, vm.consortiumContabilidadEmitida);
            consortiumContabilidadEmitida.id = null;
            ConsortiumContabilidadEmitida.save(consortiumContabilidadEmitida, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-contabilidad', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el expediente');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumContabilidadEmitidaDetailController', ConsortiumContabilidadEmitidaDetailController);

    ConsortiumContabilidadEmitidaDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumContabilidadEmitida', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumContabilidadEmitidaFile', 'ConsortiumUsers', '$http', 'Upload'];

    function ConsortiumContabilidadEmitidaDetailController($mdDialog, entity, Principal, ConsortiumContabilidadEmitida, toastr, $mdSidenav, $state, previousState, ConsortiumContabilidadEmitidaFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumContabilidadEmitida = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumContabilidadEmitidaFile.query({
            id: vm.consortiumContabilidadEmitida.id
        }, onSuccess, onError);

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumContabilidadEmitida = Object.assign({}, vm.consortiumContabilidadEmitida);
            ConsortiumContabilidadEmitida.update(consortiumContabilidadEmitida, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumContabilidadEmitidaFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-contabilidad-emitida-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function (data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function (data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea borrar el documento?')
                .textContent('Si elimina el documento no se podrá recuperar.')
                .ok('Borrar')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {

            });
        }

        function removeDocument(documentId) {
            ConsortiumContabilidadEmitidaFile.delete({
                id: documentId
            },
                function () {
                    toastr.success('Documento eliminado con éxito');
                    ConsortiumContabilidadEmitidaFile.query({
                        id: vm.consortiumContabilidadEmitidaOtra.id
                    }, onSuccess, onError);
                },
                function () {
                    toastr.error('Error al eliminar el documento');
                });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-contabilidad-emitida-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumContabilidadEmitidaId: vm.consortiumContabilidadEmitida.id
                    },
                    method: 'POST'
                }).then(
                    function () {
                        toastr.success('Documento subido con éxito');
                        ConsortiumContabilidadEmitidaFile.query({
                            id: vm.consortiumContabilidadEmitida.id
                        }, onSuccess, onError);
                    },
                    function (response) {
                        toastr.error('Error al subir el documento');
                    },
                    function () { }
                );

            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID).toggle().then(function () {
                });
            };
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-contabilidad-emitidas', {
                parent: 'entity',
                url: '/consortium-contabilidad-emitida?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumContabilidadEmitida'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-emitidas/consortium-contabilidad-emitidas.html',
                        controller: 'ConsortiumContabilidadEmitidaController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-contabilidad-emitidas.new', {
                parent: 'consortium-contabilidad-emitidas',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-emitidas/consortium-contabilidad-emitidas-new.html',
                        controller: 'ConsortiumContabilidadEmitidaNewController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Nuevo',
                    parent: 'consortium-contabilidad-emitidas'
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-contabilidad-emitidas',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            }).state('consortium-contabilidad-emitidas.edit', {
                parent: 'consortium-contabilidad-emitidas',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumContabilidadEmitida'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-emitidas/consortium-contabilidad-emitidas-detail.html',
                        controller: 'ConsortiumContabilidadEmitidaDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Lista',
                    parent: 'consortium-contabilidad-emitidas'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumContabilidadEmitida', function ($stateParams, ConsortiumContabilidadEmitida) {
                        return ConsortiumContabilidadEmitida.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-contabilidad-emitidas',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumContabilidadEmitidaController', ConsortiumContabilidadEmitidaController);

        ConsortiumContabilidadEmitidaController.$inject = ['ConsortiumContabilidadEmitida', 'DateUtils', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$mdSidenav', 'Principal'];

    function ConsortiumContabilidadEmitidaController (ConsortiumContabilidadEmitida, DateUtils, $state, ParseLinks, AlertService, paginationConstants, pagingParams, $mdSidenav, Principal) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchConsortiumContabilidadEmitidaParameters'));

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function(result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem('searchConsortiumContabilidadEmitidaParameters', JSON.stringify(vm.searchItem));
            ConsortiumContabilidadEmitida.query({
                year: vm.searchItem.year,
                consortium: vm.searchItem.consortium,
                namedesc: vm.searchItem.namedesc,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.consortiumContabilidadEmitidaItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();

          localStorage.setItem('searchConsortiumContabilidadEmitidaParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumContabilidadAnualNewController', ConsortiumContabilidadAnualNewController);

        ConsortiumContabilidadAnualNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumContabilidadAnual', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumContabilidadAnualNewController($rootScope, $timeout, $scope, entity, ConsortiumContabilidadAnual, $state, previousState,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumContabilidadAnual = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumContabilidadAnual = Object.assign({}, vm.consortiumContabilidadAnual);
            consortiumContabilidadAnual.id = null;
            ConsortiumContabilidadAnual.save(consortiumContabilidadAnual, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-contabilidad-anuales', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear la cuenta anual');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumContabilidadAnualDetailController', ConsortiumContabilidadAnualDetailController);

        ConsortiumContabilidadAnualDetailController.$inject = ['$mdDialog', 'entity', 'Principal', 'ConsortiumContabilidadAnual', 'toastr', '$mdSidenav', '$state', 'previousState', 'ConsortiumContabilidadAnualFile', 'ConsortiumUsers', '$http', 'Upload' ];

    function ConsortiumContabilidadAnualDetailController($mdDialog, entity, Principal, ConsortiumContabilidadAnual, toastr, $mdSidenav, $state, previousState, ConsortiumContabilidadAnualFile, ConsortiumUsers, $http, Upload) {
        var vm = this;

        vm.consortiumContabilidadAnual = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler('left');
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumContabilidadAnualFile.query({
            id: vm.consortiumContabilidadAnual.id
        }, onSuccess, onError);
        
        ConsortiumUsers.query({}, onConsortiumSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumContabilidadAnual = Object.assign({}, vm.consortiumContabilidadAnual);
            ConsortiumContabilidadAnual.update(consortiumContabilidadAnual, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumContabilidadAnualFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            toastr.success('Guardado con éxito!');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al guardar');
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: 'GET',
                url: 'api/consortium-contabilidad-anual-files/download/' + documentId,
                responseType: 'arraybuffer',
                cache: false
            }).success(function(data) {
                var a = document.createElement('a');
                var blob = new Blob([data], {
                    'type': "application/octet-stream"
                });
                a.href = URL.createObjectURL(blob);
                var documentName = "";
                for (var i = 0; i < vm.documents.length; i++) {
                    var doc = vm.documents[i];
                    if (doc.id === documentId) {
                        documentName = doc.fileName;
                    }
                }
                a.download = documentName;
                a.click();
            }).error(function(data, status, headers, config) {
                toastr.error('Error al descargar el documento');
            });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog.confirm()
              .title('¿Desea borrar el documento?')
              .textContent('Si elimina el documento no se podrá recuperar.')
              .ok('Borrar')
              .cancel('Cancelar');
        
            $mdDialog.show(confirm).then(function () {
                removeDocument(documentId);
            }, function () {
              
            });
        }

        function removeDocument(documentId) {
            ConsortiumContabilidadAnualFile.delete({
                id: documentId
            },
            function() {
                toastr.success('Documento eliminado con éxito');
                ConsortiumContabilidadAnualFile.query({
                    id: vm.consortiumContabilidadOtra.id
                }, onSuccess, onError);
            },
            function () {
                toastr.error('Error al eliminar el documento');
            });
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-contabilidad-anual-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumContabilidadAnualId: vm.consortiumContabilidadAnual.id
                    },
                    method: 'POST'
                }).then(
                    function() {
                        toastr.success('Documento subido con éxito');
                        ConsortiumContabilidadAnualFile.query({
                            id: vm.consortiumContabilidadAnual.id
                        }, onSuccess, onError);
                    },
                    function(response) {
                        toastr.error('Error al subir el documento');
                    },
                    function() {}
                );              

            }
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-contabilidad-anuales', {
                parent: 'entity',
                url: '/consortium-contabilidad-anuales?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumContabilidadAnual'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-anuales/consortium-contabilidad-anuales.html',
                    controller: 'ConsortiumContabilidadAnualController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-contabilidad-anuales.new', {
                parent: 'consortium-contabilidad-anuales',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-anuales/consortium-contabilidad-anuales-new.html',
                    controller: 'ConsortiumContabilidadAnualNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'consortium-contabilidad-anuales'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'consortium-contabilidad-anuales',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            }).state('consortium-contabilidad-anuales.edit', {
                parent: 'consortium-contabilidad-anuales',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumContabilidadAnuales'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-contabilidad/consortium-contabilidad-anuales/consortium-contabilidad-anuales-detail.html',
                        controller: 'ConsortiumContabilidadAnualDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Lista',
                      parent: 'consortium-contabilidad-anuales'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumContabilidadAnual', function($stateParams, ConsortiumContabilidadAnual) {
                        return ConsortiumContabilidadAnual.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-contabilidad-anuales',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumContabilidadAnualController",
            ConsortiumContabilidadAnualController
        );

    ConsortiumContabilidadAnualController.$inject = [
        "ConsortiumContabilidadAnual",
        "$state",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function ConsortiumContabilidadAnualController(
        ConsortiumContabilidadAnual,
        $state,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchConsortiumContabilidadAnualParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function (result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem(
                "searchConsortiumContabilidadAnualParameters",
                JSON.stringify(vm.searchItem)
            );
            ConsortiumContabilidadAnual.query(
                {
                    year: vm.searchItem.year,
                    consortium: vm.searchItem.consortium,
                    desc: vm.searchItem.desc,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.consortiumContabilidadAnualItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchConsortiumContabilidadAnualParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("ConsortiumCeaNewController", ConsortiumCeaNewController);

    ConsortiumCeaNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "ConsortiumCea",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "ConsortiumUsers",
    ];

    function ConsortiumCeaNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        ConsortiumCea,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        ConsortiumUsers
    ) {
        var vm = this;

        vm.consortiumCea = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        ConsortiumUsers.query({}, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumCea = Object.assign({}, vm.consortiumCea);
            consortiumCea.id = null;
            ConsortiumCea.save(consortiumCea, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("consortium-cea", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumCeaDetailController",
            ConsortiumCeaDetailController
        );

    ConsortiumCeaDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "ConsortiumCea",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "ConsortiumCeaFile",
        "ConsortiumUsers",
        "$http",
        "Upload",
    ];

    function ConsortiumCeaDetailController(
        $mdDialog,
        entity,
        Principal,
        ConsortiumCea,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        ConsortiumCeaFile,
        ConsortiumUsers,
        $http,
        Upload
    ) {
        var vm = this;

        vm.consortiumCea = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumCeaFile.query(
            {
                id: vm.consortiumCea.id,
            },
            onSuccess,
            onError
        );

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumCea = Object.assign({}, vm.consortiumCea);

            ConsortiumCea.update(consortiumCea, onSaveSuccess, onSaveError);
        }

        function updateDocument(document) {
            ConsortiumCeaFile.update(document, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Guardado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/consortium-cea-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            ConsortiumCeaFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    ConsortiumCeaFile.query(
                        {
                            id: vm.consortiumCea.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-cea-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumCeaId: vm.consortiumCea.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        ConsortiumCeaFile.query(
                            {
                                id: vm.consortiumCea.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-cea", {
                parent: "entity",
                url: "/consortium-cea?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumCea",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-cea/consortium-cea.html",
                        controller: "ConsortiumCeaController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-cea.new", {
                parent: "consortium-cea",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-cea/consortium-cea-new.html",
                        controller: "ConsortiumCeaNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-cea",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "consortium-cea",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-cea.edit", {
                parent: "consortium-cea",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumCea",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-cea/consortium-cea-detail.html",
                        controller: "ConsortiumCeaDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-cea",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumCea",
                        function ($stateParams, ConsortiumCea) {
                            return ConsortiumCea.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "consortium-cea",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("ConsortiumCeaController", ConsortiumCeaController);

    ConsortiumCeaController.$inject = [
        "DateUtils",
        "$state",
        "ConsortiumCea",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function ConsortiumCeaController(
        DateUtils,
        $state,
        ConsortiumCea,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchConsortiumCeaParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function (result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem(
                "searchConsortiumCeaParameters",
                JSON.stringify(vm.searchItem)
            );
            ConsortiumCea.query(
                {
                    year: vm.searchItem.year,
                    consortium: vm.searchItem.consortium,
                    namedesc: vm.searchItem.namedesc,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.consortiumCeas = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchConsortiumCeaParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumAuditoriaNewController",
            ConsortiumAuditoriaNewController
        );

    ConsortiumAuditoriaNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "ConsortiumAuditoria",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
        "ConsortiumUsers",
    ];

    function ConsortiumAuditoriaNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        ConsortiumAuditoria,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav,
        ConsortiumUsers
    ) {
        var vm = this;

        vm.consortiumAuditoria = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        ConsortiumUsers.query({}, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumAuditoria = Object.assign({}, vm.consortiumAuditoria);
            consortiumAuditoria.id = null;
            ConsortiumAuditoria.save(
                consortiumAuditoria,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess(result) {
            toastr.success("Creado con éxito!");
            vm.isSaving = false;
            $state.go("consortium-Auditoria", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el expediente");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumAuditoriaDetailController",
            ConsortiumAuditoriaDetailController
        );

    ConsortiumAuditoriaDetailController.$inject = [
        "$mdDialog",
        "entity",
        "Principal",
        "ConsortiumAuditoria",
        "toastr",
        "$mdSidenav",
        "$state",
        "previousState",
        "ConsortiumAuditoriaFile",
        "ConsortiumUsers",
        "$http",
        "Upload",
    ];

    function ConsortiumAuditoriaDetailController(
        $mdDialog,
        entity,
        Principal,
        ConsortiumAuditoria,
        toastr,
        $mdSidenav,
        $state,
        previousState,
        ConsortiumAuditoriaFile,
        ConsortiumUsers,
        $http,
        Upload
    ) {
        var vm = this;

        vm.consortiumAuditoria = entity;
        vm.clear = clear;

        vm.toggleSidenav = buildToggler("left");
        vm.save = save;

        vm.updateDocument = updateDocument;
        vm.downloadDocument = downloadDocument;
        vm.removeDocument = removeDocument;
        vm.uploadDocument = uploadDocument;
        vm.showConfirm = showConfirm;

        vm.updatetree = false;
        vm.nodes = [];

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
            vm.isAdmin = result;
        });

        ConsortiumAuditoriaFile.query(
            {
                id: vm.consortiumAuditoria.id,
            },
            onSuccess,
            onError
        );

        ConsortiumUsers.query({}, onConsortiumSuccess, onError);

        function onSuccess(data, headers) {
            vm.documents = data;
        }

        function onConsortiumSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function save() {
            vm.isSaving = true;
            var consortiumAuditoria = Object.assign({}, vm.consortiumAuditoria);

            ConsortiumAuditoria.update(
                consortiumAuditoria,
                onSaveSuccess,
                onSaveError
            );
        }

        function updateDocument(document) {
            ConsortiumAuditoriaFile.update(
                document,
                onSaveSuccess,
                onSaveError
            );
        }

        function onSaveSuccess(result) {
            toastr.success("Guardado con éxito!");
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error al guardar");
            vm.isSaving = false;
        }

        function downloadDocument(documentId) {
            $http({
                method: "GET",
                url: "api/consortium-auditoria-files/download/" + documentId,
                responseType: "arraybuffer",
                cache: false,
            })
                .success(function (data) {
                    var a = document.createElement("a");
                    var blob = new Blob([data], {
                        type: "application/octet-stream",
                    });
                    a.href = URL.createObjectURL(blob);
                    var documentName = "";
                    for (var i = 0; i < vm.documents.length; i++) {
                        var doc = vm.documents[i];
                        if (doc.id === documentId) {
                            documentName = doc.fileName;
                        }
                    }
                    a.download = documentName;
                    a.click();
                })
                .error(function (data, status, headers, config) {
                    toastr.error("Error al descargar el documento");
                });
        }

        function showConfirm(documentId) {
            var confirm = $mdDialog
                .confirm()
                .title("¿Desea borrar el documento?")
                .textContent("Si elimina el documento no se podrá recuperar.")
                .ok("Borrar")
                .cancel("Cancelar");

            $mdDialog.show(confirm).then(
                function () {
                    removeDocument(documentId);
                },
                function () {}
            );
        }

        function removeDocument(documentId) {
            ConsortiumAuditoriaFile.delete(
                {
                    id: documentId,
                },
                function () {
                    toastr.success("Documento eliminado con éxito");
                    ConsortiumAuditoriaFile.query(
                        {
                            id: vm.consortiumAuditoria.id,
                        },
                        onSuccess,
                        onError
                    );
                },
                function () {
                    toastr.error("Error al eliminar el documento");
                }
            );
        }

        function uploadDocument(file, errFiles) {
            if (file) {
                Upload.upload({
                    url: "api/consortium-auditoria-files",
                    data: {
                        file: file,
                        fileName: file.name,
                        consortiumAuditoriaId: vm.consortiumAuditoria.id,
                    },
                    method: "POST",
                }).then(
                    function () {
                        toastr.success("Documento subido con éxito");
                        ConsortiumAuditoriaFile.query(
                            {
                                id: vm.consortiumAuditoria.id,
                            },
                            onSuccess,
                            onError
                        );
                    },
                    function (response) {
                        toastr.error("Error al subir el documento");
                    },
                    function () {}
                );
            }
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-auditoria", {
                parent: "entity",
                url: "/consortium-auditoria?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumAuditoria",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-auditoria/consortium-auditoria.html",
                        controller: "ConsortiumAuditoriaController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-auditoria.new", {
                parent: "consortium-auditoria",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-auditoria/consortium-auditoria-new.html",
                        controller: "ConsortiumAuditoriaNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-auditoria",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-auditoria",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-auditoria.edit", {
                parent: "consortium-auditoria",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumAuditoria",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-auditoria/consortium-auditoria-detail.html",
                        controller: "ConsortiumAuditoriaDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-auditoria",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumAuditoria",
                        function ($stateParams, ConsortiumAuditoria) {
                            return ConsortiumAuditoria.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-auditoria",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();

(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller(
            "ConsortiumAuditoriaController",
            ConsortiumAuditoriaController
        );

    ConsortiumAuditoriaController.$inject = [
        "DateUtils",
        "$state",
        "ConsortiumAuditoria",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "$mdSidenav",
        "Principal",
    ];

    function ConsortiumAuditoriaController(
        DateUtils,
        $state,
        ConsortiumAuditoria,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        $mdSidenav,
        Principal
    ) {
        var vm = this;
        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;

        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchConsortiumAuditoriaParameters")
        );

        if (vm.searchItem === null) {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.hasAuthority("ROLE_CONSORTIUM").then(function (result) {
            if (result) vm.searchItem.consortium = "";
            searchExp();
        });

        function searchExp() {
            // Store the value(s)
            localStorage.setItem(
                "searchConsortiumAuditoriaParameters",
                JSON.stringify(vm.searchItem)
            );
            ConsortiumAuditoria.query(
                {
                    year: vm.searchItem.year,
                    consortium: vm.searchItem.consortium,
                    text: vm.searchItem.text,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                ];
                if (vm.predicate !== "id") {
                    result.push("id");
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.totalItems = headers("X-Total-Count");
                vm.queryCount = vm.totalItems;
                vm.consortiumAuditorias = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function deleteSearchItem() {
            vm.searchItem = {};
            vm.searchItem.year = new Date().getFullYear();

            localStorage.setItem(
                "searchConsortiumAuditoriaParameters",
                JSON.stringify(vm.searchItem)
            );
            vm.page = 1;
            vm.transition();
            searchExp();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
            });
        }

        function buildToggler(navID) {
            return function () {
                // Component lookup should always be available since we are not using `ng-if`
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {});
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ReportsNewController', ReportsNewController);

    ReportsNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'Advice', '$state', 'previousState', 'advicestatus', 'toastr', '$mdSidenav'];

    function ReportsNewController($rootScope, $timeout, $scope, entity, Advice,  $state, previousState, advicestatus, toastr, $mdSidenav) {
        var vm = this;

        vm.report = entity;
        vm.clear = clear;
        vm.save = save;
        vm.advicestatus = advicestatus;
        vm.toggleSidenav = buildToggler('left');

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            vm.report.adviceType = 'REPORTS';
            var report = Object.assign({}, vm.report);
            report.adviceType = vm.report.adviceType;
            report.adviceStatus = vm.report.adviceStatus.name;
            report.id = null;
            Advice.save(report, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!', 'Informe');
            vm.isSaving = false;
            $state.go('reports.edit', {
                'id': result.id
            });
        }

        function onSaveError() {
            toastr.error('Error al crear el informe');
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
            };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ReportsDetailController', ReportsDetailController);

    ReportsDetailController.$inject = ['$scope', '$rootScope', '$http', 'previousState', 'entity', 'Principal', 'Advice', '$state',
        'DateUtils', 'toastr', 'advicestatus', '$mdSidenav'];

    function ReportsDetailController($scope, $rootScope, $http, previousState, entity, Principal, Advice,  $state,
                                    DateUtils, toastr, advicestatus, $mdSidenav) {
        var vm = this;

        vm.report = entity;
        vm.advicestatus = advicestatus;
        vm.entityType = "AD";
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');

        Principal.hasAuthority("ROLE_ADMIN")
            .then(function (result) {
                vm.isAdmin = result;
            });

        function save() {
            vm.isSaving = true;

            var report = Object.assign({}, vm.report);
            report.adviceType = vm.report.adviceType.name;
            report.adviceStatus = vm.report.adviceStatus.name;
            Advice.update(report, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Actualizado con éxito!', 'Consulta ');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al actualizar la consulta');
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
            };
          }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reports', {
                parent: 'entity',
                url: '/reports',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'Reports'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/advices/reports/reports.html',
                    controller: 'ReportsController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    status: ['$stateParams', 'AdviceStatus', function($stateParams, AdviceStatus) {
                        return AdviceStatus.query().$promise;
                    }]
                }
            })
            .state('reports.edit', {
                parent: 'reports',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'Reports'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/advices/reports/reports-detail.html',
                        controller: 'ReportsDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Administrar',
                      parent: 'reports'
                },
                resolve: {
                    entity: ['$stateParams', 'Advice', function($stateParams, Advice) {
                        return Advice.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    advicestatus: ['$stateParams', 'AdviceStatus', function($stateParams, AdviceStatus) {
                        return AdviceStatus.query().$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'reports',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('reports.new', {
                parent: 'reports',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/advices/reports/reports-new.html',
                    controller: 'ReportsNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'reports'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    advicestatus: ['$stateParams', 'AdviceStatus', function($stateParams, AdviceStatus) {
                        return AdviceStatus.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'reports',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ReportsController', ReportsController);

    ReportsController.$inject = ['DateUtils', '$state', 'Advice', 'AdviceCsv', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','status', '$mdSidenav'];
    function ReportsController (DateUtils, $state, Advice, AdviceCsv, ParseLinks, AlertService, paginationConstants, pagingParams, status, $mdSidenav) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;
    
        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchAdviceParameters'));

        if (vm.searchItem === null) {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];
        }

        if (vm.searchItem.startDate !== null) {
            vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
        }

        if (vm.searchItem.endDate !== null) {
            vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);
        }

        vm.status = status;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.csvOrder = ["caseFileId",  "requestDate", "applicantName", "background", "issue",  "issueDate", "adviceStatus"];
        vm.getHeader = function () {
            return ["Expediente",  "Fecha de solicitud", "Solicitante", "antecedentes", "Emisión informe", "Fecha de emisión", "Estado"];
        };

        searchExp();

        function searchExp() {
            // Store the value(s)
            if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
            if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);
            localStorage.setItem('searchAdviceParameters', JSON.stringify(vm.searchItem));

            var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
                idStatus = vm.searchItem.status.name;
            }

            Advice.query({
                type: 'REPORTS',
                caseFile: vm.searchItem.caseFile,
                status: idStatus,
                client: vm.searchItem.client,
                startDate: vm.searchItem.startDate,
                endDate: vm.searchItem.endDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.reports = data;
                vm.page = pagingParams.page;

                if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
                if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);

                vm.filename = getFilename();
                getExportData();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getFilename() {
          var today = new Date();

          var dd = today.getDate();
          if(dd < 10) dd = "0" + dd;

          var mm = today.getMonth()+1;
          if(mm < 10) mm = "0" + mm;

          var yy = today.getFullYear();

            return "export_informe_dictamen_" + yy + mm + dd + ".csv";
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];

          localStorage.setItem('searchAdviceParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function getExportData(){
          var idFileType = null;
          if (angular.isDefined(vm.searchItem.fileType) ) {
            idFileType = vm.searchItem.fileType.id;
          }

          var idStep = null;
          if (angular.isDefined(vm.searchItem.step) ) {
              idStep = vm.searchItem.step.id;
          }

          var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
              idStatus = vm.searchItem.status.id;
          }

          if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
          if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);

          AdviceCsv.query({
            type: 'REPORTS',
            caseFile: vm.searchItem.caseFile,
            status: idStatus,
            client: vm.searchItem.client,
            startDate: vm.searchItem.startDate,
            endDate: vm.searchItem.endDate
          }, function(data) {
              vm.exportData = data;
              vm.exportData.forEach(function(item) {
                item.adviceStatus = item.adviceStatus.description;
              });
          });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
            });
          };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('newAdviceDocument', {
            bindings: {
                advice: '<',
                action: '='
            },
            templateUrl: 'app/entities/advices/documents/new-advice-document.component.html',
            controller: ['$scope', 'Upload', 'AdviceDocument',  'toastr',
                function ($scope, Upload, AdviceDocument,  toastr) {
                    var $ctrl = this;

                    $ctrl.$onInit = initialization;
                    $ctrl.save = save;
                    $ctrl.uploadfile = uploadfile;
                    $ctrl.close = close;

                    $ctrl.document = {};

                    $scope.$watch('$ctrl.newdocumentform', function() {
                        if ($ctrl.newdocumentform === true) {
                            $ctrl.document = {};
                        }
                    });

                    function initialization() {

                    }

                    function save() {
                        $ctrl.isSaving = true;
                        $ctrl.document.signed = false;
                        var document = Object.assign({}, $ctrl.document);
                        document.advice = $ctrl.advice.id;
                        AdviceDocument.save(document, onSaveSuccess, onSaveError);
                    }

                    function uploadfile(file) {
                      if (file) {
                        $ctrl.file = file;
                        $ctrl.document.path = "/opt/expedientes_uriarte_repo/" + $ctrl.advice.id + "/" + file.name;
                      }
                    }

                    function upload() {
                      Upload.upload({
                                url: "api/advices-documents/upload",
                                data: {
                                    file: $ctrl.file,
                                    name: $ctrl.file.name,
                                    previousFile: "",
                                    adviceId: $ctrl.advice.id,
                                    documentID: $ctrl.document.id
                                },
                                method: 'POST'
                            }).then(
                                function() {
                                    $ctrl.isSaving = false;
                                    toastr.success('Documento subido con éxito');
                                    close();
                                },
                                function(response) {
                                    $ctrl.isSaving = false;
                                    toastr.error('Error al subir el documento');
                                },
                                function() {});
                    }

                    function onSaveSuccess(result) {
//                        toastr.success('Documento creado con éxito');
                        $ctrl.updatetree = true;
                        $ctrl.newdocumentform = false;
                        $ctrl.editdocumentform = false;
                        $ctrl.isSaving = false;
                        $ctrl.document = result;

                        upload();
                    }

                    function onSaveError() {
                        toastr.error('Error al crear el documento');
                        $ctrl.isSaving = false;
                    }

                    function close() {
                        $ctrl.document = {};
                        $ctrl.action = 'query';
                    }

                }
            ]
        });
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('editAdviceDocument', {
            bindings: {
                document: '=',
                action: '='
            },
            templateUrl: 'app/entities/advices/documents/edit-advice-document.component.html',
            controller: ['$scope', 'AdviceDocument', 'Upload', '$http', 'DateUtils', 'toastr',
                function ($scope, AdviceDocument,  Upload, $http, DateUtils, toastr) {
                    var $ctrl = this;

                    $ctrl.$onInit = initialization;
                    $ctrl.save = save;
                    $ctrl.close = close;
                    $ctrl.uploadfile = uploadfile;
                    $ctrl.downloadfile = downloadfile;
                    $ctrl.remove_document = remove_document;

                    function initialization() {

                    }

                    function save() {
                       $ctrl.isSaving = true;
                       var document = Object.assign({}, $ctrl.document);
                       AdviceDocument.update(document, onSaveSuccess, onSaveError);
                    }

                    function close() {
                      $ctrl.document = {};
                      $ctrl.action = 'query';
                    }

                    function uploadfile(file, errFiles) {
                      if (file) {
                        $ctrl.file = file;
                        $ctrl.document.filename = file.name;
                      }
                    }

                    function upload() {
                      var data = {
                            file: $ctrl.file,
                            name: $ctrl.file.name,
                            adviceId: $ctrl.document.advice,
                            documentID: $ctrl.document.id
                            };
                      Upload.upload({
                                url: "api/advices-documents/upload",
                                data: data,
                                method: 'POST'
                            }).then(
                                function() {
                                    $ctrl.isSaving = false;
                                    toastr.success('Documento subido con éxito');
                                    close();
                                },
                                function(response) {
                                    $ctrl.isSaving = false;
                                    toastr.error('Error al subir el documento');
                                },
                                function() {});
                    }

                    function onUploadSuccess(result) {
                      $ctrl.document = result;
                    }

                    function onUploadError() {
                        $ctrl.isSaving = false;
                    }

                    function onSaveSuccess(result) {
                        if ($ctrl.file) {
                          upload();
                        }
                        else {
                          $ctrl.isSaving = false;
                          toastr.success('Documento actualizado con éxito');
                          close();
                        }
                    }

                    function onSaveError() {
                        $ctrl.isSaving = false;
                        toastr.error('Error al actualizar el documento');
                    }

                    function remove_document() {
                        AdviceDocument.delete({
                                id: $ctrl.document.id
                            },
                            function() {
                                toastr.success('Documento eliminado con éxito');
                                close();
                            },
                            function () {
                                toastr.error('Error al eliminar el documento');
                            });
                    }

                    function downloadfile() {
                        $http({
                            method: 'GET',
                            url: 'api/advice-documents/download/' + $ctrl.document.id,
                            responseType: 'arraybuffer',
                            cache: false
                        }).success(function(data) {
                            var a = document.createElement('a');
                            var blob = new Blob([data], {
                                'type': "application/octet-stream"
                            });
                            a.href = URL.createObjectURL(blob);
                            a.download = data.filename;
                            a.click();
                        }).error(function(data, status, headers, config) {

                        });
                    }

                }
            ]
        });
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('adviceDocuments', {
            bindings: {
                advice: '<'
            },
            templateUrl: 'app/entities/advices/documents/advice-documents.component.html',
            controller: ['$timeout', '$rootScope', '$scope', 'AdviceDocument', '$q', 'toastr', 'DateUtils', '$http', 'Principal',
                function($timeout, $rootScope, $scope, AdviceDocument, $q, toastr, DateUtils, $http, Principal) {
                    var $ctrl = this;
                    $ctrl.document = {};
                    $ctrl.documents = {};
                    $ctrl.$onInit = onInit;
                    $ctrl.openNewAdviceDocument = openNewAdviceDocument;
                    $ctrl.editAdviceDocument = editAdviceDocument;
                    $ctrl.action = "query";
                    $ctrl.downloadFile = downloadFile;
                    $ctrl.$onChanges = function(changes) {
                        retrieveDocuments();
                    };
                    Principal.hasAuthority("ROLE_ADMIN")
                    .then(function (result) {
                        $ctrl.isAdmin = result;
                    });
                    $scope.$watch('$ctrl.action', function() {
                        if ($ctrl.action === 'query') {
                            retrieveDocuments();
                        }
                    });

                    function downloadFile(documentId) {
                        AdviceDocument.get({
                            id: documentId
                        }, function(data) {
                            $http({
                                method: 'GET',
                                url: 'api/advice-documents/download/' + documentId,
                                responseType: 'arraybuffer',
                                cache: false
                            }).success(function (result) {
                                var a = document.createElement('a');
                                var blob = new Blob([result], {
                                    'type': "application/octet-stream"
                                });
                                a.href = URL.createObjectURL(blob);
                                var path_file = "/opt/expedientes_uriarte_repo/" + data.advice + "/";
                                var full_file = data.path;

                                a.download = full_file.slice(full_file.search(path_file) + path_file.length, full_file.length);
                                a.click();
                            }).error(function (data, status, headers, config) {

                            });
                        });
                    }

                    function onInit() {
                        retrieveDocuments();
                    }

                    function openNewAdviceDocument() {
                      $ctrl.action = "new";
                    }

                    function editAdviceDocument(adviceDocument) {
                      AdviceDocument.get({
                        id: adviceDocument.id
                      }, onEditDocumentSuccess, onEditDocumentError);
                    }

                    function onEditDocumentSuccess(data) {
                        $ctrl.action = 'edit';
                        $ctrl.document = data;
                    }

                    function onEditDocumentError() {
                    }

                    function retrieveDocuments() {
                        $q.all([
                                AdviceDocument.query({
                                    adviceId: $ctrl.advice.id
                                }).$promise
                            ])
                            .then(function(data) {
                                $ctrl.documents = data[0];
                            });
                    }
                }
            ]
        });
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('AdvicesController', AdvicesController);

    AdvicesController.$inject = ['DateUtils', '$state', 'Advice', 'AdviceCsv', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','status', '$mdSidenav'];

    function AdvicesController (DateUtils, $state, Advice, AdviceCsv, ParseLinks, AlertService, paginationConstants, pagingParams, status, $mdSidenav) {
        var vm = this;

        vm.searchExp = searchExp;
        vm.deleteSearchItem = deleteSearchItem;
    
        vm.toggleSidenav = buildToggler('left');

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(localStorage.getItem('searchAdviceParameters'));

        if (vm.searchItem === null) {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];
        }

        if (vm.searchItem.startDate !== null) {
            vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
        }

        if (vm.searchItem.endDate !== null) {
            vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);
        }

        vm.status = status;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.csvOrder = ["caseFileId", "adviceQueryType", "requestDate", "applicantName", "applicantNif", "background", "resolution",  "resolutionDate", "adviceStatus"];
        vm.getHeader = function () {
            return ["Expediente", "Tipo", "Fecha de solicitud", "Solicitante", "NIF Solicitante", "antecedentes", "Resolución", "Fecha de resolución", "Estado"];
        };

        searchExp();

        function searchExp() {
            // Store the value(s)
            if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
            if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);
            localStorage.setItem('searchAdviceParameters', JSON.stringify(vm.searchItem));

            var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
                idStatus = vm.searchItem.status.name;
            }

            Advice.query({
                type: 'QUERY',
                caseFile: vm.searchItem.caseFile,
                status: idStatus,
                client: vm.searchItem.client,
                startDate: vm.searchItem.startDate,
                endDate: vm.searchItem.endDate,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.advices = data;
                vm.page = pagingParams.page;

                if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateFromServer(vm.searchItem.startDate);
                if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateFromServer(vm.searchItem.endDate);

                vm.filename = getFilename();
                getExportData();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getFilename() {
          var today = new Date();

          var dd = today.getDate();
          if(dd < 10) dd = "0" + dd;

          var mm = today.getMonth()+1;
          if(mm < 10) mm = "0" + mm;

          var yy = today.getFullYear();

            return "export_consultas_verbales_escritas_" + yy + mm + dd + ".csv";
        }

        function deleteSearchItem() {
          vm.searchItem = {};
          vm.searchItem.year = new Date().getFullYear();
          vm.searchItem.status = status[0];

          localStorage.setItem('searchAdviceParameters', JSON.stringify(vm.searchItem));
          vm.page = 1;
          vm.transition();
          searchExp();
        }

        function getExportData(){
          var idFileType = null;
          if (angular.isDefined(vm.searchItem.fileType) ) {
            idFileType = vm.searchItem.fileType.id;
          }

          var idStep = null;
          if (angular.isDefined(vm.searchItem.step) ) {
              idStep = vm.searchItem.step.id;
          }

          var idStatus = null;
            if (angular.isDefined(vm.searchItem.status) && vm.searchItem.status != null) {
              idStatus = vm.searchItem.status.id;
          }

          if(vm.searchItem.startDate !== null) vm.searchItem.startDate = DateUtils.convertLocalDateToServer(vm.searchItem.startDate);
          if(vm.searchItem.endDate !== null) vm.searchItem.endDate = DateUtils.convertLocalDateToServer(vm.searchItem.endDate);

          AdviceCsv.query({
            type: 'QUERY',
            caseFile: vm.searchItem.caseFile,
            status: idStatus,
            client: vm.searchItem.client,
            startDate: vm.searchItem.startDate,
            endDate: vm.searchItem.endDate
          }, function(data) {
              vm.exportData = data;
              vm.exportData.forEach(function(item) {
                item.adviceStatus = item.adviceStatus.description;
                item.adviceQueryType = item.adviceQueryType.description;
              });
          });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
          });
        };
      }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('AdviceNewController', AdviceNewController);

    AdviceNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'Advice', '$state', 'previousState', 'advicequerytypes', 'advicestatus', 'toastr', '$mdSidenav'];

    function AdviceNewController($rootScope, $timeout, $scope, entity, Advice,  $state, previousState, advicequerytypes, advicestatus, toastr, $mdSidenav) {
        var vm = this;

        vm.advice = entity;
        vm.clear = clear;
        vm.save = save;
        vm.advicequerytypes = advicequerytypes;
        vm.advicestatus = advicestatus;
        vm.toggleSidenav = buildToggler('left');

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            vm.advice.adviceType = 'QUERY';
            var advice = Object.assign({}, vm.advice);
            advice.adviceQueryType = vm.advice.adviceQueryType.name;
            advice.adviceStatus = vm.advice.adviceStatus.name;
            advice.id = null;
            Advice.save(advice, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!', 'Consulta');
            vm.isSaving = false;
            $state.go('advices.edit', {
                'id': result.id
            });
        }

        function onSaveError() {
            toastr.error('Error al crear la consulta');
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
            });
          };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('AdviceDetailController', AdviceDetailController);

    AdviceDetailController.$inject = ['$scope', '$rootScope', '$http', 'previousState', 'entity', 'Principal', 'Advice', '$state',
        'DateUtils', 'toastr', 'advicequerytypes', 'advicestatus', '$mdSidenav'];

    function AdviceDetailController($scope, $rootScope, $http, previousState, entity, Principal, Advice,  $state,
                                    DateUtils, toastr, advicequerytypes, advicestatus, $mdSidenav) {
        var vm = this;

        vm.advice = entity;
        vm.advicequerytypes = advicequerytypes;
        vm.advicestatus = advicestatus;
        vm.entityType = "AD";
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');

        Principal.hasAuthority("ROLE_ADMIN")
            .then(function (result) {
                vm.isAdmin = result;
            });

        function save() {
            vm.isSaving = true;

            var advice = Object.assign({}, vm.advice);
            advice.adviceType = vm.advice.adviceType.name;
            advice.adviceQueryType = vm.advice.adviceQueryType.name;
            advice.adviceStatus = vm.advice.adviceStatus.name;
            Advice.update(advice, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Actualizado con éxito!', 'Consulta ');
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error('Error al actualizar la consulta');
            vm.isSaving = false;
        }

        function buildToggler(navID) {
          return function() {
            // Component lookup should always be available since we are not using `ng-if`
            $mdSidenav(navID).toggle().then(function () {
            });
            };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('advices', {
                parent: 'entity',
                url: '/advices',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'Advices'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/advices/advice/advices.html',
                    controller: 'AdvicesController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    status: ['$stateParams', 'AdviceStatus', function($stateParams, AdviceStatus) {
                        return AdviceStatus.query().$promise;
                    }]
                }
            })
            .state('advices.edit', {
                parent: 'advices',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'Advice'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/advices/advice/advice-detail.html',
                        controller: 'AdviceDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Administrar',
                      parent: 'advices'
                },
                resolve: {
                    entity: ['$stateParams', 'Advice', function($stateParams, Advice) {
                        return Advice.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    advicequerytypes: ['$stateParams', 'AdviceQueryType', function($stateParams, AdviceQueryType) {
                        return AdviceQueryType.query().$promise;
                    }],
                    advicestatus: ['$stateParams', 'AdviceStatus', function($stateParams, AdviceStatus) {
                        return AdviceStatus.query().$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'advices',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('advices.new', {
                parent: 'advices',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/advices/advice/advice-new.html',
                    controller: 'AdviceNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'advices'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    advicequerytypes: ['$stateParams', 'AdviceQueryType', function($stateParams, AdviceQueryType) {
                        return AdviceQueryType.query().$promise;
                    }],
                    advicestatus: ['$stateParams', 'AdviceStatus', function($stateParams, AdviceStatus) {
                        return AdviceStatus.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'advices',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Mostrando {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'de {{$ctrl.queryCount}} registros.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('expedientesUriarteApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('/');
                return new Date(dateString[2], dateString[1] - 1, dateString[0]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'dd/MM/yyyy');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'dd/MM/yyyy';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            url: '/login',
            views: {
                'content': {
                    templateUrl: 'app/components/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            },
            data: {
                authorities: [],
                pageTitle: ''
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$state'];

    function LoginService ($state) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            $state.go("login");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', 'User', '$window'];

    function LoginController ($rootScope, $state, $timeout, Auth, User, $window) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
    
        $timeout(function (){angular.element('#username').focus();});
        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                if ($state.current.name === 'login' ||
                    $state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {

                    User.get({login : vm.username}, function(result) {
                      if(result.authorities.indexOf("ROLE_MUNICIPAL") > -1) {
                        $state.go('signatory');
                      } else {
                        $state.go('home');
                      }
                    });
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $state.go('register');
        }

        function requestResetPassword () {
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .directive('phoneNumber', phoneNumber);

    var phonePattern = /^(\+34|0034|34)?[\s|\-|\.]?[6|7|8|9][\s|\-|\.]?([0-9][\s|\-|\.]?){8}$/;
    
    function phoneNumber () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.phoneNumber = function (modelValue, viewValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return true;
                    }

                    if (phonePattern.test(viewValue)) {
                        return true;
                    }

                    return false;
                };
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('nifValidationFactory', nifValidationFactory);

    function nifValidationFactory () {
        return {
            validCIF: function(cif){
                var control, sum_a, sum_b, aux_a, aux_b, sum_c, sum_d, letters,
                    r_expression1 = /^[ABEH][0-9]{8}$/i,
                    r_expression2 = /^[KPQS][0-9]{7}[A-J]$/i,
                    r_expression3 = /^[CDFGJLMNRUVW][0-9]{7}[0-9A-J]$/i;
                cif = cif.toUpperCase();
                if(cif.match(r_expression1) || cif.match(r_expression2) || cif.match(r_expression3)) {
                    control = cif[cif.length-1];
                    sum_a 	= 0;
                    sum_b 	= 0;
    
                    for (var i = 1; i < 8; i++) {
                        if (i % 2 == 0) {
                            sum_a += parseInt(cif[i], 10);
                        }else{
                            aux_a = parseInt(cif[i], 10) * 2;
                            aux_b = 0;
    
                            if(aux_a > 9) {
                                aux_b = 1+(aux_a-10);
                            } else {
                                aux_b = aux_a;
                            }
                            sum_b += aux_b;
                        }
                    }
    
                    sum_c 	= (parseInt(sum_a + sum_b, 10)) + "";
                    sum_d 	= (10 - (parseInt(sum_c[sum_c.length - 1], 10))) % 10;
    
                    letters = "JABCDEFGHI";
                    if (control >= "0" && control <= "9") {
                        return (control == sum_d);
                    } else {
                        return ((control.toUpperCase()) == letters[sum_d]);
                    }
                } else {
                    return false;
                }
            },
            validNIF: function(nif) {
                var niePrefix,
                    nifRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i,
                    nifLetters = 'TRWAGMYFPDXBNJZSQVHLCKE',
                    valid = false;
    
                nif = nif.toUpperCase();
                if (9 === nif.length) {
                    if (nif.match(nifRegex)) {
                        valid = (nif.charAt(8) === nifLetters.charAt(parseInt(nif, 10) % 23));
                    }
                }
    
                return valid;
            },
            validNIE: function(nie) {
                var niePrefix = null,
                    nifRegex =  /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i,
                    nifLetters = 'TRWAGMYFPDXBNJZSQVHLCKE',
                    valid = false;
    
                nie = nie.toUpperCase();
                if (9 === nie.length) {
                    niePrefix = nie.charAt(0);
                    switch ( niePrefix ) {
                        case 'X':
                            niePrefix = 0;
                            break;
                        case 'Y':
                            niePrefix = 1;
                            break;
                        case 'Z':
                            niePrefix = 2;
                            break;
                        default:
                            niePrefix = null
                            break;
                    }
                    nie = niePrefix + nie.substr(1);
                    if (nie.match(nifRegex)) {
                        valid = (nie.charAt(8) === nifLetters.charAt(parseInt(nie, 10) % 23));
                    }
                }
    
                return valid;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .directive('validateNiEs', validateNiEs);

        validateNiEs.$inject = ['nifValidationFactory'];

    function validateNiEs (nifValidationFactory) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elem, iAttrs, ctrl) {
                var idTypeDoc,
                    result = false;
    
                ctrl.$parsers.unshift(checkNIEs); //Sensible to changes in DOM
                ctrl.$formatters.unshift(checkNIEs); //Sensible to changes ins Model

                function checkNIEs (value) {
                    if (value) {
                        result = nifValidationFactory.validNIF(value);
                        if (!result) {
                            result = nifValidationFactory.validNIE(value);
                        }
                        if (!result) {
                            result = nifValidationFactory.validCIF(value);
                        }
                    }
                    ctrl.$setValidity('validateNiEs', result);
    
                    return value;
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('expedientesUriarteApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('expedientesUriarteApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('expedientesUriarteApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('expedientesUriarteApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
  /*              var titleKey = 'expedientes' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey; */
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';
  
    angular
      .module('expedientesUriarteApp')
      .config(html5ModeConfig);
  
    html5ModeConfig.$inject = ['$locationProvider'];
  
    function html5ModeConfig($locationProvider) {
      $locationProvider.html5Mode({ enabled: true, requireBase: true });
    }
  })();
(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
 /*               'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },  */
                'sidebar@': {
                    templateUrl: 'app/layouts/sidebar/sidebar.html',
                    controller: 'SidebarController',
                    controllerAs: 'sb'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('expedientesUriarteApp')
        .constant('VERSION', "1.0.7")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function () {
    "use strict";
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular.module("expedientesUriarteApp").config(config);

    config.$inject = [
        "$mdThemingProvider",
        "$mdDateLocaleProvider",
        "toastrConfig",
    ];

    function config($mdThemingProvider, $mdDateLocaleProvider, toastrConfig) {
        $mdThemingProvider
            .theme("default")
            .primaryPalette("cyan")
            .accentPalette("teal");
        $mdThemingProvider.theme("alt");
        $mdDateLocaleProvider.firstDayOfWeek = 1;
        $mdDateLocaleProvider.formatDate = function (date) {
            var momDate = moment(date);
            return momDate.isValid() ? momDate.format("DD/MM/YYYY") : "";
        };

        angular.extend(toastrConfig, {
            positionClass: "toast-bottom-right",
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$state', 'entity', 'User', 'toastr', '$mdSidenav'];

    function UserManagementDialogController ($state, entity, User, toastr, $mdSidenav) {
        var vm = this;

        vm.authorities = ['ROLE_ADMIN', 'ROLE_CLIENT', 'ROLE_CONSORTIUM', 'ROLE_JUBILAR'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        vm.deleteUser = deleteUser;
        vm.toggleSidenav = buildToggler('left');

        function clear () {
            $state.go('user-management');
        }

        function onSaveSuccess (result) {
            toastr.success('Actualizado con éxito!', 'Usuario ' + result.login);

            $state.go('user-management.edit', {
                'login': result.login
            });

            vm.isSaving = false;
        }

        function onSaveError () {
            toastr.error('Error al actualizar usuario');
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function deleteUser() {
            User.delete({login: vm.user.login},
                function() {
                    toastr.success('Usuario eliminado con éxito');
                    $state.go('user-management');
                },
                function() {
                    toastr.error('Error al eliminar el usuario');
                }
            );
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
            };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                  templateUrl: 'app/admin/user-management/user-management-dialog.html',
                  controller: 'UserManagementDialogController',
                  controllerAs: 'vm'
                }
            },
            ncyBreadcrumb: {
                label: 'Nuevo'
            },
            resolve: {
                entity: function () {
                    return {
                        id: null, login: null, firstName: null, lastName: null, email: null,
                        activated: true, langKey: null, createdBy: null, createdDate: null,
                        lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                        resetKey: null, authorities: null
                    };
                }
            }
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                  templateUrl: 'app/admin/user-management/user-management-dialog.html',
                  controller: 'UserManagementDialogController',
                  controllerAs: 'vm'
                }
            },
            ncyBreadcrumb: {
                label: 'Editar'
            },
            resolve: {
                entity: ['User', '$stateParams', function(User, $stateParams) {
                    return User.get({login : $stateParams.login});
                }]
            }
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', '$mdSidenav'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, $mdSidenav) {
        var vm = this;

        vm.authorities = ['ROLE_ADMIN', 'ROLE_CLIENT'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.toggleSidenav = buildToggler('left');

        vm.loadAll();

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/appmetrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/apphealth',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('expedientesUriarteApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_CLIENT','ROLE_CONSORTIUM'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            ncyBreadcrumb: {
                label: 'Ajustes de usuario'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'toastr'];

    function SettingsController(Principal, Auth, toastr) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                toastr.success('Usuario actualizado con éxito');
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                toastr.error('Error al actualizar el usuario');
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        return {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Fuerza de la contraseña</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };

            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_CLIENT', 'ROLE_CONSORTIUM', 'ROLE_JUBILAR'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            ncyBreadcrumb: {
                label: 'Cambio de contraseña'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['$scope', 'Auth', 'Principal', 'toastr',  '$mdSidenav'];

    function PasswordController($scope, Auth, Principal, toastr, $mdSidenav) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.checkStrength = checkStrength;
        vm.error = null;
        vm.success = null;
        vm.toggleSidenav = buildToggler('left');
        
        vm.onChangePassword = onChangePassword;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function checkStrength() {
            if (mesureStrength(vm.password) <= 40) {
                $scope.passwordForm.password.$invalid = true;
                $scope.passwordForm.password.$error.strengthLess = true;
                vm.strengthLess = true;
            } else {
                $scope.passwordForm.password.$invalid = false;
                $scope.passwordForm.password.$error.strengthLess = false;
                vm.strengthLess = false;
            }
        }

        function onChangePassword() {
            if (vm.password !== vm.confirmPassword) {
                $scope.passwordForm.confirmPassword.$invalid = true;
                $scope.passwordForm.confirmPassword.$error.doNotMatch = true;
                vm.doNotMatch = true;
            } else {
                $scope.passwordForm.confirmPassword.$invalid = false;
                $scope.passwordForm.confirmPassword.$error.doNotMatch = false;
                vm.doNotMatch = false;
            }
        }

        function changePassword() {
            Auth.changePassword(vm.password).then(function () {
                toastr.success('Contraseña actualizada con éxito');
                vm.error = null;
                vm.success = 'OK';
            }).catch(function () {
                toastr.success('Error al actualizar la contraseña');
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
            };
        }

        function mesureStrength(p) {

            var _force = 0;
            var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

            var _lowerLetters = /[a-z]+/.test(p);
            var _upperLetters = /[A-Z]+/.test(p);
            var _numbers = /[0-9]+/.test(p);
            var _symbols = _regex.test(p);

            var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
            var _passedMatches = $.grep(_flags, function (el) {
                return el === true;
            }).length;

            _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
            _force += _passedMatches * 10;

            // penalty (short password)
            _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

            // penalty (poor variety of characters)
            _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
            _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
            _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

            return _force;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('expedientesUriarteApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center" flex-offset="2"><md-button class="md-icon-button"><md-icon class="icon-theme">timeline</md-icon></md-button><span>Indicadores</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-content class="md-padding"><div layout="row" ng-if="vm.isAdmin || vm.isClient"><span class="page-subtitle"><md-icon>gavel</md-icon>DEFENSA LETRADA</span></div><div layout="row" ng-if="vm.isAdmin || vm.isClient"><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="totalGFiles">EXPEDIENTES TOTALES</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="totalGFiles">{{vm.numGFiles}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numGFiles">EXPEDIENTES ABIERTOS</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numGFiles">{{vm.numActiveGFiles}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="totalGFiles">EXP. JUR. CIVIL TOTALES</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="totalGFiles">{{vm.numCivilGFiles}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numGFiles">EXP. JUR. CIVIL ABIERTOS</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numGFiles">{{vm.numCivilActiveGFiles}}</span></div></md-card-content></md-card><!--        <md-card flex="25">\n            <md-card-title layout-align="center">\n                <label class="chart-title" for="numExpiredTasks">TAREAS VENCIDAS</label>\n            </md-card-title>\n            <md-card-content>\n                <div layout="row" layout-align="center">\n                    <span class="chart-value" id="numExpiredTasks">{{vm.numExpiredTasks}}</span>\n                </div>\n            </md-card-content>\n        </md-card>\n\n        <md-card flex="25">\n            <md-card-title layout-align="center">\n                <label class="chart-title" for="numExpiredTasksSoon">TAREAS PR\xD3XIMAS A VENCER</label>\n            </md-card-title>\n            <md-card-content>\n                <div layout="row" layout-align="center">\n                    <span class="chart-value" id="numExpiredTasksSoon">{{vm.numExpiredTasksSoon}}</span>\n                </div>\n            </md-card-content>\n        </md-card> --></div><div layout="row" ng-if="vm.isAdmin || vm.isClient"><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numExpiredTasks">EXP. JUR. MERCANTIL TOTALES</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numExpiredTasks">{{vm.numMercantilGFiles}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numExpiredTasks">EXP. JUR. MERCANTIL ABIERTOS</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numExpiredTasks">{{vm.numMercantilActiveGFiles}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="totalGFiles">EXP. JUR. PENAL TOTALES</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="totalGFiles">{{vm.numPenalGFiles}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numGFiles">EXP. JUR. PENAL ABIERTOS</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numGFiles">{{vm.numPenalActiveGFiles}}</span></div></md-card-content></md-card></div><div layout="row" ng-if="vm.isAdmin || vm.isClient"><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numExpiredTasks">EXP. JUR. CONTENCIOSO-ADMIN. TOTALES</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numExpiredTasks">{{vm.numContenciosoGFiles}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numExpiredTasks">EXP. JUR. CONTENCIOSO-ADMIN. ABIERTOS</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numExpiredTasks">{{vm.numContenciosoActiveGFiles}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numExpiredTasks">EXP. JUR. LABORAL TOTALES</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numExpiredTasks">{{vm.numLaboralGFiles}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numExpiredTasks">EXP. JUR. LABORAL ABIERTOS</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numExpiredTasks">{{vm.numLaboralActiveGFiles}}</span></div></md-card-content></md-card><br></div><div layout="row" ng-if="vm.isAdmin || vm.isClient"><span class="page-subtitle"><md-icon>forum</md-icon>ASESORAMIENTO</span></div><div layout="row" ng-if="vm.isAdmin || vm.isClient"><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numExpiredTasks">CONSULTAS TOTALES</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numExpiredTasks">{{vm.numTotalAdvices}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numExpiredTasks">CONSULTAS ABIERTAS</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numExpiredTasks">{{vm.numActiveAdvices}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numExpiredTasks">INFORMES O DICT\xC1MENES TOTALES</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numExpiredTasks">{{vm.numTotalReports}}</span></div></md-card-content></md-card><md-card flex="25"><md-card-title layout-align="center"><label class="chart-title" for="numExpiredTasks">INFORMES O DICT\xC1MENES ABIERTOS</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="numExpiredTasks">{{vm.numActiveReports}}</span></div></md-card-content></md-card><br></div><div layout="row" ng-if="vm.isAdmin || vm.isConsortium"><span class="page-subtitle"><md-icon>extension</md-icon>CONSORCIOS</span></div><div layout="row" ng-if="vm.isAdmin || vm.isConsortium"><md-card flex="50"><md-card-title layout-align="center"><label class="chart-title" for="expAdmin">EXP. ADMINISTRATIVOS TOTALES</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="expAdmin">{{vm.numTotalCExpedientes}}</span></div></md-card-content></md-card><md-card flex="50"><md-card-title layout-align="center"><label class="chart-title" for="expAdminActives">EXP. ADMINISTRATIVOS ABIERTOS</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="expAdminActives">{{vm.numActiveCExpedientes}}</span></div></md-card-content></md-card><br></div><div layout="row" ng-if="vm.isAdmin || vm.isJubilar"><span class="page-subtitle"><md-icon>extension</md-icon>A\xD1O JUBILAR LEBANIEGO 2023</span></div><div layout="row" ng-if="vm.isAdmin || vm.isJubilar"><md-card flex="33"><md-card-title layout-align="center"><label class="chart-title" for="donantesJubilar">DONANTES</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="donantesJubilar">{{vm.numDonantesJubilar}}</span></div></md-card-content></md-card><md-card flex="33"><md-card-title layout-align="center"><label class="chart-title" for="aportantesJubilar">APORTANTES</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="aportantesJubilar">{{vm.numAportantesJubilar}}</span></div></md-card-content></md-card><md-card flex><md-card-title layout-align="center"><label class="chart-title" for="conveniosJubilar">CONVENIOS DE COLABORACI\xD3N EMPRESARIAL</label></md-card-title><md-card-content><div layout="row" layout-align="center"><span class="chart-value" id="conveniosJubilar">{{vm.numConveniosJubilar}}</span></div></md-card-content></md-card></div><!--\n    <div layout="row">\n        <md-card flex="50">\n            <md-card-title layout-align="center">\n                <label class="chart-title" for="gfiletype-chart">EXPEDIENTES POR TIPO (\xDALTIMOS 18 MESES)</label>\n            </md-card-title>\n            <md-card-content>\n                <canvas id="gfiletype-chart" class="chart chart-line" chart-data="vm.gfiletypeMonth.data"\n                        chart-labels="vm.gfiletypeMonth.label"\n                        chart-series="vm.gfiletypeMonth.series" chart-options="vm.options" chart-click="vm.onClick"\n                        chart-colors="vm.colors"></canvas>\n            </md-card-content>\n        </md-card>\n        <md-card flex="50">\n            <md-card-title layout-align="center">\n                <label class="chart-title" for="gfiletypeYear-chart">EXPEDIENTES POR TIPO (EJERCICIO)</label>\n            </md-card-title>\n            <md-card-content>\n                <canvas id="gfiletypeYear-chart" class="chart chart-bar" chart-data="vm.gfiletypeYear.data"\n                        chart-labels="vm.gfiletypeYear.label"\n                        chart-series="vm.gfiletypeYear.series" chart-options="vm.options" chart-click="vm.onClick"\n                        chart-colors="vm.colors"></canvas>\n            </md-card-content>\n        </md-card>\n    </div>\n\n    <div layout="row">\n        <md-card flex>\n            <md-card-title layout-align="center">\n                <label class="chart-title" for="gfileDate-chart">EXPEDIENTES POR D\xCDA</label>\n            </md-card-title>\n            <md-card-content>\n                <canvas id="gfileDate-chart" class="chart chart-line" height="60" chart-data="vm.gfileDate.data"\n                        chart-labels="vm.gfileDate.label"\n                        chart-series="vm.gfileDate.series" chart-click="vm.onClick" chart-colors="vm.colors"></canvas>\n            </md-card-content>\n        </md-card>\n    </div>\n\n    <div layout="row">\n        <md-card flex="33">\n            <md-card-title layout-align="center">\n                <label class="chart-title" for="gfileStep-chart">EXPEDIENTES ABIERTOS POR FASE</label>\n            </md-card-title>\n            <md-card-content>\n                <canvas id="gfileStep-chart" height="200" class="chart chart-pie" chart-data="vm.gfileStep.data"\n                        chart-labels="vm.gfileStep.label"\n                        chart-colors="vm.colors" chart-options="vm.pieOptions"></canvas>\n            </md-card-content>\n        </md-card>\n        <md-card flex="66">\n            <md-card-title layout-align="center">\n                <label class="chart-title" for="notificationDate-chart">NOTIFICACIONES POR FECHA DE BLOQUE</label>\n            </md-card-title>\n            <md-card-content>\n                <canvas id="notificationDate-chart" height="100" class="chart chart-line"\n                        chart-data="vm.notificationDate.data" chart-labels="vm.notificationDate.label"\n                        chart-series="vm.notificationDate.series" chart-click="vm.onClick"\n                        chart-colors="vm.colors"></canvas>\n            </md-card-content>\n        </md-card>\n    </div>--></md-content>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon>lock</md-icon></md-button><span>Cambio de contrase\xF1a [<b>{{vm.account.login}}</b>]</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="passwordForm" class="form-horizontal" novalidate ng-submit="vm.changePassword()" show-validation><div layout="row"><md-input-container class="md-block" flex><label for="password">Nueva contrase\xF1a</label><input type="password" id="password" name="password" ng-model="vm.password" ng-change="vm.checkStrength()" ng-minlength="8" ng-maxlength="50" required><div ng-messages="passwordForm.password.$error"><div ng-message="required">La contrase\xF1a es obligatoria</div><div ng-message="minlength">La contrase\xF1a debe tener al menos 8 caracteres</div><div ng-message="maxlength">La contrase\xF1a no debe ser superior a 50 caracteres</div><div ng-message="strengthLess">La contrase\xF1a debe tener una longitud de al menos 8 caracteres. Debe incluir al menos una letra may\xFAscula, un signo de puntuaci\xF3n y un caracter num\xE9rico</div></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label for="confirmPassword">Nueva contrase\xF1a confirmaci\xF3n</label><input type="password" id="confirmPassword" name="confirmPassword" ng-change="vm.onChangePassword()" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-messages="passwordForm.confirmPassword.$error"><div ng-message="required">La contrase\xF1a de confirmaci\xF3n es obligatoria</div><div ng-message="minlength">La contrase\xF1a de confirmaci\xF3n debe tener al menos 4 caracteres</div><div ng-message="maxlength">La contrase\xF1a de confirmaci\xF3n no debe ser superior a 50 caracteres</div><div ng-message="doNotMatch">La contrase\xF1a no coincide con la de confirmaci\xF3n</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button type="submit" ng-disabled="passwordForm.$invalid || vm.doNotMatch || vm.strengthLess" class="md-raised md-primary" title="Grabar nueva contrase\xF1a" aria-label="Grabar nueva contrase\xF1a">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/account/settings/settings.html','<md-content flex><div class="top-bg"></div><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon>settings</md-icon></md-button><span>Ajustes del usuario [<b>{{vm.settingsAccount.login}}</b>]</span></div></div><md-content class="md-padding main-content"><md-card><md-card-content><div class="md-inline-form"><form name="form" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div layout="row"><md-input-container class="md-block" flex><label for="firstName">Nombre</label><input type="text" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-messages="form.firstName.$error"><div ng-message="required">El nombre es obligatorio</div><div ng-message="minlength">El nombre es obligatorio y al menos debe tener al menos un car\xE1cter</div><div ng-message="maxlength">El nombre no pueden tener m\xE1s de 50 caracteres</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label for="lastName">Apellidos</label><input type="text" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-messages="form.lastName.$error"><div ng-message="required">Los apellidos son obligatorios</div><div ng-message="minlength">Los apellidos son obligatorios y deben tener al menos un car\xE1cter</div><div ng-message="maxlength">Los apellidos no pueden tener m\xE1s de 50 caracteres</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label for="email">E-mail</label><input type="email" id="email" name="email" placeholder="Your e-mail" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-messages="form.email.$error"><div ng-message="required">El e-mail es obligatorio</div><div ng-message="email">El e-mail es inv\xE1lido</div><div ng-message="minlength">El e-mail es obligatorio y al menos debe tener 5 caracteres</div><div ng-message="maxlength">El e-mail no puede tener m\xE1s de 100 caracteres</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button type="submit" ng-disabled="form.$invalid" class="md-raised md-primary" title="Grabar ajustes de usuario" aria-label="Grabar ajustes de usuario">Grabar</md-button></section></form></div></md-card-content></md-card></md-content></md-content>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3>Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Cache name</th><th class="text-right">Cache Hits</th><th class="text-right">Cache Misses</th><th class="text-right">Cache Gets</th><th class="text-right">Cache Puts</th><th class="text-right">Cache Removals</th><th class="text-right">Cache Evictions</th><th class="text-right">Cache Hit %</th><th class="text-right">Cache Miss %</th><th class="text-right">Average get time (\xB5s)</th><th class="text-right">Average put time (\xB5s)</th><th class="text-right">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="user-management"><md-icon>undo</md-icon></md-button><span ng-show="vm.user.id == null">Nuevo usuario</span> <span ng-show="vm.user.id !== null">Usuario {{vm.user.login}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-content class="md-padding"><md-card><md-card-content><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div layout="row" layout-align="space-between center"><md-input-container class="md-block" flex="30"><label class="control-label" for="login">Nombre de usuario</label><input name="login" id="login" ng-model="vm.user.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-messages="editForm.login.$error"><div ng-message="required">Este campo es requerido.</div><div ng-message="maxlength">La longitud del campo debe de ser como m\xE1ximo de 50 caracteres.</div></div></md-input-container><md-input-container ng-show="vm.user.id !== null"><md-switch ng-model="vm.user.activated" class="active">Activo</md-switch></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="40"><label class="control-label" for="firstName">Nombre</label><input name="firstName" id="firstName" ng-model="vm.user.firstName" required ng-maxlength="50"><div ng-messages="editForm.firstName.$error"><div ng-message="maxlength">La longitud del campo debe de ser como m\xE1ximo de 50 caracteres.</div></div></md-input-container><md-input-container class="md-block" flex="60"><label class="control-label" for="lastName">Apellidos</label><input name="lastName" id="lastName" ng-model="vm.user.lastName" required ng-maxlength="50"><div ng-messages="editForm.firstName.$error"><div ng-message="maxlength">La longitud del campo debe de ser como m\xE1ximo de 50 caracteres.</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label class="control-label" for="nif">NIF</label><input name="nif" id="nif" ng-model="vm.user.nif" validate-ni-es required ng-maxlength="20"><div ng-messages="editForm.nif.$error"><div ng-message="maxlength">La longitud del campo debe de ser como m\xE1ximo de 20 caracteres.</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><md-icon>email</md-icon><label class="control-label" for="email">Email</label><input type="email" name="email" id="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-messages="editForm.email.$error"><div ng-message="required">Este campo es requerido.</div><div ng-message="maxlength">La longitud del campo debe de ser como mucho de 100 caracteres.</div><div ng-message="editForm.email.$error.email">La direcci\xF3n de correo no es v\xE1lida.</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label class="control-label" for="sign2">Roles</label><md-select id="sign2" name="sign2" multiple="multiple" name="authority" ng-model="vm.user.authorities"><md-option ng-value="authority" ng-repeat="authority in vm.authorities ">{{ authority }}</md-option></md-select></md-input-container></div><div layout="row"><md-input-container ng-show="vm.user.id !== null"><md-switch ng-model="vm.user.lawyer">El usuario es un letrado</md-switch></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button type="button" class="md-raised" ng-click="vm.clear()">Cancelar</md-button><div data-confirm-delete data-on-confirm="vm.deleteUser()" ng-show="vm.user.id !== null"></div><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary">Grabar</md-button></section></form></md-card-content></md-card></md-content>');
$templateCache.put('app/admin/user-management/user-management.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">person</md-icon></md-button><span>Usuarios</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo usuario" ui-sref="user-management.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo usuario</md-tooltip><md-icon>add</md-icon></md-button></div></div><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="jh-table table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="login"><span>Usuario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>E-mail</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="activated"><span>Estado</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Perfiles</span></th><th jh-sort-by="createdDate"><span>Fecha de creaci\xF3n</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id" ui-sref="user-management.edit({login:user.login})"><td>{{user.firstName}} {{user.lastName}} ({{user.nif}})</td><td>{{user.email}}</td><td><span ng-if="user.activated">Activo</span> <span ng-if="!user.activated">Inactivo</span></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td></tr></tbody></table><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></md-content></div></md-content>');
$templateCache.put('app/components/login/login.html','<div class="login"><div layout="column" class="container-login" layout-align="center center"><div class="logo-login"></div><div class="logo-subtitle-login"></div><md-card class="md-whiteframe-8dp form-login"><md-card-content><div layout="row" class="header" layout-align="center center"><h2 md-truncate="">SEGUIMIENTO DE EXPEDIENTES</h2></div><div layout="row"><div class="alert alert-danger" ng-show="vm.authenticationError"><strong>\xA1Error al acceder!</strong> Usuario o contrase\xF1a incorrectos.</div></div><p></p><p class="text-center"></p><form role="form" id="loginForm" ng-submit="vm.login($event)" autocomplete="nofill"><div layout="row"><md-input-container flex="100"><label for="username" class="active">Usuario</label><md-icon>person</md-icon><input type="text" id="username" name="username" ng-model="vm.username"><div ng-messages="form.username.$error"><div ng-message="required">El usuario es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container flex="100"><label for="password" class="active">Contrase\xF1a</label><md-icon>lock</md-icon><input type="password" id="password" ng-model="vm.password"></md-input-container></div><div layout="row" flex="100" layout-align="space-around center"><md-checkbox md-no-ink aria-label="Recu\xE9rdame" id="rememberMe" ng-model="vm.rememberMe" class="md-primary" flex="50">Recu\xE9rdame</md-checkbox><a class="alert-link" href="" ng-click="vm.requestResetPassword()">\xBFHas olvidado tu contrase\xF1a?</a></div><div layout="row" layout-align="center center"><md-button type="submit" class="md-raised md-primary" flex="75">Acceder</md-button></div></form></md-card-content></md-card></div></div><div class="login-background"></div>');
$templateCache.put('app/entities/consortium-auditoria/consortium-auditoria-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-auditoria"><md-icon>undo</md-icon></md-button><span>Edici\xF3n auditor\xEDa</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumAuditoria.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumAuditoria.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumAuditoria.auditCompany" for="field_company">Empresa auditora</label><input name="company" id="field_company" ng-model="vm.consortiumAuditoria.auditCompany" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.company.$error"><div ng-message="required">La empresa es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumAuditoria.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.consortiumAuditoria.description" name="description" id="field_description" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumAuditoria.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumAuditoria.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumAuditoria.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-auditoria/consortium-auditoria-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-auditoria"><md-icon>undo</md-icon></md-button><span>Nueva auditor\xEDa</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumAuditoria.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumAuditoria.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumAuditoria.auditCompany" for="field_company">Empresa auditora</label><input name="company" id="field_company" ng-model="vm.consortiumAuditoria.auditCompany" required><div ng-messages="editForm.company.$error"><div ng-message="required">La empresa es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumAuditoria.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.consortiumAuditoria.description" name="description" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-auditoria/consortium-auditoria.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Auditor\xEDa</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="consortium-auditoria.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">Ejercicio</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_text">Empresa auditora o descripci\xF3n</label><input type="string" name="text" id="field_text" ng-model="vm.searchItem.text"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Ejercicio</span></th><th><span>Empresa auditora</span></th><th><span>Descripci\xF3n</span></th><th><span>Consorcio</span></th></tr></thead><tbody><tr ng-repeat="consortiumAuditoria in vm.consortiumAuditorias track by consortiumAuditoria.id" ui-sref="consortium-auditoria.edit({id:consortiumAuditoria.id})"><td>{{consortiumAuditoria.year}}</td><td><div class="table-details"><div class="title">{{consortiumAuditoria.auditCompany}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumAuditoria.description}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumAuditoria.consortium.firstName}} {{consortiumAuditoria.consortium.lastName}}</div><div class="detail">{{consortiumAuditoria.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-cea/consortium-cea-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-cea"><md-icon>undo</md-icon></md-button><span>Edici\xF3n expediente</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumCea.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumCea.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="30"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumCea.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumCea.name" for="field_name">Nombre</label><input name="name" id="field_name" ng-model="vm.consortiumCea.name" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.name.$error"><div ng-message="required">El nombre es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumCea.date" for="field_date">Fecha de escritura</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumCea.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha de escritura es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.consortiumCea.description" name="description" ng-disabled="!vm.isAdmin" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumCea.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumCea.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumCea.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-cea/consortium-cea-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-cea"><md-icon>undo</md-icon></md-button><span>Nuevo expediente</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumCea.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumCea.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumCea.name" for="field_name">Nombre</label><input name="name" id="field_name" ng-model="vm.consortiumCea.name" required><div ng-messages="editForm.name.$error"><div ng-message="required">El nombre es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumCea.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumCea.date" for="field_date">Fecha de escritura</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumCea.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha de escritura es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.consortiumCea.description" name="description" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-cea/consortium-cea.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Constituci\xF3n, estatutos y actas</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="consortium-cea.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_namedesc">Nombre o descripci\xF3n</label><input type="string" name="namedesc" id="field_namedesc" ng-model="vm.searchItem.namedesc"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Nombre</span></th><th><span>Descripci\xF3n</span></th><th><span>Fecha de escritura</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="consortiumCea in vm.consortiumCeas track by consortiumCea.id" ui-sref="consortium-cea.edit({id:consortiumCea.id})"><td>{{consortiumCea.year}}</td><td><div class="table-details"><div class="title">{{consortiumCea.name}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumCea.description}}</div></div></td><td>{{ consortiumCea.date | date:\'dd/MM/yyyy\' }}</td><td><div class="table-details"><div class="title">{{consortiumCea.consortium.firstName}} {{consortiumCea.consortium.lastName}}</div><div class="detail">{{consortiumCea.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-contrato/consortium-contrato-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-contrato"><md-icon>undo</md-icon></md-button><span>Edici\xF3n contrato</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumContrato.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumContrato.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumContrato.type" for="field_type">Tipo</label><input name="type" id="field_type" ng-model="vm.consortiumContrato.type" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.type.$error"><div ng-message="required">El tipo es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumContrato.intervening" for="field_intervening">Interviniente</label><input name="intervening" id="field_intervening" ng-model="vm.consortiumContrato.intervening" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.intervening.$error"><div ng-message="required">El interviniente es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumContrato.date" for="field_date">Fecha</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumContrato.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="30"><label>Descripci\xF3n</label><input ng-model="vm.consortiumContrato.description" name="description" id="field_description" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumContrato.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumContrato.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumContrato.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumContrato.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-contrato/consortium-contrato-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-contrato"><md-icon>undo</md-icon></md-button><span>Nuevo contrato</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumContrato.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumContrato.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumContrato.type" for="field_type">Tipo</label><input name="type" id="field_type" ng-model="vm.consortiumContrato.type" required><div ng-messages="editForm.type.$error"><div ng-message="required">El tipo es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumContrato.intervening" for="field_intervening">Interviniente</label><input name="intervening" id="field_intervening" ng-model="vm.consortiumContrato.intervening" required><div ng-messages="editForm.intervening.$error"><div ng-message="required">El interviniente es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumContrato.date" for="field_date">Fecha</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumContrato.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="30"><label>Descripci\xF3n</label><input ng-model="vm.consortiumContrato.description" name="description" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumContrato.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-contrato/consortium-contrato.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Contratos</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="consortium-contrato.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_text">Tipo o descripci\xF3n</label><input type="string" name="text" id="field_text" ng-model="vm.searchItem.text"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Descripci\xF3n</span></th><th><span>Tipo</span></th><th><span>Fecha</span></th><th><span>Consorcio</span></th></tr></thead><tbody><tr ng-repeat="consortiumContrato in vm.consortiumContratos track by consortiumContrato.id" ui-sref="consortium-contrato.edit({id:consortiumContrato.id})"><td>{{consortiumContrato.year}}</td><td><div class="table-details"><div class="title">{{consortiumContrato.description}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumContrato.type}}</div></div></td><td>{{ consortiumContrato.date | date:\'dd/MM/yyyy\' }}</td><td><div class="table-details"><div class="title">{{consortiumContrato.consortium.firstName}} {{consortiumContrato.consortium.lastName}}</div><div class="detail">{{consortiumContrato.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-expedientes/consortium-expedientes-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-expedientes"><md-icon>undo</md-icon></md-button><span>Expediente Administrativo {{vm.consortiumExpediente.code}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-tabs md-dynamic-height="" md-border-bottom="" class="md-default-theme content-detail"><md-tab label="Datos generales"><md-content class="md-padding"><md-card flex><md-card-content><div class="md-inline-form"><form name="editForm" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.consortiumExpediente.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.consortiumExpediente.code" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.consortiumExpediente.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-model="vm.consortiumExpediente.processType" ng-model-options="{trackBy: \'$value.id\'  }" required ng-disabled="!vm.isAdmin"><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="33"><label for="field_status">Estado</label><md-select id="field_status" name="status" ng-model="vm.consortiumExpediente.status" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="status" ng-repeat="status in vm.status">{{ status.name }}</md-option></md-select></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.consortiumExpediente.notificationDate" for="field_notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.consortiumExpediente.notificationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.consortiumExpediente.presentationDate" for="field_presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.consortiumExpediente.presentationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumExpediente.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.consortiumExpediente.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.consortiumExpediente.client" required ng-model-options="{trackBy: \'$value.name\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="66"><label data-translate="expedientesUriarteApp.consortiumExpediente.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.consortiumExpediente.lawyer" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.consortiumExpediente.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.consortiumExpediente.applicantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpediente.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" ng-model="vm.consortiumExpediente.applicantNif" validate-ni-es ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.consortiumExpediente.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" ng-model="vm.consortiumExpediente.applicantPhone" phone-number ng-disabled="!vm.isAdmin"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.consortiumExpediente.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-disabled="!vm.isAdmin" ng-model="vm.consortiumExpediente.procuratorApplicantName"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.consortiumExpediente.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" id="field_procuratorApplicantPhone" ng-disabled="!vm.isAdmin" phone-number ng-model="vm.consortiumExpediente.procuratorApplicantPhone"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.consortiumExpediente.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.consortiumExpediente.defendantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpediente.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" ng-model="vm.consortiumExpediente.defendantNif" validate-ni-es ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpediente.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" ng-model="vm.consortiumExpediente.defendantPhone" phone-number ng-disabled="!vm.isAdmin"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.consortiumExpediente.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-disabled="!vm.isAdmin" ng-model="vm.consortiumExpediente.procuratorDefendantName"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.consortiumExpediente.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" ng-disabled="!vm.isAdmin" phone-number ng-model="vm.consortiumExpediente.procuratorDefendantPhone"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpediente.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.consortiumExpediente.court" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.consortiumExpediente.topic" columns="1" md-maxlength="1000" rows="3" ng-disabled="!vm.isAdmin"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right" has-authority="ROLE_ADMIN"><md-button type="submit" ng-disabled="editForm.$invalid" class="md-raised md-primary" title="Actualizar expediente" aria-label="Actualizar expediente">Guardar</md-button></section></form></div></md-card-content></md-card></md-content></md-tab><md-tab label="Fases"><md-content class="md-padding"><div layout="row" layout-wrap ng-hide="vm.newstepform === true || vm.editstepform === true  || vm.newstepactionform === true || vm.editstepactionform === true || vm.newdocumentform === true || vm.editdocumentform === true || vm.newstepactionactionform === true || vm.editstepactionactionform === true"><md-card flex><md-card-content><div layout="row" layout-align="end center" flex="100" ng-if="vm.isAdmin"><md-button ng-click="vm.openNewStepForm(null)" class="md-primary add-phase">A\xF1adir fase</md-button></div><div ui-tree id="tree-root" ng-if="vm.nodes.length > 0" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.nodes"><li ng-repeat="node in vm.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></md-card-content></md-card></div><new-gfile-step ng-show="vm.newstepform === true" data-stepparent="vm.stepParent" data-gfilestep="vm.gfilestep" data-gfile="vm.consortiumExpediente" data-updatetree="vm.updatetree" data-newstepform="vm.newstepform"></new-gfile-step><edit-gfile-step ng-show="vm.editstepform === true" data-updatetree="vm.updatetree" data-gfilestep="vm.gfilestep" data-isdeletedstep="vm.isdeletedstep" data-editstepform="vm.editstepform"></edit-gfile-step><new-document ng-show="vm.newdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.consortiumExpediente" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform" data-newdocumentform="vm.newdocumentform"></new-document><edit-document ng-show="vm.editdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.consortiumExpediente" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform"></edit-document></md-content></md-tab><md-tab label="Tareas" ng-if="vm.isAdmin"><md-content class="md-padding"><tasks data-entitytype="vm.entityType" data-entityid="vm.consortiumExpediente.id"></tasks></md-content></md-tab><md-tab ng-if="vm.isAdmin"><md-tab-label><span class="has-notes" ng-show="hasNotes > 0">Notas ({{hasNotes}}) </span><span ng-hide="hasNotes > 0">Notas</span></md-tab-label><md-tab-body class="md-padding"><notes data-entitytype="vm.entityType" data-entityid="vm.consortiumExpediente.id"></notes></md-tab-body></md-tab></md-tabs></md-content><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\n    <div class="node-item" >\n      <md-button class="md-icon-button" aria-label="Collapse tree"  ng-if="node.nodes && node.nodes.length > 0" data-nodrag ng-click="toggle(this)">\n        <md-icon ng-if="!collapsed">keyboard_arrow_down</md-icon>\n        <md-icon ng-if="collapsed">keyboard_arrow_right</md-icon>\n      </md-button>\n      <md-icon ng-if="node.type==\'D\'" class="document-icon">description</md-icon>\n      <div class="step-description" ng-class="{\'step-description-margin\': !node.nodes || node.nodes.length <= 0}">\n          <div class="title" ng-class="{\'step-title\': node.level == 0, \'step-1-title\': node.level == 1, \'step-2-title\': node.level == 2 , \'step-3-title\': node.level == 3}" ng-show="node.type != \'D\'">{{node.title}} <span ng-if="node.status">( {{node.status}} )</span></div>\n          <div class="title" ng-show="node.type == \'D\'" >{{node.title}}</div>\n          <div class="period" ng-show="node.date">\n              <span ng-if="node.dateLabel">{{node.dateLabel}}</span> {{node.date}}\n              <div ng-show="node.date2"><span ng-if="node.date2Label">{{node.date2Label}}</span>{{node.date2}}</div>\n          </div>\n      </div>\n    </div>\n    <div ng-if="node.type != \'D\'">\n      <md-button aria-label="Editar fase" title="Editar fase"\n                 class="md-icon-button" ng-hide="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.edit_gstep(node.id, node.nodes.length > 0)">\n          <md-tooltip md-direction="left">Editar fase</md-tooltip>\n          <md-icon aria-label="Editar fase">mode_edit</md-icon>\n      </md-button>\n      <md-button aria-label="Nueva actuaci\xF3n" title="Nueva actuaci\xF3n"\n                 class="md-icon-button" ng-hide="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.openNewStepForm(node.id)">\n          <md-tooltip md-direction="left">A\xF1adir nueva fase</md-tooltip>\n          <md-icon aria-label="Nueva actuaci\xF3n">add_circle</md-icon>\n      </md-button>\n      <md-button aria-label="A\xF1adir documento" title="A\xF1adir documento"\n                 data-nodrag\n                 ng-click="vm.new_document(node.id)"\n                 ng-hide="!vm.isAdmin"\n                 ng-show="node.documents"\n                 class="md-icon-button">\n          <md-tooltip md-direction="left">A\xF1adir un nuevo documento</md-tooltip>\n          <md-icon aria-label="A\xF1adir documento">note_add</md-icon>\n      </md-button>\n    </div>\n    <div ng-if="node.type == \'D\'">\n        <md-button aria-label="Editar documento" title="Editar documento"\n            ng-click="vm.edit_document(node.id)"\n            ng-hide="!vm.isAdmin"\n            class="md-icon-button">\n            <md-icon aria-label="Editar documento">mode_edit</md-icon>\n        </md-button>\n        <md-button aria-label="Descargar documento" title="Descargar documento"\n            ng-click="vm.download_file(node.id, \'file\')"\n            class="md-icon-button">\n            <md-icon aria-label="Descargar documento">cloud_download</md-icon>\n        </md-button>\n    </div>    \n  </div>\n  <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\n    <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\n  </ol></script><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/consortium-expedientes/consortium-expedientes-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-expedientes"><md-icon>undo</md-icon></md-button><span>Nuevo expediente administrativo</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.consortiumExpediente.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.consortiumExpediente.code"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.consortiumExpediente.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-model="vm.consortiumExpediente.processType" ng-model-options="{trackBy: \'$value.id\'  }" required><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumExpediente.notificationDate" for="notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.consortiumExpediente.notificationDate"><div ng-messages="formData.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumExpediente.presentationDate" for="presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.consortiumExpediente.presentationDate"><div ng-messages="formData.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="30"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumExpediente.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumExpediente.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.consortiumExpediente.client" required><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.consortiumExpediente.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.consortiumExpediente.lawyer"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.consortiumExpediente.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.consortiumExpediente.applicantName" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpediente.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" validate-ni-es ng-model="vm.consortiumExpediente.applicantNif" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.consortiumExpediente.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" phone-number ng-model="vm.consortiumExpediente.applicantPhone"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.consortiumExpediente.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-model="vm.consortiumExpediente.procuratorApplicantName"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.consortiumExpediente.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" id="field_procuratorApplicantPhone" phone-number ng-model="vm.consortiumExpediente.procuratorApplicantPhone"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.consortiumExpediente.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.consortiumExpediente.defendantName" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpediente.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" validate-ni-es ng-model="vm.consortiumExpediente.defendantNif" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.consortiumExpediente.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" phone-number ng-model="vm.consortiumExpediente.defendantPhone"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.consortiumExpediente.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-model="vm.consortiumExpediente.procuratorDefendantName"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.consortiumExpediente.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" phone-number ng-model="vm.consortiumExpediente.procuratorDefendantPhone"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpediente.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.consortiumExpediente.court" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.consortiumExpediente.topic" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-expedientes/consortium-expedientes.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Expedientes Administrativos</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="consortium-expedientes.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo expediente</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="25"><label for="field_code">N\xBA procedimiento</label><input type="string" name="code" id="field_code" ng-model="vm.searchItem.code"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-input-container class="md-block" flex="20"><label for="status">Estado</label><md-select id="status" name="status" ng-model="vm.searchItem.status" ng-model-options="{trackBy: \'$value.id\' }"><md-option ng-value="">Todos</md-option><md-option ng-value="status" ng-repeat="status in vm.status ">{{ status.name }}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>N\xBA procedimiento</span></th><th><span>Procedimiento</span></th><th><span>Consorcio</span></th><th><span>Estado</span></th></tr></thead><tbody><tr ng-repeat="item in vm.consortiumExpedienteItems track by item.gFileId" ui-sref="consortium-expedientes.edit({id:item.gFileId})"><td>{{item.code}}</td><td><div class="table-details"><div class="title">{{item.processType.description}} <span ng-if="item.court">en el juzgado/tribunal {{item.court}}</span><span ng-if="item.procuratorDefendant">, procurador del demandado {{gFile.procuratorDefendant}}</span> <span ng-if="item.procuratorApplicant">y procurador del demandante {{gFile.procuratorApplicant}}</span></div><div class="detail"><span ng-if="item.lawyer">Letrado {{item.lawyer}}</span> <span ng-if="item.step">en fase de {{item.step}}</span></div></div></td><td><div class="table-details"><div class="title">{{item.consortium.firstName}} {{item.consortium.lastName}}</div><div class="detail">{{item.consortium.nif}}</div></div></td><td ng-if="item.status === \'Abierto\'"><div class="column-center"><md-icon>lock_open</md-icon></div></td><td ng-if="item.status === \'Cerrado\'"><div class="column-center"><md-icon>lock</md-icon></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-financiera/consortium-financiera-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-financiera"><md-icon>undo</md-icon></md-button><span>Edici\xF3n expediente</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><!-- EJERCICIO --><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumFinanciera.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumFinanciera.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><!-- ORGANO --><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumFinanciera.organ" for="field_organ">\xD3rgano</label><input name="name" id="field_organ" ng-model="vm.consortiumFinanciera.organ" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.name.$error"><div ng-message="required">El \xF3rgano es obligatorio</div></div></md-input-container><!-- CONSORCIO --><md-input-container class="md-block" flex><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumFinanciera.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><!-- FECHA --><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumFinanciera.date" for="field_date">Fecha</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumFinanciera.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><!-- DESCRIPCION --><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.consortiumFinanciera.description" name="description" id="field_description" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumFinanciera.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumFinanciera.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumFinanciera.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-financiera/consortium-financiera-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-financiera"><md-icon>undo</md-icon></md-button><span>Nuevo expediente</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><!-- EJERCICIO --><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumFinanciera.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumFinanciera.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><!-- ORGANO --><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumFinanciera.organ" for="field_organ">\xD3rgano</label><input name="organ" id="field_organ" ng-model="vm.consortiumFinanciera.organ" required><div ng-messages="editForm.organ.$error"><div ng-message="required">El \xF3rgano es obligatorio</div></div></md-input-container><!-- CONSORCIO --><md-input-container class="md-block" flex><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumFinanciera.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><!-- FECHA --><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumFinanciera.date" for="field_date">Fecha</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumFinanciera.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><!-- DESCRIPCION --><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.consortiumFinanciera.description" name="description" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-financiera/consortium-financiera.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Financiera</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="consortium-financiera.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">Ejercicio</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_text">\xD3rgano o descripci\xF3n</label><input type="string" name="text" id="field_text" ng-model="vm.searchItem.text"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Ejercicio</span></th><th><span>Fecha</span></th><th><span>\xD3rgano</span></th><th><span>Descripci\xF3n</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="consortiumFinanciera in vm.consortiumFinancieras track by consortiumFinanciera.id" ui-sref="consortium-financiera.edit({id:consortiumFinanciera.id})"><td>{{consortiumFinanciera.year}}</td><td>{{ consortiumFinanciera.date | date:\'dd/MM/yyyy\' }}</td><td><div class="table-details"><div class="title">{{consortiumFinanciera.organ}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumFinanciera.description}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumFinanciera.consortium.firstName}} {{consortiumFinanciera.consortium.lastName}}</div><div class="detail">{{consortiumFinanciera.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/document/edit-document-component.html','<md-card><md-card-title><md-card-title-text><span class="md-headline">Editar documento</span></md-card-title-text></md-card-title><md-card-content><div class="md-inline-form"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div layout="row"><md-input-container class="md-block" flex><label for="name">Nombre</label><input id="name" name="name" ng-model="$ctrl.document.name" ng-disabled="$ctrl.document.signatureDate != null"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label for="registerdate">Fecha</label><md-icon>date_range</md-icon><input type="date" id="registerdate" name="registerdate" ng-model="$ctrl.document.register_date" ng-disabled="$ctrl.document.signatureDate != null"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label for="docpath">Documento</label><input type="text" id="filename" name="filename" value="{{$ctrl.document.filename}}" disabled="disabled"></md-input-container><div flex="50"><md-button class="md-fab md-mini md-primary" title="Subir un fichero" ngf-select="$ctrl.uploadfile($file, $invalidFiles)" aria-label="Subir un fichero"><md-icon>add</md-icon></md-button></div></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="$ctrl.document.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button type="button" class="md-raised" ng-click="$ctrl.close()">Cancelar</md-button><md-button type="button" class="md-raised md-primary md-hue-2" ng-click="$ctrl.downloadfile()">Descargar documento</md-button><div data-confirm-delete data-on-confirm="$ctrl.remove_document()"></div><md-button type="submit" ng-disabled="editForm.$invalid || $ctrl.isSaving || $ctrl.document.name === undefined || $ctrl.document.name === null || $ctrl.document.signatureDate != null" class="md-raised md-primary">Grabar</md-button></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/document/new-document-component.html','<md-card><md-card-title><md-card-title-text><span class="md-headline">Nuevo documento</span></md-card-title-text></md-card-title><md-card-content><div class="md-inline-form"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div layout="row"><md-input-container class="md-block" flex><label for="name">Nombre</label><input id="name" name="name" ng-model="$ctrl.document.name"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label for="registerdate">Fecha</label><md-icon>date_range</md-icon><input type="date" id="registerdate" name="registerdate" ng-model="$ctrl.document.register_date"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label for="docpath">Documento</label><input type="text" id="filename" name="filename" value="{{$ctrl.document.filename}}" disabled="disabled"></md-input-container><div flex="50"><md-button class="md-fab md-mini md-primary" title="Subir un fichero" ngf-select="$ctrl.uploadfile($file, $invalidFiles)" aria-label="Subir un fichero"><md-icon>add</md-icon></md-button></div></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="$ctrl.document.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button type="button" class="md-raised" ng-click="$ctrl.close()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || $ctrl.isSaving || $ctrl.document.name === undefined || $ctrl.document.name === null" class="md-raised md-primary">Grabar</md-button></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/file-type/file-type-detail.html','<div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="file-type"><md-icon>undo</md-icon></md-button><span ng-show="vm.fileType.name == null">Nuevo tipo de expediente</span> <span ng-show="vm.fileType.name !== null">Tipo de expediente {{vm.fileType.name}}</span></div></div><md-content class="md-padding"><md-card><md-card-content><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div layout="row"><md-input-container class="md-block" flex="33"><label class="control-label" for="field_code">C\xF3digo</label><input name="code" id="field_code" ng-model="vm.fileType.code" maxlength="3" required><div ng-messages="editForm.code.$error"><div ng-message="required">El c\xF3digo es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="66"><label class="control-label" for="field_name">Nombre</label><input name="name" id="field_name" ng-model="vm.fileType.name" required><div ng-messages="editForm.name.$error"><div ng-message="required">El nombre es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button type="button" class="md-raised" ng-click="vm.clear()">Cancelar</md-button><div data-confirm-delete data-on-confirm="vm.deleteFileType()" ng-show="vm.fileType.id !== null"></div><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary">Grabar</md-button></section></form></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/file-type/file-type-new.html','<div class="row content-header"><div class="col-xs-12 col-sm-12"><div ncy-breadcrumb></div></div></div><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"><div class="panel panel-default"><div class="panel-heading"><h2>Tipo de expediente</h2></div><div class="panel-body"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="col-xs-2 control-label" for="code">C\xF3digo</label><div class="col-xs-7"><input type="text" class="form-control" id="code" name="code" ng-model="vm.fileType.code"></div></div><div class="form-group"><label class="col-xs-2 control-label" for="field_name">Nombre</label><div class="col-xs-7"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.fileType.name" required ng-minlength="5"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">Este campo es obligatorio.</p><p class="help-block" ng-show="editForm.name.$error.minlength" translate-value-min="5">Este campo requiere al menos 5 caracteres.</p></div></div></div><div class="form-group"><div class="col-xs-9 text-right"><button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancelar</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Grabar</span></button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/file-type/file-types.html','<md-content flex><div class="top-bg"></div><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center" flex-offset="2"><md-button class="md-icon-button"><md-icon class="icon-theme">view_list</md-icon></md-button><span>Tipos de expediente</span></div></div><div layout="row" layout-wrap><md-sidenav class="md-sidenav-left sidenav-filter" md-component-id="left" md-is-locked-open="$mdMedia(\'gt-md\')" flex="20"><p></p><div class="bottom-sheet-demo inset new-button" layout="row" layout-sm="column" layout-align="center"><md-button class="md-raised md-primary" ui-sref="file-type.new">Nuevo tipo de expediente</md-button></div></md-sidenav><md-content flex="" class="md-whiteframe-4dp result-box"><table class="jh-table table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="code"><span>C\xF3digo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="fileType in vm.fileTypes track by fileType.id"><td>{{fileType.code}}</td><td>{{fileType.name}}</td><td class="text-left"><md-button class="md-icon-button" ui-sref="file-type.edit({id:fileType.id})" aria-label="More"><md-icon>more_horiz</md-icon></md-button></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></md-content></div></md-content>');
$templateCache.put('app/entities/g-file-civil/g-file-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="g-file-civil"><md-icon>undo</md-icon></md-button><span>Expediente de Jurisdicci\xF3n Civil {{vm.gFile.code}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-tabs md-dynamic-height="" md-border-bottom="" class="md-default-theme content-detail"><md-tab label="Datos generales"><md-content class="md-padding"><md-card flex><md-card-content><div class="md-inline-form"><form name="editForm" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.gFile.code" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-model="vm.gFile.processType" ng-model-options="{trackBy: \'$value.id\'  }" required ng-disabled="!vm.isAdmin"><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_status">Estado</label><md-select id="field_status" name="status" ng-model="vm.gFile.status" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="status" ng-repeat="status in vm.status">{{ status.name }}</md-option></md-select></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.notificationDate" for="field_notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.gFile.notificationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.presentationDate" for="field_presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.gFile.presentationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.gFile.client" required ng-model-options="{trackBy: \'$value.name\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.gFile.lawyer" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.gFile.applicantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" ng-model="vm.gFile.applicantNif" validate-ni-es ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" ng-model="vm.gFile.applicantPhone" phone-number ng-disabled="!vm.isAdmin"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-disabled="!vm.isAdmin" ng-model="vm.gFile.procuratorApplicantName"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" id="field_procuratorApplicantPhone" ng-disabled="!vm.isAdmin" phone-number ng-model="vm.gFile.procuratorApplicantPhone"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.gFile.defendantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" ng-model="vm.gFile.defendantNif" validate-ni-es ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" ng-model="vm.gFile.defendantPhone" phone-number ng-disabled="!vm.isAdmin"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-disabled="!vm.isAdmin" ng-model="vm.gFile.procuratorDefendantName"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" ng-disabled="!vm.isAdmin" phone-number ng-model="vm.gFile.procuratorDefendantPhone"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.gFile.court" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.gFile.topic" columns="1" md-maxlength="1000" rows="3" ng-disabled="!vm.isAdmin"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right" has-authority="ROLE_ADMIN"><md-button type="submit" ng-disabled="editForm.$invalid" class="md-raised md-primary" title="Actualizar expediente" aria-label="Actualizar expediente">Guardar</md-button></section></form></div></md-card-content></md-card></md-content></md-tab><md-tab label="Fases"><md-content class="md-padding"><div layout="row" layout-wrap ng-hide="vm.newstepform === true || vm.editstepform === true  || vm.newstepactionform === true || vm.editstepactionform === true || vm.newdocumentform === true || vm.editdocumentform === true || vm.newstepactionactionform === true || vm.editstepactionactionform === true"><md-card flex><md-card-content><div layout="row" layout-align="end center" flex="100" ng-if="vm.isAdmin"><md-button ng-click="vm.openNewStepForm(null)" class="md-primary add-phase">A\xF1adir fase</md-button></div><div ui-tree id="tree-root" ng-if="vm.nodes.length > 0" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.nodes"><li ng-repeat="node in vm.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></md-card-content></md-card></div><new-gfile-step ng-show="vm.newstepform === true" data-stepparent="vm.stepParent" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-newstepform="vm.newstepform"></new-gfile-step><edit-gfile-step ng-show="vm.editstepform === true" data-updatetree="vm.updatetree" data-gfilestep="vm.gfilestep" data-isdeletedstep="vm.isdeletedstep" data-editstepform="vm.editstepform"></edit-gfile-step><new-document ng-show="vm.newdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform" data-newdocumentform="vm.newdocumentform"></new-document><edit-document ng-show="vm.editdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform"></edit-document></md-content></md-tab><md-tab label="Tareas" ng-if="vm.isAdmin"><md-content class="md-padding"><tasks data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></tasks></md-content></md-tab><md-tab ng-if="vm.isAdmin"><md-tab-label><span class="has-notes" ng-show="hasNotes > 0">Notas ({{hasNotes}}) </span><span ng-hide="hasNotes > 0">Notas</span></md-tab-label><md-tab-body class="md-padding"><notes data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></notes></md-tab-body></md-tab></md-tabs></md-content><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\n    <div class="node-item" >\n      <md-button class="md-icon-button" aria-label="Collapse tree"  ng-if="node.nodes && node.nodes.length > 0" data-nodrag ng-click="toggle(this)">\n        <md-icon ng-if="!collapsed">keyboard_arrow_down</md-icon>\n        <md-icon ng-if="collapsed">keyboard_arrow_right</md-icon>\n      </md-button>\n      <md-icon ng-if="node.type==\'D\'" class="document-icon">description</md-icon>\n      <div class="step-description" ng-class="{\'step-description-margin\': !node.nodes || node.nodes.length <= 0}">\n          <div class="title" ng-class="{\'step-title\': node.level == 0, \'step-1-title\': node.level == 1, \'step-2-title\': node.level == 2 , \'step-3-title\': node.level == 3}" ng-show="node.type != \'D\'">{{node.title}} <span ng-if="node.status">( {{node.status}} )</span></div>\n          <div class="title" ng-show="node.type == \'D\'" >{{node.title}}</div>\n          <div class="period" ng-show="node.date">\n              <span ng-if="node.dateLabel">{{node.dateLabel}}</span> {{node.date}}\n              <div ng-show="node.date2"><span ng-if="node.date2Label">{{node.date2Label}}</span>{{node.date2}}</div>\n          </div>\n      </div>\n    </div>\n    <div ng-if="node.type != \'D\'">\n      <md-button aria-label="Editar fase" title="Editar fase"\n                 class="md-icon-button" ng-hide="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.edit_gstep(node.id, node.nodes.length > 0)">\n          <md-tooltip md-direction="left">Editar fase</md-tooltip>\n          <md-icon aria-label="Editar fase">mode_edit</md-icon>\n      </md-button>\n      <md-button aria-label="Nueva actuaci\xF3n" title="Nueva actuaci\xF3n"\n                 class="md-icon-button" ng-hide="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.openNewStepForm(node.id)">\n          <md-tooltip md-direction="left">A\xF1adir nueva fase</md-tooltip>\n          <md-icon aria-label="Nueva actuaci\xF3n">add_circle</md-icon>\n      </md-button>\n      <md-button aria-label="A\xF1adir documento" title="A\xF1adir documento"\n                 data-nodrag\n                 ng-click="vm.new_document(node.id)"\n                 ng-hide="!vm.isAdmin"\n                 ng-show="node.documents"\n                 class="md-icon-button">\n          <md-tooltip md-direction="left">A\xF1adir un nuevo documento</md-tooltip>\n          <md-icon aria-label="A\xF1adir documento">note_add</md-icon>\n      </md-button>\n    </div>\n    <div ng-if="node.type == \'D\'">\n        <md-button aria-label="Editar documento" title="Editar documento"\n            ng-click="vm.edit_document(node.id)"\n            ng-hide="!vm.isAdmin"\n            class="md-icon-button">\n            <md-icon aria-label="Editar documento">mode_edit</md-icon>\n        </md-button>\n        <md-button aria-label="Descargar documento" title="Descargar documento"\n            ng-click="vm.download_file(node.id, \'file\')"\n            class="md-icon-button">\n            <md-icon aria-label="Descargar documento">cloud_download</md-icon>\n        </md-button>\n    </div>    \n  </div>\n  <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\n    <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\n  </ol></script><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/g-file-civil/g-file-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="g-file-civil"><md-icon>undo</md-icon></md-button><span>Nuevo expediente de Jurisdicci\xF3n Civil</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.gFile.code"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-model="vm.gFile.processType" ng-model-options="{trackBy: \'$value.id\'  }" required><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.notificationDate" for="notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.gFile.notificationDate"><div ng-messages="formData.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.presentationDate" for="presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.gFile.presentationDate"><div ng-messages="formData.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.gFile.client" required><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.gFile.lawyer"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.gFile.applicantName" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" validate-ni-es ng-model="vm.gFile.applicantNif" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" phone-number ng-model="vm.gFile.applicantPhone"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-model="vm.gFile.procuratorApplicantName"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" id="field_procuratorApplicantPhone" phone-number ng-model="vm.gFile.procuratorApplicantPhone"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.gFile.defendantName" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" validate-ni-es ng-model="vm.gFile.defendantNif" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" phone-number ng-model="vm.gFile.defendantPhone"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-model="vm.gFile.procuratorDefendantName"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" phone-number ng-model="vm.gFile.procuratorDefendantPhone"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.gFile.court" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.gFile.topic" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/g-file-civil/g-files.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">description</md-icon></md-button><span>Expedientes de Jurisdicci\xF3n Civil</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="g-file-civil.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo expediente</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="25"><label for="field_code">N\xBA procedimiento</label><input type="string" name="code" id="field_code" ng-model="vm.searchItem.code"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_client">Cliente</label><input type="string" name="client" id="field_client" ng-model="vm.searchItem.client"></md-input-container><md-input-container class="md-block" flex="20"><label for="status">Estado</label><md-select id="status" name="status" ng-model="vm.searchItem.status" ng-model-options="{trackBy: \'$value.id\' }"><md-option ng-value="">Todos</md-option><md-option ng-value="status" ng-repeat="status in vm.status ">{{ status.name }}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>N\xBA procedimiento</span></th><th><span>Procedimiento</span></th><th><span>Cliente</span></th><th><span>Estado</span></th></tr></thead><tbody><tr ng-repeat="gFile in vm.gFiles track by gFile.gFileId" ui-sref="g-file-civil.edit({id:gFile.gFileId})"><td>{{gFile.code}}</td><td><div class="table-details"><div class="title">{{gFile.processType.description}} <span ng-if="gFile.court">en el juzgado/tribunal {{gFile.court}}</span><span ng-if="gFile.procuratorDefendant">, procurador del demandado {{gFile.procuratorDefendant}}</span> <span ng-if="gFile.procuratorApplicant">y procurador del demandante {{gFile.procuratorApplicant}}</span></div><div class="detail"><span ng-if="gFile.lawyer">Letrado {{gFile.lawyer}}</span> <span ng-if="gFile.step">en fase de {{gFile.step}}</span></div></div></td><td ng-if="gFile.client.name === \'APPLICANT\'"><div class="table-details"><div class="title">{{gFile.applicant}}</div><div class="detail">{{gFile.applicantNif}} (Demandante)</div></div></td><td ng-if="gFile.client.name === \'DEFENDANT\'"><div class="table-details"><div class="title">{{gFile.defendant}}</div><div class="detail">{{gFile.defendantNif}} (Demandado)</div></div></td><td ng-if="gFile.status === \'Abierto\'"><div class="column-center"><md-icon>lock_open</md-icon></div></td><td ng-if="gFile.status === \'Cerrado\'"><div class="column-center"><md-icon>lock</md-icon></div></td><!--                        <td class="hidden-sm hidden-xs">{{gFile.hasNotes}}</td> --></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="searchForm.$invalid || vm.gFiles.length === 0"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/g-file-contencioso/g-file-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="g-file-contencioso"><md-icon>undo</md-icon></md-button><span>Expediente de Jurisdicci\xF3n Contencioso - Administrativo {{vm.gFile.code}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-tabs md-dynamic-height="" md-border-bottom="" class="md-default-theme content-detail"><md-tab label="Datos generales"><md-content class="md-padding"><md-card flex><md-card-content><div class="md-inline-form"><form name="editForm" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.gFile.code" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-disabled="!vm.isAdmin" ng-model="vm.gFile.processType" ng-model-options="{trackBy: \'$value.id\'  }" required><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_status">Estado</label><md-select id="field_status" name="status" ng-model="vm.gFile.status" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="status" ng-repeat="status in vm.status">{{ status.name }}</md-option></md-select></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.notificationDate" for="field_notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.gFile.notificationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.presentationDate" for="field_presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.gFile.presentationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.gFile.client" required ng-model-options="{trackBy: \'$value.name\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.gFile.lawyer" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.gFile.applicantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" ng-model="vm.gFile.applicantNif" validate-ni-es ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" ng-model="vm.gFile.applicantPhone" phone-number ng-disabled="!vm.isAdmin"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-model="vm.gFile.procuratorApplicantName" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" id="field_procuratorApplicantPhone" phone-number ng-model="vm.gFile.procuratorApplicantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.gFile.defendantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" ng-model="vm.gFile.defendantNif" validate-ni-es ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" ng-model="vm.gFile.defendantPhone" phone-number ng-disabled="!vm.isAdmin"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-model="vm.gFile.procuratorDefendantName" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" phone-number ng-model="vm.gFile.procuratorDefendantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.gFile.court" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.gFile.topic" columns="1" md-maxlength="1000" rows="3" ng-disabled="!vm.isAdmin"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right" has-authority="ROLE_ADMIN"><md-button type="submit" ng-disabled="editForm.$invalid" class="md-raised md-primary" title="Actualizar expediente" aria-label="Actualizar expediente">Guardar</md-button></section></form></div></md-card-content></md-card></md-content></md-tab><md-tab label="Fases"><md-content class="md-padding"><div layout="row" layout-wrap ng-hide="vm.newstepform === true || vm.editstepform === true  || vm.newstepactionform === true || vm.editstepactionform === true || vm.newdocumentform === true || vm.editdocumentform === true || vm.newstepactionactionform === true || vm.editstepactionactionform === true"><md-card flex><md-card-content><div layout="row" layout-align="end center" flex="100" ng-if="vm.isAdmin"><md-button ng-click="vm.openNewStepForm(null)" class="md-primary add-phase">A\xF1adir fase</md-button></div><div ui-tree id="tree-root" ng-if="vm.nodes.length > 0" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.nodes"><li ng-repeat="node in vm.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></md-card-content></md-card></div><new-gfile-step ng-show="vm.newstepform === true" data-stepparent="vm.stepParent" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-newstepform="vm.newstepform"></new-gfile-step><edit-gfile-step ng-show="vm.editstepform === true" data-updatetree="vm.updatetree" data-gfilestep="vm.gfilestep" data-isdeletedstep="vm.isdeletedstep" data-editstepform="vm.editstepform"></edit-gfile-step><new-document ng-show="vm.newdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform" data-newdocumentform="vm.newdocumentform"></new-document><edit-document ng-show="vm.editdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform"></edit-document></md-content></md-tab><md-tab label="Tareas" ng-if="vm.isAdmin"><md-content class="md-padding"><tasks data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></tasks></md-content></md-tab><md-tab ng-if="vm.isAdmin"><md-tab-label><span class="has-notes" ng-show="hasNotes > 0">Notas ({{hasNotes}}) </span><span ng-hide="hasNotes > 0">Notas</span></md-tab-label><md-tab-body class="md-padding"><notes data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></notes></md-tab-body></md-tab></md-tabs></md-content><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\n    <div class="node-item" >\n      <md-button class="md-icon-button" aria-label="Collapse tree"  ng-if="node.nodes && node.nodes.length > 0" data-nodrag ng-click="toggle(this)">\n        <md-icon ng-if="!collapsed">keyboard_arrow_down</md-icon>\n        <md-icon ng-if="collapsed">keyboard_arrow_right</md-icon>\n      </md-button>\n      <md-icon ng-if="node.type==\'D\'" class="document-icon">description</md-icon>\n      <div class="step-description" ng-class="{\'step-description-margin\': !node.nodes || node.nodes.length <= 0}">\n          <div class="title" ng-class="{\'step-title\': node.level == 0, \'step-1-title\': node.level == 1, \'step-2-title\': node.level == 2 , \'step-3-title\': node.level == 3}" ng-show="node.type != \'D\'">{{node.title}} <span ng-if="node.status">( {{node.status}} )</span></div>\n          <div class="title" ng-show="node.type == \'D\'" >{{node.title}}</div>\n          <div class="period" ng-show="node.date">\n              <span ng-if="node.dateLabel">{{node.dateLabel}}</span> {{node.date}}\n              <div ng-show="node.date2"><span ng-if="node.date2Label">{{node.date2Label}}</span>{{node.date2}}</div>\n          </div>\n      </div>\n    </div>\n    <div ng-if="node.type != \'D\'">\n      <md-button aria-label="Editar fase" title="Editar fase"\n                 class="md-icon-button" ng-disabled="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.edit_gstep(node.id, node.nodes.length > 0)">\n          <md-tooltip md-direction="left">Editar fase</md-tooltip>\n          <md-icon aria-label="Editar fase">mode_edit</md-icon>\n      </md-button>\n      <md-button aria-label="Nueva actuaci\xF3n" title="Nueva actuaci\xF3n"\n                 class="md-icon-button" ng-disabled="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.openNewStepForm(node.id)">\n          <md-tooltip md-direction="left">A\xF1adir nueva fase</md-tooltip>\n          <md-icon aria-label="Nueva actuaci\xF3n">add_circle</md-icon>\n      </md-button>\n      <md-button aria-label="A\xF1adir documento" title="A\xF1adir documento"\n                 data-nodrag\n                 ng-click="vm.new_document(node.id)"\n                 ng-disabled="!vm.isAdmin"\n                 ng-show="node.documents"\n                 class="md-icon-button">\n          <md-tooltip md-direction="left">A\xF1adir un nuevo documento</md-tooltip>\n          <md-icon aria-label="A\xF1adir documento">note_add</md-icon>\n      </md-button>\n    </div>\n    <div ng-if="node.type == \'D\'">\n        <md-button aria-label="Editar documento" title="Editar documento"\n            ng-click="vm.edit_document(node.id)"\n            ng-hide="!vm.isAdmin"\n            class="md-icon-button">\n            <md-icon aria-label="Editar documento">mode_edit</md-icon>\n        </md-button>\n        <md-button aria-label="Descargar documento" title="Descargar documento"\n            ng-click="vm.download_file(node.id, \'file\')"\n            class="md-icon-button">\n            <md-icon aria-label="Descargar documento">cloud_download</md-icon>\n        </md-button>\n    </div> \n  </div>\n  <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\n    <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\n  </ol></script><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/g-file-contencioso/g-file-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="g-file-contencioso"><md-icon>undo</md-icon></md-button><span>Nuevo expediente de Jurisdicci\xF3n Contencioso - Administrativo</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.gFile.code"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-model="vm.gFile.processType" ng-model-options="{trackBy: \'$value.id\'  }" required><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.notificationDate" for="notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.gFile.notificationDate"><div ng-messages="editForm.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.presentationDate" for="presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.gFile.presentationDate"><div ng-messages="editForm.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.gFile.client" required><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.gFile.lawyer"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.gFile.applicantName" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" validate-ni-es ng-model="vm.gFile.applicantNif" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" ng-model="vm.gFile.applicantPhone" phone-number><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-model="vm.gFile.procuratorApplicantName"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" phone-number id="field_procuratorApplicantPhone" ng-model="vm.gFile.procuratorApplicantPhone"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.gFile.defendantName" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" validate-ni-es ng-model="vm.gFile.defendantNif" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" phone-number ng-model="vm.gFile.defendantPhone"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-model="vm.gFile.procuratorDefendantName"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" phone-number ng-model="vm.gFile.procuratorDefendantPhone"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.gFile.court" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.gFile.topic" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/g-file-contencioso/g-files.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">description</md-icon></md-button><span>Expedientes de Jurisdicci\xF3n Contencioso - Administrativo</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="g-file-contencioso.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo expediente</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="25"><label for="field_code">N\xBA procedimiento</label><input type="string" name="code" id="field_code" ng-model="vm.searchItem.code"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_client">Cliente</label><input type="string" name="client" id="field_client" ng-model="vm.searchItem.client"></md-input-container><md-input-container class="md-block" flex="20"><label for="status">Estado</label><md-select id="status" name="status" ng-model="vm.searchItem.status" ng-model-options="{trackBy: \'$value.id\' }"><md-option ng-value="">Todos</md-option><md-option ng-value="status" ng-repeat="status in vm.status ">{{ status.name }}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><!--          <md-input-container class="md-block" flex>\n                          <label for="step">Fase</label>\n                          <md-select id="step" name="step" ng-model="vm.searchItem.step" ng-model-options="{trackBy: \'$value.id\' }">\n                              <md-option ng-value="step" ng-repeat="step in vm.steps ">{{ step.title }}</md-option>\n                          </md-select>\n                          <div class="md-errors-spacer"></div>\n                      </md-input-container>\n                      <md-input-container class="md-block" flex>\n                          <label for="startDate">Fecha de inicio</label>\n                          <input type="date" name="startDate" id="startDate" ng-model="vm.searchItem.startDate">\n                      </md-input-container>\n                      <md-input-container class="md-block" flex>\n                          <label for="endDate">Fecha de fin</label>\n                          <input type="date" name="endDate" id="endDate" ng-model="vm.searchItem.endDate">\n                      </md-input-container> --><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>N\xBA procedimiento</span></th><th><span>Procedimiento</span></th><th><span>Cliente</span></th><th><span>Estado</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="gFile in vm.gFiles track by gFile.gFileId" ui-sref="g-file-contencioso.edit({id:gFile.gFileId})"><td>{{gFile.code}}</td><td><div class="table-details"><div class="title">{{gFile.processType.description}} <span ng-if="gFile.court">en el juzgado/tribunal {{gFile.court}}</span><span ng-if="gFile.procuratorDefendant">, procurador del demandado {{gFile.procuratorDefendant}}</span> <span ng-if="gFile.procuratorApplicant">y procurador del demandante {{gFile.procuratorApplicant}}</span></div><div class="detail"><span ng-if="gFile.lawyer">Letrado {{gFile.lawyer}}</span> <span ng-if="gFile.step">en fase de {{gFile.step}}</span></div></div></td><td ng-if="gFile.client.name === \'APPLICANT\'"><div class="table-details"><div class="title">{{gFile.applicant}}</div><div class="detail">{{gFile.applicantNif}} (Demandante)</div></div></td><td ng-if="gFile.client.name === \'DEFENDANT\'"><div class="table-details"><div class="title">{{gFile.defendant}}</div><div class="detail">{{gFile.defendantNif}} (Demandado)</div></div></td><td ng-if="gFile.status === \'Abierto\'"><div class="column-center"><md-icon>lock_open</md-icon></div></td><td ng-if="gFile.status === \'Cerrado\'"><div class="column-center"><md-icon>lock</md-icon></div></td><!--                        <td class="hidden-sm hidden-xs">{{gFile.hasNotes}}</td> --></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="searchForm.$invalid || vm.gFiles.length === 0"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/g-file-laboral/g-file-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="g-file-laboral"><md-icon>undo</md-icon></md-button><span>Expediente de Jurisdicci\xF3n Laboral {{vm.gFile.code}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-tabs md-dynamic-height="" md-border-bottom="" class="md-default-theme content-detail"><md-tab label="Datos generales"><md-content class="md-padding"><md-card flex><md-card-content><div class="md-inline-form"><form name="editForm" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.gFile.code" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-model="vm.gFile.processType" ng-model-options="{trackBy: \'$value.id\'  }" ng-disabled="!vm.isAdmin" required><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_status">Estado</label><md-select id="field_status" name="status" ng-model="vm.gFile.status" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="status" ng-repeat="status in vm.status">{{ status.name }}</md-option></md-select></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.notificationDate" for="field_notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.gFile.notificationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.presentationDate" for="field_presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.gFile.presentationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.gFile.client" required ng-model-options="{trackBy: \'$value.name\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.gFile.lawyer" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.gFile.applicantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" ng-model="vm.gFile.applicantNif" validate-ni-es ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" ng-model="vm.gFile.applicantPhone" phone-number ng-disabled="!vm.isAdmin"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-model="vm.gFile.procuratorApplicantName" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" id="field_procuratorApplicantPhone" phone-number ng-model="vm.gFile.procuratorApplicantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.gFile.defendantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" validate-ni-es ng-model="vm.gFile.defendantNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" ng-model="vm.gFile.defendantPhone" phone-number ng-disabled="!vm.isAdmin"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-model="vm.gFile.procuratorDefendantName" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" phone-number ng-model="vm.gFile.procuratorDefendantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.gFile.court" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.gFile.topic" columns="1" md-maxlength="1000" rows="3" ng-disabled="!vm.isAdmin"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right" has-authority="ROLE_ADMIN"><md-button type="submit" ng-disabled="editForm.$invalid" class="md-raised md-primary" title="Actualizar expediente" aria-label="Actualizar expediente">Guardar</md-button></section></form></div></md-card-content></md-card></md-content></md-tab><md-tab label="Fases"><md-content class="md-padding"><div layout="row" layout-wrap ng-hide="vm.newstepform === true || vm.editstepform === true  || vm.newstepactionform === true || vm.editstepactionform === true || vm.newdocumentform === true || vm.editdocumentform === true || vm.newstepactionactionform === true || vm.editstepactionactionform === true"><md-card flex><md-card-content><div layout="row" layout-align="end center" flex="100" ng-if="vm.isAdmin"><md-button ng-click="vm.openNewStepForm(null)" class="md-primary add-phase">A\xF1adir fase</md-button></div><div ui-tree id="tree-root" ng-if="vm.nodes.length > 0" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.nodes"><li ng-repeat="node in vm.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></md-card-content></md-card></div><new-gfile-step ng-show="vm.newstepform === true" data-stepparent="vm.stepParent" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-newstepform="vm.newstepform"></new-gfile-step><edit-gfile-step ng-show="vm.editstepform === true" data-updatetree="vm.updatetree" data-gfilestep="vm.gfilestep" data-isdeletedstep="vm.isdeletedstep" data-editstepform="vm.editstepform"></edit-gfile-step><new-document ng-show="vm.newdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform" data-newdocumentform="vm.newdocumentform"></new-document><edit-document ng-show="vm.editdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform"></edit-document></md-content></md-tab><md-tab label="Tareas" ng-if="vm.isAdmin"><md-content class="md-padding"><tasks data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></tasks></md-content></md-tab><md-tab ng-if="vm.isAdmin"><md-tab-label><span class="has-notes" ng-show="hasNotes > 0">Notas ({{hasNotes}}) </span><span ng-hide="hasNotes > 0">Notas</span></md-tab-label><md-tab-body class="md-padding"><notes data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></notes></md-tab-body></md-tab></md-tabs></md-content><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\n    <div class="node-item" >\n      <md-button class="md-icon-button" aria-label="Collapse tree"  ng-if="node.nodes && node.nodes.length > 0" data-nodrag ng-click="toggle(this)">\n        <md-icon ng-if="!collapsed">keyboard_arrow_down</md-icon>\n        <md-icon ng-if="collapsed">keyboard_arrow_right</md-icon>\n      </md-button>\n      <md-icon ng-if="node.type==\'D\'" class="document-icon">description</md-icon>\n      <div class="step-description" ng-class="{\'step-description-margin\': !node.nodes || node.nodes.length <= 0}">\n          <div class="title" ng-class="{\'step-title\': node.level == 0, \'step-1-title\': node.level == 1, \'step-2-title\': node.level == 2 , \'step-3-title\': node.level == 3}" ng-show="node.type != \'D\'">{{node.title}} <span ng-if="node.status">( {{node.status}} )</span></div>\n          <div class="title" ng-show="node.type == \'D\'" >{{node.title}}</div>\n          <div class="period" ng-show="node.date">\n              <span ng-if="node.dateLabel">{{node.dateLabel}}</span> {{node.date}}\n              <div ng-show="node.date2"><span ng-if="node.date2Label">{{node.date2Label}}</span>{{node.date2}}</div>\n          </div>\n      </div>\n    </div>\n    <div ng-if="node.type != \'D\'">\n      <md-button aria-label="Editar fase" title="Editar fase"\n                 class="md-icon-button" ng-disabled="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.edit_gstep(node.id, node.nodes.length > 0)">\n          <md-tooltip md-direction="left">Editar fase</md-tooltip>\n          <md-icon aria-label="Editar fase">mode_edit</md-icon>\n      </md-button>\n      <md-button aria-label="Nueva actuaci\xF3n" title="Nueva actuaci\xF3n"\n                 class="md-icon-button" ng-disabled="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.openNewStepForm(node.id)">\n          <md-tooltip md-direction="left">A\xF1adir nueva fase</md-tooltip>\n          <md-icon aria-label="Nueva actuaci\xF3n">add_circle</md-icon>\n      </md-button>\n      <md-button aria-label="A\xF1adir documento" title="A\xF1adir documento"\n                 data-nodrag\n                 ng-click="vm.new_document(node.id)"\n                 ng-disabled="!vm.isAdmin"\n                 ng-show="node.documents"\n                 class="md-icon-button">\n          <md-tooltip md-direction="left">A\xF1adir un nuevo documento</md-tooltip>\n          <md-icon aria-label="A\xF1adir documento">note_add</md-icon>\n      </md-button>\n    </div>\n    <div ng-if="node.type == \'D\'">\n        <md-button aria-label="Editar documento" title="Editar documento"\n            ng-click="vm.edit_document(node.id)"\n            ng-hide="!vm.isAdmin"\n            class="md-icon-button">\n            <md-icon aria-label="Editar documento">mode_edit</md-icon>\n        </md-button>\n        <md-button aria-label="Descargar documento" title="Descargar documento"\n            ng-click="vm.download_file(node.id, \'file\')"\n            class="md-icon-button">\n            <md-icon aria-label="Descargar documento">cloud_download</md-icon>\n        </md-button>\n    </div> \n  </div>\n  \n  <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\n    <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\n  </ol></script><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/g-file-laboral/g-file-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="g-file-laboral"><md-icon>undo</md-icon></md-button><span>Nuevo expediente de Jurisdicci\xF3n Laboral</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.gFile.code"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-model="vm.gFile.processType" ng-model-options="{trackBy: \'$value.id\'  }" required><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.notificationDate" for="notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.gFile.notificationDate"><div ng-messages="editForm.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.presentationDate" for="presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.gFile.presentationDate"><div ng-messages="editForm.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.gFile.client" required><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.gFile.lawyer"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.gFile.applicantName" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" validate-ni-es ng-model="vm.gFile.applicantNif" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" phone-number ng-model="vm.gFile.applicantPhone"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-model="vm.gFile.procuratorApplicantName"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" id="field_procuratorApplicantPhone" phone-number ng-model="vm.gFile.procuratorApplicantPhone"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.gFile.defendantName" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" validate-ni-es ng-model="vm.gFile.defendantNif" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" phone-number ng-model="vm.gFile.defendantPhone"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-model="vm.gFile.procuratorDefendantName"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" phone-number ng-model="vm.gFile.procuratorDefendantPhone"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.gFile.court" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.gFile.topic" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/g-file-laboral/g-files.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">description</md-icon></md-button><span>Expedientes de Jurisdicci\xF3n Laboral</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="g-file-laboral.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo expediente</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="25"><label for="field_code">N\xBA procedimiento</label><input type="string" name="code" id="field_code" ng-model="vm.searchItem.code"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_client">Cliente</label><input type="string" name="client" id="field_client" ng-model="vm.searchItem.client"></md-input-container><md-input-container class="md-block" flex="20"><label for="status">Estado</label><md-select id="status" name="status" ng-model="vm.searchItem.status" ng-model-options="{trackBy: \'$value.id\' }"><md-option ng-value="">Todos</md-option><md-option ng-value="status" ng-repeat="status in vm.status ">{{ status.name }}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><!--          <md-input-container class="md-block" flex>\n                          <label for="step">Fase</label>\n                          <md-select id="step" name="step" ng-model="vm.searchItem.step" ng-model-options="{trackBy: \'$value.id\' }">\n                              <md-option ng-value="step" ng-repeat="step in vm.steps ">{{ step.title }}</md-option>\n                          </md-select>\n                          <div class="md-errors-spacer"></div>\n                      </md-input-container>\n                      <md-input-container class="md-block" flex>\n                          <label for="startDate">Fecha de inicio</label>\n                          <input type="date" name="startDate" id="startDate" ng-model="vm.searchItem.startDate">\n                      </md-input-container>\n                      <md-input-container class="md-block" flex>\n                          <label for="endDate">Fecha de fin</label>\n                          <input type="date" name="endDate" id="endDate" ng-model="vm.searchItem.endDate">\n                      </md-input-container> --><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>N\xBA procedimiento</span></th><th><span>Procedimiento</span></th><th><span>Cliente</span></th><th><span>Estado</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="gFile in vm.gFiles track by gFile.gFileId" ui-sref="g-file-laboral.edit({id:gFile.gFileId})"><td>{{gFile.code}}</td><td><div class="table-details"><div class="title">{{gFile.processType.description}} <span ng-if="gFile.court">en el juzgado/tribunal {{gFile.court}}</span><span ng-if="gFile.procuratorDefendant">, procurador del demandado {{gFile.procuratorDefendant}}</span> <span ng-if="gFile.procuratorApplicant">y procurador del demandante {{gFile.procuratorApplicant}}</span></div><div class="detail"><span ng-if="gFile.lawyer">Letrado {{gFile.lawyer}}</span> <span ng-if="gFile.step">en fase de {{gFile.step}}</span></div></div></td><td ng-if="gFile.client.name === \'APPLICANT\'"><div class="table-details"><div class="title">{{gFile.applicant}}</div><div class="detail">{{gFile.applicantNif}} (Demandante)</div></div></td><td ng-if="gFile.client.name === \'DEFENDANT\'"><div class="table-details"><div class="title">{{gFile.defendant}}</div><div class="detail">{{gFile.defendantNif}} (Demandado)</div></div></td><td ng-if="gFile.status === \'Abierto\'"><div class="column-center"><md-icon>lock_open</md-icon></div></td><td ng-if="gFile.status === \'Cerrado\'"><div class="column-center"><md-icon>lock</md-icon></div></td><!--                        <td class="hidden-sm hidden-xs">{{gFile.hasNotes}}</td> --></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="searchForm.$invalid || vm.gFiles.length === 0"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/g-file-mercantil/g-file-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="g-file-mercantil"><md-icon>undo</md-icon></md-button><span>Expediente de Jurisdicci\xF3n Mercantil {{vm.gFile.code}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-tabs md-dynamic-height="" md-border-bottom="" class="md-default-theme content-detail"><md-tab label="Datos generales"><md-content class="md-padding"><md-card flex><md-card-content><div class="md-inline-form"><form name="editForm" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.gFile.code" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-model="vm.gFile.processType" ng-model-options="{trackBy: \'$value.id\'  }" required ng-disabled="!vm.isAdmin"><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_status">Estado</label><md-select id="field_status" name="status" ng-model="vm.gFile.status" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="status" ng-repeat="status in vm.status">{{ status.name }}</md-option></md-select></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.notificationDate" for="field_notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.gFile.notificationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.presentationDate" for="field_presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.gFile.presentationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.gFile.client" required ng-model-options="{trackBy: \'$value.name\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.gFile.lawyer" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.gFile.applicantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" ng-model="vm.gFile.applicantNif" validate-ni-es ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" phone-number ng-model="vm.gFile.applicantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-model="vm.gFile.procuratorApplicantName" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" id="field_procuratorApplicantPhone" phone-number ng-model="vm.gFile.procuratorApplicantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.gFile.defendantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" ng-model="vm.gFile.defendantNif" validate-ni-es ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" phone-number ng-model="vm.gFile.defendantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-model="vm.gFile.procuratorDefendantName" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" phone-number ng-model="vm.gFile.procuratorDefendantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.gFile.court" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.gFile.topic" columns="1" md-maxlength="1000" rows="3" ng-disabled="!vm.isAdmin"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right" has-authority="ROLE_ADMIN"><md-button type="submit" ng-disabled="editForm.$invalid" class="md-raised md-primary" title="Actualizar expediente" aria-label="Actualizar expediente">Guardar</md-button></section></form></div></md-card-content></md-card></md-content></md-tab><md-tab label="Fases"><md-content class="md-padding"><div layout="row" layout-wrap ng-hide="vm.newstepform === true || vm.editstepform === true  || vm.newstepactionform === true || vm.editstepactionform === true || vm.newdocumentform === true || vm.editdocumentform === true || vm.newstepactionactionform === true || vm.editstepactionactionform === true"><md-card flex><md-card-content><div layout="row" layout-align="end center" flex="100" ng-if="vm.isAdmin"><md-button ng-click="vm.openNewStepForm(null)" class="md-primary add-phase">A\xF1adir fase</md-button></div><div ui-tree id="tree-root" ng-if="vm.nodes.length > 0" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.nodes"><li ng-repeat="node in vm.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></md-card-content></md-card></div><new-gfile-step ng-show="vm.newstepform === true" data-stepparent="vm.stepParent" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-newstepform="vm.newstepform"></new-gfile-step><edit-gfile-step ng-show="vm.editstepform === true" data-updatetree="vm.updatetree" data-gfilestep="vm.gfilestep" data-isdeletedstep="vm.isdeletedstep" data-editstepform="vm.editstepform"></edit-gfile-step><new-document ng-show="vm.newdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform" data-newdocumentform="vm.newdocumentform"></new-document><edit-document ng-show="vm.editdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform"></edit-document></md-content></md-tab><md-tab label="Tareas" ng-if="vm.isAdmin"><md-content class="md-padding"><tasks data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></tasks></md-content></md-tab><md-tab ng-if="vm.isAdmin"><md-tab-label><span class="has-notes" ng-show="hasNotes > 0">Notas ({{hasNotes}}) </span><span ng-hide="hasNotes > 0">Notas</span></md-tab-label><md-tab-body class="md-padding"><notes data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></notes></md-tab-body></md-tab></md-tabs></md-content><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\n    <div class="node-item" >\n      <md-button class="md-icon-button" aria-label="Collapse tree"  ng-if="node.nodes && node.nodes.length > 0" data-nodrag ng-click="toggle(this)">\n        <md-icon ng-if="!collapsed">keyboard_arrow_down</md-icon>\n        <md-icon ng-if="collapsed">keyboard_arrow_right</md-icon>\n      </md-button>\n      <md-icon ng-if="node.type==\'D\'" class="document-icon">description</md-icon>\n      <div class="step-description" ng-class="{\'step-description-margin\': !node.nodes || node.nodes.length <= 0}">\n          <div class="title" ng-class="{\'step-title\': node.level == 0, \'step-1-title\': node.level == 1, \'step-2-title\': node.level == 2 , \'step-3-title\': node.level == 3}" ng-show="node.type != \'D\'">{{node.title}} <span ng-if="node.status">( {{node.status}} )</span></div>\n          <div class="title" ng-show="node.type == \'D\'" >{{node.title}}</div>\n          <div class="period" ng-show="node.date">\n              <span ng-if="node.dateLabel">{{node.dateLabel}}</span> {{node.date}}\n              <div ng-show="node.date2"><span ng-if="node.date2Label">{{node.date2Label}}</span>{{node.date2}}</div>\n          </div>\n      </div>\n    </div>\n    <div ng-if="node.type != \'D\'">\n      <md-button aria-label="Editar fase" title="Editar fase"\n                 class="md-icon-button" ng-disabled="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.edit_gstep(node.id, node.nodes.length > 0)">\n          <md-tooltip md-direction="left">Editar fase</md-tooltip>\n          <md-icon aria-label="Editar fase">mode_edit</md-icon>\n      </md-button>\n      <md-button aria-label="Nueva actuaci\xF3n" title="Nueva actuaci\xF3n"\n                 class="md-icon-button" ng-disabled="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.openNewStepForm(node.id)">\n          <md-tooltip md-direction="left">A\xF1adir nueva fase</md-tooltip>\n          <md-icon aria-label="Nueva actuaci\xF3n">add_circle</md-icon>\n      </md-button>\n      <md-button aria-label="A\xF1adir documento" title="A\xF1adir documento"\n                 data-nodrag\n                 ng-click="vm.new_document(node.id)"\n                 ng-disabled="!vm.isAdmin"\n                 ng-show="node.documents"\n                 class="md-icon-button">\n          <md-tooltip md-direction="left">A\xF1adir un nuevo documento</md-tooltip>\n          <md-icon aria-label="A\xF1adir documento">note_add</md-icon>\n      </md-button>\n    </div>\n    <div ng-if="node.type == \'D\'">\n        <md-button aria-label="Editar documento" title="Editar documento"\n            ng-click="vm.edit_document(node.id)"\n            ng-hide="!vm.isAdmin"\n            class="md-icon-button">\n            <md-icon aria-label="Editar documento">mode_edit</md-icon>\n        </md-button>\n        <md-button aria-label="Descargar documento" title="Descargar documento"\n            ng-click="vm.download_file(node.id, \'file\')"\n            class="md-icon-button">\n            <md-icon aria-label="Descargar documento">cloud_download</md-icon>\n        </md-button>\n    </div> \n  </div>\n  <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\n    <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\n  </ol></script><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/g-file-mercantil/g-file-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="g-file-mercantil"><md-icon>undo</md-icon></md-button><span>Nuevo expediente de Jurisdicci\xF3n Mercantil</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.gFile.code"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-model="vm.gFile.processType" ng-model-options="{trackBy: \'$value.id\'  }" required><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.notificationDate" for="notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.gFile.notificationDate"><div ng-messages="editForm.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.presentationDate" for="presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.gFile.presentationDate"><div ng-messages="editForm.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.gFile.client" required><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.gFile.lawyer"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.gFile.applicantName" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" validate-ni-es ng-model="vm.gFile.applicantNif" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" phone-number ng-model="vm.gFile.applicantPhone"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-model="vm.gFile.procuratorApplicantName"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" id="field_procuratorApplicantPhone" phone-number ng-model="vm.gFile.procuratorApplicantPhone"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.gFile.defendantName" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" validate-ni-es ng-model="vm.gFile.defendantNif" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" phone-number ng-model="vm.gFile.defendantPhone"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-model="vm.gFile.procuratorDefendantName"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" phone-number ng-model="vm.gFile.procuratorDefendantPhone"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.gFile.court" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.gFile.topic" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/g-file-mercantil/g-files.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">description</md-icon></md-button><span>Expedientes de jurisdicci\xF3n mercantil</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="g-file-mercantil.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo expediente</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="25"><label for="field_code">N\xBA procedimiento</label><input type="string" name="code" id="field_code" ng-model="vm.searchItem.code"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_client">Cliente</label><input type="string" name="client" id="field_client" ng-model="vm.searchItem.client"></md-input-container><md-input-container class="md-block" flex="20"><label for="status">Estado</label><md-select id="status" name="status" ng-model="vm.searchItem.status" ng-model-options="{trackBy: \'$value.id\' }"><md-option ng-value="">Todos</md-option><md-option ng-value="status" ng-repeat="status in vm.status ">{{ status.name }}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><!--          <md-input-container class="md-block" flex>\n                          <label for="step">Fase</label>\n                          <md-select id="step" name="step" ng-model="vm.searchItem.step" ng-model-options="{trackBy: \'$value.id\' }">\n                              <md-option ng-value="step" ng-repeat="step in vm.steps ">{{ step.title }}</md-option>\n                          </md-select>\n                          <div class="md-errors-spacer"></div>\n                      </md-input-container>\n                      <md-input-container class="md-block" flex>\n                          <label for="startDate">Fecha de inicio</label>\n                          <input type="date" name="startDate" id="startDate" ng-model="vm.searchItem.startDate">\n                      </md-input-container>\n                      <md-input-container class="md-block" flex>\n                          <label for="endDate">Fecha de fin</label>\n                          <input type="date" name="endDate" id="endDate" ng-model="vm.searchItem.endDate">\n                      </md-input-container> --><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>N\xBA procedimiento</span></th><th><span>Procedimiento</span></th><th><span>Cliente</span></th><th><span>Estado</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="gFile in vm.gFiles track by gFile.gFileId" ui-sref="g-file-mercantil.edit({id:gFile.gFileId})"><td>{{gFile.code}}</td><td><div class="table-details"><div class="title">{{gFile.processType.description}} <span ng-if="gFile.court">en el juzgado/tribunal {{gFile.court}}</span><span ng-if="gFile.procuratorDefendant">, procurador del demandado {{gFile.procuratorDefendant}}</span> <span ng-if="gFile.procuratorApplicant">y procurador del demandante {{gFile.procuratorApplicant}}</span></div><div class="detail"><span ng-if="gFile.lawyer">Letrado {{gFile.lawyer}}</span> <span ng-if="gFile.step">en fase de {{gFile.step}}</span></div></div></td><td ng-if="gFile.client.name === \'APPLICANT\'"><div class="table-details"><div class="title">{{gFile.applicant}}</div><div class="detail">{{gFile.applicantNif}} (Demandante)</div></div></td><td ng-if="gFile.client.name === \'DEFENDANT\'"><div class="table-details"><div class="title">{{gFile.defendant}}</div><div class="detail">{{gFile.defendantNif}} (Demandado)</div></div></td><td ng-if="gFile.status === \'Abierto\'"><div class="column-center"><md-icon>lock_open</md-icon></div></td><td ng-if="gFile.status === \'Cerrado\'"><div class="column-center"><md-icon>lock</md-icon></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="searchForm.$invalid || vm.gFiles.length === 0"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/g-file-penal/g-file-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="g-file-penal"><md-icon>undo</md-icon></md-button><span>Expediente de Jurisdicci\xF3n Penal {{vm.gFile.code}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-tabs md-dynamic-height="" md-border-bottom="" class="md-default-theme content-detail"><md-tab label="Datos generales"><md-content class="md-padding"><md-card flex><md-card-content><div class="md-inline-form"><form name="editForm" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.gFile.code" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-model="vm.gFile.processType" ng-model-options="{trackBy: \'$value.id\'  }" required ng-disabled="!vm.isAdmin" s><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_status">Estado</label><md-select id="field_status" name="status" ng-model="vm.gFile.status" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="status" ng-repeat="status in vm.status">{{ status.name }}</md-option></md-select></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.notificationDate" for="field_notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.gFile.notificationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.presentationDate" for="field_presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.gFile.presentationDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.gFile.client" required ng-model-options="{trackBy: \'$value.name\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.gFile.lawyer" ng-model-options="{trackBy: \'$value.id\' }" ng-disabled="!vm.isAdmin"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.gFile.applicantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" validate-ni-es ng-model="vm.gFile.applicantNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" ng-model="vm.gFile.applicantPhone" phone-number ng-disabled="!vm.isAdmin"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-model="vm.gFile.procuratorApplicantName" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" id="field_procuratorApplicantPhone" phone-number ng-model="vm.gFile.procuratorApplicantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.gFile.defendantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" validate-ni-es ng-model="vm.gFile.defendantNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" phone-number ng-model="vm.gFile.defendantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-model="vm.gFile.procuratorDefendantName" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" phone-number ng-model="vm.gFile.procuratorDefendantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.gFile.court" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.gFile.topic" columns="1" md-maxlength="1000" rows="3" ng-disabled="!vm.isAdmin"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right" has-authority="ROLE_ADMIN"><md-button type="submit" ng-disabled="editForm.$invalid" class="md-raised md-primary" title="Actualizar expediente" aria-label="Actualizar expediente">Guardar</md-button></section></form></div></md-card-content></md-card></md-content></md-tab><md-tab label="Fases"><md-content class="md-padding"><div layout="row" layout-wrap ng-hide="vm.newstepform === true || vm.editstepform === true  || vm.newstepactionform === true || vm.editstepactionform === true || vm.newdocumentform === true || vm.editdocumentform === true || vm.newstepactionactionform === true || vm.editstepactionactionform === true"><md-card flex><md-card-content><div layout="row" layout-align="end center" flex="100" ng-if="vm.isAdmin"><md-button ng-click="vm.openNewStepForm(null)" class="md-primary add-phase">A\xF1adir fase</md-button></div><div ui-tree id="tree-root" ng-if="vm.nodes.length > 0" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.nodes"><li ng-repeat="node in vm.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></md-card-content></md-card></div><new-gfile-step ng-show="vm.newstepform === true" data-stepparent="vm.stepParent" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-newstepform="vm.newstepform"></new-gfile-step><edit-gfile-step ng-show="vm.editstepform === true" data-updatetree="vm.updatetree" data-gfilestep="vm.gfilestep" data-isdeletedstep="vm.isdeletedstep" data-editstepform="vm.editstepform"></edit-gfile-step><new-document ng-show="vm.newdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform" data-newdocumentform="vm.newdocumentform"></new-document><edit-document ng-show="vm.editdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform"></edit-document></md-content></md-tab><md-tab label="Tareas" ng-if="vm.isAdmin"><md-content class="md-padding"><tasks data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></tasks></md-content></md-tab><md-tab ng-if="vm.isAdmin"><md-tab-label><span class="has-notes" ng-show="hasNotes > 0">Notas ({{hasNotes}}) </span><span ng-hide="hasNotes > 0">Notas</span></md-tab-label><md-tab-body class="md-padding"><notes data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></notes></md-tab-body></md-tab></md-tabs></md-content><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\n    <div class="node-item" >\n      <md-button class="md-icon-button" aria-label="Collapse tree"  ng-if="node.nodes && node.nodes.length > 0" data-nodrag ng-click="toggle(this)">\n        <md-icon ng-if="!collapsed">keyboard_arrow_down</md-icon>\n        <md-icon ng-if="collapsed">keyboard_arrow_right</md-icon>\n      </md-button>\n      <md-icon ng-if="node.type==\'D\'" class="document-icon">description</md-icon>\n      <div class="step-description" ng-class="{\'step-description-margin\': !node.nodes || node.nodes.length <= 0}">\n          <div class="title" ng-class="{\'step-title\': node.level == 0, \'step-1-title\': node.level == 1, \'step-2-title\': node.level == 2 , \'step-3-title\': node.level == 3}" ng-show="node.type != \'D\'">{{node.title}} <span ng-if="node.status">( {{node.status}} )</span></div>\n          <div class="title" ng-show="node.type == \'D\'" >{{node.title}}</div>\n          <div class="period" ng-show="node.date">\n              <span ng-if="node.dateLabel">{{node.dateLabel}}</span> {{node.date}}\n              <div ng-show="node.date2"><span ng-if="node.date2Label">{{node.date2Label}}</span>{{node.date2}}</div>\n          </div>\n      </div>\n    </div>\n    <div ng-if="node.type != \'D\'">\n      <md-button aria-label="Editar fase" title="Editar fase"\n                 class="md-icon-button" ng-disabled="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.edit_gstep(node.id, node.nodes.length > 0)">\n          <md-tooltip md-direction="left">Editar fase</md-tooltip>\n          <md-icon aria-label="Editar fase">mode_edit</md-icon>\n      </md-button>\n      <md-button aria-label="Nueva actuaci\xF3n" title="Nueva actuaci\xF3n"\n                 class="md-icon-button" ng-disabled="!vm.isAdmin"\n                 data-nodrag\n                 ng-click="vm.openNewStepForm(node.id)">\n          <md-tooltip md-direction="left">A\xF1adir nueva fase</md-tooltip>\n          <md-icon aria-label="Nueva actuaci\xF3n">add_circle</md-icon>\n      </md-button>\n      <md-button aria-label="A\xF1adir documento" title="A\xF1adir documento"\n                 data-nodrag\n                 ng-click="vm.new_document(node.id)"\n                 ng-disabled="!vm.isAdmin"\n                 ng-show="node.documents"\n                 class="md-icon-button">\n          <md-tooltip md-direction="left">A\xF1adir un nuevo documento</md-tooltip>\n          <md-icon aria-label="A\xF1adir documento">note_add</md-icon>\n      </md-button>\n    </div>\n    <div ng-if="node.type == \'D\'">\n        <md-button aria-label="Editar documento" title="Editar documento"\n            ng-click="vm.edit_document(node.id)"\n            ng-hide="!vm.isAdmin"\n            class="md-icon-button">\n            <md-icon aria-label="Editar documento">mode_edit</md-icon>\n        </md-button>\n        <md-button aria-label="Descargar documento" title="Descargar documento"\n            ng-click="vm.download_file(node.id, \'file\')"\n            class="md-icon-button">\n            <md-icon aria-label="Descargar documento">cloud_download</md-icon>\n        </md-button>\n    </div> \n  </div>\n  <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\n    <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\n  </ol></script><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/g-file-penal/g-file-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="g-file-penal"><md-icon>undo</md-icon></md-button><span>Nuevo expediente de Jurisdicci\xF3n Penal</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.code" for="field_code">N\xBA procedimiento</label><input type="text" name="code" id="field_code" ng-model="vm.gFile.code"><div ng-messages="editForm.code.$error"></div></md-input-container><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.gFile.processType" for="field_processType">Tipo de procedimiento</label><md-select id="field_processType" name="processType" ng-model="vm.gFile.processType" ng-model-options="{trackBy: \'$value.id\'  }" required><md-option ng-value="processType" ng-repeat="processType in vm.processtypes">{{ processType.description }}</md-option></md-select><div ng-messages="editForm.processType.$error"><div ng-message="required">El tipo de procedimiento es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.notificationDate" for="notificationDate">Fecha de notificaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="notificationDate" id="field_notificationDate" ng-model="vm.gFile.notificationDate"><div ng-messages="editForm.notificationDate.$error"><div ng-message="required">La fecha de notificaci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.gFile.presentationDate" for="presentationDate">Fecha de presentaci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="presentationDate" id="field_presentationDate" ng-model="vm.gFile.presentationDate"><div ng-messages="editForm.presentationDate.$error"><div ng-message="required">La fecha de presentaci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.client" for="field_client">Cliente</label><md-select id="field_client" name="client" ng-model="vm.gFile.client" required><md-option ng-value="client" ng-repeat="client in vm.clients">{{ client.description }}</md-option></md-select><div ng-messages="editForm.client.$error"><div ng-message="required">El cliente es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.lawyer" for="field_lawyer">Letrado</label><md-select id="field_lawyer" name="lawyer" ng-model="vm.gFile.lawyer"><md-option ng-value="lawyer" ng-repeat="lawyer in vm.lawyers">{{ lawyer.firstName }} {{lawyer.lastName}}</md-option></md-select><div ng-messages="editForm.lawyer.$error"><div ng-message="required">El Letrado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.gFile.applicantName" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El demandante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" validate-ni-es ng-model="vm.gFile.applicantNif" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El documento del demandante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" phone-number ng-model="vm.gFile.applicantPhone"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorApplicantName">Procurador</label><input name="procuratorApplicantName" id="field_procuratorApplicantName" ng-model="vm.gFile.procuratorApplicantName"><div ng-messages="editForm.procuratorApplicantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorApplicantPhone" for="field_procuratorApplicantPhone">Tel\xE9fono</label><input name="procuratorApplicantPhone" id="field_procuratorApplicantPhone" phone-number ng-model="vm.gFile.procuratorApplicantPhone"><div ng-messages="editForm.procuratorApplicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Demandado</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.defendantName" for="field_defendantName">Nombre y apellidos</label><input name="defendantName" id="field_defendantName" ng-model="vm.gFile.defendantName" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El demandado es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.defendantNif" for="field_defendantNif">NIF</label><input name="defendantNif" id="field_defendantNif" validate-ni-es ng-model="vm.gFile.defendantNif" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El documento del demandado es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.defendantPhone" for="field_defendantPhone">Tel\xE9fono</label><input name="defendantPhone" id="field_defendantPhone" phone-number ng-model="vm.gFile.defendantPhone"><div ng-messages="editForm.defendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.gFile.procuratorName" for="field_procuratorDefendantName">Procurador</label><input name="procuratorDefendantName" id="field_procuratorDefendantName" ng-model="vm.gFile.procuratorDefendantName"><div ng-messages="editForm.procuratorDefendantName.$error"><div ng-message="required">El nombre y apellidos del procurador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.gFile.procuratorDefendantPhone" for="field_procuratorDefendantPhone">Tel\xE9fono</label><input name="procuratorDefendantPhone" id="field_procuratorDefendantPhone" phone-number ng-model="vm.gFile.procuratorDefendantPhone"><div ng-messages="editForm.procuratorDefendantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.court" for="field_court">Juzgado / Tribunal</label><input name="court" id="field_court" ng-model="vm.gFile.court" required><div ng-messages="editForm.court.$error"><div ng-message="required">El juzgado es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Asunto</label><textarea ng-model="vm.gFile.topic" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/g-file-penal/g-files.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">description</md-icon></md-button><span>Expedientes de Jurisdicci\xF3n Penal</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="g-file-penal.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo expediente</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="25"><label for="field_code">N\xBA procedimiento</label><input type="string" name="code" id="field_code" ng-model="vm.searchItem.code"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_client">Cliente</label><input type="string" name="client" id="field_client" ng-model="vm.searchItem.client"></md-input-container><md-input-container class="md-block" flex="20"><label for="status">Estado</label><md-select id="status" name="status" ng-model="vm.searchItem.status" ng-model-options="{trackBy: \'$value.id\' }"><md-option ng-value="">Todos</md-option><md-option ng-value="status" ng-repeat="status in vm.status ">{{ status.name }}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><!--          <md-input-container class="md-block" flex>\n                          <label for="step">Fase</label>\n                          <md-select id="step" name="step" ng-model="vm.searchItem.step" ng-model-options="{trackBy: \'$value.id\' }">\n                              <md-option ng-value="step" ng-repeat="step in vm.steps ">{{ step.title }}</md-option>\n                          </md-select>\n                          <div class="md-errors-spacer"></div>\n                      </md-input-container>\n                      <md-input-container class="md-block" flex>\n                          <label for="startDate">Fecha de inicio</label>\n                          <input type="date" name="startDate" id="startDate" ng-model="vm.searchItem.startDate">\n                      </md-input-container>\n                      <md-input-container class="md-block" flex>\n                          <label for="endDate">Fecha de fin</label>\n                          <input type="date" name="endDate" id="endDate" ng-model="vm.searchItem.endDate">\n                      </md-input-container> --><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>N\xBA procedimiento</span></th><th><span>Procedimiento</span></th><th><span>Cliente</span></th><th><span>Estado</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="gFile in vm.gFiles track by gFile.gFileId" ui-sref="g-file-penal.edit({id:gFile.gFileId})"><td>{{gFile.code}}</td><td><div class="table-details"><div class="title">{{gFile.processType.description}} <span ng-if="gFile.court">en el juzgado/tribunal {{gFile.court}}</span><span ng-if="gFile.procuratorDefendant">, procurador del demandado {{gFile.procuratorDefendant}}</span> <span ng-if="gFile.procuratorApplicant">y procurador del demandante {{gFile.procuratorApplicant}}</span></div><div class="detail"><span ng-if="gFile.lawyer">Letrado {{gFile.lawyer}}</span> <span ng-if="gFile.step">en fase de {{gFile.step}}</span></div></div></td><td ng-if="gFile.client.name === \'APPLICANT\'"><div class="table-details"><div class="title">{{gFile.applicant}}</div><div class="detail">{{gFile.applicantNif}} (Demandante)</div></div></td><td ng-if="gFile.client.name === \'DEFENDANT\'"><div class="table-details"><div class="title">{{gFile.defendant}}</div><div class="detail">{{gFile.defendantNif}} (Demandado)</div></div></td><td ng-if="gFile.status === \'Abierto\'"><div class="column-center"><md-icon>lock_open</md-icon></div></td><td ng-if="gFile.status === \'Cerrado\'"><div class="column-center"><md-icon>lock</md-icon></div></td><!--                        <td class="hidden-sm hidden-xs">{{gFile.hasNotes}}</td> --></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="searchForm.$invalid || vm.gFiles.length === 0"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/g-file-step/edit-g-file-step-component.html','<md-card><md-card-title><md-card-title-text><span class="md-headline">Editar fase</span></md-card-title-text></md-card-title><md-card-content><div class="md-inline-form"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label for="field_step">Nombre</label><input id="field_step" name="id" value="{{$ctrl.gfilestep.step.name}}" disabled="disabled"></md-input-container></div><div layout="row" ng-if="$ctrl.gfilestep.step.amount_label == \'Cuant\xEDa\'"><md-input-container class="md-block" flex="33"><label for="amount">{{$ctrl.gfilestep.step.amount_label}}</label><input type="number" id="amount" name="amount" ng-model="$ctrl.gfilestep.amount"></md-input-container></div><div layout="row" ng-if="$ctrl.gfilestep.step.amount_label == \'Donativo\'"><md-input-container class="md-block" flex="20"><label for="amount">Cuant\xEDa en especie (valoraci\xF3n en EUR)</label><input type="number" id="amount_kind" name="amountKind" ng-model="$ctrl.gfilestep.amountKind"></md-input-container><md-input-container class="md-block" flex="20"><label for="amount">Cuant\xEDa en met\xE1lico (cantidad en EUR)</label><input type="number" id="amount_cash" name="amountCash" ng-model="$ctrl.gfilestep.amountCash"></md-input-container></div><div layout="row" ng-if="$ctrl.gfilestep.step.date_label"><md-input-container class="md-block" flex="33"><label for="startdate">{{$ctrl.gfilestep.step.date_label}}</label><md-icon>date_range</md-icon><input type="date" id="date" name="date" ng-model="$ctrl.gfilestep.date"></md-input-container><md-input-container class="md-block" flex="33" ng-if="$ctrl.gfilestep.step.date_2_label"><label for="startdate">{{$ctrl.gfilestep.step.date_2_label}}</label><md-icon>date_range</md-icon><input type="date" id="date" name="date" ng-model="$ctrl.gfilestep.date2"></md-input-container></div><div layout="row" ng-if="$ctrl.gfilestep.step.status"><md-input-container class="md-block" flex="33"><label for="field_status">Estado</label><md-select id="field_status" name="status" ng-model="$ctrl.gfilestep.status" ng-model-options="{trackBy: \'$value.id\' }"><md-option ng-value="status" ng-repeat="status in $ctrl.status">{{ status.description }}</md-option></md-select></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="$ctrl.gfilestep.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button type="button" class="md-raised" ng-click="$ctrl.close()">Cancelar</md-button><div data-confirm-delete data-on-confirm="$ctrl.remove_gstep()" ng-hide="$ctrl.isdeletedstep"></div><md-button type="submit" ng-disabled="editForm.$invalid || $ctrl.isSaving || $ctrl.gfilestep.step === undefined || $ctrl.gfilestep.step === null" class="md-raised md-primary">Guardar</md-button></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/g-file-step/new-g-file-step-component.html','<md-card><md-card-title><md-card-title-text><span class="md-headline">Nueva fase</span></md-card-title-text></md-card-title><md-card-content><div class="md-inline-form"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div layout="row"><md-input-container class="md-block" flex="40"><label for="field_step">Nombre</label><md-select id="field_step" name="step" ng-model="$ctrl.gfilestep.step" required><md-option ng-value="step" ng-repeat="step in $ctrl.steps">{{ step.name }}</md-option></md-select><div class="md-errors-spacer"></div><div ng-messages="editForm.step.$error"><div ng-message="required">El nombre de la fase es obligatorio</div></div></md-input-container></div><div layout="row" ng-if="$ctrl.gfilestep.step.amount_label == \'Cuant\xEDa\'"><md-input-container class="md-block" flex="33"><label for="amount">{{$ctrl.gfilestep.step.amount_label}}</label><input type="number" id="amount" name="amount" ng-model="$ctrl.gfilestep.amount"></md-input-container></div><div layout="row" ng-if="$ctrl.gfilestep.step.amount_label == \'Donativo\'"><md-input-container class="md-block" flex="20"><label for="amount">Cuant\xEDa en especie (valoraci\xF3n en EUR)</label><input type="number" id="amount_kind" name="amountKind" ng-model="$ctrl.gfilestep.amountKind"></md-input-container><md-input-container class="md-block" flex="20"><label for="amount">Cuant\xEDa en met\xE1lico (cantidad en EUR)</label><input type="number" id="amount_cash" name="amountCash" ng-model="$ctrl.gfilestep.amountCash"></md-input-container></div><div layout="row" ng-if="$ctrl.gfilestep.step.date_label"><md-input-container class="md-block" flex="33"><label for="date">{{$ctrl.gfilestep.step.date_label}}</label><md-icon>date_range</md-icon><input type="date" id="date" name="date" ng-model="$ctrl.gfilestep.date"></md-input-container><md-input-container class="md-block" flex="33" ng-if="$ctrl.gfilestep.step.date_2_label"><label for="date2">{{$ctrl.gfilestep.step.date_2_label}}</label><md-icon>date_range</md-icon><input type="date" id="date2" name="date" ng-model="$ctrl.gfilestep.date2"></md-input-container></div><div layout="row" ng-if="$ctrl.gfilestep.step.status"><md-input-container class="md-block" flex="33"><label for="field_status">Estado</label><md-select id="field_status" name="status" ng-model="$ctrl.gfilestep.status"><md-option ng-value="status" ng-repeat="status in $ctrl.status">{{ status.description }}</md-option></md-select></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="$ctrl.gfilestep.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="$ctrl.close()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || $ctrl.isSaving || $ctrl.gfilestep.step === undefined || $ctrl.gfilestep.step === null" class="md-raised md-primary" title="Crear nueva fase" aria-label="Crear nueva fase">Grabar</md-button></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/observation/edit-observation-component.html','<md-card class="md-whiteframe-2dp"><md-card-content><div class="md-inline-form notes" click-outside="$ctrl.onCancel()" outside-if-not="md-calendar-date-selection-indicator, md-calendar-month-label"><form name="noteForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.onUpdate()" show-validation><div layout="row"><textarea name="description" id="description" ng-model="$ctrl.editObservation.description" placeholder="Toma nota..." required></textarea></div><section layout="row" layout-sm="column" layout-align="end right"><div><md-button type="submit" ng-disabled="noteForm.$invalid || $ctrl.isSaving" title="A\xF1adir una nota" aria-label="A\xF1adir una nota">Actualizar</md-button><md-button class="md-warn" title="Borrar" aria-label="Borrar" ng-click="$ctrl.delete()">Borrar</md-button></div></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/observation/new-observation-component.html','<md-card class="md-whiteframe-2dp"><md-card-content><div class="new-note-button" ng-show="!$ctrl.onNew" ng-click="$ctrl.initNew()"><span>Toma nota...</span></div><div class="md-inline-form notes" ng-show="$ctrl.onNew" click-outside="$ctrl.onCancel()" outside-if-not="md-calendar-date-selection-indicator, md-calendar-month-label"><form name="noteForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.onSave()" show-validation><div layout="row"><textarea name="description" id="description" ng-model="$ctrl.newObservation.description" placeholder="Toma nota..." required></textarea></div><section layout="row" layout-sm="column" layout-align="end right"><div><md-button type="submit" ng-disabled="noteForm.$invalid || $ctrl.isSaving" title="A\xF1adir una nota" aria-label="A\xF1adir una nota">A\xF1adir</md-button></div></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/observation/observations-component.html','<md-content class="notes"><new-note save="$ctrl.newSave()" ng-hide="$ctrl.onEdit" on-new="$ctrl.onNew" cancel="$ctrl.newCancel()" entitytype="$ctrl.entitytype" entityid="$ctrl.entityid" new-observation="$ctrl.newObservation"></new-note><edit-note delete="$ctrl.editDelete()" cancel="$ctrl.editCancel()" update="$ctrl.editUpdate()" edit-observation="$ctrl.editObservation" ng-show="$ctrl.onEdit"></edit-note><div layout="row" layout-xs="column" layout-align="center center"><div flex="80"><md-grid-list md-cols="1" md-cols-sm="2" md-cols-md="3" md-cols-gt-md="6" md-row-height-gt-md="1:1" md-row-height="4:3" md-gutter="8px" md-gutter-gt-sm="4px"><md-grid-tile ng-repeat="note in $ctrl.notes" ng-class="note.background" ng-click="$ctrl.editNote(note.id)"><span class="text">{{note.description}}</span><md-grid-tile-footer></md-grid-tile-footer></md-grid-tile></md-grid-list></div></div></md-content>');
$templateCache.put('app/entities/step/edit-step-component.html','<md-card><md-card-title><md-card-title-text><span class="md-headline">Editar fase</span></md-card-title-text></md-card-title><md-card-content><div class="md-inline-form"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div layout="row" ng-show="$ctrl.stepparent != null"><md-input-container class="md-block" flex="40"><label for="field_stepparent">Nodo padre</label><input type="text" name="name" id="field_stepparent" ng-model="$ctrl.stepparent.name" disabled="disabled"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="40"><label for="field_name">Nombre</label><input type="text" name="name" id="field_name" ng-model="$ctrl.step.name" ng-minlength="5" required><div class="md-errors-spacer"></div><div ng-messages="editForm.name.$error"><div ng-message="required">El nombre de la fase es obligatorio</div><div ng-message="minlength">La nombre de la fase debe tener al menos 5 caracteres</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_sorder">Orden</label><input type="number" name="sorder" id="field_sorder" ng-model="$ctrl.step.sorder" min="0" required><div ng-messages="editForm.sorder.$error"><div ng-message="required">El orden de la fase es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label for="field_Date_label">Etiqueta para fecha 1</label><input type="text" id="field_Date_label" name="date_label" ng-model="$ctrl.step.date_label"></md-input-container><md-input-container class="md-block" flex="30"><label for="field_Date_2_label">Etiqueta para fecha 2</label><input type="text" id="field_Date_2_label" name="date_2_label" ng-model="$ctrl.step.date_2_label"></md-input-container></div><div layout="row"><md-input-container flex="30"><md-switch ng-model="$ctrl.step.documents" class="active">Admite subida de documentos</md-switch></md-input-container></div><div layout="row"><md-input-container flex="30"><md-switch ng-model="$ctrl.step.status" class="active">Admite estados</md-switch></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Estados</span></div><div layout="row" ng-show="$ctrl.step.status"><md-input-container flex="30"><label for="field_newStatus">A\xF1adir nuevo estado</label><input type="text" name="newStatus" id="field_newStatus" ng-model="$ctrl.status"></md-input-container><md-input-container flex="20"><md-button ng-click="$ctrl.save_status()" class="md-primary md-fab md-mini"><md-icon class="icon-theme">add</md-icon></md-button></md-input-container></div><div layout="row" ng-show="$ctrl.step.status"><table class="table" flex="40"><thead><tr><th class="text-left">Estados dispobibles</th><th></th></tr></thead><tbody><tr ng-repeat="status in $ctrl.stepStatus"><td>{{status.description}}</td><td><div class="text-right"><md-button ng-click="$ctrl.delete_status(status.id)" class="md-icon-button"><md-tooltip md-direction="left">Borrar estado</md-tooltip><md-icon class="icon-theme">delete</md-icon></md-button></div></td></tr></tbody></table></div></div><section layout="row" layout-sm="column" layout-align="end right"><md-button type="button" class="md-raised" ng-click="$ctrl.close()">Cancelar</md-button><div data-confirm-delete data-on-confirm="$ctrl.remove_step()" ng-hide="$ctrl.isdeletedstep"></div><md-button type="submit" ng-disabled="editForm.$invalid || $ctrl.isSaving" class="md-raised md-primary">Guardar</md-button></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/step/new-step-component.html','<md-card><md-card-title><md-card-title-text><span class="md-headline">Nueva fase</span></md-card-title-text></md-card-title><md-card-content><div class="md-inline-form"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div layout="row" ng-show="$ctrl.stepparent != null"><md-input-container class="md-block" flex="40"><label for="field_stepparent">Nodo padre</label><input type="text" name="name" id="field_stepparent" ng-model="$ctrl.stepparent.name" disabled="disabled"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="40"><label for="field_name">Nombre</label><input type="text" name="name" id="field_name" ng-model="$ctrl.step.name" ng-minlength="5" required><div class="md-errors-spacer"></div><div ng-messages="editForm.name.$error"><div ng-message="required">El nombre de la fase es obligatorio</div><div ng-message="minlength">La nombre de la fase debe tener al menos 5 caracteres</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_sorder">Orden</label><input type="number" name="sorder" id="field_sorder" ng-model="$ctrl.step.sorder" min="0" required><div ng-messages="editForm.sorder.$error"><div ng-message="required">El orden de la fase es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label for="field_Date_label">Etiqueta para fecha 1</label><input type="text" id="field_Date_label" name="date_label" ng-model="$ctrl.step.date_label"></md-input-container><md-input-container class="md-block" flex="30"><label for="field_Date_2_label">Etiqueta para fecha 2</label><input type="text" id="field_Date_2_label" name="date_2_label" ng-model="$ctrl.step.date_2_label"></md-input-container></div><div layout="row"><md-input-container flex="30"><md-switch ng-model="$ctrl.step.documents" class="active">Admite subida de documentos</md-switch></md-input-container></div><div layout="row"><md-input-container flex="30"><md-switch ng-model="$ctrl.step.status" class="active">Admite estados</md-switch></md-input-container></div><div layout="row"><md-input-container flex="30" ng-show="$ctrl.step.status"><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Estados</th></tr></thead><tbody><tr ng-repeat="status in vm.status"><td>{{status}}</td></tr></tbody></table></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="$ctrl.close()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || $ctrl.isSaving || $ctrl.step === undefined || $ctrl.step === null" class="md-raised md-primary" title="Crear nueva fase" aria-label="Crear nueva fase">Grabar</md-button></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/step/steps.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">view_list</md-icon></md-button><span>Fases de expediente</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="20"><label for="jurisdiction">Jurisdicci\xF3n</label><md-select id="jurisdiction" name="status" ng-model="vm.searchItem.jurisdiction" ng-change="vm.changeJurisdiction()" ng-disabled="vm.newstepform || vm.editstepform || vm.newstepactionform || vm.editstepactionform || vm.newdocumentform || vm.editdocumentform || vm.newstepactionactionform === true || vm.editstepactionactionform"><md-option ng-value="jurisdiction" ng-repeat="jurisdiction in vm.jurisdictions ">{{jurisdiction}}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container></div><div layout="row" layout-wrap ng-hide="vm.newstepform || vm.editstepform || vm.newstepactionform || vm.editstepactionform || vm.newdocumentform || vm.editdocumentform || vm.newstepactionactionform === true || vm.editstepactionactionform"><md-card flex><md-card-content><div layout="row" layout-align="end center" flex="100"><md-button ng-click="vm.openNewStepForm(null)" class="md-primary add-phase">A\xF1adir fase</md-button></div><div ui-tree id="tree-root" ng-if="vm.nodes.length > 0" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.nodes"><li ng-repeat="node in vm.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></md-card-content></md-card></div><new-step ng-show="vm.newstepform" data-updatetree="vm.updatetree" data-stepparent="vm.stepParent" data-jurisdiction="vm.searchItem.jurisdiction" data-newstepform="vm.newstepform"></new-step><edit-step ng-show="vm.editstepform" data-updatetree="vm.updatetree" data-step="vm.step" data-editstepform="vm.editstepform"></edit-step></md-content><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\n        <div class="node-item">\n            <md-button class="md-icon-button" aria-label="Collapse tree"  ng-if="node.nodes && node.nodes.length > 0" data-nodrag ng-click="toggle(this)">\n                <md-icon ng-if="!collapsed">keyboard_arrow_down</md-icon>\n                <md-icon ng-if="collapsed">keyboard_arrow_right</md-icon>\n            </md-button>\n            <md-icon ng-if="node.type==\'D\'" class="document-icon">description</md-icon>\n            <div class="step-description" ng-class="{\'step-description-margin\': !node.nodes || node.nodes.length <= 0}">\n                <div class="title" ng-class="{\'step-title\': node.level == 0, \'step-1-title\': node.level == 1, \'step-2-title\': node.level == 2 , \'step-3-title\': node.level == 3}">{{node.sorder}}. {{node.title}}</div>\n                <div class="title" ng-show="node.type == \'D\'" >{{node.title}}</div>\n            </div>\n        </div>\n        <div>\n            <md-button aria-label="Editar fase" title="Editar fase" class="md-icon-button" data-nodrag ng-click="vm.editStep(node.id, node.nodes.length > 0)">\n                <md-tooltip md-direction="left">Editar fase</md-tooltip>\n                <md-icon aria-label="Editar fase">mode_edit</md-icon>\n            </md-button>\n\n            <md-button aria-label="Nueva actuaci\xF3n" title="Nueva actuaci\xF3n" class="md-icon-button" data-nodrag ng-click="vm.openNewStepForm(node.id)">\n                <md-tooltip md-direction="left">A\xF1adir nueva fase</md-tooltip>\n                <md-icon aria-label="Nueva actuaci\xF3n">add_circle</md-icon>\n            </md-button>\n        </div>\n    </div>\n    <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\n        <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\n    </ol></script><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/task/edit-task-component.html','<md-card class="md-whiteframe-2dp"><md-card-content><div class="md-inline-form notes" click-outside="$ctrl.onCancel()" outside-if-not="md-calendar-date-selection-indicator, md-calendar-month-label"><form name="taskForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.onUpdate()" show-validation><div layout="row"><textarea name="description" id="description" ng-model="$ctrl.editTask.description" placeholder="Tarea..." required></textarea></div><section layout="row" layout-sm="column" layout-align="space-between center"><div><md-datepicker id="reminderDate" ng-model="$ctrl.editTask.reminderDate" md-placeholder="Recordatorio"></md-datepicker></div><div><md-checkbox ng-model="$ctrl.editTask.done" aria-label="Completed" ng-change="vm.checkTask(task)">HECHO</md-checkbox></div><div layout="row" layout-sm="column" layout-align="end right"><md-button type="submit" ng-disabled="taskForm.$invalid" title="A\xF1adir una tarea" aria-label="A\xF1adir una tarea">Actualizar</md-button><md-button class="md-warn" title="Borrar" aria-label="Borrar" ng-click="$ctrl.delete()">Borrar</md-button></div></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/task/new-task-component.html','<md-card class="md-whiteframe-2dp"><md-card-content><div class="new-task-button" ng-show="!$ctrl.onNew" ng-click="$ctrl.initNew()"><span>Nueva tarea...</span></div><div class="md-inline-form notes" ng-show="$ctrl.onNew" click-outside="$ctrl.onCancel()" outside-if-not="md-calendar-date-selection-indicator, md-calendar-month-label"><form name="taskForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.onSave()" show-validation><div layout="row"><textarea name="description" id="description" ng-model="$ctrl.newTask.description" placeholder="Nueva tarea..." required></textarea></div><section layout="row" layout-sm="column" layout-align="space-between center"><div><md-datepicker id="reminder_date" ng-model="$ctrl.newTask.reminderDate" md-placeholder="Recordatorio"></md-datepicker></div><div><md-button type="submit" ng-disabled="taskForm.$invalid || $ctrl.isSaving" title="A\xF1adir una tarea" aria-label="A\xF1adir una tarea">A\xF1adir</md-button></div></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/task/tasks-component.html','<md-content class="notes"><new-task save="$ctrl.newSave()" ng-hide="$ctrl.onEdit" on-new="$ctrl.onNew" cancel="$ctrl.newCancel()" entitytype="$ctrl.entitytype" entityid="$ctrl.entityid" new-task="$ctrl.newTask"></new-task><edit-task delete="$ctrl.editDelete()" cancel="$ctrl.editCancel()" update="$ctrl.editUpdate()" edit-task="$ctrl.editTask" ng-show="$ctrl.onEdit"></edit-task><div layout="row" layout-xs="column" layout-align="center center"><div flex="80"><md-grid-list md-cols="1" md-cols-sm="2" md-cols-md="3" md-cols-gt-md="6" md-row-height-gt-md="1:1" md-row-height="4:3" md-gutter="8px" md-gutter-gt-sm="4px"><md-grid-tile ng-repeat="task in $ctrl.tasks" ng-class="task.background" md-colspan-sm="1" md-colspan-xs="1" ng-click="$ctrl.modifyTask(task)"><span class="text">{{task.description}}</span><md-grid-tile-footer><div layout="row" layout-align="center center"><div><md-icon class="alarm-icon">access_alarm</md-icon></div><div><span class="text" ng-show="task.reminderDate !== null">{{task.reminderDate}}</span> <span class="text" ng-show="task.reminderDate === null">--</span> <span class="text" ng-show="task.done"><md-icon class="icon">done</md-icon></span></div></div></md-grid-tile-footer></md-grid-tile></md-grid-list></div></div></md-content>');
$templateCache.put('app/entities/task-panel/task-panel.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">assignment</md-icon></md-button><span>Tareas</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><md-toolbar class="panel-task-toolbar"><md-input-container class="md-block select-time" flex="25"><md-select id="untilDate" ng-model="vm.untilDate" ng-change="vm.searchExp()"><md-option ng-value="opt.value" ng-repeat="opt in vm.untilDates">{{ opt.label }}</md-option></md-select></md-input-container></md-toolbar><div class="text-center" ng-show="vm.taskPanel.length == 0"><p class="no-results">No tiene ninguna tarea pendiente</p></div><md-list ng-show="vm.taskPanel.length > 0"><md-list-item class="md-2-line todo-item" ng-repeat="task in vm.taskPanel"><md-checkbox ng-model="task.done" aria-label="Completed" ng-change="vm.checkTask(task)"></md-checkbox><div layout="row" layout-align="start center" flex><div class="md-list-item-text"><div class="title" ng-class="{strike: task.done}" flex>{{task.description}}</div><p ng-class="{strike: task.done}" flex>{{task.entity}}</p><p ng-class="{strike: task.done}" flex>{{task.reminderDate | date:"dd/MM/yyyy"}}</p></div><div layout="row" layout-align="start center"><md-button type="button" class="md-icon-button" ng-if="task.expiredDate" aria-label="Expired"><md-icon class="taskexpired">error</md-icon></md-button></div></div></md-list-item></md-list><div layout="row" layout-align="end center"><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div class="alert alert-danger">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/footer/footer.html','<section layout="row" layout-sm="column" class="footer" data-ng-cloak layout-align="left center"><div flex>SEGUIMIENTO DE EXPEDIENTES v{{VERSION}}</div><div class="text-right" flex>Uriarte & asociados</div></section>');
$templateCache.put('app/layouts/navbar/navbar.html','<md-toolbar class="md-hue-1 md-accent md-whiteframe-1dp"><div class="md-toolbar-tools" flex><md-button class="md-icon-button"><md-icon>business_center</md-icon></md-button><h2 md-truncate="">SEGUIMIENTO DE EXPEDIENTES JUR\xCDDICOS</h2><md-button class="md-icon-button" aria-label="Menu" data-ng-click="vm.toggleSidenav()" hide-gt-md ng-disabled="false"><md-icon>menu</md-icon></md-button><span flex></span><md-menu md-offset="0 +80" class="menu-right"><md-button ng-click="$mdMenu.open()" class="button-menu"><md-icon>account_circle</md-icon>{{vm.account.login}}<md-icon>keyboard_arrow_down</md-icon></md-button><md-menu-content width="2"><md-menu-item><md-button ui-sref="settings"><md-icon md-menu-align-target="">settings</md-icon>Ajustes</md-button></md-menu-item><md-menu-item><md-button ui-sref="password"><md-icon>autorenew</md-icon>Cambiar contrase\xF1a</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click="vm.logout()" id="logout"><md-icon>exit_to_app</md-icon>Cerrar sesi\xF3n</md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar>');
$templateCache.put('app/layouts/sidebar/sidebar.html','<md-sidenav class="md-sidenav-left" md-component-id="left" md-is-locked-open="$mdMedia(\'gt-md\')" md-whiteframe="4"><div class="sidebar-header"><div class="logo-container"><div class="logo"></div><div class="logo-subtitle"></div></div><div class="profile-container"><div class="profile"><div class="avatar"></div><div class="description"><div class="name">{{sb.account.firstName}} {{sb.account.lastName}}</div><div class="title" ng-if="sb.account.authorities[0] === \'ROLE_ADMIN\'"><b>[{{sb.account.login}}]</b> Administrador</div><div class="title" ng-if="sb.account.authorities[0] === \'ROLE_CLIENT\'"><b>[{{sb.account.login}}]</b> Cliente</div><div class="title" ng-if="sb.account.authorities[0] === \'ROLE_CONSORTIUM\'"><b>[{{sb.account.login}}]</b> Consorcio</div><div class="title" ng-if="sb.account.authorities[0] === \'ROLE_JUBILAR\'"><b>[{{sb.account.login}}]</b> Jubilar</div></div></div></div></div><md-sidemenu locked="false" md-theme="alt" md-theme-watch><md-sidemenu-button ui-sref="home" has-any-authority="ROLE_ADMIN, ROLE_CLIENT, ROLE_CONSORTIUM, ROLE_JUBILAR"><md-icon>timeline</md-icon>INDICADORES</md-sidemenu-button><md-sidemenu-button ui-sref="task-panel" has-any-authority="ROLE_ADMIN"><md-icon>assignment</md-icon>TAREAS</md-sidemenu-button><md-sidemenu-content md-icon="extension" md-heading="CONSORCIOS" md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_CONSORTIUM"><md-sidemenu-button ui-sref="consortium-cea">Constituci\xF3n, estat. y actas</md-sidemenu-button><md-sidemenu-content md-heading="EXP.ADMINISTRATIVOS" md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_CONSORTIUM"><md-sidemenu-button class="ml-20" ui-sref="consortium-expediente-expropiaciones">Expropiaciones</md-sidemenu-button><md-sidemenu-content md-heading="EXP. JUR\xCDDICOS" md-arrow="true" class="sub-menu ml-20" has-any-authority="ROLE_ADMIN, ROLE_CONSORTIUM"><md-sidemenu-button class="ml-20" ui-sref="consortium-expediente-juridicos-informes">Informes</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="consortium-expediente-juridicos-judiciales">Exp. Judiciales</md-sidemenu-button></md-sidemenu-content></md-sidemenu-content><md-sidemenu-content md-heading="CONTABILIDAD" md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_CONSORTIUM"><md-sidemenu-button class="ml-20" ui-sref="consortium-contabilidad-recibidas">Facturas recibidas</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="consortium-contabilidad-emitidas">Facturas emitidas</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="consortium-contabilidad-anuales">Cuentas anuales</md-sidemenu-button></md-sidemenu-content><md-sidemenu-button ui-sref="consortium-financiera">Financiera</md-sidemenu-button><md-sidemenu-button ui-sref="consortium-auditoria">Auditor\xEDas</md-sidemenu-button><md-sidemenu-button ui-sref="consortium-contrato">Contratos</md-sidemenu-button><md-sidemenu-content md-heading="TRIBUTOS" md-arrow="true"><md-sidemenu-button class="ml-20" ui-sref="consortium-tributos-ccaa">Abonados a CC.AA.</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="consortium-tributos-eell">Abonados a EE.LL.</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="consortium-tributos-aeat">Declaraciones AEAT</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="consortium-tributos-devolucion">Dev. ingresos indebidos</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="consortium-tributos-revision">Revisi\xF3n sancionadores</md-sidemenu-button></md-sidemenu-content><md-sidemenu-content md-heading="GESTI\xD3N DE PERSONAL" md-arrow="true"><md-sidemenu-button class="ml-20" ui-sref="consortium-personal-nominas">N\xF3minas</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="consortium-personal-seguros">Seguros Sociales</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="consortium-personal-contratos">Contratos</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="consortium-personal-otras">Otras gestiones</md-sidemenu-button></md-sidemenu-content></md-sidemenu-content><md-sidemenu-content md-icon="gavel" md-heading="DEFENSA LETRADA" md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_CLIENT"><md-sidemenu-button ui-sref="g-file-civil">Jurisdicci\xF3n Civil</md-sidemenu-button><md-sidemenu-button ui-sref="g-file-mercantil">Jurisdicci\xF3n Mercantil</md-sidemenu-button><md-sidemenu-button ui-sref="g-file-penal">Jurisdicci\xF3n Penal</md-sidemenu-button><md-sidemenu-button ui-sref="g-file-contencioso">Jur. Contencioso-admin.</md-sidemenu-button><md-sidemenu-button ui-sref="g-file-laboral">Jurisdicci\xF3n Laboral</md-sidemenu-button></md-sidemenu-content><md-sidemenu-content md-icon="forum" md-heading="ASESORAMIENTO" md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_CLIENT"><md-sidemenu-button ui-sref="advices">Consultas</md-sidemenu-button><md-sidemenu-button ui-sref="reports">Informes o dict\xE1menes</md-sidemenu-button></md-sidemenu-content><md-sidemenu-content md-icon="settings" md-heading="MANTENIMIENTO" md-arrow="true" has-authority="ROLE_ADMIN"><md-sidemenu-button ui-sref="step">Fases de expediente</md-sidemenu-button></md-sidemenu-content><md-sidemenu-content md-icon="church" md-heading="A\xD1O LEBANIEGO 2023" md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><!--<md-icon md-svg-icon="../../../content/images/jubilar-cruz.svg" aria-label="Cake"></md-icon>--><md-sidemenu-content md-heading="COMISI\xD3N INTERADMIN." md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-sidemenu-button class="ml-20" ui-sref="lebaniego-comission-annoucement">Convocatoria</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-comission-proceeding">Actas</md-sidemenu-button></md-sidemenu-content><md-sidemenu-content md-heading="DOCUMENTOS DE APOYO" md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-sidemenu-button class="ml-20" ui-sref="lebaniego-documents-manual">Beneficios Fiscales</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-documents-dossier">Dossiers de presentaci\xF3n</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-documents-accion">Acciones</md-sidemenu-button></md-sidemenu-content><md-sidemenu-content md-heading="CONTACTOS" md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-sidemenu-content class="sub-menu ml-20" md-heading="CONTACTOS SECTOR" md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-sidemenu-button class="ml-20" ui-sref="lebaniego-contacts-sector-bac">Alimentario de Cant.</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-contacts-sector-san">Alimentario nacional</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-contacts-sector-sbn">Bebidas nacionales</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-contacts-sector-sfa">Fabricantes de aceite</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-contacts-sector-ed">Empresas de distrib.</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-contacts-sector-os">Otros sectores</md-sidemenu-button></md-sidemenu-content><md-sidemenu-button class="ml-20" ui-sref="lebaniego-contacts-visit">Programaci\xF3n de visitas</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-contacts-meeting">Reuniones mantenidas</md-sidemenu-button></md-sidemenu-content><md-sidemenu-button ui-sref="lebaniego-donor">Donantes</md-sidemenu-button><md-sidemenu-button ui-sref="lebaniego-contributor">Aportantes</md-sidemenu-button><md-sidemenu-button ui-sref="lebaniego-agreement">Convenios de colaboraci\xF3n</md-sidemenu-button><md-sidemenu-content md-heading="CONTROL OPERATIVO" md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-sidemenu-button class="sub-menu ml-20" ui-sref="lebaniego-control-donor">Donantes</md-sidemenu-button><md-sidemenu-button class="sub-menu ml-20" ui-sref="lebaniego-control-contributor">Aportantes</md-sidemenu-button><md-sidemenu-button class="sub-menu ml-20" ui-sref="lebaniego-control-agreement">Convenios de colab.</md-sidemenu-button></md-sidemenu-content><md-sidemenu-content md-heading="RESULTADOS CUANTITAT." md-arrow="true" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-sidemenu-button class="ml-20" ui-sref="lebaniego-result-donor">Donantes</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-result-contributor">Aportantes</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-result-agreement">Convenios de colab.</md-sidemenu-button><md-sidemenu-button class="ml-20" ui-sref="lebaniego-result-summary">Resumen anual</md-sidemenu-button></md-sidemenu-content><md-sidemenu-button ui-sref="lebaniego-amount" has-authority="ROLE_ADMIN">Cuant\xEDas</md-sidemenu-button></md-sidemenu-content><md-sidemenu-button ui-sref="user-management" has-authority="ROLE_ADMIN"><md-icon>people</md-icon>USUARIOS</md-sidemenu-button><md-sidemenu-button ui-sref="password"><md-icon>lock</md-icon>CAMBIAR CONTRASE\xD1A</md-sidemenu-button><md-button data-ng-click="sb.logout()"><md-icon>exit_to_app</md-icon>Cerrar sesi\xF3n</md-button></md-sidemenu></md-sidenav>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="login"><div layout="column" class="container-login" layout-align="center center"><div class="logo-login"></div><div class="logo-subtitle-login"></div><md-card class="md-whiteframe-8dp form-login"><md-card-content><div layout="row" class="header" layout-align="center center"><h2 md-truncate="">SEGUIMIENTO DE EXPEDIENTES</h2></div><div class="text-align-center"><h3>Volver a establecer contrase\xF1a</h3></div><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>\xA1No existe este electr\xF3nico registrado!</strong></div><div class="alert alert-warning" ng-hide="vm.success"><p>Introduce el correo electr\xF3nico con el que te has registrado en el sistema.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p>Revisa el buz\xF3n de correo para ver como resetear la contrase\xF1a.</p></div><p></p><p class="text-center"></p><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div layout="row"><md-input-container flex="100"><label for="email">Correo electr\xF3nico</label><md-icon>email</md-icon><input type="email" class="form-control" id="email" name="email" placeholder="Introduce el correo electr\xF3nico" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-messages="form.email.$error"><div ng-message="required">El Correo electr\xF3nico es obligatorio</div><div ng-message="email">El formato de Correo electr\xF3nico es incorrecto</div><div ng-message="minlength">El E-mail debe ser de 5 car\xE1cteres como m\xEDnimo</div><div ng-message="maxlength">El E-mail debe ser de 100 car\xE1cteres como m\xE1ximo</div></div></md-input-container></div><div layout="row" layout-align="end right"><md-button type="submit" ng-disabled="form.$invalid" class="md-raised md-primary">Resetear</md-button></div></form></md-card-content></md-card></div></div><div class="login-background"></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div class="login"><div layout="column" class="container-login" layout-align="center center"><div class="logo-login"></div><div class="logo-subtitle-login"></div><md-card class="md-whiteframe-8dp form-login"><md-card-conten><div layout="row" class="header" layout-align="center center"><h2 md-truncate="">SEGUIMIENTO DE EXPEDIENTES</h2></div><div class="text-align-center"><h3>Volver a establecer contrase\xF1a</h3></div><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>El token para resetear la contrase\xF1a no es v\xE1lido</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Elige una nueva contrase\xF1a</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Tu contrase\xF1a no puede ser reseteada. Recuerda que la solicitud s\xF3lo es v\xE1lida 24 horas</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>La contrase\xF1a ha sido reseteada.</strong> Por favor <a class="alert-link" href="" ng-click="vm.login()">accede</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">La contrase\xF1as no coinciden.</div><p></p><p class="text-center"></p><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div layout="row"><md-input-container flex="100"><label for="password">Nueva contrase\xF1a</label><input type="password" class="form-control" id="password" name="password" placeholder="Nueva contrase\xF1a" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-messages="form.password.$error"><div ng-message="required">La contrase\xF1a es obligatoria</div><div ng-message="minlength">La contrase\xF1a debe ser de 4 car\xE1cteres como m\xEDnimo</div><div ng-message="maxlength">La contrase\xF1a debe ser de 50 car\xE1cteres como m\xE1ximo</div></div></md-input-container></div><div layout="row"><md-input-container flex="100"><label for="password">Confirmar nueva contrase\xF1a</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirmar nueva contrase\xF1a" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-messages="form.confirmPassword.$error"><div ng-message="required">La contrase\xF1a de confirmaci\xF3n es obligatoria</div><div ng-message="minlength">La contrase\xF1a de confirmaci\xF3n debe ser de 4 car\xE1cteres como m\xEDnimo</div><div ng-message="maxlength">La contrase\xF1a de confirmaci\xF3n debe ser de 50 car\xE1cteres como m\xE1ximo</div></div></md-input-container></div><div layout="row" layout-align="end right"><md-button type="submit" ng-disabled="form.$invalid" class="md-raised md-primary">Guardar contrase\xF1a</md-button></div></form></div></md-card-conten></md-card></div><div class="login-background"></div></div>');
$templateCache.put('app/entities/advices/advice/advice-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="advices"><md-icon>undo</md-icon></md-button><span>Consulta verbal o escrita</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-tabs md-dynamic-height="" md-border-bottom="" class="md-default-theme content-detail"><md-tab label="Datos generales"><md-content class="md-padding"><md-card flex><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" layout-align="space-between center"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.advice.adviceQueryType" for="field_adviceQueryType">Tipo de consulta</label><md-select id="field_adviceQueryType" name="adviceQueryType" ng-model="vm.advice.adviceQueryType" ng-model-options="{trackBy: \'$value.name\' }" ng-disabled="!vm.isAdmin" required><md-option ng-value="type" ng-repeat="type in vm.advicequerytypes">{{ type.description }}</md-option></md-select><div class="md-error-spacer"></div><div ng-messages="editForm.process.$error"><div ng-message="required">El tipo de consulta es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.advice.adviceStatus" for="field_adviceStatus">Estado</label><md-select id="field_adviceStatus" name="adviceStatus" ng-model="vm.advice.adviceStatus" ng-model-options="{trackBy: \'$value.name\' }" ng-disabled="!vm.isAdmin" required><md-option ng-value="status" ng-repeat="status in vm.advicestatus">{{ status.description }}</md-option></md-select><div ng-messages="editForm.process.$error"><div ng-message="required">El tipo de consulta es obligatorio</div></div></md-input-container></div><div layout="row" layout-align="space-between center"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.advice.caseFileId" for="field_caseFileId">Expediente</label><input type="text" name="caseFileId" id="field_caseFileId" ng-model="vm.advice.caseFileId" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.caseFileId.$error"></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.advice.requestDate" for="field_requestDate">Fecha de solicitud</label><md-icon>date_range</md-icon><input type="date" name="requestDate" id="field_requestDate" ng-model="vm.advice.requestDate" ng-disabled="!vm.isAdmin"><div ng-messages="formData.requestDate.$error"><div ng-message="required">La fecha de solicitud es obligatoria</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Solicitante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.advice.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.advice.applicantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El solicitante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.advice.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" validate-ni-es ng-model="vm.advice.applicantNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El nif del solicitante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.advice.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" ng-disabled="!vm.isAdmin" phone-number ng-model="vm.advice.applicantPhone"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label>Antecedentes</label><textarea ng-model="vm.advice.background" columns="1" md-maxlength="1000" rows="3" ng-disabled="!vm.isAdmin"></textarea></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.advice.resolutionDate" for="field_resolutionDate">Fecha de resoluci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="resolutionDate" id="field_resolutionDate" ng-model="vm.advice.resolutionDate" ng-disabled="!vm.isAdmin"><div ng-messages="formData.resolutionDate.$error"><div ng-message="required">La fecha de resoluci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Resoluci\xF3n</label><textarea ng-model="vm.advice.resolution" columns="1" md-maxlength="1000" rows="3" ng-disabled="!vm.isAdmin"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right" has-authority="ROLE_ADMIN"><md-button type="submit" ng-disabled="editForm.$invalid" class="md-raised md-primary" title="Actualizar expediente" aria-label="Actualizar expediente">Guardar</md-button></section></form></div></md-card-content></md-card></md-content></md-tab><md-tab label="Documentos"><md-content class="md-padding"><advice-documents data-advice="vm.advice"></advice-documents></md-content></md-tab><md-tab label="Tareas" ng-if="vm.isAdmin"><md-content class="md-padding"><tasks entitytype="vm.entityType" entityid="vm.advice.id"></tasks></md-content></md-tab><md-tab ng-if="vm.isAdmin"><md-tab-label><span class="has-notes" ng-show="hasNotes > 0">Notas ({{hasNotes}}) </span><span ng-hide="hasNotes > 0">Notas</span></md-tab-label><md-tab-body class="md-padding"><notes entitytype="vm.entityType" entityid="vm.advice.id"></notes></md-tab-body></md-tab>--></md-tabs></md-content><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/advices/advice/advice-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="advices"><md-icon>undo</md-icon></md-button><span>Nueva consulta verbal o escrita</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" layout-align="space-between center"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.advice.adviceQueryType" for="field_adviceQueryType">Tipo de consulta</label><md-select id="field_adviceQueryType" name="adviceQueryType" ng-model="vm.advice.adviceQueryType" ng-model-options="{trackBy: \'$value.name\' }" required><md-option ng-value="type" ng-repeat="type in vm.advicequerytypes">{{ type.description }}</md-option></md-select><div class="md-error-spacer"></div><div ng-messages="editForm.process.$error"><div ng-message="required">El tipo de consulta es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.advice.adviceStatus" for="field_adviceStatus">Estado</label><md-select id="field_adviceStatus" name="adviceStatus" ng-model="vm.advice.adviceStatus" ng-model-options="{trackBy: \'$value.name\' }" required><md-option ng-value="status" ng-repeat="status in vm.advicestatus">{{ status.description }}</md-option></md-select><div ng-messages="editForm.process.$error"><div ng-message="required">El tipo de consulta es obligatorio</div></div></md-input-container></div><div layout="row" layout-align="space-between center"><md-input-container class="md-block" flex="40"><label data-translate="expedientesUriarteApp.advice.caseFileId" for="field_caseFileId">Expediente</label><input type="text" name="caseFileId" id="field_caseFileId" ng-model="vm.advice.caseFileId"><div ng-messages="editForm.caseFileId.$error"></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.advice.requestDate" for="field_requestDate">Fecha de solicitud</label><md-icon>date_range</md-icon><input type="date" name="requestDate" id="field_requestDate" ng-model="vm.advice.requestDate"><div ng-messages="formData.requestDate.$error"><div ng-message="required">La fecha de solicitud es obligatoria</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Solicitante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.advice.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.advice.applicantName" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El solicitante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.advice.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" validate-ni-es ng-model="vm.advice.applicantNif" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El nif del solicitante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.advice.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" phone-number ng-model="vm.advice.applicantPhone"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label>Antecedentes</label><textarea ng-model="vm.advice.background" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.advice.resolutionDate" for="field_resolutionDate">Fecha de resoluci\xF3n</label><md-icon>date_range</md-icon><input type="date" name="resolutionDate" id="field_resolutionDate" ng-model="vm.advice.resolutionDate"><div ng-messages="formData.resolutionDate.$error"><div ng-message="required">La fecha de resoluci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Resoluci\xF3n</label><textarea ng-model="vm.advice.resolution" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar una consulta" aria-label="Grabar una consulta">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/advices/advice/advices.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">chat</md-icon></md-button><span>Consultas verbales o escritas</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="advices.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nueva consulta</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="25"><label for="field_code">Expediente</label><input type="string" name="caseFile" id="field_code" ng-model="vm.searchItem.caseFile"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_client">Solicitante</label><input type="string" name="client" id="field_client" ng-model="vm.searchItem.client"></md-input-container><md-input-container class="md-block" flex="20"><label for="status">Estado</label><md-select id="status" name="status" ng-model="vm.searchItem.status" ng-model-options="{trackBy: \'$value.name\' }"><md-option ng-value="null">Todos</md-option><md-option ng-value="status" ng-repeat="status in vm.status ">{{ status.description }}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Expediente</span></th><th><span>Tipo</span></th><th><span>Solicitante</span></th><th><div class="column-center">Fecha de solicitud</div></th><th><div class="column-center">Fecha de resoluci\xF3n</div></th><th><div class="column-center">Estado</div></th></tr></thead><tbody><tr ng-repeat="advice in vm.advices track by advice.id" ui-sref="advices.edit({id:advice.id})"><td>{{advice.caseFileId}}</td><td>{{advice.adviceQueryType.description}}</td><td>{{advice.applicantName}} ({{advice.applicantNif}})</td><td><div class="column-center">{{advice.requestDate | date:"dd/MM/yyyy"}}</div></td><td><div class="column-center">{{advice.resolutionDate | date:"dd/MM/yyyy"}}</div></td><td ng-if="advice.adviceStatus.name === \'OPEN\'"><div class="column-center"><md-icon>lock_open</md-icon></div></td><td ng-if="advice.adviceStatus.name === \'Cerrado\'"><div class="column-center"><md-icon>lock</md-icon></div></td><!--                        <td>{{gFile.stepAction}}</td> --><!--                        <td class="hidden-sm hidden-xs">{{gFile.hasNotes}}</td> --></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="searchForm.$invalid || vm.gFiles.length === 0"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/advices/documents/advice-documents.component.html','<div layout="row" layout-align="start center" flex="100"><edit-advice-document document="$ctrl.document" action="$ctrl.action" ng-show="$ctrl.action === \'edit\'" flex="100"></edit-advice-document><new-advice-document advice="$ctrl.advice" action="$ctrl.action" ng-show="$ctrl.action === \'new\'" flex="100"></new-advice-document><md-card flex ng-show="$ctrl.action === \'query\'"><md-card-content><div layout="row" ng-show="$ctrl.documents.length > 0 && $ctrl.action === \'query\'" class="steps" layout-wrap><div ng-repeat="document in $ctrl.documents" class="history-item" layout="row" layout-align="center start" layout-gt-md="row" layout-align-gt-md="center start"><div class="step-phase-container history-item-detail"><div class="step-phase"><div class="title">{{document.name}}</div><div class="period">{{document.date}}</div></div></div><div class="step-point" ng-cloak><md-fab-speed-dial md-open="false" md-direction="right" class="md-fling"><md-fab-trigger><md-button aria-label="Fase" title="Fase" class="md-fab md-primary md-hue-5"><md-icon>insert_drive_file</md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label="Editar documento" title="Editar documento" ng-click="$ctrl.editAdviceDocument(document)" ng-disabled="!$ctrl.isAdmin" class="md-fab md-raised md-mini"><md-icon aria-label="Editar documento">mode_edit</md-icon></md-button><md-button aria-label="Descargar documento" title="Descargar documento" ng-click="$ctrl.downloadFile(document.id)" class="md-fab md-raised md-mini"><md-icon aria-label="Descargar documento">cloud_download</md-icon></md-button></md-fab-actions></md-fab-speed-dial></div><div class="history-card history-card-left" layout="row" flex="50"></div></div></div><div layout="row" layout-align="end center" flex="50"><md-button ng-click="$ctrl.openNewAdviceDocument()" class="md-primary add-phase">A\xF1adir documento</md-button></div></md-card-content></md-card></div>');
$templateCache.put('app/entities/advices/documents/edit-advice-document.component.html','<md-card><md-card-title><md-card-title-text><span class="md-headline">Editar documento</span></md-card-title-text></md-card-title><md-card-content><div class="md-inline-form"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div layout="row"><md-input-container class="md-block" flex><label for="name">Nombre</label><input id="name" name="name" ng-model="$ctrl.document.name"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label for="date">Fecha</label><md-icon>date_range</md-icon><input type="date" id="date" name="date" ng-model="$ctrl.document.date"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label for="docpath">Nombre del fichero</label><input type="text" id="filename" name="filename" value="{{$ctrl.document.filename}}" disabled="disabled"></md-input-container><div flex="50"><md-button class="md-fab md-mini md-primary" title="Subir un fichero" ngf-select="$ctrl.uploadfile($file, $invalidFiles)" aria-label="Subir un fichero"><md-icon>add</md-icon></md-button></div></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="$ctrl.document.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button type="button" class="md-raised" ng-click="$ctrl.close()">Cancelar</md-button><md-button type="button" class="md-raised md-primary md-hue-2" ng-click="$ctrl.downloadfile()">Descargar documento</md-button><div data-confirm-delete data-on-confirm="$ctrl.remove_document()"></div><md-button type="submit" ng-disabled="editForm.$invalid || $ctrl.isSaving || $ctrl.document.name === undefined || $ctrl.document.name === null || $ctrl.document.signatureDate != null" class="md-raised md-primary">Grabar</md-button></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/advices/documents/new-advice-document.component.html','<md-card flex="100"><md-card-title><md-card-title-text><span class="md-headline">Nuevo documento</span></md-card-title-text></md-card-title><md-card-content><div class="md-inline-form"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="$ctrl.save()" show-validation><div layout="row"><md-input-container class="md-block" flex><label for="name">Nombre</label><input id="name" name="name" ng-model="$ctrl.document.name"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label for="registerdate">Fecha</label><md-icon>date_range</md-icon><input type="date" id="date" name="date" ng-model="$ctrl.document.date"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label for="docpath">Path</label><input type="text" id="docpath" name="docpath" value="{{$ctrl.document.path}}" disabled="disabled"></md-input-container><div flex="40"><md-button class="md-fab md-mini md-primary" title="Subir un fichero" ngf-select="$ctrl.uploadfile($file, $invalidFiles)" aria-label="Subir un fichero"><md-icon>add</md-icon></md-button></div></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="$ctrl.document.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button type="button" class="md-raised" ng-click="$ctrl.close()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || $ctrl.isSaving || $ctrl.document.name === undefined || $ctrl.document.name === null" class="md-raised md-primary">Grabar</md-button></section></form></div></md-card-content></md-card>');
$templateCache.put('app/entities/advices/reports/reports-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="reports"><md-icon>undo</md-icon></md-button><span>Informe o dictamen</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-tabs md-dynamic-height="" md-border-bottom="" class="md-default-theme content-detail"><md-tab label="Datos generales"><md-content class="md-padding"><md-card flex><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" layout-align="space-between"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.advice.caseFileId" for="field_caseFileId">Expediente</label><input type="text" name="caseFileId" id="field_caseFileId" ng-model="vm.report.caseFileId" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.caseFileId.$error"></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.advice.requestDate" for="field_requestDate">Fecha de solicitud</label><md-icon>date_range</md-icon><input type="date" name="requestDate" id="field_requestDate" ng-model="vm.report.requestDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.requestDate.$error"><div ng-message="required">La fecha de solicitud es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.advice.adviceStatus" for="field_adviceStatus">Estado</label><md-select id="field_adviceStatus" name="adviceStatus" ng-model="vm.report.adviceStatus" ng-model-options="{trackBy: \'$value.name\' }" ng-disabled="!vm.isAdmin" required><md-option ng-value="status" ng-repeat="status in vm.advicestatus">{{ status.description }}</md-option></md-select><div ng-messages="editForm.status.$error"><div ng-message="required">El estado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Solicitante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.advice.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.report.applicantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El solicitante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.advice.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" validate-ni-es ng-model="vm.report.applicantNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El nif del solicitante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.advice.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" phone-number ng-model="vm.report.applicantPhone" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label>Antecedentes</label><textarea ng-model="vm.report.background" columns="1" md-maxlength="1000" rows="3" ng-disabled="!vm.isAdmin"></textarea></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.advice.issueDate" for="field_issueDate">Fecha de emisi\xF3n</label><md-icon>date_range</md-icon><input type="date" name="issueDate" id="field_issueDate" ng-model="vm.report.issueDate" ng-disabled="!vm.isAdmin"><div ng-messages="editForm.issueDate.$error"><div ng-message="required">La fecha de emisi\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Emisi\xF3n del informe</label><textarea ng-model="vm.report.issue" columns="1" md-maxlength="1000" rows="3" ng-disabled="!vm.isAdmin"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right" has-authority="ROLE_ADMIN"><md-button type="submit" ng-disabled="editForm.$invalid" class="md-raised md-primary" title="Actualizar expediente" aria-label="Actualizar expediente">Guardar</md-button></section></form></div></md-card-content></md-card></md-content></md-tab><md-tab label="Documentos"><md-content class="md-padding"><advice-documents data-advice="vm.report"></advice-documents></md-content></md-tab><md-tab label="Tareas" ng-if="vm.isAdmin"><md-content class="md-padding"><tasks entitytype="vm.entityType" entityid="vm.report.id"></tasks></md-content></md-tab><md-tab ng-if="vm.isAdmin"><md-tab-label><span class="has-notes" ng-show="hasNotes > 0">Notas ({{hasNotes}}) </span><span ng-hide="hasNotes > 0">Notas</span></md-tab-label><md-tab-body class="md-padding"><notes entitytype="vm.entityType" entityid="vm.report.id"></notes></md-tab-body></md-tab>--></md-tabs></md-content><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/advices/reports/reports-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="reports"><md-icon>undo</md-icon></md-button><span>Nuevo informe o dictamen</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" layout-align="space-between"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.advice.caseFileId" for="field_caseFileId">Expediente</label><input type="text" name="caseFileId" id="field_caseFileId" ng-model="vm.report.caseFileId"><div ng-messages="editForm.caseFileId.$error"></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.advice.requestDate" for="field_requestDate">Fecha de solicitud</label><md-icon>date_range</md-icon><input type="date" name="requestDate" id="field_requestDate" ng-model="vm.report.requestDate"><div ng-messages="editForm.requestDate.$error"><div ng-message="required">La fecha de solicitud es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.advice.adviceStatus" for="field_adviceStatus">Estado</label><md-select id="field_adviceStatus" name="adviceStatus" ng-model="vm.report.adviceStatus" ng-model-options="{trackBy: \'$value.name\' }" required><md-option ng-value="status" ng-repeat="status in vm.advicestatus">{{ status.description }}</md-option></md-select><div ng-messages="editForm.status.$error"><div ng-message="required">El estado es obligatorio</div></div></md-input-container></div><div class="subform"><div layout="row"><span class="page-subtitle"><md-icon>label</md-icon>Solicitante</span></div><div layout="row"><md-input-container class="md-block" flex="50"><label data-translate="expedientesUriarteApp.advice.applicantName" for="field_applicantName">Nombre y apellidos</label><input name="applicantName" id="field_applicantName" ng-model="vm.report.applicantName" required><div ng-messages="editForm.applicantName.$error"><div ng-message="required">El solicitante es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.advice.applicantNif" for="field_applicantNif">NIF</label><input name="applicantNif" id="field_applicantNif" validate-ni-es ng-model="vm.report.applicantNif" required><div ng-messages="editForm.applicantNif.$error"><div ng-message="required">El nif del solicitante es obligatorio</div><div ng-message="validateNiEs">Debe indicar un NIF v\xE1lido</div></div></md-input-container><md-input-container class="md-block" flex><md-icon>phone</md-icon><label data-translate="expedientesUriarteApp.advice.applicantPhone" for="field_applicantPhone">Tel\xE9fono</label><input name="applicantPhone" id="field_applicantPhone" phone-number ng-model="vm.report.applicantPhone"><div ng-messages="editForm.applicantPhone.$error"><div ng-message="phoneNumber">Debe indicar un tel\xE9fono v\xE1lido</div></div></md-input-container></div></div><div layout="row"><md-input-container class="md-block" flex><label>Antecedentes</label><textarea ng-model="vm.report.background" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="33"><label data-translate="expedientesUriarteApp.advice.issueDate" for="field_issueDate">Fecha de emisi\xF3n</label><md-icon>date_range</md-icon><input type="date" name="issueDate" id="field_issueDate" ng-model="vm.report.issueDate"><div ng-messages="editForm.issueDate.$error"><div ng-message="required">La fecha de emisi\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Emisi\xF3n del informe</label><textarea ng-model="vm.report.issue" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar una consulta" aria-label="Grabar una consulta">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/advices/reports/reports.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">chat</md-icon></md-button><span>Informes o dict\xE1menes</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="reports.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo informe</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="25"><label for="field_code">Expediente</label><input type="string" name="caseFile" id="field_code" ng-model="vm.searchItem.caseFile"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_client">Solicitante</label><input type="string" name="client" id="field_client" ng-model="vm.searchItem.client"></md-input-container><md-input-container class="md-block" flex="20"><label for="status">Estado</label><md-select id="status" name="status" ng-model="vm.searchItem.status" ng-model-options="{trackBy: \'$value.name\' }"><md-option ng-value="null">Todos</md-option><md-option ng-value="status" ng-repeat="status in vm.status ">{{ status.description }}</md-option></md-select><div class="md-errors-spacer"></div></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Expediente</span></th><th><span>Solicitante</span></th><th><div class="column-center">Fecha de solicitud</div></th><th><div class="column-center">Fecha de emisi\xF3n</div></th><th><div class="column-center">Estado</div></th></tr></thead><tbody><tr ng-repeat="report in vm.reports track by report.id" ui-sref="reports.edit({id:report.id})"><td>{{report.caseFileId}}</td><td>{{report.applicantName}} ({{report.applicantNif}})</td><td><div class="column-center">{{report.requestDate | date:"dd/MM/yyyy"}}</div></td><td><div class="column-center">{{report.issueDate | date:"dd/MM/yyyy"}}</div></td><td ng-if="report.adviceStatus.name === \'OPEN\'"><div class="column-center"><md-icon>lock_open</md-icon></div></td><td ng-if="report.adviceStatus.name === \'Cerrado\'"><div class="column-center"><md-icon>lock</md-icon></div></td><!--                        <td>{{gFile.stepAction}}</td> --><!--                        <td class="hidden-sm hidden-xs">{{gFile.hasNotes}}</td> --></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="searchForm.$invalid || vm.gFiles.length === 0"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-contabilidad/consortium-contabilidad-anuales/consortium-contabilidad-anuales-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-contabilidad-anuales"><md-icon>undo</md-icon></md-button><span>Edici\xF3n cuenta anual</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumContabilidadAnual.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumContabilidadAnual.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="30"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumContabilidadAnual.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.consortiumContabilidadAnual.description" name="description" id="field_description" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumContabilidadAnual.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumContabilidadAnual.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumContabilidadAnual.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-contabilidad/consortium-contabilidad-anuales/consortium-contabilidad-anuales-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-contabilidad-anuales"><md-icon>undo</md-icon></md-button><span>Nueva cuenta anual</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumContabilidadAnual.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumContabilidadAnual.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.consortiumContabilidadAnual.description" name="description" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="30"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumContabilidadAnual.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-contabilidad/consortium-contabilidad-anuales/consortium-contabilidad-anuales.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Cuentas Anuales</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nueva cuenta anual" ui-sref="consortium-contabilidad-anuales.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">Ejercicio</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_desc">Descripci\xF3n</label><input type="string" name="desc" id="field_desc" ng-model="vm.searchItem.desc"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Ejercicio</span></th><th><span>Descripci\xF3n</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="consortiumContabilidadAnual in vm.consortiumContabilidadAnualItems track by consortiumContabilidadAnual.id" ui-sref="consortium-contabilidad-anuales.edit({id:consortiumContabilidadAnual.id})"><td>{{consortiumContabilidadAnual.year}}</td><td><div class="table-details"><div class="title">{{consortiumContabilidadAnual.description}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumContabilidadAnual.consortium.firstName}} {{consortiumContabilidadAnual.consortium.lastName}}</div><div class="detail">{{consortiumContabilidadAnual.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-contabilidad/consortium-contabilidad-emitidas/consortium-contabilidad-emitidas-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-contabilidad-emitidas"><md-icon>undo</md-icon></md-button><span>Edici\xF3n factura emitida</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumContabilidadEmitida.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.invoiceDate" for="field_invoiceDate">Fecha</label><input type="date" name="invoiceDate" id="field_invoiceDate" ng-model="vm.consortiumContabilidadEmitida.invoiceDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.invoiceDate.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.receiveDate" for="field_receiveDate">Fecha de cobro</label><input type="date" name="receiveDate" id="field_receiveDate" ng-model="vm.consortiumContabilidadEmitida.receiveDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.receiveDate.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumContabilidadEmitida.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.invoiceName" for="field_name">Nombre de factura</label><input name="invoiceName" id="field_name" ng-model="vm.consortiumContabilidadEmitida.invoiceName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.invoiceName.$error"><div ng-message="required">El nombre es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.invoiceNif" for="field_name">NIF</label><input name="invoiceNif" id="field_nif" ng-model="vm.consortiumContabilidadEmitida.invoiceNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.invoiceNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label>Descripci\xF3n</label><input ng-model="vm.consortiumContabilidadEmitida.description" name="description" id="field_description" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumContabilidadEmitida.amount" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-contabilidad/consortium-contabilidad-emitidas/consortium-contabilidad-emitidas-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-contabilidad-emitidas"><md-icon>undo</md-icon></md-button><span>Nueva factura emitida</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumContabilidadEmitida.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.invoiceDate" for="field_date">Fecha</label><input type="date" name="field_invoiceDate" id="field_invoiceDate" ng-model="vm.consortiumContabilidadEmitida.invoiceDate" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.receiveDate" for="field_date">Fecha de cobro</label><input type="date" name="field_receiveDate" id="field_receiveDate" ng-model="vm.consortiumContabilidadEmitida.receiveDate" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumContabilidadEmitida.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.invoiceName" for="field_name">Nombre de factura</label><input name="invoiceName" id="field_name" ng-model="vm.consortiumContabilidadEmitida.invoiceName" required><div ng-messages="editForm.invoiceName.$error"><div ng-message="required">El nombre es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.invoiceNif" for="field_name">NIF</label><input name="invoiceNif" id="field_nif" ng-model="vm.consortiumContabilidadEmitida.invoiceNif" required><div ng-messages="editForm.invoiceNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label>Descripci\xF3n</label><input ng-model="vm.consortiumContabilidadEmitida.description" name="description" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadEmitida.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumContabilidadEmitida.amount" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-contabilidad/consortium-contabilidad-emitidas/consortium-contabilidad-emitidas.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Facturas Emitidas</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nueva factura emitida" ui-sref="consortium-contabilidad-emitidas.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">Ejercicio</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_namedesc">N\xBA de factura</label><input type="string" name="namedesc" id="field_namedesc" ng-model="vm.searchItem.namedesc"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Ejercicio</span></th><th><span>N\xBA de factura</span></th><th><span>Importe</span></th><th><span>NIF</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="consortiumContabilidadEmitida in vm.consortiumContabilidadEmitidaItems track by consortiumContabilidadEmitida.id" ui-sref="consortium-contabilidad-emitidas.edit({id:consortiumContabilidadEmitida.id})"><td>{{consortiumContabilidadEmitida.year}}</td><td><div class="table-details"><div class="title">{{consortiumContabilidadEmitida.invoiceName}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumContabilidadEmitida.amount}} \u20AC</div></div></td><td><div class="table-details"><div class="title">{{consortiumContabilidadEmitida.invoiceNif}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumContabilidadEmitida.consortium.firstName}} {{consortiumContabilidadEmitida.consortium.lastName}}</div><div class="detail">{{consortiumContabilidadEmitida.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-contabilidad/consortium-contabilidad-recibidas/consortium-contabilidad-recibidas-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-contabilidad-recibidas"><md-icon>undo</md-icon></md-button><span>Edici\xF3n factura recibida</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumContabilidadRecibida.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.invoiceDate" for="field_invoiceDate">Fecha</label><input type="date" name="invoiceDate" id="field_invoiceDate" ng-model="vm.consortiumContabilidadRecibida.invoiceDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.invoiceDate.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.payDate" for="field_payDate">Fecha de pago</label><input type="date" name="payDate" id="field_payDate" ng-model="vm.consortiumContabilidadRecibida.payDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.payDate.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumContabilidadRecibida.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.invoiceName" for="field_name">N\xFAmero de factura</label><input name="invoiceName" id="field_name" ng-model="vm.consortiumContabilidadRecibida.invoiceName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.invoiceName.$error"><div ng-message="required">El n\xFAmero es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.invoiceNif" for="field_name">NIF</label><input name="invoiceNif" id="field_nif" ng-model="vm.consortiumContabilidadRecibida.invoiceNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.invoiceNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label>Descripci\xF3n</label><input ng-model="vm.consortiumContabilidadRecibida.description" name="description" id="field_description" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumContabilidadRecibida.amount" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-contabilidad/consortium-contabilidad-recibidas/consortium-contabilidad-recibidas-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-contabilidad-recibidas"><md-icon>undo</md-icon></md-button><span>Nueva factura recibida</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumContabilidadRecibida.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.invoiceDate" for="field_date">Fecha</label><input type="date" name="field_invoiceDate" id="field_invoiceDate" ng-model="vm.consortiumContabilidadRecibida.invoiceDate" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.payDate" for="field_date">Fecha de pago</label><input type="date" name="field_payDate" id="field_payDate" ng-model="vm.consortiumContabilidadRecibida.payDate" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumContabilidadRecibida.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.invoiceName" for="field_name">N\xFAmero de factura</label><input name="invoiceName" id="field_name" ng-model="vm.consortiumContabilidadRecibida.invoiceName" required><div ng-messages="editForm.invoiceName.$error"><div ng-message="required">El n\xFAmero es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.invoiceNif" for="field_name">NIF</label><input name="invoiceNif" id="field_nif" ng-model="vm.consortiumContabilidadRecibida.invoiceNif" required><div ng-messages="editForm.invoiceNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label>Descripci\xF3n</label><input ng-model="vm.consortiumContabilidadRecibida.description" name="description" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumContabilidadRecibida.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumContabilidadRecibida.amount" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-contabilidad/consortium-contabilidad-recibidas/consortium-contabilidad-recibidas.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Facturas Recibidas</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nueva factura recibida" ui-sref="consortium-contabilidad-recibidas.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">Ejercicio</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_namedesc">N\xBA de factura</label><input type="string" name="namedesc" id="field_namedesc" ng-model="vm.searchItem.namedesc"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Ejercicio</span></th><th><span>N\xBA de factura</span></th><th><span>Importe</span></th><th><span>NIF</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="consortiumContabilidadRecibida in vm.consortiumContabilidadRecibidaItems track by consortiumContabilidadRecibida.id" ui-sref="consortium-contabilidad-recibidas.edit({id:consortiumContabilidadRecibida.id})"><td>{{consortiumContabilidadRecibida.year}}</td><td><div class="table-details"><div class="title">{{consortiumContabilidadRecibida.invoiceName}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumContabilidadRecibida.amount}} \u20AC</div></div></td><td><div class="table-details"><div class="title">{{consortiumContabilidadRecibida.invoiceNif}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumContabilidadRecibida.consortium.firstName}} {{consortiumContabilidadRecibida.consortium.lastName}}</div><div class="detail">{{consortiumContabilidadRecibida.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-expediente/consortium-expediente-expropiaciones/consortium-expediente-expropiaciones-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-expediente-expropiaciones"><md-icon>undo</md-icon></md-button><span>Edici\xF3n expropiaci\xF3n</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><!-- A\xD1O --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumExpedienteExpropiacion.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><!-- FECHA --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.date" for="field_date">Fecha de expropiaci\xF3n</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumExpedienteExpropiacion.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><!-- DENOMINACION DE LA FINCA --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.denominationFarm" for="field_denominationFarm">Denominaci\xF3n de la finca</label><input name="denominationFarm" id="field_denominationFarm" ng-model="vm.consortiumExpedienteExpropiacion.denominationFarm" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.denominationFarm.$error"><div ng-message="required">La denominaci\xF3n de la finca es obligatoria</div></div></md-input-container><!-- CONSORCIO --><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumExpedienteExpropiacion.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><!-- INTERESADOS --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.interested" for="field_interested">Interesados</label><input name="interested" id="field_interested" ng-model="vm.consortiumExpedienteExpropiacion.interested" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.interested.$error"><div ng-message="required">Los interesados son obligatorios</div></div></md-input-container><!-- N\xBA DE PROTOCOLO --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.protocolNumber" for="field_protocolNumber">N\xBA de protocolo</label><input name="protocolNumber" id="field_protocolNumber" ng-model="vm.consortiumExpedienteExpropiacion.protocolNumber" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.protocolNumber.$error"><div ng-message="required">El protocolo es obligatorio</div></div></md-input-container><!-- BENEFICIARIO --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.beneficiary" for="field_beneficiary">Beneficiario</label><input name="beneficiary" id="field_beneficiary" ng-model="vm.consortiumExpedienteExpropiacion.beneficiary" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.beneficiary.$error"><div ng-message="required">El beneficiario es obligatorio</div></div></md-input-container><!-- REFERENCIA CATASTRAL --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.cadastralReference" for="field_cadastralReference">Referencia Catastral</label><input name="cadastralReference" id="field_cadastralReference" ng-model="vm.consortiumExpedienteExpropiacion.cadastralReference" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.cadastralReference.$error"><div ng-message="required">La referencia catastral es obligatoria</div></div></md-input-container></div><div layout="row"><!-- FINCAS EXPROPIADAS --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.expropiatedFarms" for="field_expropiatedFarms">Fincas expropiadas</label><input name="expropiatedFarms" id="field_expropiatedFarms" ng-model="vm.consortiumExpedienteExpropiacion.expropiatedFarms" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.expropiatedFarms.$error"><div ng-message="required">Las fincas son obligatorias</div></div></md-input-container><!-- TITULO --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.title" for="field_title">T\xEDtulo</label><input name="title" id="field_title" ng-model="vm.consortiumExpedienteExpropiacion.title" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.title.$error"><div ng-message="required">El t\xEDtulo es obligatorio</div></div></md-input-container><!-- INSCRIPCION --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.inscription" for="field_inscription">Inscripci\xF3n</label><input name="inscription" id="field_inscription" ng-model="vm.consortiumExpedienteExpropiacion.inscription" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.inscription.$error"><div ng-message="required">La inscripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><!-- JUSTIPRECIO IMPORTE --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.fairPriceAmount" for="field_fairPriceAmount">Justiprecio (\u20AC)</label><input type="number" name="fairPriceAmount" id="field_fairPriceAmount" ng-model="vm.consortiumExpedienteExpropiacion.fairPriceAmount" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.fairPriceAmount.$error"><div ng-message="required">El justiprecio es obligatorio</div></div></md-input-container><!-- JUSTIPRECIO FECHA --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.fairPriceDate" for="field_date">Fecha del justiprecio</label><input type="date" name="field_fairPriceDate" id="field_fairPriceDate" ng-model="vm.consortiumExpedienteExpropiacion.fairPriceDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><!-- INTERESES --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.interest" for="field_interest">Intereses (\u20AC)</label><input type="number" name="interest" id="field_interest" ng-model="vm.consortiumExpedienteExpropiacion.interest" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.interest.$error"><div ng-message="required">Los intereses son obligatorios</div></div></md-input-container><!-- PAGO IMPORTE --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.amount" for="field_amount">Importe de pago (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumExpedienteExpropiacion.amount" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe de pago es obligatorio</div></div></md-input-container></div><!-- COPY --><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div><!-- PASTE --></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-expediente/consortium-expediente-expropiaciones/consortium-expediente-expropiaciones-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-expediente-expropiaciones"><md-icon>undo</md-icon></md-button><span>Nueva expropiaci\xF3n</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><!-- A\xD1O --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumExpedienteExpropiacion.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><!-- FECHA --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.date" for="field_date">Fecha de expropiaci\xF3n</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumExpedienteExpropiacion.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><!-- DENOMINACION DE LA FINCA --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.denominationFarm" for="field_denominationFarm">Denominaci\xF3n de la finca</label><input name="denominationFarm" id="field_denominationFarm" ng-model="vm.consortiumExpedienteExpropiacion.denominationFarm" required><div ng-messages="editForm.denominationFarm.$error"><div ng-message="required">La denominaci\xF3n de la finca es obligatoria</div></div></md-input-container><!-- CONSORCIO --><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumExpedienteExpropiacion.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><!-- INTERESADOS --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.interested" for="field_interested">Interesados</label><input name="interested" id="field_interested" ng-model="vm.consortiumExpedienteExpropiacion.interested" required><div ng-messages="editForm.interested.$error"><div ng-message="required">Los interesados son obligatorios</div></div></md-input-container><!-- N\xBA DE PROTOCOLO --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.protocolNumber" for="field_protocolNumber">N\xBA de protocolo</label><input name="protocolNumber" id="field_protocolNumber" ng-model="vm.consortiumExpedienteExpropiacion.protocolNumber" required><div ng-messages="editForm.protocolNumber.$error"><div ng-message="required">El protocolo es obligatorio</div></div></md-input-container><!-- BENEFICIARIO --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.beneficiary" for="field_beneficiary">Beneficiario</label><input name="beneficiary" id="field_beneficiary" ng-model="vm.consortiumExpedienteExpropiacion.beneficiary" required><div ng-messages="editForm.beneficiary.$error"><div ng-message="required">El beneficiario es obligatorio</div></div></md-input-container><!-- REFERENCIA CATASTRAL --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.cadastralReference" for="field_cadastralReference">Referencia Catastral</label><input name="cadastralReference" id="field_cadastralReference" ng-model="vm.consortiumExpedienteExpropiacion.cadastralReference" required><div ng-messages="editForm.cadastralReference.$error"><div ng-message="required">La referencia catastral es obligatoria</div></div></md-input-container></div><div layout="row"><!-- FINCAS EXPROPIADAS --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.expropiatedFarms" for="field_expropiatedFarms">Fincas expropiadas</label><input name="expropiatedFarms" id="field_expropiatedFarms" ng-model="vm.consortiumExpedienteExpropiacion.expropiatedFarms" required><div ng-messages="editForm.expropiatedFarms.$error"><div ng-message="required">Las fincas son obligatorias</div></div></md-input-container><!-- TITULO --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.title" for="field_title">T\xEDtulo</label><input name="title" id="field_title" ng-model="vm.consortiumExpedienteExpropiacion.title" required><div ng-messages="editForm.title.$error"><div ng-message="required">El t\xEDtulo es obligatorio</div></div></md-input-container><!-- INSCRIPCION --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.inscription" for="field_inscription">Inscripci\xF3n</label><input name="inscription" id="field_inscription" ng-model="vm.consortiumExpedienteExpropiacion.inscription" required><div ng-messages="editForm.inscription.$error"><div ng-message="required">La inscripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><!-- JUSTIPRECIO IMPORTE --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.fairPriceAmount" for="field_fairPriceAmount">Justiprecio (\u20AC)</label><input type="number" name="fairPriceAmount" id="field_fairPriceAmount" ng-model="vm.consortiumExpedienteExpropiacion.fairPriceAmount" required><div ng-messages="editForm.fairPriceAmount.$error"><div ng-message="required">El justiprecio es obligatorio</div></div></md-input-container><!-- JUSTIPRECIO FECHA --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.fairPriceDate" for="field_date">Fecha del justiprecio</label><input type="date" name="field_fairPriceDate" id="field_fairPriceDate" ng-model="vm.consortiumExpedienteExpropiacion.fairPriceDate" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><!-- INTERESES --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.interest" for="field_interest">Intereses (\u20AC)</label><input type="number" name="interest" id="field_interest" ng-model="vm.consortiumExpedienteExpropiacion.interest" required><div ng-messages="editForm.interest.$error"><div ng-message="required">Los intereses son obligatorios</div></div></md-input-container><!-- PAGO IMPORTE --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteExpropiacion.amount" for="field_amount">Importe de pago (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumExpedienteExpropiacion.amount" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe de pago es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un contrato" aria-label="Grabar contrato">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-expediente/consortium-expediente-expropiaciones/consortium-expediente-expropiaciones.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Expropiaciones</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nueva expropiacion" ui-sref="consortium-expediente-expropiaciones.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_denomination">Denominaci\xF3n de la finca</label><input type="string" name="denomination" id="field_denomination" ng-model="vm.searchItem.denomination"></md-input-container><md-input-container class="md-block" flex><label for="field_text">N\xBA protocolo o Referencia catastral</label><input type="string" name="text" id="field_text" ng-model="vm.searchItem.text"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Denominaci\xF3n de la finca</span></th><th><span>Referencia Catastral</span></th><th><span>N\xBA protocolo</span></th><th><span>Consorcio</span></th></tr></thead><tbody><tr ng-repeat="consortiumExpedienteExpropiacion in vm.consortiumExpedienteExpropiaciones track by consortiumExpedienteExpropiacion.id" ui-sref="consortium-expediente-expropiaciones.edit({id:consortiumExpedienteExpropiacion.id})"><td>{{consortiumExpedienteExpropiacion.year}}</td><td><div class="table-details"><div class="title">{{consortiumExpedienteExpropiacion.denominationFarm}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumExpedienteExpropiacion.cadastralReference}}</div></div></td><td>{{consortiumExpedienteExpropiacion.protocolNumber}}</td><td><div class="table-details"><div class="title">{{consortiumExpedienteExpropiacion.consortium.firstName}} {{consortiumExpedienteExpropiacion.consortium.lastName}}</div><div class="detail">{{consortiumExpedienteExpropiacion.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-contratos/consortium-personal-contratos-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-personal-contratos"><md-icon>undo</md-icon></md-button><span>Edici\xF3n contrato</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalContrato.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumPersonalContrato.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalContrato.date" for="field_date">Fecha Alta S.S.</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumPersonalContrato.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumPersonalContrato.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalContrato.employeeNif" for="field_employeeNif">NIF del trabajador</label><input name="employeeNif" id="field_employeeNif" ng-model="vm.consortiumPersonalContrato.employeeNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeNif.$error"><div ng-message="required">El nif del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalContrato.employeeFirstName" for="field_employeeFirstName">Nombre del trabajador</label><input name="employeeFirstName" id="field_employeeFirstName" ng-model="vm.consortiumPersonalContrato.employeeFirstName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeFirstName.$error"><div ng-message="required">El nombre del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Apellidos del trabajador</label><input ng-model="vm.consortiumPersonalContrato.employeeLastName" name="employeeLastName" id="field_employeeLastName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeLastName.$error"><div ng-message="required">El apellido del trabajador es obligatorio</div></div></md-input-container></div><!-- COPY --><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumPersonalContrato.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumPersonalContrato.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumPersonalContrato.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div><!-- PASTE --></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-contratos/consortium-personal-contratos-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-personal-contratos"><md-icon>undo</md-icon></md-button><span>Nuevo contrato</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalContrato.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumPersonalContrato.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalContrato.date" for="field_date">Fecha alta S.S.</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumPersonalContrato.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumPersonalContrato.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalContrato.employeeNif" for="field_employeeNif">NIF del trabajador</label><input name="employeeNif" id="field_employeeNif" ng-model="vm.consortiumPersonalContrato.employeeNif" required><div ng-messages="editForm.employeeNif.$error"><div ng-message="required">El nif del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumPersonalContrato.employeeFirstName" for="field_employeeFirstName">Nombre del trabajador</label><input name="employeeFirstName" id="field_employeeFirstName" ng-model="vm.consortiumPersonalContrato.employeeFirstName" required><div ng-messages="editForm.employeeFirstName.$error"><div ng-message="required">El nombre del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Apellidos del trabajador</label><input ng-model="vm.consortiumPersonalContrato.employeeLastName" name="employeeLastName" id="field_employeeLastName" required><div ng-messages="editForm.employeeLastName.$error"><div ng-message="required">El apellido del trabajador es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un contrato" aria-label="Grabar contrato">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-contratos/consortium-personal-contratos.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Contratos</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo contrato" ui-sref="consortium-personal-contratos.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_employee">Trabajador</label><input type="string" name="employee" id="field_employee" ng-model="vm.searchItem.employee"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar seguros" aria-label="Buscar seguros" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Fecha Alta S.S.</span></th><th><span>Trabajador</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="consortiumPersonalContrato in vm.consortiumPersonalContratos track by consortiumPersonalContrato.id" ui-sref="consortium-personal-contratos.edit({id:consortiumPersonalContrato.id})"><td>{{consortiumPersonalContrato.year}}</td><td>{{ consortiumPersonalContrato.date | date:\'dd/MM/yyyy\' }}</td><td><div class="table-details"><div class="title">{{consortiumPersonalContrato.employeeFirstName}} {{consortiumPersonalContrato.employeeLastName}}</div><div class="detail">{{consortiumPersonalContrato.employeeNif}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumPersonalContrato.consortium.firstName}} {{consortiumPersonalContrato.consortium.lastName}}</div><div class="detail">{{consortiumPersonalContrato.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-nominas/consortium-personal-nominas-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-personal-nominas"><md-icon>undo</md-icon></md-button><span>Edici\xF3n n\xF3mina</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalNomina.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumPersonalNomina.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_month">Mes</label><md-select id="field_month" name="month" ng-model="vm.consortiumPersonalNomina.month" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="month in vm.months" ng-value="month">{{ month }}</md-option></md-select><div ng-messages="editForm.month.$error"><div ng-message="required">El mes es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumPersonalNomina.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalNomina.employeeNif" for="field_employeeNif">NIF del trabajador</label><input name="employeeNif" id="field_employeeNif" ng-model="vm.consortiumPersonalNomina.employeeNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeNif.$error"><div ng-message="required">El nif del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalNomina.employeeFirstName" for="field_employeeFirstName">Nombre del trabajador</label><input name="employeeFirstName" id="field_employeeFirstName" ng-model="vm.consortiumPersonalNomina.employeeFirstName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeFirstName.$error"><div ng-message="required">El nombre del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Apellidos del trabajador</label><input ng-model="vm.consortiumPersonalNomina.employeeLastName" name="employeeLastName" id="field_employeeLastName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeLastName.$error"><div ng-message="required">El apellido del trabajador es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumPersonalNomina.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumPersonalNomina.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumPersonalNomina.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-nominas/consortium-personal-nominas-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-personal-nominas"><md-icon>undo</md-icon></md-button><span>Nueva n\xF3mina</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalNomina.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumPersonalNomina.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_month">Mes</label><md-select id="field_month" name="month" ng-model="vm.consortiumPersonalNomina.month" required><md-option ng-repeat="month in vm.months" ng-value="month">{{ month }}</md-option></md-select><div ng-messages="editForm.month.$error"><div ng-message="required">El mes es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumPersonalNomina.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalNomina.employeeNif" for="field_employeeNif">NIF del trabajador</label><input name="employeeNif" id="field_employeeNif" ng-model="vm.consortiumPersonalNomina.employeeNif" required><div ng-messages="editForm.employeeNif.$error"><div ng-message="required">El nif del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalNomina.employeeFirstName" for="field_employeeFirstName">Nombre del trabajador</label><input name="employeeFirstName" id="field_employeeFirstName" ng-model="vm.consortiumPersonalNomina.employeeFirstName" required><div ng-messages="editForm.employeeFirstName.$error"><div ng-message="required">El nombre del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Apellidos del trabajador</label><input ng-model="vm.consortiumPersonalNomina.employeeLastName" name="employeeLastName" id="field_employeeLastName" required><div ng-messages="editForm.employeeLastName.$error"><div ng-message="required">El apellido del trabajador es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-nominas/consortium-personal-nominas.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>N\xF3minas</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nueva n\xF3mina" ui-sref="consortium-personal-nominas.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_employee">Trabajador</label><input type="string" name="employee" id="field_employee" ng-model="vm.searchItem.employee"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar expedientes" aria-label="Buscar expedientes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Mes</span></th><th><span>Trabajador</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="consortiumPersonalNomina in vm.consortiumPersonalNominas track by consortiumPersonalNomina.id" ui-sref="consortium-personal-nominas.edit({id:consortiumPersonalNomina.id})"><td>{{consortiumPersonalNomina.year}}</td><td>{{consortiumPersonalNomina.month}}</td><td><div class="table-details"><div class="title">{{consortiumPersonalNomina.employeeFirstName}} {{consortiumPersonalNomina.employeeLastName}}</div><div class="detail">{{consortiumPersonalNomina.employeeNif}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumPersonalNomina.consortium.firstName}} {{consortiumPersonalNomina.consortium.lastName}}</div><div class="detail">{{consortiumPersonalNomina.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-otras/consortium-personal-otras-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-personal-otras"><md-icon>undo</md-icon></md-button><span>Edici\xF3n gesti\xF3n de personal</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumPersonalOtra.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.date" for="field_date">Fecha</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumPersonalOtra.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.concept" for="field_concept">Concepto</label><input name="concept" id="field_concept" ng-model="vm.consortiumPersonalOtra.concept" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumPersonalOtra.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.employeeNif" for="field_employeeNif">NIF del trabajador</label><input name="employeeNif" id="field_employeeNif" ng-model="vm.consortiumPersonalOtra.employeeNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeNif.$error"><div ng-message="required">El nif del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.employeeFirstName" for="field_employeeFirstName">Nombre del trabajador</label><input name="employeeFirstName" id="field_employeeFirstName" ng-model="vm.consortiumPersonalOtra.employeeFirstName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeFirstName.$error"><div ng-message="required">El nombre del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Apellidos del trabajador</label><input ng-model="vm.consortiumPersonalOtra.employeeLastName" name="employeeLastName" id="field_employeeLastName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeLastName.$error"><div ng-message="required">El apellido del trabajador es obligatorio</div></div></md-input-container></div><!-- CAMBIOS RENATO--><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-otras/consortium-personal-otras-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-personal-otras"><md-icon>undo</md-icon></md-button><span>Nueva gesti\xF3n de personal</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumPersonalOtra.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.date" for="field_date">Fecha</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumPersonalOtra.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.concept" for="field_concept">Concepto</label><input name="concept" id="field_concept" ng-model="vm.consortiumPersonalOtra.concept" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumPersonalOtra.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.employeeNif" for="field_employeeNif">NIF del trabajador</label><input name="employeeNif" id="field_employeeNif" ng-model="vm.consortiumPersonalOtra.employeeNif" required><div ng-messages="editForm.employeeNif.$error"><div ng-message="required">El nif del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalOtra.employeeFirstName" for="field_employeeFirstName">Nombre del trabajador</label><input name="employeeFirstName" id="field_employeeFirstName" ng-model="vm.consortiumPersonalOtra.employeeFirstName" required><div ng-messages="editForm.employeeFirstName.$error"><div ng-message="required">El nombre del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Apellidos del trabajador</label><input ng-model="vm.consortiumPersonalOtra.employeeLastName" name="employeeLastName" id="field_employeeLastName" required><div ng-messages="editForm.employeeLastName.$error"><div ng-message="required">El apellido del trabajador es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un seguro social" aria-label="Grabar seguro social">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-otras/consortium-personal-otras.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Otras gestiones de personal</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Otra nueva gesti\xF3n" ui-sref="consortium-personal-otras.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_employee">Trabajador</label><input type="string" name="employee" id="field_employee" ng-model="vm.searchItem.employee"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar seguros" aria-label="Buscar seguros" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Fecha</span></th><th><span>Concepto</span></th><th><span>Trabajador</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="consortiumPersonalOtra in vm.consortiumPersonalOtras track by consortiumPersonalOtra.id" ui-sref="consortium-personal-otras.edit({id:consortiumPersonalOtra.id})"><td>{{consortiumPersonalOtra.year}}</td><td>{{ consortiumPersonalOtra.date | date:\'dd/MM/yyyy\' }}</td><td>{{consortiumPersonalOtra.concept}}</td><td><div class="table-details"><div class="title">{{consortiumPersonalOtra.employeeFirstName}} {{consortiumPersonalOtra.employeeLastName}}</div><div class="detail">{{consortiumPersonalOtra.employeeNif}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumPersonalOtra.consortium.firstName}} {{consortiumPersonalOtra.consortium.lastName}}</div><div class="detail">{{consortiumPersonalOtra.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-seguros/consortium-personal-seguros-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-personal-seguros"><md-icon>undo</md-icon></md-button><span>Edici\xF3n seguro social</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalSeguro.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumPersonalSeguro.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_month">Mes</label><md-select id="field_month" name="month" ng-model="vm.consortiumPersonalSeguro.month" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="month in vm.months" ng-value="month">{{ month }}</md-option></md-select><div ng-messages="editForm.month.$error"><div ng-message="required">El mes es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumPersonalSeguro.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalSeguro.employeeNif" for="field_employeeNif">NIF del trabajador</label><input name="employeeNif" id="field_employeeNif" ng-model="vm.consortiumPersonalSeguro.employeeNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeNif.$error"><div ng-message="required">El nif del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalSeguro.employeeFirstName" for="field_employeeFirstName">Nombre del trabajador</label><input name="employeeFirstName" id="field_employeeFirstName" ng-model="vm.consortiumPersonalSeguro.employeeFirstName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeFirstName.$error"><div ng-message="required">El nombre del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Apellidos del trabajador</label><input ng-model="vm.consortiumPersonalSeguro.employeeLastName" name="employeeLastName" id="field_employeeLastName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.employeeLastName.$error"><div ng-message="required">El apellido del trabajador es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumPersonalSeguro.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumPersonalSeguro.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumPersonalSeguro.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-seguros/consortium-personal-seguros-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-personal-seguros"><md-icon>undo</md-icon></md-button><span>Nuevo seguro social</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalSeguro.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumPersonalSeguro.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_month">Mes</label><md-select id="field_month" name="month" ng-model="vm.consortiumPersonalSeguro.month" required><md-option ng-repeat="month in vm.months" ng-value="month">{{ month }}</md-option></md-select><div ng-messages="editForm.month.$error"><div ng-message="required">El mes es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumPersonalSeguro.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalSeguro.employeeNif" for="field_employeeNif">NIF del trabajador</label><input name="employeeNif" id="field_employeeNif" ng-model="vm.consortiumPersonalSeguro.employeeNif" required><div ng-messages="editForm.employeeNif.$error"><div ng-message="required">El nif del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumPersonalSeguro.employeeFirstName" for="field_employeeFirstName">Nombre del trabajador</label><input name="employeeFirstName" id="field_employeeFirstName" ng-model="vm.consortiumPersonalSeguro.employeeFirstName" required><div ng-messages="editForm.employeeFirstName.$error"><div ng-message="required">El nombre del trabajador es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Apellidos del trabajador</label><input ng-model="vm.consortiumPersonalSeguro.employeeLastName" name="employeeLastName" id="field_employeeLastName" required><div ng-messages="editForm.employeeLastName.$error"><div ng-message="required">El apellido del trabajador es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un seguro social" aria-label="Grabar seguro social">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-personal/consortium-personal-seguros/consortium-personal-seguros.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Seguros sociales</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo seguro social" ui-sref="consortium-personal-seguros.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_employee">Trabajador</label><input type="string" name="employee" id="field_employee" ng-model="vm.searchItem.employee"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar seguros" aria-label="Buscar seguros" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Mes</span></th><th><span>Trabajador</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="consortiumPersonalSeguro in vm.consortiumPersonalSeguros track by consortiumPersonalSeguro.id" ui-sref="consortium-personal-seguros.edit({id:consortiumPersonalSeguro.id})"><td>{{consortiumPersonalSeguro.year}}</td><td>{{consortiumPersonalSeguro.month}}</td><td><div class="table-details"><div class="title">{{consortiumPersonalSeguro.employeeFirstName}} {{consortiumPersonalSeguro.employeeLastName}}</div><div class="detail">{{consortiumPersonalSeguro.employeeNif}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumPersonalSeguro.consortium.firstName}} {{consortiumPersonalSeguro.consortium.lastName}}</div><div class="detail">{{consortiumPersonalSeguro.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-aeat/consortium-tributos-aeat-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-tributos-aeat"><md-icon>undo</md-icon></md-button><span>Edici\xF3n declaraci\xF3n AEAT</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumTributosAeat.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumTributosAeat.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumTributosAeat.model" for="field_model">Modelo</label><input type="text" name="model" id="field_model" ng-model="vm.consortiumTributosAeat.model" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.model.$error"><div ng-message="required">El modelo es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumTributosAeat.period" for="field_period">Periodo</label><input type="text" name="period" id="field_period" ng-model="vm.consortiumTributosAeat.period" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.period.$error"><div ng-message="required">El periodo es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumTributosAeat.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Concepto</label><input ng-model="vm.consortiumTributosAeat.concept" name="concept" id="field_concept" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumTributosAeat.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumTributosAeat.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumTributosAeat.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-aeat/consortium-tributos-aeat-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-tributos-aeat"><md-icon>undo</md-icon></md-button><span>Nueva declaraci\xF3n AEAT</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumTributosAeat.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumTributosAeat.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumTributosAeat.model" for="field_model">Modelo</label><input type="text" name="model" id="field_model" ng-model="vm.consortiumTributosAeat.model" required><div ng-messages="editForm.model.$error"><div ng-message="required">El modelo es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumTributosAeat.period" for="field_period">Periodo</label><input type="text" name="period" id="field_period" ng-model="vm.consortiumTributosAeat.period" required><div ng-messages="editForm.period.$error"><div ng-message="required">El periodo es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumTributosAeat.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Concepto</label><input ng-model="vm.consortiumTributosAeat.concept" name="concept" id="field_concept" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un tributo" aria-label="Grabar tributo">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-aeat/consortium-tributos-aeat.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Declaraciones AEAT</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nueva tributo" ui-sref="consortium-tributos-aeat.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">Ejercicio</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_concept">Concepto</label><input type="string" name="concept" id="field_concept" ng-model="vm.searchItem.concept"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar tributos" aria-label="Buscar tributos" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Ejercicio</span></th><th><span>Concepto</span></th><th><span>Modelo</span></th><th><span>Periodo</span></th><th><span>Consorcio</span></th></tr></thead><tbody><tr ng-repeat="item in vm.consortiumTributosAeatItems track by item.id" ui-sref="consortium-tributos-aeat.edit({id:item.id})"><td>{{item.year}}</td><td><div class="table-details"><div class="title">{{item.concept}}</div></div></td><td><div class="table-details"><div class="title">{{item.model}}</div></div></td><td><div class="table-details"><div class="title">{{item.period}}</div></div></td><td><div class="table-details"><div class="title">{{item.consortium.firstName}} {{item.consortium.lastName}}</div><div class="detail">{{item.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-ccaa/consortium-tributos-ccaa-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-tributos-ccaa"><md-icon>undo</md-icon></md-button><span>Edici\xF3n tributo abonado a CCAA</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosCcaa.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumTributosCcaa.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumTributosCcaa.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumTributosCcaa.entity" for="field_entity">Entidad</label><input name="entity" id="field_entity" ng-model="vm.consortiumTributosCcaa.entity" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.entity.$error"><div ng-message="required">La entidad es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosCcaa.paymentDate" for="field_paymentDate">Fecha de abono</label><input type="date" name="field_paymentDate" id="field_paymentDate" ng-model="vm.consortiumTributosCcaa.paymentDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.paymentDate.$error"><div ng-message="required">La fecha de abono es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosCcaa.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumTributosCcaa.amount" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Concepto</label><input ng-model="vm.consortiumTributosCcaa.concept" name="concept" id="field_concept" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumTributosCcaa.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumTributosCcaa.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumTributosCcaa.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-ccaa/consortium-tributos-ccaa-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-tributos-ccaa"><md-icon>undo</md-icon></md-button><span>Nuevo tributo abonado a CCAA</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosCcaa.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumTributosCcaa.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumTributosCcaa.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumTributosCcaa.entity" for="field_entity">Entidad</label><input name="entity" id="field_entity" ng-model="vm.consortiumTributosCcaa.entity" required><div ng-messages="editForm.entity.$error"><div ng-message="required">La entidad es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosCcaa.paymentDate" for="field_paymentDate">Fecha de abono</label><input type="date" name="field_paymentDate" id="field_paymentDate" ng-model="vm.consortiumTributosCcaa.paymentDate" required><div ng-messages="editForm.paymentDate.$error"><div ng-message="required">La fecha de abono es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosCcaa.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumTributosCcaa.amount" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Concepto</label><input ng-model="vm.consortiumTributosCcaa.concept" name="concept" id="field_concept" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un tributo" aria-label="Grabar tributo">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-ccaa/consortium-tributos-ccaa.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Tributos abonados a CCAA</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo tributo" ui-sref="consortium-tributos-ccaa.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">Ejercicio</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_text">Concepto o entidad</label><input type="string" name="text" id="field_text" ng-model="vm.searchItem.text"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar tributos" aria-label="Buscar tributos" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Ejercicio</span></th><th><span>Concepto</span></th><th><span>Entidad</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="item in vm.consortiumTributosCcaaItems track by item.id" ui-sref="consortium-tributos-ccaa.edit({id:item.id})"><td>{{item.year}}</td><td><div class="table-details"><div class="title">{{item.concept}}</div></div></td><td><div class="table-details"><div class="title">{{item.entity}}</div></div></td><td><div class="table-details"><div class="title">{{item.consortium.firstName}} {{item.consortium.lastName}}</div><div class="detail">{{item.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-devolucion/consortium-tributos-devolucion-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-tributos-devolucion"><md-icon>undo</md-icon></md-button><span>Edici\xF3n devoluci\xF3n de ingresos indebidos</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumTributosDevolucion.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumTributosDevolucion.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.entity" for="field_entity">Entidad</label><input name="entity" id="field_entity" ng-model="vm.consortiumTributosDevolucion.entity" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.entity.$error"><div ng-message="required">La entidad es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.requestDate" for="field_requestDate">Fecha de solicitud</label><input type="date" name="requestDate" id="field_requestDate" ng-model="vm.consortiumTributosDevolucion.requestDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.requestDate.$error"><div ng-message="required">La fecha de solicitud es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.resolutionDate" for="field_resolutionDate">Fecha de resoluci\xF3n</label><input type="date" name="resolutionDate" id="field_resolutionDate" ng-model="vm.consortiumTributosDevolucion.resolutionDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.resolutionDate.$error"><div ng-message="required">La fecha de resoluci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.incomeDate" for="field_incomeDate">Fecha de ingreso</label><input type="date" name="incomeDate" id="field_incomeDate" ng-model="vm.consortiumTributosDevolucion.incomeDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.incomeDate.$error"><div ng-message="required">La fecha de ingreso es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumTributosDevolucion.amount" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Concepto</label><input ng-model="vm.consortiumTributosDevolucion.concept" name="concept" id="field_concept" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-devolucion/consortium-tributos-devolucion-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-tributos-devolucion"><md-icon>undo</md-icon></md-button><span>Nueva devoluci\xF3n de ingresos indebidos</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumTributosDevolucion.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumTributosDevolucion.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.entity" for="field_entity">Entidad</label><input name="entity" id="field_entity" ng-model="vm.consortiumTributosDevolucion.entity" required><div ng-messages="editForm.entity.$error"><div ng-message="required">La entidad es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.requestDate" for="field_requestDate">Fecha de solicitud</label><input type="date" name="requestDate" id="field_requestDate" ng-model="vm.consortiumTributosDevolucion.requestDate" required><div ng-messages="editForm.requestDate.$error"><div ng-message="required">La fecha de solicitud es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.resolutionDate" for="field_resolutionDate">Fecha de resoluci\xF3n</label><input type="date" name="resolutionDate" id="field_resolutionDate" ng-model="vm.consortiumTributosDevolucion.resolutionDate" required><div ng-messages="editForm.resolutionDate.$error"><div ng-message="required">La fecha de resoluci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.incomeDate" for="field_incomeDate">Fecha de ingreso</label><input type="date" name="incomeDate" id="field_incomeDate" ng-model="vm.consortiumTributosDevolucion.incomeDate" required><div ng-messages="editForm.incomeDate.$error"><div ng-message="required">La fecha de ingreso es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosDevolucion.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumTributosDevolucion.amount" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Concepto</label><input ng-model="vm.consortiumTributosDevolucion.concept" name="concept" id="field_concept" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un tributo" aria-label="Grabar tributo">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-devolucion/consortium-tributos-devolucion.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Devoluciones de ingresos indebidos</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo tributo" ui-sref="consortium-tributos-devolucion.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">Ejercicio</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_text">Concepto o entidad</label><input type="string" name="text" id="field_text" ng-model="vm.searchItem.text"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar tributos" aria-label="Buscar tributos" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Ejercicio</span></th><th><span>Concepto</span></th><th><span>Entidad</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="item in vm.consortiumTributosDevolucionItems track by item.id" ui-sref="consortium-tributos-devolucion.edit({id:item.id})"><td>{{item.year}}</td><td><div class="table-details"><div class="title">{{item.concept}}</div></div></td><td><div class="table-details"><div class="title">{{item.entity}}</div></div></td><td><div class="table-details"><div class="title">{{item.consortium.firstName}} {{item.consortium.lastName}}</div><div class="detail">{{item.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-eell/consortium-tributos-eell-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-tributos-eell"><md-icon>undo</md-icon></md-button><span>Edici\xF3n tributo abonado a EELL</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosEell.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumTributosEell.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="30"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumTributosEell.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumTributosEell.entity" for="field_entity">Entidad</label><input name="entity" id="field_entity" ng-model="vm.consortiumTributosEell.entity" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.entity.$error"><div ng-message="required">La entidad es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosEell.paymentDate" for="field_paymentDate">Fecha de abono</label><input type="date" name="paymentDate" id="field_paymentDate" ng-model="vm.consortiumTributosEell.paymentDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.paymentDate.$error"><div ng-message="required">La fecha de abono es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.consortiumTributosEell.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumTributosEell.amount" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Concepto</label><input ng-model="vm.consortiumTributosEell.concept" name="concept" id="field_concept" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumTributosEell.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumTributosEell.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumTributosEell.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-eell/consortium-tributos-eell-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-tributos-eell"><md-icon>undo</md-icon></md-button><span>Nuevo tributo abonado a EELL</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosEell.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumTributosEell.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumTributosEell.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumTributosEell.entity" for="field_entity">Entidad</label><input name="entity" id="field_entity" ng-model="vm.consortiumTributosEell.entity" required><div ng-messages="editForm.entity.$error"><div ng-message="required">La entidad es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosEell.paymentDate" for="field_paymentDate">Fecha de abono</label><input type="date" name="paymentDate" id="field_paymentDate" ng-model="vm.consortiumTributosEell.paymentDate" required><div ng-messages="editForm.paymentDate.$error"><div ng-message="required">La fecha de abono es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosEell.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumTributosEell.amount" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Concepto</label><input ng-model="vm.consortiumTributosEell.concept" name="concept" id="field_concept" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un tributo" aria-label="Grabar tributo">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-eell/consortium-tributos-eell.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Tributos abonados a EELL</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo tributo" ui-sref="consortium-tributos-eell.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">Ejercicio</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_text">Concepto o entidad</label><input type="string" name="text" id="field_text" ng-model="vm.searchItem.text"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar tributos" aria-label="Buscar tributos" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Ejercicio</span></th><th><span>Concepto</span></th><th><span>Entidad</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="item in vm.consortiumTributosEellItems track by item.id" ui-sref="consortium-tributos-eell.edit({id:item.id})"><td>{{item.year}}</td><td><div class="table-details"><div class="title">{{item.concept}}</div></div></td><td><div class="table-details"><div class="title">{{item.entity}}</div></div></td><td><div class="table-details"><div class="title">{{item.consortium.firstName}} {{item.consortium.lastName}}</div><div class="detail">{{item.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-revision/consortium-tributos-revision-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-tributos-revision"><md-icon>undo</md-icon></md-button><span>Edici\xF3n revisi\xF3n de tributos</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumTributosRevision.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumTributosRevision.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumTributosRevision.entity" for="field_entity">Entidad</label><input name="entity" id="field_entity" ng-model="vm.consortiumTributosRevision.entity" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.entity.$error"><div ng-message="required">La entidad es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.requestDate" for="field_requestDate">Fecha de solicitud</label><input type="date" name="requestDate" id="field_requestDate" ng-model="vm.consortiumTributosRevision.requestDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.requestDate.$error"><div ng-message="required">La fecha de solicitud es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.resolutionDate" for="field_resolutionDate">Fecha de resoluci\xF3n</label><input type="date" name="resolutionDate" id="field_resolutionDate" ng-model="vm.consortiumTributosRevision.resolutionDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.resolutionDate.$error"><div ng-message="required">La fecha de resoluci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.incomeDate" for="field_incomeDate">Fecha de ingreso</label><input type="date" name="incomeDate" id="field_incomeDate" ng-model="vm.consortiumTributosRevision.incomeDate" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.incomeDate.$error"><div ng-message="required">La fecha de ingreso es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumTributosRevision.amount" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Concepto</label><input ng-model="vm.consortiumTributosRevision.concept" name="concept" id="field_concept" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-revision/consortium-tributos-revision-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-tributos-revision"><md-icon>undo</md-icon></md-button><span>Nueva revisi\xF3n de tributos</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.year" for="field_year">Ejercicio</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumTributosRevision.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El ejercicio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumTributosRevision.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumTributosRevision.entity" for="field_entity">Entidad</label><input name="entity" id="field_entity" ng-model="vm.consortiumTributosRevision.entity" required><div ng-messages="editForm.entity.$error"><div ng-message="required">La entidad es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.requestDate" for="field_requestDate">Fecha de solicitud</label><input type="date" name="requestDate" id="field_requestDate" ng-model="vm.consortiumTributosRevision.requestDate" required><div ng-messages="editForm.requestDate.$error"><div ng-message="required">La fecha de solicitud es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.resolutionDate" for="field_resolutionDate">Fecha de resoluci\xF3n</label><input type="date" name="resolutionDate" id="field_resolutionDate" ng-model="vm.consortiumTributosRevision.resolutionDate" required><div ng-messages="editForm.resolutionDate.$error"><div ng-message="required">La fecha de resoluci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.incomeDate" for="field_incomeDate">Fecha de ingreso</label><input type="date" name="incomeDate" id="field_incomeDate" ng-model="vm.consortiumTributosRevision.incomeDate" required><div ng-messages="editForm.incomeDate.$error"><div ng-message="required">La fecha de ingreso es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.consortiumTributosRevision.amount" for="field_amount">Importe (\u20AC)</label><input type="number" name="amount" id="field_amount" ng-model="vm.consortiumTributosRevision.amount" required><div ng-messages="editForm.amount.$error"><div ng-message="required">El importe es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Concepto</label><input ng-model="vm.consortiumTributosRevision.concept" name="concept" id="field_concept" required><div ng-messages="editForm.concept.$error"><div ng-message="required">El concepto es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un tributo" aria-label="Grabar tributo">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-tributos/consortium-tributos-revision/consortium-tributos-revision.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Revisi\xF3n de tributos</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo tributo" ui-sref="consortium-tributos-revision.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">Ejercicio</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_text">Concepto o entidad</label><input type="string" name="text" id="field_text" ng-model="vm.searchItem.text"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar tributos" aria-label="Buscar tributos" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Ejercicio</span></th><th><span>Concepto</span></th><th><span>Entidad</span></th><th><span>Consorcio</span></th><!--<th class="hidden-sm hidden-xs"><span>Notas</span></th> --></tr></thead><tbody><tr ng-repeat="item in vm.consortiumTributosRevisionItems track by item.id" ui-sref="consortium-tributos-revision.edit({id:item.id})"><td>{{item.year}}</td><td><div class="table-details"><div class="title">{{item.concept}}</div></div></td><td><div class="table-details"><div class="title">{{item.entity}}</div></div></td><td><div class="table-details"><div class="title">{{item.consortium.firstName}} {{item.consortium.lastName}}</div><div class="detail">{{item.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-aportantes/lebaniego-aportante-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contributor"><md-icon>undo</md-icon></md-button><span>Aportante {{vm.actualContributor}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-tabs md-dynamic-height="" md-border-bottom="" class="md-default-theme content-detail"><md-tab label="Datos generales"><md-content class="md-padding"><md-card flex><md-card-content><div class="md-inline-form"><form name="editForm" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.gFile.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorBusinessName" for="field_sectorBusinessName">Raz\xF3n social</label><input type="text" name="sectorBusinessName" id="field_sectorBusinessName" ng-model="vm.gFile.sectorBusinessName" required><div ng-messages="editForm.sectorBusinessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorNif" for="field_sectorNif">NIF</label><input type="text" name="sectorNif" id="field_sectorNif" ng-model="vm.gFile.sectorNif" required><div ng-messages="editForm.sectorNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.sectorDate" for="field_sectorDate">Fecha</label><input type="date" name="sectorDate" id="field_sectorDate" ng-model="vm.gFile.sectorDate" required><div ng-messages="editForm.sectorDate.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.sectorContact" for="field_sectorContact">Persona de contacto</label><input type="text" name="sectorContact" id="field_sectorContact" ng-model="vm.gFile.sectorContact" required><div ng-messages="editForm.sectorContact.$error"><div ng-message="required">La persona de contacto es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorAddress" for="field_sectorAddress">Direcci\xF3n</label><input type="text" name="sectorAddress" id="field_sectorAddress" ng-model="vm.gFile.sectorAddress" required><div ng-messages="editForm.sectorAddress.$error"><div ng-message="required">La direcci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorEmail" for="field_sectorEmail">Correo Electr\xF3nico</label><input type="text" name="sectorEmail" id="field_sectorEmail" ng-model="vm.gFile.sectorEmail" required><div ng-messages="editForm.sectorEmail.$error"><div ng-message="required">El correo electr\xF3nico es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorTelephone" for="field_sectorTelephone">Tel\xE9fono</label><input type="text" name="sectorTelephone" id="field_sectorTelephone" ng-model="vm.gFile.sectorTelephone" required><div ng-messages="editForm.sectorTelephone.$error"><div ng-message="required">El tel\xE9fono es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid" class="md-raised md-primary" title="Actualizar aportante" aria-label="Actualizar aportante">Guardar</md-button></section></form></div></md-card-content></md-card></md-content></md-tab><md-tab label="Fases"><md-content class="md-padding"><div layout="row" layout-wrap ng-hide="vm.newstepform === true || vm.editstepform === true  || vm.newstepactionform === true || vm.editstepactionform === true || vm.newdocumentform === true || vm.editdocumentform === true || vm.newstepactionactionform === true || vm.editstepactionactionform === true"><md-card flex><md-card-content><div layout="row" layout-align="end center" flex="100" ng-if="vm.isAdmin"><md-button ng-click="vm.openNewStepForm(null)" class="md-primary add-phase">A\xF1adir fase</md-button></div><div ui-tree id="tree-root" ng-if="vm.nodes.length > 0" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.nodes"><li ng-repeat="node in vm.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></md-card-content></md-card></div><new-gfile-step ng-show="vm.newstepform === true" data-stepparent="vm.stepParent" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-newstepform="vm.newstepform"></new-gfile-step><edit-gfile-step ng-show="vm.editstepform === true" data-updatetree="vm.updatetree" data-gfilestep="vm.gfilestep" data-isdeletedstep="vm.isdeletedstep" data-editstepform="vm.editstepform"></edit-gfile-step><new-document ng-show="vm.newdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform" data-newdocumentform="vm.newdocumentform"></new-document><edit-document ng-show="vm.editdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform"></edit-document></md-content></md-tab><md-tab label="Tareas" ng-if="vm.isAdmin"><md-content class="md-padding"><tasks data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></tasks></md-content></md-tab><md-tab ng-if="vm.isAdmin"><md-tab-label><span class="has-notes" ng-show="hasNotes > 0">Notas ({{hasNotes}}) </span><span ng-hide="hasNotes > 0">Notas</span></md-tab-label><md-tab-body class="md-padding"><notes data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></notes></md-tab-body></md-tab></md-tabs></md-content><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\n      <div class="node-item" >\n        <md-button class="md-icon-button" aria-label="Collapse tree"  ng-if="node.nodes && node.nodes.length > 0" data-nodrag ng-click="toggle(this)">\n          <md-icon ng-if="!collapsed">keyboard_arrow_down</md-icon>\n          <md-icon ng-if="collapsed">keyboard_arrow_right</md-icon>\n        </md-button>\n        <md-icon ng-if="node.type==\'D\'" class="document-icon">description</md-icon>\n        <div class="step-description" ng-class="{\'step-description-margin\': !node.nodes || node.nodes.length <= 0}">\n            <div class="title" ng-class="{\'step-title\': node.level == 0, \'step-1-title\': node.level == 1, \'step-2-title\': node.level == 2 , \'step-3-title\': node.level == 3}" ng-show="node.type != \'D\'">{{node.title}} <span ng-if="node.status">( {{node.status}} )</span></div>\n            <div class="title" ng-show="node.type == \'D\'" >{{node.title}}</div>\n            <div class="period" ng-show="node.date">\n                <span ng-if="node.dateLabel">{{node.dateLabel}}</span> {{node.date}}\n                <div ng-show="node.date2"><span ng-if="node.date2Label">{{node.date2Label}}</span>{{node.date2}}</div>\n            </div>\n        </div>\n      </div>\n      <div ng-if="node.type != \'D\'">\n        <md-button aria-label="Editar fase" title="Editar fase"\n                   class="md-icon-button" ng-disabled="!vm.isAdmin"\n                   data-nodrag\n                   ng-click="vm.edit_gstep(node.id, node.nodes.length > 0)">\n            <md-tooltip md-direction="left">Editar fase</md-tooltip>\n            <md-icon aria-label="Editar fase">mode_edit</md-icon>\n        </md-button>\n        <md-button aria-label="Nueva actuaci\xF3n" title="Nueva actuaci\xF3n"\n                   class="md-icon-button" ng-disabled="!vm.isAdmin"\n                   data-nodrag\n                   ng-click="vm.openNewStepForm(node.id)">\n            <md-tooltip md-direction="left">A\xF1adir nueva fase</md-tooltip>\n            <md-icon aria-label="Nueva actuaci\xF3n">add_circle</md-icon>\n        </md-button>\n        <md-button aria-label="A\xF1adir documento" title="A\xF1adir documento"\n                   data-nodrag\n                   ng-click="vm.new_document(node.id)"\n                   ng-disabled="!vm.isAdmin"\n                   ng-show="node.documents"\n                   class="md-icon-button">\n            <md-tooltip md-direction="left">A\xF1adir un nuevo documento</md-tooltip>\n            <md-icon aria-label="A\xF1adir documento">note_add</md-icon>\n        </md-button>\n      </div>\n      <div ng-if="node.type == \'D\'">\n          <md-button aria-label="Editar documento" title="Editar documento"\n              ng-click="vm.edit_document(node.id)"\n              ng-hide="!vm.isAdmin"\n              class="md-icon-button">\n              <md-icon aria-label="Editar documento">mode_edit</md-icon>\n          </md-button>\n          <md-button aria-label="Descargar documento" title="Descargar documento"\n              ng-click="vm.download_file(node.id, \'file\')"\n              class="md-icon-button">\n              <md-icon aria-label="Descargar documento">cloud_download</md-icon>\n          </md-button>\n      </div> \n    </div>\n    <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\n      <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\n    </ol></script><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/lebaniego/lebaniego-aportantes/lebaniego-aportante-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contributor"><md-icon>undo</md-icon></md-button><span>Nuevo aportante</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><span>Seleccione los datos del aportante de un contacto previo:</span></div><div layout="row"><md-autocomplete flex id="custom-autocomplete" md-selected-item="selectedItem" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}} - {{item.sectorContact}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found></md-autocomplete></div><div layout="row" class="mb-10"><span>O crea un nuevo aportante rellenando los campos:</span></div><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.gFile.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorBusinessName" for="field_sectorBusinessName">Raz\xF3n social</label><input type="text" name="sectorBusinessName" id="field_sectorBusinessName" ng-model="vm.gFile.sectorBusinessName" required><div ng-messages="editForm.sectorBusinessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorNif" for="field_sectorNif">NIF</label><input type="text" name="sectorNif" id="field_sectorNif" ng-model="vm.gFile.sectorNif" required><div ng-messages="editForm.sectorNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.sectorDate" for="field_sectorDate">Fecha</label><input type="date" name="sectorDate" id="field_sectorDate" ng-model="vm.gFile.sectorDate" required><div ng-messages="editForm.sectorDate.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.sectorContact" for="field_sectorContact">Persona de contacto</label><input type="text" name="sectorContact" id="field_sectorContact" ng-model="vm.gFile.sectorContact" required><div ng-messages="editForm.sectorContact.$error"><div ng-message="required">La persona de contacto es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorAddress" for="field_sectorAddress">Direcci\xF3n</label><input type="text" name="sectorAddress" id="field_sectorAddress" ng-model="vm.gFile.sectorAddress" required><div ng-messages="editForm.sectorAddress.$error"><div ng-message="required">La direcci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorEmail" for="field_sectorEmail">Correo Electr\xF3nico</label><input type="text" name="sectorEmail" id="field_sectorEmail" ng-model="vm.gFile.sectorEmail" required><div ng-messages="editForm.sectorEmail.$error"><div ng-message="required">El correo electr\xF3nico es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorTelephone" for="field_sectorTelephone">Tel\xE9fono</label><input type="text" name="sectorTelephone" id="field_sectorTelephone" ng-model="vm.gFile.sectorTelephone" required><div ng-messages="editForm.sectorTelephone.$error"><div ng-message="required">El tel\xE9fono es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un aportante" aria-label="Grabar aportante">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-aportantes/lebaniego-aportante.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Aportantes</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo aportante" ui-sref="lebaniego-contributor.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar aportantes" aria-label="Buscar aportantes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>Fecha</span></th><th><span>Contacto</span></th></tr></thead><tbody><tr ng-repeat="gFile in vm.gFiles track by gFile.gFileId" ui-sref="lebaniego-contributor.edit({id:gFile.gFileId})"><td>{{ gFile.year }}</td><td><div class="table-details"><div class="title">{{ gFile.sectorBusinessName }}</div><div class="detail">{{ gFile.sectorNif }}</div></div></td><td>{{ gFile.sectorDate }}</td><td>{{ gFile.sectorContact }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-convenios/lebaniego-convenio-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-agreement"><md-icon>undo</md-icon></md-button><span>Convenio {{vm.actualAgreement}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-tabs md-dynamic-height="" md-border-bottom="" class="md-default-theme content-detail"><md-tab label="Datos generales"><md-content class="md-padding"><md-card flex><md-card-content><div class="md-inline-form"><form name="editForm" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.gFile.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorBusinessName" for="field_sectorBusinessName">Raz\xF3n social</label><input type="text" name="sectorBusinessName" id="field_sectorBusinessName" ng-model="vm.gFile.sectorBusinessName" required><div ng-messages="editForm.sectorBusinessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorNif" for="field_sectorNif">NIF</label><input type="text" name="sectorNif" id="field_sectorNif" ng-model="vm.gFile.sectorNif" required><div ng-messages="editForm.sectorNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.sectorDate" for="field_sectorDate">Fecha</label><input type="date" name="sectorDate" id="field_sectorDate" ng-model="vm.gFile.sectorDate" required><div ng-messages="editForm.sectorDate.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.sectorContact" for="field_sectorContact">Persona de contacto</label><input type="text" name="sectorContact" id="field_sectorContact" ng-model="vm.gFile.sectorContact" required><div ng-messages="editForm.sectorContact.$error"><div ng-message="required">La persona de contacto es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorAddress" for="field_sectorAddress">Direcci\xF3n</label><input type="text" name="sectorAddress" id="field_sectorAddress" ng-model="vm.gFile.sectorAddress" required><div ng-messages="editForm.sectorAddress.$error"><div ng-message="required">La direcci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorEmail" for="field_sectorEmail">Correo Electr\xF3nico</label><input type="text" name="sectorEmail" id="field_sectorEmail" ng-model="vm.gFile.sectorEmail" required><div ng-messages="editForm.sectorEmail.$error"><div ng-message="required">El correo electr\xF3nico es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorTelephone" for="field_sectorTelephone">Tel\xE9fono</label><input type="text" name="sectorTelephone" id="field_sectorTelephone" ng-model="vm.gFile.sectorTelephone" required><div ng-messages="editForm.sectorTelephone.$error"><div ng-message="required">El tel\xE9fono es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid" class="md-raised md-primary" title="Actualizar convenio" aria-label="Actualizar convenio">Guardar</md-button></section></form></div></md-card-content></md-card></md-content></md-tab><md-tab label="Fases"><md-content class="md-padding"><div layout="row" layout-wrap ng-hide="vm.newstepform === true || vm.editstepform === true  || vm.newstepactionform === true || vm.editstepactionform === true || vm.newdocumentform === true || vm.editdocumentform === true || vm.newstepactionactionform === true || vm.editstepactionactionform === true"><md-card flex><md-card-content><div layout="row" layout-align="end center" flex="100" ng-if="vm.isAdmin"><md-button ng-click="vm.openNewStepForm(null)" class="md-primary add-phase">A\xF1adir fase</md-button></div><div ui-tree id="tree-root" ng-if="vm.nodes.length > 0" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.nodes"><li ng-repeat="node in vm.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></md-card-content></md-card></div><new-gfile-step ng-show="vm.newstepform === true" data-stepparent="vm.stepParent" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-newstepform="vm.newstepform"></new-gfile-step><edit-gfile-step ng-show="vm.editstepform === true" data-updatetree="vm.updatetree" data-gfilestep="vm.gfilestep" data-isdeletedstep="vm.isdeletedstep" data-editstepform="vm.editstepform"></edit-gfile-step><new-document ng-show="vm.newdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform" data-newdocumentform="vm.newdocumentform"></new-document><edit-document ng-show="vm.editdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform"></edit-document></md-content></md-tab><md-tab label="Tareas" ng-if="vm.isAdmin"><md-content class="md-padding"><tasks data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></tasks></md-content></md-tab><md-tab ng-if="vm.isAdmin"><md-tab-label><span class="has-notes" ng-show="hasNotes > 0">Notas ({{hasNotes}}) </span><span ng-hide="hasNotes > 0">Notas</span></md-tab-label><md-tab-body class="md-padding"><notes data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></notes></md-tab-body></md-tab></md-tabs></md-content><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\n      <div class="node-item" >\n        <md-button class="md-icon-button" aria-label="Collapse tree"  ng-if="node.nodes && node.nodes.length > 0" data-nodrag ng-click="toggle(this)">\n          <md-icon ng-if="!collapsed">keyboard_arrow_down</md-icon>\n          <md-icon ng-if="collapsed">keyboard_arrow_right</md-icon>\n        </md-button>\n        <md-icon ng-if="node.type==\'D\'" class="document-icon">description</md-icon>\n        <div class="step-description" ng-class="{\'step-description-margin\': !node.nodes || node.nodes.length <= 0}">\n            <div class="title" ng-class="{\'step-title\': node.level == 0, \'step-1-title\': node.level == 1, \'step-2-title\': node.level == 2 , \'step-3-title\': node.level == 3}" ng-show="node.type != \'D\'">{{node.title}} <span ng-if="node.status">( {{node.status}} )</span></div>\n            <div class="title" ng-show="node.type == \'D\'" >{{node.title}}</div>\n            <div class="period" ng-show="node.date">\n                <span ng-if="node.dateLabel">{{node.dateLabel}}</span> {{node.date}}\n                <div ng-show="node.date2"><span ng-if="node.date2Label">{{node.date2Label}}</span>{{node.date2}}</div>\n            </div>\n        </div>\n      </div>\n      <div ng-if="node.type != \'D\'">\n        <md-button aria-label="Editar fase" title="Editar fase"\n                   class="md-icon-button" ng-disabled="!vm.isAdmin"\n                   data-nodrag\n                   ng-click="vm.edit_gstep(node.id, node.nodes.length > 0)">\n            <md-tooltip md-direction="left">Editar fase</md-tooltip>\n            <md-icon aria-label="Editar fase">mode_edit</md-icon>\n        </md-button>\n        <md-button aria-label="Nueva actuaci\xF3n" title="Nueva actuaci\xF3n"\n                   class="md-icon-button" ng-disabled="!vm.isAdmin"\n                   data-nodrag\n                   ng-click="vm.openNewStepForm(node.id)">\n            <md-tooltip md-direction="left">A\xF1adir nueva fase</md-tooltip>\n            <md-icon aria-label="Nueva actuaci\xF3n">add_circle</md-icon>\n        </md-button>\n        <md-button aria-label="A\xF1adir documento" title="A\xF1adir documento"\n                   data-nodrag\n                   ng-click="vm.new_document(node.id)"\n                   ng-disabled="!vm.isAdmin"\n                   ng-show="node.documents"\n                   class="md-icon-button">\n            <md-tooltip md-direction="left">A\xF1adir un nuevo documento</md-tooltip>\n            <md-icon aria-label="A\xF1adir documento">note_add</md-icon>\n        </md-button>\n      </div>\n      <div ng-if="node.type == \'D\'">\n          <md-button aria-label="Editar documento" title="Editar documento"\n              ng-click="vm.edit_document(node.id)"\n              ng-hide="!vm.isAdmin"\n              class="md-icon-button">\n              <md-icon aria-label="Editar documento">mode_edit</md-icon>\n          </md-button>\n          <md-button aria-label="Descargar documento" title="Descargar documento"\n              ng-click="vm.download_file(node.id, \'file\')"\n              class="md-icon-button">\n              <md-icon aria-label="Descargar documento">cloud_download</md-icon>\n          </md-button>\n      </div> \n    </div>\n    <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\n      <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\n    </ol></script><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/lebaniego/lebaniego-convenios/lebaniego-convenio-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-agreement"><md-icon>undo</md-icon></md-button><span>Nuevo convenio</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.gFile.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorBusinessName" for="field_sectorBusinessName">Raz\xF3n social</label><input type="text" name="sectorBusinessName" id="field_sectorBusinessName" ng-model="vm.gFile.sectorBusinessName" required><div ng-messages="editForm.sectorBusinessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorNif" for="field_sectorNif">NIF</label><input type="text" name="sectorNif" id="field_sectorNif" ng-model="vm.gFile.sectorNif" required><div ng-messages="editForm.sectorNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.sectorDate" for="field_sectorDate">Fecha</label><input type="date" name="sectorDate" id="field_sectorDate" ng-model="vm.gFile.sectorDate" required><div ng-messages="editForm.sectorDate.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.sectorContact" for="field_sectorContact">Persona de contacto</label><input type="text" name="sectorContact" id="field_sectorContact" ng-model="vm.gFile.sectorContact" required><div ng-messages="editForm.sectorContact.$error"><div ng-message="required">La persona de contacto es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorAddress" for="field_sectorAddress">Direcci\xF3n</label><input type="text" name="sectorAddress" id="field_sectorAddress" ng-model="vm.gFile.sectorAddress" required><div ng-messages="editForm.sectorAddress.$error"><div ng-message="required">La direcci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorEmail" for="field_sectorEmail">Correo Electr\xF3nico</label><input type="text" name="sectorEmail" id="field_sectorEmail" ng-model="vm.gFile.sectorEmail" required><div ng-messages="editForm.sectorEmail.$error"><div ng-message="required">El correo electr\xF3nico es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorTelephone" for="field_sectorTelephone">Tel\xE9fono</label><input type="text" name="sectorTelephone" id="field_sectorTelephone" ng-model="vm.gFile.sectorTelephone" required><div ng-messages="editForm.sectorTelephone.$error"><div ng-message="required">El tel\xE9fono es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un convenio" aria-label="Grabar convenio">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-convenios/lebaniego-convenio.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Convenios de colaboraci\xF3n</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo convenio" ui-sref="lebaniego-agreement.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar convenios" aria-label="Buscar convenios" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>Fecha</span></th><th><span>Contacto</span></th></tr></thead><tbody><tr ng-repeat="gFile in vm.gFiles track by gFile.gFileId" ui-sref="lebaniego-agreement.edit({id:gFile.gFileId})"><td>{{ gFile.year }}</td><td><div class="table-details"><div class="title">{{ gFile.sectorBusinessName }}</div><div class="detail">{{ gFile.sectorNif }}</div></div></td><td>{{ gFile.sectorDate }}</td><td>{{ gFile.sectorContact }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-cuantias/lebaniego-cuantia.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Cuant\xEDas</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-select placeholder="Tipo de cuant\xEDa" id="jurisdiction" name="jurisdiction" ng-model="vm.searchItem.jurisdiction" flex><md-option ng-value="jurisdiction" ng-repeat="jurisdiction in vm.jurisdictions">{{ jurisdiction }}</md-option></md-select><md-button type="submit" class="md-primary" title="Buscar cuant\xEDas" aria-label="Buscar cuant\xEDas" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap class="justify-content-end mb-5"><md-content class="md-whiteframe-4dp result-box px-50 py-15"><span>Cuant\xEDa total: <b>{{ vm.totalAmount | currency: \'\u20AC\' }}</b></span></md-content></div><div layout="row" layout-wrap><md-content flex class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>Tipo</span></th><th><span>Cuant\xEDa</span></th></tr></thead><tbody><tr ng-repeat="amount in vm.amounts track by amount.id"><td>{{ amount.year }}</td><td>{{ amount.businessName }}</td><td>{{ amount.type }}</td><td>{{ amount.amount | currency: \'\u20AC\' }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="false"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-donantes/lebaniego-donante-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-donor"><md-icon>undo</md-icon></md-button><span>Donante {{vm.actualDonor}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-tabs md-dynamic-height="" md-border-bottom="" class="md-default-theme content-detail"><md-tab label="Datos generales"><md-content class="md-padding"><md-card flex><md-card-content><div class="md-inline-form"><form name="editForm" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.gFile.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorBusinessName" for="field_sectorBusinessName">Raz\xF3n social</label><input type="text" name="sectorBusinessName" id="field_sectorBusinessName" ng-model="vm.gFile.sectorBusinessName" required><div ng-messages="editForm.sectorBusinessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorNif" for="field_sectorNif">NIF</label><input type="text" name="sectorNif" id="field_sectorNif" ng-model="vm.gFile.sectorNif" required><div ng-messages="editForm.sectorNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.sectorDate" for="field_sectorDate">Fecha</label><input type="date" name="sectorDate" id="field_sectorDate" ng-model="vm.gFile.sectorDate" required><div ng-messages="editForm.sectorDate.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.sectorContact" for="field_sectorContact">Persona de contacto</label><input type="text" name="sectorContact" id="field_sectorContact" ng-model="vm.gFile.sectorContact" required><div ng-messages="editForm.sectorContact.$error"><div ng-message="required">La persona de contacto es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorAddress" for="field_sectorAddress">Direcci\xF3n</label><input type="text" name="sectorAddress" id="field_sectorAddress" ng-model="vm.gFile.sectorAddress" required><div ng-messages="editForm.sectorAddress.$error"><div ng-message="required">La direcci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorEmail" for="field_sectorEmail">Correo Electr\xF3nico</label><input type="text" name="sectorEmail" id="field_sectorEmail" ng-model="vm.gFile.sectorEmail" required><div ng-messages="editForm.sectorEmail.$error"><div ng-message="required">El correo electr\xF3nico es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorTelephone" for="field_sectorTelephone">Tel\xE9fono</label><input type="text" name="sectorTelephone" id="field_sectorTelephone" ng-model="vm.gFile.sectorTelephone" required><div ng-messages="editForm.sectorTelephone.$error"><div ng-message="required">El tel\xE9fono es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid" class="md-raised md-primary" title="Actualizar donante" aria-label="Actualizar donante">Guardar</md-button></section></form></div></md-card-content></md-card></md-content></md-tab><md-tab label="Fases"><md-content class="md-padding"><div layout="row" layout-wrap ng-hide="vm.newstepform === true || vm.editstepform === true  || vm.newstepactionform === true || vm.editstepactionform === true || vm.newdocumentform === true || vm.editdocumentform === true || vm.newstepactionactionform === true || vm.editstepactionactionform === true"><md-card flex><md-card-content><div layout="row" layout-align="end center" flex="100" ng-if="vm.isAdmin"><md-button ng-click="vm.openNewStepForm(null)" class="md-primary add-phase">A\xF1adir fase</md-button></div><div ui-tree id="tree-root" ng-if="vm.nodes.length > 0" data-drag-enabled="false"><ol ui-tree-nodes ng-model="vm.nodes"><li ng-repeat="node in vm.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></md-card-content></md-card></div><new-gfile-step ng-show="vm.newstepform === true" data-stepparent="vm.stepParent" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-newstepform="vm.newstepform"></new-gfile-step><edit-gfile-step ng-show="vm.editstepform === true" data-updatetree="vm.updatetree" data-gfilestep="vm.gfilestep" data-isdeletedstep="vm.isdeletedstep" data-editstepform="vm.editstepform"></edit-gfile-step><new-document ng-show="vm.newdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform" data-newdocumentform="vm.newdocumentform"></new-document><edit-document ng-show="vm.editdocumentform === true" data-document="vm.document" data-gfilestep="vm.gfilestep" data-gfile="vm.gFile" data-updatetree="vm.updatetree" data-editdocumentform="vm.editdocumentform"></edit-document></md-content></md-tab><md-tab label="Tareas" ng-if="vm.isAdmin"><md-content class="md-padding"><tasks data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></tasks></md-content></md-tab><md-tab ng-if="vm.isAdmin"><md-tab-label><span class="has-notes" ng-show="hasNotes > 0">Notas ({{hasNotes}}) </span><span ng-hide="hasNotes > 0">Notas</span></md-tab-label><md-tab-body class="md-padding"><notes data-entitytype="vm.entityType" data-entityid="vm.gFile.id"></notes></md-tab-body></md-tab></md-tabs></md-content><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\n      <div class="node-item" >\n        <md-button class="md-icon-button" aria-label="Collapse tree"  ng-if="node.nodes && node.nodes.length > 0" data-nodrag ng-click="toggle(this)">\n          <md-icon ng-if="!collapsed">keyboard_arrow_down</md-icon>\n          <md-icon ng-if="collapsed">keyboard_arrow_right</md-icon>\n        </md-button>\n        <md-icon ng-if="node.type==\'D\'" class="document-icon">description</md-icon>\n        <div class="step-description" ng-class="{\'step-description-margin\': !node.nodes || node.nodes.length <= 0}">\n            <div class="title" ng-class="{\'step-title\': node.level == 0, \'step-1-title\': node.level == 1, \'step-2-title\': node.level == 2 , \'step-3-title\': node.level == 3}" ng-show="node.type != \'D\'">{{node.title}} <span ng-if="node.status">( {{node.status}} )</span></div>\n            <div class="title" ng-show="node.type == \'D\'" >{{node.title}}</div>\n            <div class="period" ng-show="node.date">\n                <span ng-if="node.dateLabel">{{node.dateLabel}}</span> {{node.date}}\n                <div ng-show="node.date2"><span ng-if="node.date2Label">{{node.date2Label}}</span>{{node.date2}}</div>\n            </div>\n        </div>\n      </div>\n      <div ng-if="node.type != \'D\'">\n        <md-button aria-label="Editar fase" title="Editar fase"\n                   class="md-icon-button" ng-disabled="!vm.isAdmin"\n                   data-nodrag\n                   ng-click="vm.edit_gstep(node.id, node.nodes.length > 0)">\n            <md-tooltip md-direction="left">Editar fase</md-tooltip>\n            <md-icon aria-label="Editar fase">mode_edit</md-icon>\n        </md-button>\n        <md-button aria-label="Nueva actuaci\xF3n" title="Nueva actuaci\xF3n"\n                   class="md-icon-button" ng-disabled="!vm.isAdmin"\n                   data-nodrag\n                   ng-click="vm.openNewStepForm(node.id)">\n            <md-tooltip md-direction="left">A\xF1adir nueva fase</md-tooltip>\n            <md-icon aria-label="Nueva actuaci\xF3n">add_circle</md-icon>\n        </md-button>\n        <md-button aria-label="A\xF1adir documento" title="A\xF1adir documento"\n                   data-nodrag\n                   ng-click="vm.new_document(node.id)"\n                   ng-disabled="!vm.isAdmin"\n                   ng-show="node.documents"\n                   class="md-icon-button">\n            <md-tooltip md-direction="left">A\xF1adir un nuevo documento</md-tooltip>\n            <md-icon aria-label="A\xF1adir documento">note_add</md-icon>\n        </md-button>\n      </div>\n      <div ng-if="node.type == \'D\'">\n          <md-button aria-label="Editar documento" title="Editar documento"\n              ng-click="vm.edit_document(node.id)"\n              ng-hide="!vm.isAdmin"\n              class="md-icon-button">\n              <md-icon aria-label="Editar documento">mode_edit</md-icon>\n          </md-button>\n          <md-button aria-label="Descargar documento" title="Descargar documento"\n              ng-click="vm.download_file(node.id, \'file\')"\n              class="md-icon-button">\n              <md-icon aria-label="Descargar documento">cloud_download</md-icon>\n          </md-button>\n      </div> \n    </div>\n    <ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{hidden: collapsed}">\n      <li ng-repeat="node in node.nodes" ui-tree-node ng-include="\'nodes_renderer.html\'"></li>\n    </ol></script><script type="text/ng-template" id="templates/deleteConfirmation.html"><div class="deleteConfirmation col-md-6 form-group">\n        <div data-ng-hide="isDeleting">\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="startDelete()">\n                <i class="fa fa-trash-o" aria-hidden="true"></i> Borrar\n            </button>\n        </div>\n        <div data-ng-show="isDeleting">\n            <button type="button" class="btn btn-default btn-sm" data-ng-click="cancel()">\n                <i class="fa fa-stop" aria-hidden="true"></i> Cancelar borrado\n            </button>\n            <button type="button" class="btn btn-danger btn-sm" data-ng-click="confirm()">\n                <i class="fa fa-check" aria-hidden="true"></i> Confirmar\n            </button>\n        </div>\n    </div></script>');
$templateCache.put('app/entities/lebaniego/lebaniego-donantes/lebaniego-donante-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-donor"><md-icon>undo</md-icon></md-button><span>Nuevo donante</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><span>Seleccione los datos del donante de un contacto previo:</span></div><div layout="row"><md-autocomplete flex id="custom-autocomplete" md-selected-item="selectedItem" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}} - {{item.sectorContact}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found></md-autocomplete></div><div layout="row" class="mb-10"><span>O crea un nuevo donante rellenando los campos:</span></div><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.gFile.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorBusinessName" for="field_sectorBusinessName">Raz\xF3n social</label><input type="text" name="sectorBusinessName" id="field_sectorBusinessName" ng-model="vm.gFile.sectorBusinessName" required><div ng-messages="editForm.sectorBusinessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorNif" for="field_sectorNif">NIF</label><input type="text" name="sectorNif" id="field_sectorNif" ng-model="vm.gFile.sectorNif" required><div ng-messages="editForm.sectorNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.gFile.sectorDate" for="field_sectorDate">Fecha</label><input type="date" name="sectorDate" id="field_sectorDate" ng-model="vm.gFile.sectorDate" required><div ng-messages="editForm.sectorDate.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.gFile.sectorContact" for="field_sectorContact">Persona de contacto</label><input type="text" name="sectorContact" id="field_sectorContact" ng-model="vm.gFile.sectorContact" required><div ng-messages="editForm.sectorContact.$error"><div ng-message="required">La persona de contacto es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.gFile.sectorAddress" for="field_sectorAddress">Direcci\xF3n</label><input type="text" name="sectorAddress" id="field_sectorAddress" ng-model="vm.gFile.sectorAddress" required><div ng-messages="editForm.sectorAddress.$error"><div ng-message="required">La direcci\xF3n es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorEmail" for="field_sectorEmail">Correo Electr\xF3nico</label><input type="text" name="sectorEmail" id="field_sectorEmail" ng-model="vm.gFile.sectorEmail" required><div ng-messages="editForm.sectorEmail.$error"><div ng-message="required">El correo electr\xF3nico es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.gFile.sectorTelephone" for="field_sectorTelephone">Tel\xE9fono</label><input type="text" name="sectorTelephone" id="field_sectorTelephone" ng-model="vm.gFile.sectorTelephone" required><div ng-messages="editForm.sectorTelephone.$error"><div ng-message="required">El tel\xE9fono es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un donante" aria-label="Grabar donante">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-donantes/lebaniego-donante.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Donantes</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo donante" ui-sref="lebaniego-donor.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar donantes" aria-label="Buscar donantes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>Fecha</span></th><th><span>Contacto</span></th></tr></thead><tbody><tr ng-repeat="gFile in vm.gFiles track by gFile.gFileId" ui-sref="lebaniego-donor.edit({id:gFile.gFileId})"><td>{{ gFile.year }}</td><td><div class="table-details"><div class="title">{{ gFile.sectorBusinessName }}</div><div class="detail">{{ gFile.sectorNif }}</div></div></td><td>{{ gFile.sectorDate }}</td><td>{{ gFile.sectorContact }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/shared/utils/template/confirmDelete.html','<div class="deleteConfirmation"><div data-ng-hide="isDeleting"><md-button type="button" class="md-raised md-warn" data-ng-click="startDelete()">Borrar</md-button></div><div data-ng-show="isDeleting"><md-button class="md-raised" data-ng-click="cancel()">Cancelar borrado</md-button><md-button class="md-raised md-warn" data-ng-click="confirm()">Confirmar</md-button></div></div>');
$templateCache.put('app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-informes/consortium-expediente-juridicos-informes-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-expediente-juridicos-informes"><md-icon>undo</md-icon></md-button><span>Edici\xF3n de informe</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><!-- A\xD1O --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumExpedienteJuridicoInforme.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><!-- MATERIA --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.matter" for="field_matter">Materia</label><input name="matter" id="field_matter" ng-model="vm.consortiumExpedienteJuridicoInforme.matter" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.matter.$error"><div ng-message="required">La materia es obligatoria</div></div></md-input-container><!-- FECHA --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.date" for="field_date">Fecha de informe</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumExpedienteJuridicoInforme.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><!-- CONSORCIO --><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumExpedienteJuridicoInforme.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><!-- NOMBRE --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.petitionerName" for="field_petitionerName">Nombre del solicitante</label><input name="petitionerName" id="field_petitionerName" ng-model="vm.consortiumExpedienteJuridicoInforme.petitionerName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.petitionerName.$error"><div ng-message="required">El nombre es obligatorio</div></div></md-input-container><!-- APELLIDO --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.petitionerSurname" for="field_petitionerSurname">Apellidos del solicitante</label><input name="petitionerSurname" id="field_petitionerSurname" ng-model="vm.consortiumExpedienteJuridicoInforme.petitionerSurname" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.petitionerSurname.$error"><div ng-message="required">Los apellidos son obligatorios</div></div></md-input-container><!-- CARGO --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.petitionerGrade" for="field_petitionerGrade">Cargo</label><input name="petitionerGrade" id="field_petitionerGrade" ng-model="vm.consortiumExpedienteJuridicoInforme.petitionerGrade" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.petitionerGrade.$error"><div ng-message="required">El cargo es obligatorio</div></div></md-input-container></div><div layout="row"><!-- DESCRIPCION --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.description" for="field_description">Descripci\xF3n</label><input name="description" id="field_description" ng-model="vm.consortiumExpedienteJuridicoInforme.description" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripi\xF3n es obligatoria</div></div></md-input-container></div><!-- COPY --><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div><!-- PASTE --></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-informes/consortium-expediente-juridicos-informes-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-expediente-juridicos-informes"><md-icon>undo</md-icon></md-button><span>Nuevo informe</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><!-- A\xD1O --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumExpedienteJuridicoInforme.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><!-- MATERIA --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.matter" for="field_matter">Materia</label><input name="matter" id="field_matter" ng-model="vm.consortiumExpedienteJuridicoInforme.matter" required><div ng-messages="editForm.matter.$error"><div ng-message="required">La materia es obligatoria</div></div></md-input-container><!-- FECHA --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.date" for="field_date">Fecha de informe</label><input type="date" name="field_date" id="field_date" ng-model="vm.consortiumExpedienteJuridicoInforme.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><!-- CONSORCIO --><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumExpedienteJuridicoInforme.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><!-- NOMBRE --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.petitionerName" for="field_petitionerName">Nombre del solicitante</label><input name="petitionerName" id="field_petitionerName" ng-model="vm.consortiumExpedienteJuridicoInforme.petitionerName" required><div ng-messages="editForm.petitionerName.$error"><div ng-message="required">El nombre es obligatorio</div></div></md-input-container><!-- APELLIDO --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.petitionerSurname" for="field_petitionerSurname">Apellidos del solicitante</label><input name="petitionerSurname" id="field_petitionerSurname" ng-model="vm.consortiumExpedienteJuridicoInforme.petitionerSurname" required><div ng-messages="editForm.petitionerSurname.$error"><div ng-message="required">Los apellidos son obligatorios</div></div></md-input-container><!-- CARGO --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.petitionerGrade" for="field_petitionerGrade">Cargo</label><input name="petitionerGrade" id="field_petitionerGrade" ng-model="vm.consortiumExpedienteJuridicoInforme.petitionerGrade" required><div ng-messages="editForm.petitionerGrade.$error"><div ng-message="required">El cargo es obligatorio</div></div></md-input-container></div><div layout="row"><!-- DESCRIPCION --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoInforme.description" for="field_description">Descripci\xF3n</label><input name="description" id="field_description" ng-model="vm.consortiumExpedienteJuridicoInforme.description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripi\xF3n es obligatoria</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un informe" aria-label="Grabar informe">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-informes/consortium-expediente-juridicos-informes.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Informes</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo contrato" ui-sref="consortium-expediente-juridicos-informes.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_matter">Materia</label><input type="string" name="matter" id="field_matter" ng-model="vm.searchItem.matter"></md-input-container><md-input-container class="md-block" flex><label for="field_petitioner">Solicitante</label><input type="string" name="petitioner" id="field_petitioner" ng-model="vm.searchItem.petitioner"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar seguros" aria-label="Buscar seguros" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Materia</span></th><th><span>Solicitante</span></th><th><span>Fecha informe</span></th><th><span>Consorcio</span></th></tr></thead><tbody><tr ng-repeat="consortiumExpedienteJuridicoInforme in vm.consortiumExpedienteJuridicosInformes track by consortiumExpedienteJuridicoInforme.id" ui-sref="consortium-expediente-juridicos-informes.edit({id:consortiumExpedienteJuridicoInforme.id})"><td>{{consortiumExpedienteJuridicoInforme.year}}</td><td><div class="table-details"><div class="title">{{consortiumExpedienteJuridicoInforme.matter}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumExpedienteJuridicoInforme.petitionerName}} {{consortiumExpedienteJuridicoInforme.petitionerSurname}}</div><div class="detail">{{consortiumExpedienteJuridicoInforme.petitionerGrade}}</div></div></td><td>{{ consortiumExpedienteJuridicoInforme.date | date:\'dd/MM/yyyy\' }}</td><td><div class="table-details"><div class="title">{{consortiumExpedienteJuridicoInforme.consortium.firstName}} {{consortiumExpedienteJuridicoInforme.consortium.lastName}}</div><div class="detail">{{consortiumExpedienteJuridicoInforme.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-judiciales/consortium-expediente-juridicos-judiciales-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-expediente-juridicos-judiciales"><md-icon>undo</md-icon></md-button><span>Edici\xF3n de expediente judicial</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><!-- A\xD1O --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumExpedienteJuridicoJudicial.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><!-- JURISDICCION --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.jurisdiction" for="field_jurisdiction">Jurisdicci\xF3n</label><input name="jurisdiction" id="field_jurisdiction" ng-model="vm.consortiumExpedienteJuridicoJudicial.jurisdiction" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.jurisdiction.$error"><div ng-message="required">La jurisdicci\xF3n es obligatoria</div></div></md-input-container><!-- N\xBA PROCEDIMIENTO --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.procedureNumber" for="field_procedureNumber">N\xBA de procedimiento</label><input type="number" name="procedureNumber" id="field_procedureNumber" ng-model="vm.consortiumExpedienteJuridicoJudicial.procedureNumber" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.procedureNumber.$error"><div ng-message="required">El n\xFAmero de procedimiento es obligatorio</div></div></md-input-container><!-- CONSORCIO --><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumExpedienteJuridicoJudicial.consortium.id" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><!-- DEMANDANTE NOMBRE --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.plaintiffName" for="field_plaintiffName">Nombre del demandante</label><input name="plaintiffName" id="field_plaintiffName" ng-model="vm.consortiumExpedienteJuridicoJudicial.plaintiffName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.plaintiffName.$error"><div ng-message="required">El nombre es obligatorio</div></div></md-input-container><!-- DEMANDANTE APELLIDO --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.plaintiffSurname" for="field_plaintiffSurname">Apellidos del demandante</label><input name="plaintiffSurname" id="field_plaintiffSurname" ng-model="vm.consortiumExpedienteJuridicoJudicial.plaintiffSurname" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.plaintiffSurname.$error"><div ng-message="required">Los apellidos son obligatorios</div></div></md-input-container><!-- DEMANDANTE NIF --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.plaintiffNif" for="field_plaintiffNif">NIF del demandante</label><input name="plaintiffNif" id="field_plaintiffNif" ng-model="vm.consortiumExpedienteJuridicoJudicial.plaintiffNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.plaintiffNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container></div><div layout="row"><!-- DEMANDADO NOMBRE --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.defendantName" for="field_defendantName">Nombre del demandado</label><input name="defendantName" id="field_defendantName" ng-model="vm.consortiumExpedienteJuridicoJudicial.defendantName" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El nombre es obligatorio</div></div></md-input-container><!-- DEMANDADO APELLIDO --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.defendantSurname" for="field_defendantSurname">Apellidos del demandado</label><input name="defendantSurname" id="field_defendantSurname" ng-model="vm.consortiumExpedienteJuridicoJudicial.defendantSurname" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantSurname.$error"><div ng-message="required">Los apellidos son obligatorios</div></div></md-input-container><!-- DEMANDADO NIF --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.defendantNif" for="field_defendantNif">NIF del demandado</label><input name="defendantNif" id="field_defendantNif" ng-model="vm.consortiumExpedienteJuridicoJudicial.defendantNif" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container></div><div layout="row"><!-- DESCRIPCION --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.description" for="field_description">Descripci\xF3n</label><input name="description" id="field_description" ng-model="vm.consortiumExpedienteJuridicoJudicial.description" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripi\xF3n es obligatoria</div></div></md-input-container></div><!-- COPY --><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-authority="ROLE_ADMIN"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.consortiumExpedienteJudicial.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.consortiumExpedienteJudicial.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.consortiumExpedienteJudicial.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-authority="ROLE_ADMIN" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-authority="ROLE_ADMIN" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-authority="ROLE_ADMIN"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div><!-- PASTE --></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-judiciales/consortium-expediente-juridicos-judiciales-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="consortium-expediente-juridicos-judiciales"><md-icon>undo</md-icon></md-button><span>Nuevo expediente judicial</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><!-- A\xD1O --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.consortiumExpedienteJuridicoJudicial.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><!-- JURISDICCION --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.jurisdiction" for="field_jurisdiction">Jurisdicci\xF3n</label><input name="jurisdiction" id="field_jurisdiction" ng-model="vm.consortiumExpedienteJuridicoJudicial.jurisdiction" required><div ng-messages="editForm.jurisdiction.$error"><div ng-message="required">La jurisdicci\xF3n es obligatoria</div></div></md-input-container><!-- N\xBA PROCEDIMIENTO --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.procedureNumber" for="field_procedureNumber">N\xBA de procedimiento</label><input type="number" name="procedureNumber" id="field_procedureNumber" ng-model="vm.consortiumExpedienteJuridicoJudicial.procedureNumber" required><div ng-messages="editForm.procedureNumber.$error"><div ng-message="required">El n\xFAmero de procedimiento es obligatorio</div></div></md-input-container><!-- CONSORCIO --><md-input-container class="md-block" flex="25"><label for="field_consortium">Consorcio</label><md-select id="field_consortium" name="consortium" ng-model="vm.consortiumExpedienteJuridicoJudicial.consortium.id" required><md-option ng-repeat="user in vm.consortiumUsers" ng-value="user.id">{{ user.firstName }} {{ user.lastName }}</md-option></md-select><div ng-messages="editForm.consortium.$error"><div ng-message="required">El consorcio es obligatorio</div></div></md-input-container></div><div layout="row"><!-- DEMANDANTE NOMBRE --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.plaintiffName" for="field_plaintiffName">Nombre del demandante</label><input name="plaintiffName" id="field_plaintiffName" ng-model="vm.consortiumExpedienteJuridicoJudicial.plaintiffName" required><div ng-messages="editForm.plaintiffName.$error"><div ng-message="required">El nombre es obligatorio</div></div></md-input-container><!-- DEMANDANTE APELLIDO --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.plaintiffSurname" for="field_plaintiffSurname">Apellidos del demandante</label><input name="plaintiffSurname" id="field_plaintiffSurname" ng-model="vm.consortiumExpedienteJuridicoJudicial.plaintiffSurname" required><div ng-messages="editForm.plaintiffSurname.$error"><div ng-message="required">Los apellidos son obligatorios</div></div></md-input-container><!-- DEMANDANTE NIF --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.plaintiffNif" for="field_plaintiffNif">NIF del demandante</label><input name="plaintiffNif" id="field_plaintiffNif" ng-model="vm.consortiumExpedienteJuridicoJudicial.plaintiffNif" required><div ng-messages="editForm.plaintiffNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container></div><div layout="row"><!-- DEMANDADO NOMBRE --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.defendantName" for="field_defendantName">Nombre del demandado</label><input name="defendantName" id="field_defendantName" ng-model="vm.consortiumExpedienteJuridicoJudicial.defendantName" required><div ng-messages="editForm.defendantName.$error"><div ng-message="required">El nombre es obligatorio</div></div></md-input-container><!-- DEMANDADO APELLIDO --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.defendantSurname" for="field_defendantSurname">Apellidos del demandado</label><input name="defendantSurname" id="field_defendantSurname" ng-model="vm.consortiumExpedienteJuridicoJudicial.defendantSurname" required><div ng-messages="editForm.defendantSurname.$error"><div ng-message="required">Los apellidos son obligatorios</div></div></md-input-container><!-- DEMANDADO NIF --><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.defendantNif" for="field_defendantNif">NIF del demandado</label><input name="defendantNif" id="field_defendantNif" ng-model="vm.consortiumExpedienteJuridicoJudicial.defendantNif" required><div ng-messages="editForm.defendantNif.$error"><div ng-message="required">El NIF es obligatorio</div></div></md-input-container></div><div layout="row"><!-- DESCRIPCION --><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.consortiumExpedienteJuridicoJudicial.description" for="field_description">Descripci\xF3n</label><input name="description" id="field_description" ng-model="vm.consortiumExpedienteJuridicoJudicial.description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripi\xF3n es obligatoria</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un expediente" aria-label="Grabar expediente">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/consortium-expediente/consortium-expediente-juridicos/consortium-expediente-juridicos-judiciales/consortium-expediente-juridicos-judiciales.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Expedientes Judiciales</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo expediente" ui-sref="consortium-expediente-juridicos-judiciales.new" has-authority="ROLE_ADMIN"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="integer" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_jurisdiction">Jurisdicci\xF3n</label><input type="string" name="jurisdiction" id="field_jurisdiction" ng-model="vm.searchItem.jurisdiction"></md-input-container><md-input-container class="md-block" flex><label for="field_demand">Demandante o demandado</label><input type="string" name="demand" id="field_demand" ng-model="vm.searchItem.demand"></md-input-container><md-input-container class="md-block" flex has-authority="ROLE_ADMIN"><label for="field_consortium">Consorcio</label><input type="string" name="consortium" id="field_consortium" ng-model="vm.searchItem.consortium"></md-input-container><md-button type="submit" class="md-primary" title="Buscar seguros" aria-label="Buscar seguros" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Jurisdicci\xF3n</span></th><th><span>Demandante</span></th><th><span>Demandado</span></th><th><span>Consorcio</span></th></tr></thead><tbody><tr ng-repeat="consortiumExpedienteJuridicoJudicial in vm.consortiumExpedienteJuridicosJudiciales track by consortiumExpedienteJuridicoJudicial.id" ui-sref="consortium-expediente-juridicos-judiciales.edit({id:consortiumExpedienteJuridicoJudicial.id})"><td>{{consortiumExpedienteJuridicoJudicial.year}}</td><td><div class="table-details"><div class="title">{{consortiumExpedienteJuridicoJudicial.jurisdiction}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumExpedienteJuridicoJudicial.plaintiffName}} {{consortiumExpedienteJuridicoJudicial.plaintiffSurname}}</div><div class="detail">{{consortiumExpedienteJuridicoJudicial.plaintiffNif}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumExpedienteJuridicoJudicial.defendantName}} {{consortiumExpedienteJuridicoJudicial.defendantSurname}}</div><div class="detail">{{consortiumExpedienteJuridicoJudicial.defendantNif}}</div></div></td><td><div class="table-details"><div class="title">{{consortiumExpedienteJuridicoJudicial.consortium.firstName}} {{consortiumExpedienteJuridicoJudicial.consortium.lastName}}</div><div class="detail">{{consortiumExpedienteJuridicoJudicial.consortium.nif}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-comision/lebaniego-comision-actas/lebaniego-comision-acta-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-comission-proceeding"><md-icon>undo</md-icon></md-button><span>Edici\xF3n acta</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionActa.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearComisionActa.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.lebaniegoYearComisionActa.description" name="description" ng-disabled="!vm.isAdmin" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionActa.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearComisionActa.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearComisionActa.proceedingNumber" for="field_proceeding_number">N\xFAmero de acta</label><input type="number" name="proceedingNumber" id="field_proceeding_number" ng-model="vm.lebaniegoYearComisionActa.proceedingNumber" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.proceedingNumber.$error"><div ng-message="required">El n\xFAmero de acta es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un acta" aria-label="Grabar acta">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionActa.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionActa.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionActa.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-comision/lebaniego-comision-actas/lebaniego-comision-acta-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-comission-proceeding"><md-icon>undo</md-icon></md-button><span>Nueva acta</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionActa.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearComisionActa.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearComisionActa.description" for="field_description">Descripci\xF3n</label><input type="string" name="description" id="field_description" ng-model="vm.lebaniegoYearComisionActa.description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionActa.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearComisionActa.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearComisionActa.proceedingNumber" for="field_proceeding_number">N\xFAmero de acta</label><input type="number" name="proceedingNumber" id="field_proceeding_number" ng-model="vm.lebaniegoYearComisionActa.proceedingNumber" required><div ng-messages="editForm.proceedingNumber.$error"><div ng-message="required">El n\xFAmero de acta es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar una acta" aria-label="Grabar acta">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-comision/lebaniego-comision-actas/lebaniego-comision-acta.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Acta</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nueva acta" ui-sref="lebaniego-comission-proceeding.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nueva</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_proceedingNumber">N\xFAmero de acta</label><input type="number" name="proceedingNumber" id="field_proceedingNumber" ng-model="vm.searchItem.proceedingNumber"></md-input-container><md-input-container class="md-block" flex><label for="field_year">Descripci\xF3n</label><input type="string" name="description" id="field_description" ng-model="vm.searchItem.description"></md-input-container><md-button type="submit" class="md-primary" title="Buscar actas" aria-label="Buscar actas" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Fecha</span></th><th><span>N\xFAmero de acta</span></th><th><span>Descripci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearComisionActa in vm.lebaniegoYearComisionActas track by lebaniegoYearComisionActa.id" ui-sref="lebaniego-comission-proceeding.edit({id:lebaniegoYearComisionActa.id})"><td>{{ lebaniegoYearComisionActa.year }}</td><td>{{ lebaniegoYearComisionActa.date | date:\'dd/MM/yyyy\' }}</td><td>{{ lebaniegoYearComisionActa.proceedingNumber }}</td><td><div class="table-details"><div class="title">{{lebaniegoYearComisionActa.description}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-reunion/lebaniego-contactos-reunion-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-meeting"><md-icon>undo</md-icon></md-button><span>Edici\xF3n reuni\xF3n</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosReunion.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosReunion.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosReunion.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosReunion.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label for="field_sector">Sector</label><md-select id="field_sector" name="sector" ng-model="vm.lebaniegoYearContactosReunion.sector" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="sector in vm.sectors" ng-value="sector">{{ sector }}</md-option></md-select><div ng-messages="editForm.sector.$error"><div ng-message="required">El sector es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosReunion.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label for="field_result">Resultado</label><md-select id="field_result" name="result" ng-model="vm.lebaniegoYearContactosReunion.result" required><md-option ng-repeat="result in vm.results" ng-value="result">{{ result }}</md-option></md-select><div ng-messages="editForm.result.$error"><div ng-message="required">El resultado es obligatorio</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-reunion/lebaniego-contactos-reunion-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-meeting"><md-icon>undo</md-icon></md-button><span>Nueva reuni\xF3n</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosReunion.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosReunion.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosReunion.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosReunion.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label for="field_sector">Sector</label><md-select id="field_sector" name="sector" ng-model="vm.lebaniegoYearContactosReunion.sector" required><md-option ng-repeat="sector in vm.sectors" ng-value="sector">{{ sector }}</md-option></md-select><div ng-messages="editForm.sector.$error"><div ng-message="required">El sector es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosReunion.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label for="field_result">Resultado</label><md-select id="field_result" name="result" ng-model="vm.lebaniegoYearContactosReunion.result" required><md-option ng-repeat="result in vm.results" ng-value="result">{{ result }}</md-option></md-select><div ng-messages="editForm.result.$error"><div ng-message="required">El resultado es obligatorio</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar una reuni\xF3n" aria-label="Grabar reuni\xF3n">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-reunion/lebaniego-contactos-reunion.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Programaci\xF3n de reuniones</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nueva reuni\xF3n" ui-sref="lebaniego-contacts-meeting.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nueva reuni\xF3n</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_sector">Sector</label><input type="string" name="sector" id="field_sector" ng-model="vm.searchItem.sector"></md-input-container><md-input-container class="md-block" flex><label for="field_result">Resultado</label><input type="string" name="result" id="field_result" ng-model="vm.searchItem.result"></md-input-container><md-button type="submit" class="md-primary" title="Buscar reuniones" aria-label="Buscar reuniones" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Fecha</span></th><th><span>Sector</span></th><th><span>Resultado</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearContactosReunion in vm.lebaniegoYearContactosReuniones track by lebaniegoYearContactosReunion.id" ui-sref="lebaniego-contacts-meeting.edit({id:lebaniegoYearContactosReunion.id})"><td>{{ lebaniegoYearContactosReunion.year }}</td><td>{{ lebaniegoYearContactosReunion.date | date:\'dd/MM/yyyy\' }}</td><td>{{ lebaniegoYearContactosReunion.sector }}</td><td>{{ lebaniegoYearContactosReunion.result }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-comision/lebaniego-comision-convocatorias/lebaniego-comision-convocatoria-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-comission-annoucement"><md-icon>undo</md-icon></md-button><span>Edici\xF3n convocatoria</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionConvocatoria.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearComisionConvocatoria.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.lebaniegoYearComisionConvocatoria.description" name="description" ng-disabled="!vm.isAdmin" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionConvocatoria.date" for="field_date">Fecha</label><input type="date" name="field_date" id="field_date" ng-model="vm.lebaniegoYearComisionConvocatoria.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar una convocatoria" aria-label="Grabar convocatoria">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionConvocatoria.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionConvocatoria.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionConvocatoria.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-comision/lebaniego-comision-convocatorias/lebaniego-comision-convocatoria-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-comission-annoucement"><md-icon>undo</md-icon></md-button><span>Nueva convocatoria</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionConvocatoria.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearComisionConvocatoria.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearComisionConvocatoria.description" for="field_description">Descripci\xF3n</label><input type="string" name="description" id="field_description" ng-model="vm.lebaniegoYearComisionConvocatoria.description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearComisionConvocatoria.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearComisionConvocatoria.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar una convocatoria" aria-label="Grabar convocatoria">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-comision/lebaniego-comision-convocatorias/lebaniego-comision-convocatoria.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Convocatoria</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nueva convocatoria" ui-sref="lebaniego-comission-annoucement.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nueva</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_year">Descripci\xF3n</label><input type="string" name="description" id="field_description" ng-model="vm.searchItem.description"></md-input-container><md-button type="submit" class="md-primary" title="Buscar convocatorias" aria-label="Buscar convocatorias" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Fecha</span></th><th><span>Descripci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearComisionConvocatoria in vm.lebaniegoYearComisionConvocatorias track by lebaniegoYearComisionConvocatoria.id" ui-sref="lebaniego-comission-annoucement.edit({id:lebaniegoYearComisionConvocatoria.id})"><td>{{ lebaniegoYearComisionConvocatoria.year }}</td><td>{{ lebaniegoYearComisionConvocatoria.date | date:\'dd/MM/yyyy\' }}</td><td><div class="table-details"><div class="title">{{lebaniegoYearComisionConvocatoria.description}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-visita/lebaniego-contactos-visita-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-visit"><md-icon>undo</md-icon></md-button><span>Edici\xF3n visita</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosVisita.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosVisita.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosVisita.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosVisita.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label for="field_sector">Sector</label><md-select id="field_sector" name="sector" ng-model="vm.lebaniegoYearContactosVisita.sector" ng-disabled="!vm.isAdmin" required><md-option ng-repeat="sector in vm.sectors" ng-value="sector">{{ sector }}</md-option></md-select><div ng-messages="editForm.sector.$error"><div ng-message="required">El sector es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosVisita.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosVisita.description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-visita/lebaniego-contactos-visita-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-visit"><md-icon>undo</md-icon></md-button><span>Nueva visita</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosVisita.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosVisita.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex="25"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosVisita.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosVisita.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex><label for="field_sector">Sector</label><md-select id="field_sector" name="sector" ng-model="vm.lebaniegoYearContactosVisita.sector" required><md-option ng-repeat="sector in vm.sectors" ng-value="sector">{{ sector }}</md-option></md-select><div ng-messages="editForm.sector.$error"><div ng-message="required">El sector es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosVisita.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosVisita.description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar una visita" aria-label="Grabar visita">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-visita/lebaniego-contactos-visita.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Programaci\xF3n de visitas</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nueva visita" ui-sref="lebaniego-contacts-visit.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nueva visita</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_sector">Sector</label><input type="string" name="sector" id="field_sector" ng-model="vm.searchItem.sector"></md-input-container><md-input-container class="md-block" flex><label for="field_description">Descripci\xF3n</label><input type="string" name="description" id="field_description" ng-model="vm.searchItem.description"></md-input-container><md-button type="submit" class="md-primary" title="Buscar visitas" aria-label="Buscar visitas" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Fecha</span></th><th><span>Sector</span></th><th><span>Descripci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearContactosVisita in vm.lebaniegoYearContactosVisitas track by lebaniegoYearContactosVisita.id" ui-sref="lebaniego-contacts-visit.edit({id:lebaniegoYearContactosVisita.id})"><td>{{ lebaniegoYearContactosVisita.year }}</td><td>{{ lebaniegoYearContactosVisita.date | date:\'dd/MM/yyyy\' }}</td><td>{{ lebaniegoYearContactosVisita.sector }}</td><td>{{ lebaniegoYearContactosVisita.description }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-control/lebaniego-control-aportantes/lebaniego-control-aportante-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-control-contributor"><md-icon>undo</md-icon></md-button><span>Aportante {{vm.actualBusinessName}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearControlContributor.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearControlContributor.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-input-name="contact" required md-selected-item="vm.lebaniegoYearControlContributor.gFile.sectorBusinessName" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found><div ng-messages="editForm.contact.$error"><div ng-message="required">El contacto es obligatorio</div></div></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearControlContributor.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearControlContributor.gFile.id" required><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearControlContributor.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearControlContributor.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearControlContributor.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-control/lebaniego-control-aportantes/lebaniego-control-aportante-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-control-contributor"><md-icon>undo</md-icon></md-button><span>Nuevo aportante</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><span>Seleccione la raz\xF3n social de un aportante previo:</span></div><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearControlContributor.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearControlContributor.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-input-name="contact" required md-selected-item="selectedItem" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found><div ng-messages="editForm.contact.$error"><div ng-message="required">El contacto es obligatorio</div></div></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearControlContributor.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearControlContributor.gFile" required><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un aportante" aria-label="Grabar aportante">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-control/lebaniego-control-aportantes/lebaniego-control-aportante.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Control operativo del proyecto - Aportantes</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo aportante" ui-sref="lebaniego-control-contributor.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar aportantes" aria-label="Buscar aportantes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearControlContributor in vm.lebaniegoYearControlContributors track by lebaniegoYearControlContributor.id" ui-sref="lebaniego-control-contributor.edit({id:lebaniegoYearControlContributor.id})"><td>{{ lebaniegoYearControlContributor.year }}</td><td>{{ lebaniegoYearControlContributor.gFile.sectorBusinessName }}</td><td>{{ lebaniegoYearControlContributor.gFile.sectorNif }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-control/lebaniego-control-convenios/lebaniego-control-convenio-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-control-agreement"><md-icon>undo</md-icon></md-button><span>Convenio {{vm.actualBusinessName}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearControlAgreement.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearControlAgreement.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-input-name="contact" required md-selected-item="vm.lebaniegoYearControlAgreement.gFile.sectorBusinessName" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found><div ng-messages="editForm.contact.$error"><div ng-message="required">El contacto es obligatorio</div></div></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearControlAgreement.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearControlAgreement.gFile.id" required><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearControlAgreement.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearControlAgreement.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearControlAgreement.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-control/lebaniego-control-convenios/lebaniego-control-convenio-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-control-agreement"><md-icon>undo</md-icon></md-button><span>Nuevo convenio</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><span>Seleccione la raz\xF3n social de un convenio previo:</span></div><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearControlAgreement.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearControlAgreement.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-input-name="contact" required md-selected-item="selectedItem" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found><div ng-messages="editForm.contact.$error"><div ng-message="required">El contacto es obligatorio</div></div></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearControlAgreement.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearControlAgreement.gFile" required><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un convenio" aria-label="Grabar convenio">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-control/lebaniego-control-convenios/lebaniego-control-convenio.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Control operativo del proyecto - Convenios</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo convenio" ui-sref="lebaniego-control-agreement.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar convenios" aria-label="Buscar convenios" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearControlAgreement in vm.lebaniegoYearControlAgreements track by lebaniegoYearControlAgreement.id" ui-sref="lebaniego-control-agreement.edit({id:lebaniegoYearControlAgreement.id})"><td>{{ lebaniegoYearControlAgreement.year }}</td><td>{{ lebaniegoYearControlAgreement.gFile.sectorBusinessName }}</td><td>{{ lebaniegoYearControlAgreement.gFile.sectorNif }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-control/lebaniego-control-donantes/lebaniego-control-donante-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-control-donor"><md-icon>undo</md-icon></md-button><span>Donante {{vm.actualBusinessName}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearControlDonor.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearControlDonor.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-input-name="contact" required md-selected-item="vm.lebaniegoYearControlDonor.gFile.sectorBusinessName" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found><div ng-messages="editForm.contact.$error"><div ng-message="required">El contacto es obligatorio</div></div></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearControlDonor.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearControlDonor.gFile.id" required><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearControlDonor.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearControlDonor.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearControlDonor.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-control/lebaniego-control-donantes/lebaniego-control-donante-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-control-donor"><md-icon>undo</md-icon></md-button><span>Nuevo donante</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><span>Seleccione la raz\xF3n social de un donante previo:</span></div><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearControlDonor.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearControlDonor.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-input-name="contact" required md-selected-item="selectedItem" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found><div ng-messages="editForm.contact.$error"><div ng-message="required">El contacto es obligatorio</div></div></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearControlDonor.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearControlDonor.gFile" required><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un donante" aria-label="Grabar donante">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-control/lebaniego-control-donantes/lebaniego-control-donante.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Control operativo del proyecto - Donantes</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo donante" ui-sref="lebaniego-control-donor.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar donantes" aria-label="Buscar donantes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearControlDonor in vm.lebaniegoYearControlDonors track by lebaniegoYearControlDonor.id" ui-sref="lebaniego-control-donor.edit({id:lebaniegoYearControlDonor.id})"><td>{{ lebaniegoYearControlDonor.year }}</td><td>{{ lebaniegoYearControlDonor.gFile.sectorBusinessName }}</td><td>{{ lebaniegoYearControlDonor.gFile.sectorNif }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-acciones/lebaniego-documentos-accion-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-documents-accion"><md-icon>undo</md-icon></md-button><span>Edici\xF3n de acci\xF3n</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosAccion.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearDocumentosAccion.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.lebaniegoYearDocumentosAccion.description" name="description" ng-disabled="!vm.isAdmin" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosAccion.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearDocumentosAccion.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un accion" aria-label="Grabar accion">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosAccion.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosAccion.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosAccion.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-acciones/lebaniego-documentos-accion-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-documents-accion"><md-icon>undo</md-icon></md-button><span>Nueva acci\xF3n</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosAccion.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearDocumentosAccion.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosAccion.description" for="field_description">Descripci\xF3n</label><input name="description" id="field_description" ng-model="vm.lebaniegoYearDocumentosAccion.description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosAccion.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearDocumentosAccion.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar una acci\xF3n" aria-label="Grabar acci\xF3n">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-acciones/lebaniego-documentos-accion.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Acciones</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nueva acci\xF3n" ui-sref="lebaniego-documents-accion.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_year">Descripci\xF3n</label><input type="string" name="description" id="field_description" ng-model="vm.searchItem.description"></md-input-container><md-button type="submit" class="md-primary" title="Buscar acciones" aria-label="Buscar acciones" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Fecha</span></th><th><span>Descripci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearDocumentosAccion in vm.lebaniegoYearDocumentosAcciones track by lebaniegoYearDocumentosAccion.id" ui-sref="lebaniego-documents-accion.edit({id:lebaniegoYearDocumentosAccion.id})"><td>{{ lebaniegoYearDocumentosAccion.year }}</td><td>{{ lebaniegoYearDocumentosAccion.date | date:\'dd/MM/yyyy\' }}</td><td><div class="table-details"><div class="title">{{lebaniegoYearDocumentosAccion.description}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-dossiers/lebaniego-documentos-dossier-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-documents-dossier"><md-icon>undo</md-icon></md-button><span>Edici\xF3n de dossier</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosDossier.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearDocumentosDossier.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.lebaniegoYearDocumentosDossier.description" name="description" ng-disabled="!vm.isAdmin" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosDossier.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearDocumentosDossier.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un dossier" aria-label="Grabar dossier">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosDossier.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosDossier.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosDossier.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-dossiers/lebaniego-documentos-dossier-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-documents-dossier"><md-icon>undo</md-icon></md-button><span>Nuevo dossier</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosDossier.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearDocumentosDossier.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosDossier.description" for="field_description">Descripci\xF3n</label><input name="description" id="field_description" ng-model="vm.lebaniegoYearDocumentosDossier.description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosDossier.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearDocumentosDossier.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un dossier" aria-label="Grabar dossier">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-dossiers/lebaniego-documentos-dossier.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Dossiers de presentaci\xF3n</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo dossier" ui-sref="lebaniego-documents-dossier.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_year">Descripci\xF3n</label><input type="string" name="description" id="field_description" ng-model="vm.searchItem.description"></md-input-container><md-button type="submit" class="md-primary" title="Buscar dossiers" aria-label="Buscar dossiers" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Fecha</span></th><th><span>Descripci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearDocumentosDossier in vm.lebaniegoYearDocumentosDossiers track by lebaniegoYearDocumentosDossier.id" ui-sref="lebaniego-documents-dossier.edit({id:lebaniegoYearDocumentosDossier.id})"><td>{{ lebaniegoYearDocumentosDossier.year }}</td><td>{{ lebaniegoYearDocumentosDossier.date | date:\'dd/MM/yyyy\' }}</td><td><div class="table-details"><div class="title">{{lebaniegoYearDocumentosDossier.description}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-manuales/lebaniego-documentos-manual-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-documents-manual"><md-icon>undo</md-icon></md-button><span>Edici\xF3n manual de aplicaci\xF3n de beneficios fiscales</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosManual.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearDocumentosManual.year" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label>Descripci\xF3n</label><input ng-model="vm.lebaniegoYearDocumentosManual.description" name="description" ng-disabled="!vm.isAdmin" id="field_description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosManual.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearDocumentosManual.date" ng-disabled="!vm.isAdmin" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un manual" aria-label="Grabar manual">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosManual.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosManual.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosManual.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-manuales/lebaniego-documentos-manual-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-documents-manual"><md-icon>undo</md-icon></md-button><span>Nuevo manual</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosManual.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearDocumentosManual.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosManual.description" for="field_description">Descripci\xF3n</label><input type="string" name="description" id="field_description" ng-model="vm.lebaniegoYearDocumentosManual.description" required><div ng-messages="editForm.description.$error"><div ng-message="required">La descripci\xF3n es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearDocumentosManual.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearDocumentosManual.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un manual" aria-label="Grabar manual">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-documentos/lebaniego-documentos-manuales/lebaniego-documentos-manual.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Manual de aplicaci\xF3n de beneficios fiscales</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo manual" ui-sref="lebaniego-documents-manual.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex><label for="field_year">Descripci\xF3n</label><input type="string" name="description" id="field_description" ng-model="vm.searchItem.description"></md-input-container><md-button type="submit" class="md-primary" title="Buscar manuales" aria-label="Buscar manuales" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Fecha</span></th><th><span>Descripci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearDocumentosManual in vm.lebaniegoYearDocumentosManuales track by lebaniegoYearDocumentosManual.id" ui-sref="lebaniego-documents-manual.edit({id:lebaniegoYearDocumentosManual.id})"><td>{{ lebaniegoYearDocumentosManual.year }}</td><td>{{ lebaniegoYearDocumentosManual.date | date:\'dd/MM/yyyy\' }}</td><td><div class="table-details"><div class="title">{{lebaniegoYearDocumentosManual.description}}</div></div></td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-aportantes/lebaniego-resultado-aportante-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-result-contributor"><md-icon>undo</md-icon></md-button><span>Aportante {{vm.actualBusinessName}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultContributor.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearResultContributor.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-input-name="contact" required md-selected-item="vm.lebaniegoYearResultContributor.gFile.sectorBusinessName" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found><div ng-messages="editForm.contact.$error"><div ng-message="required">El contacto es obligatorio</div></div></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearResultContributor.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearResultContributor.gFile.id" required><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearResultContributor.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearResultContributor.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultContributor.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-aportantes/lebaniego-resultado-aportante-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-result-contributor"><md-icon>undo</md-icon></md-button><span>Nuevo aportante</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultContributor.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearResultContributor.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-selected-item="selectedItem" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearResultContributor.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearResultContributor.gFile" required><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un aportante" aria-label="Grabar aportante">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-aportantes/lebaniego-resultado-aportante.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Resultados cuantitativos del proyecto - Aportantes</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo aportante" ui-sref="lebaniego-result-contributor.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar aportantes" aria-label="Buscar aportantes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearResultContributor in vm.lebaniegoYearResultContributors track by lebaniegoYearResultContributor.id" ui-sref="lebaniego-result-contributor.edit({id:lebaniegoYearResultContributor.id})"><td>{{ lebaniegoYearResultContributor.year }}</td><td>{{ lebaniegoYearResultContributor.gFile.sectorBusinessName }}</td><td>{{ lebaniegoYearResultContributor.gFile.sectorNif }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-convenios/lebaniego-resultado-convenio-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-result-agreement"><md-icon>undo</md-icon></md-button><span>Convenio {{vm.actualBusinessName}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultAgreement.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearResultAgreement.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-input-name="contact" required md-selected-item="vm.lebaniegoYearResultAgreement.gFile.sectorBusinessName" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found><div ng-messages="editForm.contact.$error"><div ng-message="required">El contacto es obligatorio</div></div></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearResultAgreement.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearResultAgreement.gFile.id" required><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearResultAgreement.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearResultAgreement.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultAgreement.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-convenios/lebaniego-resultado-convenio-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-result-agreement"><md-icon>undo</md-icon></md-button><span>Nuevo convenio</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultAgreement.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearResultAgreement.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-selected-item="selectedItem" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearResultAgreement.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearResultAgreement.gFile" required><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un convenio" aria-label="Grabar convenio">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-convenios/lebaniego-resultado-convenio.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Resultados cuantitativos del proyecto - Convenios</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo convenio" ui-sref="lebaniego-result-agreement.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar convenios" aria-label="Buscar convenios" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearResultAgreement in vm.lebaniegoYearResultAgreements track by lebaniegoYearResultAgreement.id" ui-sref="lebaniego-result-agreement.edit({id:lebaniegoYearResultAgreement.id})"><td>{{ lebaniegoYearResultAgreement.year }}</td><td>{{ lebaniegoYearResultAgreement.gFile.sectorBusinessName }}</td><td>{{ lebaniegoYearResultAgreement.gFile.sectorNif }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-donantes/lebaniego-resultado-donante-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-result-donor"><md-icon>undo</md-icon></md-button><span>Donante {{vm.actualBusinessName}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultDonor.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearResultDonor.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-input-name="contact" required md-selected-item="vm.lebaniegoYearResultDonor.gFile.sectorBusinessName" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found><div ng-messages="editForm.contact.$error"><div ng-message="required">El contacto es obligatorio</div></div></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearResultDonor.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearResultDonor.gFile.id" required><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearResultDonor.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearResultDonor.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultDonor.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-donantes/lebaniego-resultado-donante-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-result-donor"><md-icon>undo</md-icon></md-button><span>Nuevo donante</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultDonor.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearResultDonor.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-autocomplete flex id="custom-autocomplete" md-selected-item="selectedItem" md-search-text="searchText" md-items="item in query(searchText)" md-item-text="item.sectorBusinessName" md-selected-item-change="selectedItemChange(item)" md-floating-label="Contacto" placeholder="Contacto"><md-item-template><span>{{item.sectorBusinessName}} - {{item.sectorNif}}</span></md-item-template><md-not-found>No se encontraron contactos.</md-not-found></md-autocomplete></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearResultDonor.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><input type="hidden" name="gFile" ng-model="vm.lebaniegoYearResultDonor.gFile" required><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un donante" aria-label="Grabar donante">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-donantes/lebaniego-resultado-donante.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Resultados cuantitativos del proyecto - Donantes</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo donante" ui-sref="lebaniego-result-donor.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar donantes" aria-label="Buscar donantes" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearResultDonor in vm.lebaniegoYearResultDonors track by lebaniegoYearResultDonor.id" ui-sref="lebaniego-result-donor.edit({id:lebaniegoYearResultDonor.id})"><td>{{ lebaniegoYearResultDonor.year }}</td><td>{{ lebaniegoYearResultDonor.gFile.sectorBusinessName }}</td><td>{{ lebaniegoYearResultDonor.gFile.sectorNif }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-resumenes/lebaniego-resultado-resumen-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-result-summary"><md-icon>undo</md-icon></md-button><span>Resumen del a\xF1o {{vm.actualYear}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultSummary.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearResultSummary.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearResultSummary.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un resumen" aria-label="Grabar resumen">Grabar</md-button></section><md-divider></md-divider><div layout="row"><md-input-container class="md-block" flex><label>Documentos</label></md-input-container></div><div layout="row" class="mt-10" ng-repeat="document in vm.documents"><md-input-container class="md-block mb-0" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearResultSummary.document.filename" for="doc_filename">Nombre</label><input type="text" name="doc_filename" id="doc_filename" value="{{document.fileName}}" aria-label="Documento" disabled="disabled"></md-input-container><md-input-container class="md-block mb-0" flex="40"><label data-translate="expedientesUriarteApp.lebaniegoYearResultSummary.document.description" for="doc_description">Descripci\xF3n</label><input type="text" name="doc_description" id="doc_description" ng-model="document.description" ng-disabled="!vm.isAdmin" aria-label="Descripci\xF3n"></md-input-container><md-input-container class="md-block mb-0" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultSummary.date" for="doc_date">Fecha</label><input type="date" name="doc_date" id="doc_date" ng-model="document.date" ng-disabled="!vm.isAdmin" aria-label="Fecha"></md-input-container><div class="pl-20" flex="20"><md-button class="md-fab md-mini bt-save" title="Guardar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.updateDocument(document)" aria-label="Guardar fichero"><md-icon>save</md-icon></md-button><md-button class="md-fab md-mini md-primary" title="Descargar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.downloadDocument(document.id)" aria-label="Descargar fichero"><md-icon>get_app</md-icon></md-button><md-button class="md-fab md-raised md-mini" title="Borrar documento" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR" ng-click="vm.showConfirm(document.id)" aria-label="Borrar fichero"><md-icon>clear</md-icon></md-button></div></div><div layout="row" ng-if="vm.documents.length == 0"><md-input-container class="md-block" flex>No hay documentos</md-input-container></div><div layout="row" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><div flex="50"><md-button class="md-raised md-primary" title="Subir un documento" ngf-select="vm.uploadDocument($file, $invalidFiles)" aria-label="Subir documento"><md-icon>publish</md-icon>Subir nuevo documento</md-button></div></div></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-resumenes/lebaniego-resultado-resumen-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-result-summary"><md-icon>undo</md-icon></md-button><span>Nuevo resumen</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row" class="mb-10"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearResultSummary.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearResultSummary.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearResultSummary.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un resumen" aria-label="Grabar resumen">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-resultados/lebaniego-resultados-resumenes/lebaniego-resultado-resumen.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Resultados cuantitativos del proyecto - Resumen anual</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo donante" ui-sref="lebaniego-result-summary.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-button type="submit" class="md-primary" title="Buscar donantes" aria-label="Buscar resumen" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearResultSummary in vm.lebaniegoYearResultSummarys track by lebaniegoYearResultSummary.id" ui-sref="lebaniego-result-summary.edit({id:lebaniegoYearResultSummary.id})"><td>{{ lebaniegoYearResultSummary.year }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-bac/lebaniego-contactos-sector-bac-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-bac"><md-icon>undo</md-icon></md-button><span>Edici\xF3n {{vm.actualSector}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorBac.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorBac.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorBac.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorBac.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorBac.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorBac.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorBac.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorBac.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorBac.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorBac.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-bac/lebaniego-contactos-sector-bac-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-bac"><md-icon>undo</md-icon></md-button><span>Nuevo contacto</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorBac.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorBac.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorBac.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorBac.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorBac.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorBac.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorBac.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorBac.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorBac.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorBac.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorBac.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un contacto" aria-label="Grabar contacto">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-bac/lebaniego-contactos-sector-bac.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Bebidas y alimentaci\xF3n de Cantabria</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo contacto" ui-sref="lebaniego-contacts-sector-bac.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar proveedores" aria-label="Buscar proveedores" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th><th><span>Fecha</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearContactosSectorBac in vm.lebaniegoYearContactosSectorBacs track by lebaniegoYearContactosSectorBac.id" ui-sref="lebaniego-contacts-sector-bac.edit({id:lebaniegoYearContactosSectorBac.id})"><td>{{ lebaniegoYearContactosSectorBac.year }}</td><td>{{ lebaniegoYearContactosSectorBac.businessName }}</td><td>{{ lebaniegoYearContactosSectorBac.nif }}</td><td>{{ lebaniegoYearContactosSectorBac.date | date:\'dd/MM/yyyy\' }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-ed/lebaniego-contactos-sector-ed-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-ed"><md-icon>undo</md-icon></md-button><span>Edici\xF3n {{vm.actualSector}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorEd.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorEd.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="30"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorEd.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorEd.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorEd.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorEd.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorEd.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorEd.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorEd.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorEd.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-ed/lebaniego-contactos-sector-ed-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-ed"><md-icon>undo</md-icon></md-button><span>Nuevo contacto</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorEd.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorEd.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorEd.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorEd.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorEd.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorEd.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorEd.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorEd.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorEd.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorEd.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorEd.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un contacto" aria-label="Grabar contacto">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-ed/lebaniego-contactos-sector-ed.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Empresas de distribuci\xF3n</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo contacto" ui-sref="lebaniego-contacts-sector-ed.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar proveedores" aria-label="Buscar proveedores" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" calledk="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th><th><span>Fecha</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearContactosSectorEd in vm.lebaniegoYearContactosSectorEds track by lebaniegoYearContactosSectorEd.id" ui-sref="lebaniego-contacts-sector-ed.edit({id:lebaniegoYearContactosSectorEd.id})"><td>{{ lebaniegoYearContactosSectorEd.year }}</td><td>{{ lebaniegoYearContactosSectorEd.businessName }}</td><td>{{ lebaniegoYearContactosSectorEd.nif }}</td><td>{{ lebaniegoYearContactosSectorEd.date | date:\'dd/MM/yyyy\' }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-san/lebaniego-contactos-sector-san-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-san"><md-icon>undo</md-icon></md-button><span>Edici\xF3n {{vm.actualSector}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorSan.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorSan.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorSan.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorSan.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorSan.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorSan.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorSan.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorSan.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorSan.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorSan.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-san/lebaniego-contactos-sector-san-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-san"><md-icon>undo</md-icon></md-button><span>Nuevo contacto</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorSan.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorSan.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorSan.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorSan.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorSan.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorSan.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorSan.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorSan.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSan.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorSan.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorSan.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un contacto" aria-label="Grabar contacto">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-san/lebaniego-contactos-sector-san.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Sector alimentario nacional</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo contacto" ui-sref="lebaniego-contacts-sector-san.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar proveedores" aria-label="Buscar proveedores" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callsank="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th><th><span>Fecha</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearContactosSectorSan in vm.lebaniegoYearContactosSectorSans track by lebaniegoYearContactosSectorSan.id" ui-sref="lebaniego-contacts-sector-san.edit({id:lebaniegoYearContactosSectorSan.id})"><td>{{ lebaniegoYearContactosSectorSan.year }}</td><td>{{ lebaniegoYearContactosSectorSan.businessName }}</td><td>{{ lebaniegoYearContactosSectorSan.nif }}</td><td>{{ lebaniegoYearContactosSectorSan.date | date:\'dd/MM/yyyy\' }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-os/lebaniego-contactos-sector-os-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-os"><md-icon>undo</md-icon></md-button><span>Edici\xF3n {{vm.actualSector}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorOs.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorOs.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorOs.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorOs.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorOs.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorOs.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorOs.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorOs.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorOs.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorOs.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-os/lebaniego-contactos-sector-os-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-os"><md-icon>undo</md-icon></md-button><span>Nuevo contacto</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorOs.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorOs.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorOs.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorOs.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorOs.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorOs.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorOs.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorOs.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorOs.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorOs.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorOs.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un contacto" aria-label="Grabar contacto">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-os/lebaniego-contactos-sector-os.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Otros sectores</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo contacto" ui-sref="lebaniego-contacts-sector-os.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar proveedores" aria-label="Buscar proveedores" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callosk="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th><th><span>Fecha</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearContactosSectorOs in vm.lebaniegoYearContactosSectorOss track by lebaniegoYearContactosSectorOs.id" ui-sref="lebaniego-contacts-sector-os.edit({id:lebaniegoYearContactosSectorOs.id})"><td>{{ lebaniegoYearContactosSectorOs.year }}</td><td>{{ lebaniegoYearContactosSectorOs.businessName }}</td><td>{{ lebaniegoYearContactosSectorOs.nif }}</td><td>{{ lebaniegoYearContactosSectorOs.date | date:\'dd/MM/yyyy\' }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sbn/lebaniego-contactos-sector-sbn-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-sbn"><md-icon>undo</md-icon></md-button><span>Edici\xF3n {{vm.actualSector}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorSbn.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorSbn.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorSbn.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorSbn.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorSbn.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorSbn.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorSbn.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorSbn.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorSbn.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorSbn.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sbn/lebaniego-contactos-sector-sbn-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-sbn"><md-icon>undo</md-icon></md-button><span>Nuevo contacto</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorSbn.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorSbn.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorSbn.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorSbn.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorSbn.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorSbn.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorSbn.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorSbn.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSbn.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorSbn.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorSbn.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un contacto" aria-label="Grabar contacto">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sbn/lebaniego-contactos-sector-sbn.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Bebidas nacionales</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo contacto" ui-sref="lebaniego-contacts-sector-sbn.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar proveedores" aria-label="Buscar proveedores" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callsbnk="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th><th><span>Fecha</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearContactosSectorSbn in vm.lebaniegoYearContactosSectorSbns track by lebaniegoYearContactosSectorSbn.id" ui-sref="lebaniego-contacts-sector-sbn.edit({id:lebaniegoYearContactosSectorSbn.id})"><td>{{ lebaniegoYearContactosSectorSbn.year }}</td><td>{{ lebaniegoYearContactosSectorSbn.businessName }}</td><td>{{ lebaniegoYearContactosSectorSbn.nif }}</td><td>{{ lebaniegoYearContactosSectorSbn.date | date:\'dd/MM/yyyy\' }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sfa/lebaniego-contactos-sector-sfa-detail.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-sfa"><md-icon>undo</md-icon></md-button><span>Edici\xF3n {{vm.actualSector}}</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorSfa.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorSfa.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorSfa.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorSfa.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorSfa.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorSfa.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorSfa.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorSfa.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorSfa.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorSfa.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section class="mb-40" layout="row" layout-sm="column" layout-align="start left" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un proveedor" aria-label="Grabar proveedor">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sfa/lebaniego-contactos-sector-sfa-new.html','<md-content><div layout="row" class="content-header"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button" ui-sref="lebaniego-contacts-sector-sfa"><md-icon>undo</md-icon></md-button><span>Nuevo contacto</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div></div><md-card><md-card-content><div class="md-inline-form"><form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" class="form-horizontal" show-validation><div layout="row"><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.year" for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.lebaniegoYearContactosSectorSfa.year" required><div ng-messages="editForm.year.$error"><div ng-message="required">El a\xF1o es obligatorio</div></div></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.businessName" for="field_businessName">Raz\xF3n social</label><input type="text" name="businessName" id="field_businessName" ng-model="vm.lebaniegoYearContactosSectorSfa.businessName" required><div ng-messages="editForm.businessName.$error"><div ng-message="required">La raz\xF3n social es obligatoria</div></div></md-input-container><md-input-container class="md-block" flex="20"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.nif" for="field_nif">NIF</label><input type="text" name="nif" id="field_nif" ng-model="vm.lebaniegoYearContactosSectorSfa.nif"></md-input-container><md-input-container class="md-block" flex="10"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.date" for="field_date">Fecha</label><input type="date" name="date" id="field_date" ng-model="vm.lebaniegoYearContactosSectorSfa.date" required><div ng-messages="editForm.date.$error"><div ng-message="required">La fecha es obligatoria</div></div></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.contact" for="field_contact">Persona de contacto</label><input type="text" name="contact" id="field_contact" ng-model="vm.lebaniegoYearContactosSectorSfa.contact"></md-input-container><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.address" for="field_address">Direcci\xF3n</label><input type="text" name="address" id="field_address" ng-model="vm.lebaniegoYearContactosSectorSfa.address"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.telephone" for="field_telephone">Tel\xE9fono</label><input type="text" name="telephone" id="field_telephone" ng-model="vm.lebaniegoYearContactosSectorSfa.telephone"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex="35"><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.email" for="field_email">Correo Electr\xF3nico</label><input type="text" name="email" id="field_email" ng-model="vm.lebaniegoYearContactosSectorSfa.email"></md-input-container><md-input-container class="md-block" flex><label data-translate="expedientesUriarteApp.lebaniegoYearContactosSectorSfa.description" for="field_description">Descripci\xF3n</label><input type="text" name="description" id="field_description" ng-model="vm.lebaniegoYearContactosSectorSfa.description"></md-input-container></div><div layout="row"><md-input-container class="md-block" flex><label>Observaciones</label><textarea ng-model="vm.lebaniegoYearContactosSectorSfa.observations" columns="1" md-maxlength="1000" rows="3"></textarea></md-input-container></div><section layout="row" layout-sm="column" layout-align="end right"><md-button class="md-raised" ng-click="vm.clear()">Cancelar</md-button><md-button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="md-raised md-primary" title="Grabar un contacto" aria-label="Grabar contacto">Grabar</md-button></section></form></div></md-card-content></md-card></md-content>');
$templateCache.put('app/entities/lebaniego/lebaniego-contactos/lebaniego-contactos-sector/lebaniego-contactos-sector-sfa/lebaniego-contactos-sector-sfa.html','<md-content flex><div layout="row" class="content-header" layout-align="space-between"><div layout="row" class="title" layout-align="start center"><md-button class="md-icon-button"><md-icon class="icon-theme">extension</md-icon></md-button><span>Sector fabricantes de aceite</span><md-button class="md-icon-button" hide-gt-md ng-click="vm.toggleSidenav()"><md-icon class="icon-theme">menu</md-icon></md-button></div><div class="form-box new-item"><md-button class="md-fab md-primary md-hue-2" aria-label="Nuevo contacto" ui-sref="lebaniego-contacts-sector-sfa.new" has-any-authority="ROLE_ADMIN, ROLE_JUBILAR"><md-tooltip md-direction="left">Nuevo</md-tooltip><md-icon>add</md-icon></md-button></div></div><form name="searchForm" role="form" class="form-horizontal" novalidate ng-submit="vm.searchExp()" show-validation><div layout="row" class="form-box" layout-align="start center"><md-input-container class="md-block" flex="10"><label for="field_year">A\xF1o</label><input type="number" name="year" id="field_year" ng-model="vm.searchItem.year"></md-input-container><md-input-container class="md-block" flex="45"><label for="field_businessName">Raz\xF3n social</label><input type="string" name="businessName" id="field_businessName" ng-model="vm.searchItem.businessName"></md-input-container><md-input-container class="md-block" flex><label for="field_nif">NIF</label><input type="string" name="nif" id="field_nif" ng-model="vm.searchItem.nif"></md-input-container><md-button type="submit" class="md-primary" title="Buscar proveedores" aria-label="Buscar proveedores" ng-disabled="searchForm.$invalid">APLICAR FILTROS</md-button></div></form><div layout="row" layout-wrap><md-content flex="" class="md-whiteframe-4dp result-box"><table class="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callsfak="vm.transition()"><th><span>A\xF1o</span></th><th><span>Raz\xF3n social</span></th><th><span>NIF</span></th><th><span>Fecha</span></th></tr></thead><tbody><tr ng-repeat="lebaniegoYearContactosSectorSfa in vm.lebaniegoYearContactosSectorSfas track by lebaniegoYearContactosSectorSfa.id" ui-sref="lebaniego-contacts-sector-sfa.edit({id:lebaniegoYearContactosSectorSfa.id})"><td>{{ lebaniegoYearContactosSectorSfa.year }}</td><td>{{ lebaniegoYearContactosSectorSfa.businessName }}</td><td>{{ lebaniegoYearContactosSectorSfa.nif }}</td><td>{{ lebaniegoYearContactosSectorSfa.date | date:\'dd/MM/yyyy\' }}</td></tr></tbody></table><div layout="row" layout-align="space-between center"><md-button title="Exportar" aria-label="Exportar" class="md-primary visibility-hidden" ng-csv="vm.exportData" filename="{{vm.filename}}" csv-header="vm.getHeader()" field-separator=";" decimal-separator="," csv-column-order="vm.csvOrder" charset="windows-1251" ng-disabled="true"><md-icon>save_alt</md-icon>Descargar consulta</md-button><div layout="row" layout-align="end center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></md-content></div></md-content>');}]);})();